export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Upload: { input: any; output: any; }
};

/** A Field Group registered by ACF */
export type AcfFieldGroup = {
  /** The name of the ACF Field Group */
  readonly fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** Search Results */
export type AiSearchResults = {
  readonly __typename?: 'AiSearchResults';
  /** Extractive Answers */
  readonly extractiveAnswers?: Maybe<ReadonlyArray<Maybe<ExtractiveAnswer>>>;
  /** Snippets */
  readonly snippets?: Maybe<ReadonlyArray<Maybe<Snippet>>>;
};

/** Approved State */
export type ApprovedState = {
  readonly __typename?: 'ApprovedState';
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly timestamp?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<User>;
};

/** Approved State */
export type ApprovedStateInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>;
};

/** The Headless Login authentication data. */
export type AuthenticationData = {
  readonly __typename?: 'AuthenticationData';
  /** A new authentication token to use in future requests. */
  readonly authToken?: Maybe<Scalars['String']['output']>;
  /** The authentication token expiration timestamp. */
  readonly authTokenExpiration?: Maybe<Scalars['String']['output']>;
  /** Whether the user secret has been revoked. */
  readonly isUserSecretRevoked?: Maybe<Scalars['Boolean']['output']>;
  /** A list of linked identities from the Headless Login provider. */
  readonly linkedIdentities?: Maybe<ReadonlyArray<Maybe<LinkedIdentity>>>;
  /** A new refresh token to use in future requests. */
  readonly refreshToken?: Maybe<Scalars['String']['output']>;
  /** The refresh token expiration timestamp. */
  readonly refreshTokenExpiration?: Maybe<Scalars['String']['output']>;
  /** The user secret. */
  readonly userSecret?: Maybe<Scalars['String']['output']>;
};

/** Avatars are profile images for users. WordPress by default uses the Gravatar service to host and fetch avatars from. */
export type Avatar = {
  readonly __typename?: 'Avatar';
  /** TEST: URL for the default image or a default type. Accepts &#039;404&#039; (return a 404 instead of a default image), &#039;retro&#039; (8bit), &#039;monsterid&#039; (monster), &#039;wavatar&#039; (cartoon face), &#039;indenticon&#039; (the &#039;quilt&#039;), &#039;mystery&#039;, &#039;mm&#039;, or &#039;mysteryman&#039; (The Oyster Man), &#039;blank&#039; (transparent GIF), or &#039;gravatar_default&#039; (the Gravatar logo). */
  readonly default?: Maybe<Scalars['String']['output']>;
  /** HTML attributes to insert in the IMG element. Is not sanitized. */
  readonly extraAttr?: Maybe<Scalars['String']['output']>;
  /** Whether to always show the default image, never the Gravatar. */
  readonly forceDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the avatar was successfully found. */
  readonly foundAvatar?: Maybe<Scalars['Boolean']['output']>;
  /** Height of the avatar image. */
  readonly height?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** What rating to display avatars up to. Accepts &#039;G&#039;, &#039;PG&#039;, &#039;R&#039;, &#039;X&#039;, and are judged in that order. */
  readonly rating?: Maybe<Scalars['String']['output']>;
  /** Type of url scheme to use. Typically HTTP vs. HTTPS. */
  readonly scheme?: Maybe<Scalars['String']['output']>;
  /** The size of the avatar in pixels. A value of 96 will match a 96px x 96px gravatar image. */
  readonly size?: Maybe<Scalars['Int']['output']>;
  /** URL for the gravatar image source. */
  readonly url?: Maybe<Scalars['String']['output']>;
  /** Width of the avatar image. */
  readonly width?: Maybe<Scalars['Int']['output']>;
};

/** Content rating filter for user avatars. Determines the maximum maturity level of avatars to display, following standard content rating classifications (G, PG, R, X). */
export enum AvatarRatingEnum {
  /** Indicates a G level avatar rating level. */
  G = 'G',
  /** Indicates a PG level avatar rating level. */
  Pg = 'PG',
  /** Indicates an R level avatar rating level. */
  R = 'R',
  /** Indicates an X level avatar rating level. */
  X = 'X'
}

/** The Login client options for the azure-multi-tenant provider. */
export type AzureMultiTenantClientOptions = LoginClientOptions & {
  readonly __typename?: 'AzureMultiTenantClientOptions';
  /** The client ID. */
  readonly clientId?: Maybe<Scalars['String']['output']>;
  /** The client Secret. */
  readonly clientSecret?: Maybe<Scalars['String']['output']>;
  /** The hosted domain to restrict the login to. */
  readonly hostedDomain?: Maybe<Scalars['String']['output']>;
  /** The client redirect URI. */
  readonly redirectUri?: Maybe<Scalars['String']['output']>;
  /** The fields to request from the Generic Graph API. See https://developers.facebook.com/docs/graph-api/reference/user for a list of available fields. */
  readonly scope?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** The Azure AD tenant ID. */
  readonly tenant?: Maybe<Scalars['String']['output']>;
  /** This field exists solely to generate the  ClientOptions interface, in lieu of the shared custom fields that will be added in a future release */
  readonly todo?: Maybe<Scalars['Boolean']['output']>;
};

/** The Headless Login options for the azure-multi-tenant provider. */
export type AzureMultiTenantLoginOptions = LoginOptions & {
  readonly __typename?: 'AzureMultiTenantLoginOptions';
  /** Whether to create users if none exist. */
  readonly createUserIfNoneExists?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to link existing users. */
  readonly linkExistingUsers?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to set a WordPress authentication cookie on successful login. */
  readonly useAuthenticationCookie?: Maybe<Scalars['Boolean']['output']>;
};

/** The Login client options for the azure-single-tenant provider. */
export type AzureSingleTenantClientOptions = LoginClientOptions & {
  readonly __typename?: 'AzureSingleTenantClientOptions';
  /** The client ID. */
  readonly clientId?: Maybe<Scalars['String']['output']>;
  /** The client Secret. */
  readonly clientSecret?: Maybe<Scalars['String']['output']>;
  /** The hosted domain to restrict the login to. */
  readonly hostedDomain?: Maybe<Scalars['String']['output']>;
  /** The client redirect URI. */
  readonly redirectUri?: Maybe<Scalars['String']['output']>;
  /** The fields to request from the Generic Graph API. See https://developers.facebook.com/docs/graph-api/reference/user for a list of available fields. */
  readonly scope?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** The Azure AD tenant ID. */
  readonly tenant?: Maybe<Scalars['String']['output']>;
  /** This field exists solely to generate the  ClientOptions interface, in lieu of the shared custom fields that will be added in a future release */
  readonly todo?: Maybe<Scalars['Boolean']['output']>;
};

/** The Headless Login options for the azure-single-tenant provider. */
export type AzureSingleTenantLoginOptions = LoginOptions & {
  readonly __typename?: 'AzureSingleTenantLoginOptions';
  /** Whether to create users if none exist. */
  readonly createUserIfNoneExists?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to link existing users. */
  readonly linkExistingUsers?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to set a WordPress authentication cookie on successful login. */
  readonly useAuthenticationCookie?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for the batchPostMutation mutation. */
export type BatchPostMutationInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the posts to perform a batch operation */
  readonly ids: ReadonlyArray<InputMaybe<Scalars['ID']['input']>>;
  /** Type of the post */
  readonly postType: ZnglyPostTypeEnum;
  /** Status of the post */
  readonly status: PostStatusEnum;
};

/** The payload for the batchPostMutation mutation. */
export type BatchPostMutationPayload = {
  readonly __typename?: 'BatchPostMutationPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** IDs */
  readonly ids?: Maybe<ReadonlyArray<Maybe<Scalars['ID']['output']>>>;
  /** Message */
  readonly message?: Maybe<Scalars['String']['output']>;
};

export type BqDatetime = {
  readonly __typename?: 'BqDATETIME';
  /** Date type */
  readonly date?: Maybe<Scalars['String']['output']>;
  /** Timezone */
  readonly timezone?: Maybe<Scalars['String']['output']>;
  /** Timezone type */
  readonly timezone_type?: Maybe<Scalars['Int']['output']>;
};

export type BqDashboard = {
  readonly __typename?: 'BqDashboard';
  /** Data */
  readonly data: ReadonlyArray<Maybe<BqDashboardData>>;
};

export type BqDashboardData = {
  readonly __typename?: 'BqDashboardData';
  readonly active_users?: Maybe<Scalars['String']['output']>;
  readonly author?: Maybe<Scalars['String']['output']>;
  readonly author_id?: Maybe<Scalars['String']['output']>;
  readonly c_addressLine1?: Maybe<Scalars['String']['output']>;
  readonly c_addressLine2?: Maybe<Scalars['String']['output']>;
  readonly c_addressLine3?: Maybe<Scalars['String']['output']>;
  readonly c_city?: Maybe<Scalars['String']['output']>;
  readonly c_company?: Maybe<Scalars['String']['output']>;
  readonly c_country?: Maybe<Scalars['String']['output']>;
  readonly c_email?: Maybe<Scalars['String']['output']>;
  readonly c_firstname?: Maybe<Scalars['String']['output']>;
  readonly c_id?: Maybe<Scalars['String']['output']>;
  readonly c_jobTitle?: Maybe<Scalars['String']['output']>;
  readonly c_lastname?: Maybe<Scalars['String']['output']>;
  readonly c_phone?: Maybe<Scalars['String']['output']>;
  readonly c_postalCode?: Maybe<Scalars['String']['output']>;
  readonly c_props?: Maybe<Scalars['String']['output']>;
  readonly c_region?: Maybe<Scalars['String']['output']>;
  readonly campaign?: Maybe<Scalars['String']['output']>;
  readonly catalog_author_display_name?: Maybe<Scalars['String']['output']>;
  readonly catalog_author_email?: Maybe<Scalars['String']['output']>;
  readonly catalog_author_first_name?: Maybe<Scalars['String']['output']>;
  readonly catalog_author_last_name?: Maybe<Scalars['String']['output']>;
  readonly catalog_author_registered?: Maybe<Scalars['String']['output']>;
  readonly catalog_author_user_login?: Maybe<Scalars['String']['output']>;
  readonly categories?: Maybe<Scalars['String']['output']>;
  readonly client_id?: Maybe<Scalars['String']['output']>;
  readonly cnt_engaged_sessions?: Maybe<Scalars['String']['output']>;
  readonly content_id?: Maybe<Scalars['String']['output']>;
  readonly country?: Maybe<Scalars['String']['output']>;
  readonly device_category?: Maybe<Scalars['String']['output']>;
  readonly duration?: Maybe<Scalars['String']['output']>;
  readonly engagement_rate?: Maybe<Scalars['String']['output']>;
  readonly event_action?: Maybe<Scalars['String']['output']>;
  readonly event_category?: Maybe<Scalars['String']['output']>;
  readonly event_count?: Maybe<Scalars['Int']['output']>;
  readonly event_date?: Maybe<BqDatetime>;
  readonly event_label?: Maybe<Scalars['String']['output']>;
  readonly event_name?: Maybe<Scalars['String']['output']>;
  readonly event_timestamp?: Maybe<BqDatetime>;
  readonly file_download_name?: Maybe<Scalars['String']['output']>;
  readonly hub_author?: Maybe<Scalars['String']['output']>;
  readonly hub_author_display_name?: Maybe<Scalars['String']['output']>;
  readonly hub_author_email?: Maybe<Scalars['String']['output']>;
  readonly hub_author_first_name?: Maybe<Scalars['String']['output']>;
  readonly hub_author_id?: Maybe<Scalars['String']['output']>;
  readonly hub_author_last_name?: Maybe<Scalars['String']['output']>;
  readonly hub_author_registered?: Maybe<Scalars['String']['output']>;
  readonly hub_author_user_login?: Maybe<Scalars['String']['output']>;
  readonly hub_group?: Maybe<Scalars['String']['output']>;
  readonly hub_id?: Maybe<Scalars['String']['output']>;
  readonly hub_title?: Maybe<Scalars['String']['output']>;
  readonly is_new_user?: Maybe<Scalars['String']['output']>;
  readonly media_type?: Maybe<Scalars['String']['output']>;
  readonly page?: Maybe<Scalars['String']['output']>;
  readonly page_title?: Maybe<Scalars['String']['output']>;
  readonly page_type?: Maybe<Scalars['String']['output']>;
  readonly part1eng?: Maybe<Scalars['String']['output']>;
  readonly sessions_sum?: Maybe<Scalars['Int']['output']>;
  readonly source?: Maybe<Scalars['String']['output']>;
  readonly source_url?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly u_display_name?: Maybe<Scalars['String']['output']>;
  readonly u_email?: Maybe<Scalars['String']['output']>;
  readonly u_first_name?: Maybe<Scalars['String']['output']>;
  readonly u_last_name?: Maybe<Scalars['String']['output']>;
  readonly u_registered?: Maybe<Scalars['String']['output']>;
  readonly u_role?: Maybe<Scalars['String']['output']>;
  readonly u_user_login?: Maybe<Scalars['String']['output']>;
  readonly user_client_id?: Maybe<Scalars['String']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
  readonly user_pseudo_id?: Maybe<Scalars['String']['output']>;
  readonly user_source?: Maybe<Scalars['String']['output']>;
  readonly user_type?: Maybe<Scalars['String']['output']>;
  readonly users?: Maybe<Scalars['Int']['output']>;
  readonly znglist_author?: Maybe<Scalars['String']['output']>;
  readonly znglist_author_display_name?: Maybe<Scalars['String']['output']>;
  readonly znglist_author_email?: Maybe<Scalars['String']['output']>;
  readonly znglist_author_first_name?: Maybe<Scalars['String']['output']>;
  readonly znglist_author_id?: Maybe<Scalars['String']['output']>;
  readonly znglist_author_last_name?: Maybe<Scalars['String']['output']>;
  readonly znglist_author_registered?: Maybe<Scalars['String']['output']>;
  readonly znglist_author_user_login?: Maybe<Scalars['String']['output']>;
  readonly znglist_id?: Maybe<Scalars['String']['output']>;
  readonly znglist_title?: Maybe<Scalars['String']['output']>;
};

export type BqRoot = {
  readonly __typename?: 'BqRoot';
  /** Instance name */
  readonly instanceName?: Maybe<Scalars['String']['output']>;
  /** bg response */
  readonly targetDataset?: Maybe<Scalars['String']['output']>;
};

export type BucketStorage = {
  readonly __typename?: 'BucketStorage';
  /** GCP Storage Bucket */
  readonly bucket?: Maybe<Scalars['String']['output']>;
  /** GCP Storage Bucket */
  readonly gcsUri?: Maybe<Scalars['String']['output']>;
  /** GCP Storage Bucket */
  readonly object?: Maybe<Scalars['String']['output']>;
  /** GCP tStorage Bucket */
  readonly publicUri?: Maybe<Scalars['String']['output']>;
  /** GCP Storage Bucket */
  readonly publicUrl?: Maybe<Scalars['String']['output']>;
};

/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type Category = DatabaseIdentifier & HierarchicalNode & HierarchicalTermNode & MenuItemLinkable & Node & TermNode & UniformResourceIdentifiable & {
  readonly __typename?: 'Category';
  /** The ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  readonly ancestors?: Maybe<CategoryToAncestorsCategoryConnection>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  readonly categoryId?: Maybe<Scalars['Int']['output']>;
  /** Connection between the category type and its children categories. */
  readonly children?: Maybe<CategoryToCategoryConnection>;
  /** Connection between the Category type and the ContentNode type */
  readonly contentNodes?: Maybe<CategoryToContentNodeConnection>;
  /** The number of objects connected to the object */
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** The description of the object */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The link to the term */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** The human friendly name of the object. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Connection between the category type and its parent category. */
  readonly parent?: Maybe<CategoryToParentCategoryConnectionEdge>;
  /** Database id of the parent node */
  readonly parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent node. */
  readonly parentId?: Maybe<Scalars['ID']['output']>;
  /** Connection between the Category type and the post type */
  readonly posts?: Maybe<CategoryToPostConnection>;
  /** An alphanumeric identifier for the object unique to its type. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** Connection between the Category type and the Taxonomy type */
  readonly taxonomy?: Maybe<CategoryToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  readonly taxonomyName?: Maybe<Scalars['String']['output']>;
  /** The ID of the term group that this term object belongs to */
  readonly termGroupId?: Maybe<Scalars['Int']['output']>;
  /** The taxonomy ID that the object is associated with */
  readonly termTaxonomyId?: Maybe<Scalars['Int']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
  /** Connection between the Category type and the znglyVideo type */
  readonly znglyVideos?: Maybe<CategoryToZnglyVideoConnection>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;ZnglyCategory Settings&quot; was set to Show in GraphQL. */
  readonly znglycategory?: Maybe<Category_Znglycategory>;
};


/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type CategoryAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type CategoryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryToCategoryConnectionWhereArgs>;
};


/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type CategoryContentNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryToContentNodeConnectionWhereArgs>;
};


/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type CategoryEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type CategoryEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type CategoryPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryToPostConnectionWhereArgs>;
};


/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type CategoryZnglyVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryToZnglyVideoConnectionWhereArgs>;
};

/** A paginated collection of category Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of category Nodes */
export type CategoryConnection = {
  /** A list of edges (relational context) between RootQuery and connected category Nodes */
  readonly edges: ReadonlyArray<CategoryConnectionEdge>;
  /** A list of connected category Nodes */
  readonly nodes: ReadonlyArray<Category>;
  /** Information about pagination in a connection. */
  readonly pageInfo: CategoryConnectionPageInfo;
};

/** Represents a connection to a category. Contains both the category Node and metadata about the relationship. */
export type CategoryConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected category Node */
  readonly node: Category;
};

/** Pagination metadata specific to &quot;CategoryConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;CategoryConnectionEdge&quot; Nodes. */
export type CategoryConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifier types for retrieving a specific Category. Determines which unique property (global ID, database ID, slug, etc.) is used to locate the Category. */
export enum CategoryIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the Category type and the category type */
export type CategoryToAncestorsCategoryConnection = CategoryConnection & Connection & {
  readonly __typename?: 'CategoryToAncestorsCategoryConnection';
  /** Edges for the CategoryToAncestorsCategoryConnection connection */
  readonly edges: ReadonlyArray<CategoryToAncestorsCategoryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Category>;
  /** Information about pagination in a connection. */
  readonly pageInfo: CategoryToAncestorsCategoryConnectionPageInfo;
};

/** An edge in a connection */
export type CategoryToAncestorsCategoryConnectionEdge = CategoryConnectionEdge & Edge & {
  readonly __typename?: 'CategoryToAncestorsCategoryConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Category;
};

/** Pagination metadata specific to &quot;CategoryToAncestorsCategoryConnection&quot; collections. Provides cursors and flags for navigating through sets of CategoryToAncestorsCategoryConnection Nodes. */
export type CategoryToAncestorsCategoryConnectionPageInfo = CategoryConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'CategoryToAncestorsCategoryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the Category type and the category type */
export type CategoryToCategoryConnection = CategoryConnection & Connection & {
  readonly __typename?: 'CategoryToCategoryConnection';
  /** Edges for the CategoryToCategoryConnection connection */
  readonly edges: ReadonlyArray<CategoryToCategoryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Category>;
  /** Information about pagination in a connection. */
  readonly pageInfo: CategoryToCategoryConnectionPageInfo;
};

/** An edge in a connection */
export type CategoryToCategoryConnectionEdge = CategoryConnectionEdge & Edge & {
  readonly __typename?: 'CategoryToCategoryConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Category;
};

/** Pagination metadata specific to &quot;CategoryToCategoryConnection&quot; collections. Provides cursors and flags for navigating through sets of CategoryToCategoryConnection Nodes. */
export type CategoryToCategoryConnectionPageInfo = CategoryConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'CategoryToCategoryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the CategoryToCategoryConnection connection */
export type CategoryToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the Category type and the ContentNode type */
export type CategoryToContentNodeConnection = Connection & ContentNodeConnection & {
  readonly __typename?: 'CategoryToContentNodeConnection';
  /** Edges for the CategoryToContentNodeConnection connection */
  readonly edges: ReadonlyArray<CategoryToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ContentNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: CategoryToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type CategoryToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  readonly __typename?: 'CategoryToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ContentNode;
};

/** Pagination metadata specific to &quot;CategoryToContentNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of CategoryToContentNodeConnection Nodes. */
export type CategoryToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'CategoryToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the CategoryToContentNodeConnection connection */
export type CategoryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  readonly contentTypes?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypesOfCategoryEnum>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the Category type and the category type */
export type CategoryToParentCategoryConnectionEdge = CategoryConnectionEdge & Edge & OneToOneConnection & {
  readonly __typename?: 'CategoryToParentCategoryConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Category;
};

/** Connection between the Category type and the post type */
export type CategoryToPostConnection = Connection & PostConnection & {
  readonly __typename?: 'CategoryToPostConnection';
  /** Edges for the CategoryToPostConnection connection */
  readonly edges: ReadonlyArray<CategoryToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Post>;
  /** Information about pagination in a connection. */
  readonly pageInfo: CategoryToPostConnectionPageInfo;
};

/** An edge in a connection */
export type CategoryToPostConnectionEdge = Edge & PostConnectionEdge & {
  readonly __typename?: 'CategoryToPostConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Post;
};

/** Pagination metadata specific to &quot;CategoryToPostConnection&quot; collections. Provides cursors and flags for navigating through sets of CategoryToPostConnection Nodes. */
export type CategoryToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'CategoryToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the CategoryToPostConnection connection */
export type CategoryToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  readonly categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  readonly categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  readonly tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  readonly tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  readonly tagSlugAnd?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  readonly tagSlugIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the Category type and the Taxonomy type */
export type CategoryToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  readonly __typename?: 'CategoryToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Taxonomy;
};

/** Connection between the Category type and the znglyVideo type */
export type CategoryToZnglyVideoConnection = Connection & ZnglyVideoConnection & {
  readonly __typename?: 'CategoryToZnglyVideoConnection';
  /** Edges for the CategoryToZnglyVideoConnection connection */
  readonly edges: ReadonlyArray<CategoryToZnglyVideoConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ZnglyVideo>;
  /** Information about pagination in a connection. */
  readonly pageInfo: CategoryToZnglyVideoConnectionPageInfo;
};

/** An edge in a connection */
export type CategoryToZnglyVideoConnectionEdge = Edge & ZnglyVideoConnectionEdge & {
  readonly __typename?: 'CategoryToZnglyVideoConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ZnglyVideo;
};

/** Pagination metadata specific to &quot;CategoryToZnglyVideoConnection&quot; collections. Provides cursors and flags for navigating through sets of CategoryToZnglyVideoConnection Nodes. */
export type CategoryToZnglyVideoConnectionPageInfo = PageInfo & WpPageInfo & ZnglyVideoConnectionPageInfo & {
  readonly __typename?: 'CategoryToZnglyVideoConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the CategoryToZnglyVideoConnection connection */
export type CategoryToZnglyVideoConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  readonly categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  readonly categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  readonly tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  readonly tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  readonly tagSlugAnd?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  readonly tagSlugIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Field Group */
export type Category_Znglycategory = AcfFieldGroup & {
  readonly __typename?: 'Category_Znglycategory';
  /** The name of the ACF Field Group */
  readonly fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Main video to appear when this sub-category is selected */
  readonly pinnedContent?: Maybe<ReadonlyArray<Maybe<Category_Znglycategory_PinnedContent>>>;
  readonly uxOrder?: Maybe<Scalars['Float']['output']>;
};

export type Category_Znglycategory_PinnedContent = ZnglyVideo;

/** Citation */
export type Citation = {
  readonly __typename?: 'Citation';
  readonly endIndex?: Maybe<Scalars['Float']['output']>;
  readonly sources?: Maybe<ReadonlyArray<Maybe<CitationSource>>>;
  readonly startIndex?: Maybe<Scalars['Float']['output']>;
};

/** Citation Metadata */
export type CitationMetadata = {
  readonly __typename?: 'CitationMetadata';
  readonly citations?: Maybe<ReadonlyArray<Maybe<Citation>>>;
};

/** Citation Source */
export type CitationSource = {
  readonly __typename?: 'CitationSource';
  readonly referenceIndex?: Maybe<Scalars['String']['output']>;
};

/** A response or reaction to content submitted by users. Comments are typically associated with a specific content entry. */
export type Comment = DatabaseIdentifier & Node & UniformResourceIdentifiable & {
  readonly __typename?: 'Comment';
  /** User agent used to post the comment. This field is equivalent to WP_Comment-&gt;comment_agent and the value matching the &quot;comment_agent&quot; column in SQL. */
  readonly agent?: Maybe<Scalars['String']['output']>;
  /**
   * The approval status of the comment. This field is equivalent to WP_Comment-&gt;comment_approved and the value matching the &quot;comment_approved&quot; column in SQL.
   * @deprecated Deprecated in favor of the `status` field
   */
  readonly approved?: Maybe<Scalars['Boolean']['output']>;
  /** The author of the comment */
  readonly author?: Maybe<CommentToCommenterConnectionEdge>;
  /**
   * IP address for the author at the time of commenting. This field is equivalent to WP_Comment-&gt;comment_author_IP and the value matching the &quot;comment_author_IP&quot; column in SQL.
   * @deprecated Use the ipAddress field on the edge between the comment and author
   */
  readonly authorIp?: Maybe<Scalars['String']['output']>;
  /**
   * ID for the comment, unique among comments.
   * @deprecated Deprecated in favor of databaseId
   */
  readonly commentId?: Maybe<Scalars['Int']['output']>;
  /** Connection between the Comment type and the ContentNode type */
  readonly commentedOn?: Maybe<CommentToContentNodeConnectionEdge>;
  /** Content of the comment. This field is equivalent to WP_Comment-&gt;comment_content and the value matching the &quot;comment_content&quot; column in SQL. */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** Date the comment was posted in local time. This field is equivalent to WP_Comment-&gt;date and the value matching the &quot;date&quot; column in SQL. */
  readonly date?: Maybe<Scalars['String']['output']>;
  /** Date the comment was posted in GMT. This field is equivalent to WP_Comment-&gt;date_gmt and the value matching the &quot;date_gmt&quot; column in SQL. */
  readonly dateGmt?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier for the comment object */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** Karma value for the comment. This field is equivalent to WP_Comment-&gt;comment_karma and the value matching the &quot;comment_karma&quot; column in SQL. */
  readonly karma?: Maybe<Scalars['Int']['output']>;
  /** The permalink of the comment */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** Connection between the Comment type and the Comment type */
  readonly parent?: Maybe<CommentToParentCommentConnectionEdge>;
  /** The database id of the parent comment node or null if it is the root comment */
  readonly parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent comment node. */
  readonly parentId?: Maybe<Scalars['ID']['output']>;
  /** Connection between the Comment type and the Comment type */
  readonly replies?: Maybe<CommentToCommentConnection>;
  /** The approval status of the comment. This field is equivalent to WP_Comment-&gt;comment_approved and the value matching the &quot;comment_approved&quot; column in SQL. */
  readonly status?: Maybe<CommentStatusEnum>;
  /** Type of comment. This field is equivalent to WP_Comment-&gt;comment_type and the value matching the &quot;comment_type&quot; column in SQL. */
  readonly type?: Maybe<Scalars['String']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};


/** A response or reaction to content submitted by users. Comments are typically associated with a specific content entry. */
export type CommentContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** A response or reaction to content submitted by users. Comments are typically associated with a specific content entry. */
export type CommentParentArgs = {
  where?: InputMaybe<CommentToParentCommentConnectionWhereArgs>;
};


/** A response or reaction to content submitted by users. Comments are typically associated with a specific content entry. */
export type CommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommentToCommentConnectionWhereArgs>;
};

/** A Comment Author object */
export type CommentAuthor = Commenter & DatabaseIdentifier & Node & {
  readonly __typename?: 'CommentAuthor';
  /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
  readonly avatar?: Maybe<Avatar>;
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** The email for the comment author */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier for the comment author object */
  readonly id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** The name for the comment author. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** The url the comment author. */
  readonly url?: Maybe<Scalars['String']['output']>;
};


/** A Comment Author object */
export type CommentAuthorAvatarArgs = {
  forceDefault?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<AvatarRatingEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated collection of Comment Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of Comment Nodes */
export type CommentConnection = {
  /** A list of edges (relational context) between RootQuery and connected Comment Nodes */
  readonly edges: ReadonlyArray<CommentConnectionEdge>;
  /** A list of connected Comment Nodes */
  readonly nodes: ReadonlyArray<Comment>;
  /** Information about pagination in a connection. */
  readonly pageInfo: CommentConnectionPageInfo;
};

/** Represents a connection to a Comment. Contains both the Comment Node and metadata about the relationship. */
export type CommentConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Comment Node */
  readonly node: Comment;
};

/** Pagination metadata specific to &quot;CommentConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;CommentConnectionEdge&quot; Nodes. */
export type CommentConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifier types for retrieving a specific comment. Specifies which unique attribute is used to find a particular comment. */
export enum CommentNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID'
}

/** Moderation state for user comments. Determines whether comments are publicly visible, pending approval, or marked as spam. */
export enum CommentStatusEnum {
  /** Comments with the Approved status */
  Approve = 'APPROVE',
  /** Comments with the Unapproved status */
  Hold = 'HOLD',
  /** Comments with the Spam status */
  Spam = 'SPAM',
  /** Comments with the Trash status */
  Trash = 'TRASH'
}

/** Connection between the Comment type and the Comment type */
export type CommentToCommentConnection = CommentConnection & Connection & {
  readonly __typename?: 'CommentToCommentConnection';
  /** Edges for the CommentToCommentConnection connection */
  readonly edges: ReadonlyArray<CommentToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Comment>;
  /** Information about pagination in a connection. */
  readonly pageInfo: CommentToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type CommentToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  readonly __typename?: 'CommentToCommentConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Comment;
};

/** Pagination metadata specific to &quot;CommentToCommentConnection&quot; collections. Provides cursors and flags for navigating through sets of CommentToCommentConnection Nodes. */
export type CommentToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'CommentToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the CommentToCommentConnection connection */
export type CommentToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  readonly authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  readonly authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  readonly commentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  readonly commentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  readonly commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  readonly commentTypeIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  readonly commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  readonly contentAuthor?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  readonly contentAuthorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  readonly contentAuthorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  readonly contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  readonly contentIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  readonly contentIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  readonly contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  readonly contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentStatus?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentType?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  readonly includeUnapproved?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  readonly karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  readonly orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the Comment type and the Commenter type */
export type CommentToCommenterConnectionEdge = CommenterConnectionEdge & Edge & OneToOneConnection & {
  readonly __typename?: 'CommentToCommenterConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The email address representing the author for this particular comment */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** IP address of the author at the time of making this comment. This field is equivalent to WP_Comment-&gt;comment_author_IP and the value matching the &quot;comment_author_IP&quot; column in SQL. */
  readonly ipAddress?: Maybe<Scalars['String']['output']>;
  /** The display name of the comment author for this particular comment */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Commenter;
  /** The url entered for the comment author on this particular comment */
  readonly url?: Maybe<Scalars['String']['output']>;
};

/** Connection between the Comment type and the ContentNode type */
export type CommentToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & OneToOneConnection & {
  readonly __typename?: 'CommentToContentNodeConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: ContentNode;
};

/** Connection between the Comment type and the Comment type */
export type CommentToParentCommentConnectionEdge = CommentConnectionEdge & Edge & OneToOneConnection & {
  readonly __typename?: 'CommentToParentCommentConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Comment;
};

/** Arguments for filtering the CommentToParentCommentConnection connection */
export type CommentToParentCommentConnectionWhereArgs = {
  /** Comment author email address. */
  readonly authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  readonly authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  readonly commentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  readonly commentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  readonly commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  readonly commentTypeIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  readonly commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  readonly contentAuthor?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  readonly contentAuthorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  readonly contentAuthorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  readonly contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  readonly contentIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  readonly contentIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  readonly contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  readonly contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentStatus?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentType?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  readonly includeUnapproved?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  readonly karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  readonly orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** A user or guest who has submitted a comment. Provides identification and contact information for the comment author. */
export type Commenter = {
  /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
  readonly avatar?: Maybe<Avatar>;
  /** Identifies the primary key from the database. */
  readonly databaseId: Scalars['Int']['output'];
  /** The email address of the author of a comment. */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier for the comment author. */
  readonly id: Scalars['ID']['output'];
  /** Whether the author information is considered restricted. (not fully public) */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the author of a comment. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** The url of the author of a comment. */
  readonly url?: Maybe<Scalars['String']['output']>;
};

/** Represents a connection to a Commenter. Contains both the Commenter Node and metadata about the relationship. */
export type CommenterConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Commenter Node */
  readonly node: Commenter;
};

/** Sorting attributes for comment collections. Specifies which comment property determines the order of results. */
export enum CommentsConnectionOrderbyEnum {
  /** Order by browser user agent of the commenter. */
  CommentAgent = 'COMMENT_AGENT',
  /** Order by approval status of the comment. */
  CommentApproved = 'COMMENT_APPROVED',
  /** Order by name of the comment author. */
  CommentAuthor = 'COMMENT_AUTHOR',
  /** Order by e-mail of the comment author. */
  CommentAuthorEmail = 'COMMENT_AUTHOR_EMAIL',
  /** Order by IP address of the comment author. */
  CommentAuthorIp = 'COMMENT_AUTHOR_IP',
  /** Order by URL address of the comment author. */
  CommentAuthorUrl = 'COMMENT_AUTHOR_URL',
  /** Order by the comment contents. */
  CommentContent = 'COMMENT_CONTENT',
  /** Chronological ordering by comment submission date. */
  CommentDate = 'COMMENT_DATE',
  /** Chronological ordering by comment date in UTC/GMT time. */
  CommentDateGmt = 'COMMENT_DATE_GMT',
  /** Ordering by internal ID (typically reflects creation order). */
  CommentId = 'COMMENT_ID',
  /** Preserve custom order of IDs as specified in the query. */
  CommentIn = 'COMMENT_IN',
  /** Order by the comment karma score. */
  CommentKarma = 'COMMENT_KARMA',
  /** Ordering by parent comment relationship (threaded discussions). */
  CommentParent = 'COMMENT_PARENT',
  /** Ordering by associated content item ID. */
  CommentPostId = 'COMMENT_POST_ID',
  /** Ordering by comment classification (standard comments, pingbacks, etc.). */
  CommentType = 'COMMENT_TYPE',
  /** Ordering by the user account ID associated with the comment as the comment author. */
  UserId = 'USER_ID'
}

/** A paginated relationship between objects. Supports cursor-based pagination with edges containing relationship metadata and nodes containing the related objects. */
export type Connection = {
  /** A list of edges (relational context) between connected nodes */
  readonly edges: ReadonlyArray<Edge>;
  /** A list of connected nodes */
  readonly nodes: ReadonlyArray<Node>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PageInfo;
};

/** Hub Pages &amp; Catalog Assets Connection */
export type ConnectionHpToC = ConnectionHpToCWithCatalog & Node & ZnNode & {
  readonly __typename?: 'ConnectionHpToC';
  /** Connection between the ConnectionHpToC type and the ZnglyVideo type */
  readonly catalog?: Maybe<ConnectionHpToCToZnglyVideoConnectionEdge>;
  /** The database id of the catalog item */
  readonly catalogDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Catalog Id */
  readonly catalogId?: Maybe<Scalars['ID']['output']>;
  /** order of the catalog items */
  readonly catalogOrder?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier stored in the database */
  readonly databaseId?: Maybe<Scalars['Int']['output']>;
  /** Connection between the ConnectionHpToC type and the HubPage type */
  readonly hubPage?: Maybe<ConnectionHpToCToHubPageConnectionEdge>;
  /** Hub Page Id */
  readonly hubPageId?: Maybe<Scalars['ID']['output']>;
  /** weak table id */
  readonly id: Scalars['ID']['output'];
};


/** Hub Pages &amp; Catalog Assets Connection */
export type ConnectionHpToCHubPageArgs = {
  where?: InputMaybe<ConnectionHpToCToHubPageConnectionWhereArgs>;
};

/** A paginated collection of ConnectionHpToC Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of ConnectionHpToC Nodes */
export type ConnectionHpToCConnection = {
  /** A list of edges (relational context) between HubPage and connected ConnectionHpToC Nodes */
  readonly edges: ReadonlyArray<ConnectionHpToCConnectionEdge>;
  /** A list of connected ConnectionHpToC Nodes */
  readonly nodes: ReadonlyArray<ConnectionHpToC>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ConnectionHpToCConnectionPageInfo;
};

/** Represents a connection to a ConnectionHpToC. Contains both the ConnectionHpToC Node and metadata about the relationship. */
export type ConnectionHpToCConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected ConnectionHpToC Node */
  readonly node: ConnectionHpToC;
};

/** Pagination metadata specific to &quot;ConnectionHpToCConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;ConnectionHpToCConnectionEdge&quot; Nodes. */
export type ConnectionHpToCConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** The type of ID for ConnectionHpToC */
export enum ConnectionHpToCIdType {
  Id = 'ID'
}

/** ConnectionHpToCs Search Fields Enum */
export enum ConnectionHpToCSearchFieldsEnum {
  /** Catalog Id */
  CatalogId = 'CatalogId',
  /** order of the catalog items */
  CatalogOrder = 'CatalogOrder',
  /** Hub Page Id */
  HubPageId = 'HubPageId',
  /** weak table id */
  Id = 'Id'
}

/** Connection between the ConnectionHpToC type and the HubPage type */
export type ConnectionHpToCToHubPageConnectionEdge = Edge & HubPageConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'ConnectionHpToCToHubPageConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: HubPage;
};

/** Arguments for filtering the ConnectionHpToCToHubPageConnection connection */
export type ConnectionHpToCToHubPageConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** page description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Form Id */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** Form Id */
  readonly formIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Form Id */
  readonly formIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** page id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** page id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** page id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<HubPageSearchFieldsEnum>>>;
  /** Search for HubPages by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for HubPages by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<HubPageSearchFieldsEnum>>>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status of the post */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The status of the post */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the ConnectionHpToC type and the ZnglyVideo type */
export type ConnectionHpToCToZnglyVideoConnectionEdge = Edge & OneToOneConnection & ZnglyVideoConnectionEdge & {
  readonly __typename?: 'ConnectionHpToCToZnglyVideoConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: ZnglyVideo;
};

export type ConnectionHpToCWithCatalog = {
  /** The database id of the catalog item */
  readonly catalogDatabaseId?: Maybe<Scalars['Int']['output']>;
};

/** Hub to Hub Page Connection */
export type ConnectionHubToHp = Node & ZnNode & {
  readonly __typename?: 'ConnectionHubToHp';
  /** The unique identifier stored in the database */
  readonly databaseId?: Maybe<Scalars['Int']['output']>;
  /** Connection between the ConnectionHubToHp type and the Hub type */
  readonly hub?: Maybe<ConnectionHubToHpToHubConnectionEdge>;
  /** Hub Id */
  readonly hubId?: Maybe<Scalars['ID']['output']>;
  /** Connection between the ConnectionHubToHp type and the HubPage type */
  readonly hubPage?: Maybe<ConnectionHubToHpToHubPageConnectionEdge>;
  /** weak table id */
  readonly id: Scalars['ID']['output'];
  /** Page Icon */
  readonly pageIcon?: Maybe<Scalars['String']['output']>;
  /** Page Id */
  readonly pageId?: Maybe<Scalars['ID']['output']>;
  /** order of the pages */
  readonly pageOrder?: Maybe<Scalars['Int']['output']>;
  /** Page Title */
  readonly pageTitle?: Maybe<Scalars['String']['output']>;
};


/** Hub to Hub Page Connection */
export type ConnectionHubToHpHubArgs = {
  where?: InputMaybe<ConnectionHubToHpToHubConnectionWhereArgs>;
};


/** Hub to Hub Page Connection */
export type ConnectionHubToHpHubPageArgs = {
  where?: InputMaybe<ConnectionHubToHpToHubPageConnectionWhereArgs>;
};

/** A paginated collection of ConnectionHubToHp Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of ConnectionHubToHp Nodes */
export type ConnectionHubToHpConnection = {
  /** A list of edges (relational context) between Hub and connected ConnectionHubToHp Nodes */
  readonly edges: ReadonlyArray<ConnectionHubToHpConnectionEdge>;
  /** A list of connected ConnectionHubToHp Nodes */
  readonly nodes: ReadonlyArray<ConnectionHubToHp>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ConnectionHubToHpConnectionPageInfo;
};

/** Represents a connection to a ConnectionHubToHp. Contains both the ConnectionHubToHp Node and metadata about the relationship. */
export type ConnectionHubToHpConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected ConnectionHubToHp Node */
  readonly node: ConnectionHubToHp;
};

/** Pagination metadata specific to &quot;ConnectionHubToHpConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;ConnectionHubToHpConnectionEdge&quot; Nodes. */
export type ConnectionHubToHpConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** The type of ID for ConnectionHubToHp */
export enum ConnectionHubToHpIdType {
  Id = 'ID'
}

/** ConnectionHubToHps Search Fields Enum */
export enum ConnectionHubToHpSearchFieldsEnum {
  /** Hub Id */
  HubId = 'HubId',
  /** weak table id */
  Id = 'Id',
  /** Page Icon */
  PageIcon = 'PageIcon',
  /** Page Id */
  PageId = 'PageId',
  /** order of the pages */
  PageOrder = 'PageOrder',
  /** Page Title */
  PageTitle = 'PageTitle'
}

/** Connection between the ConnectionHubToHp type and the Hub type */
export type ConnectionHubToHpToHubConnectionEdge = Edge & HubConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'ConnectionHubToHpToHubConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Hub;
};

/** Arguments for filtering the ConnectionHubToHpToHubConnection connection */
export type ConnectionHubToHpToHubConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** description of the hub */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** group of the hub used to identify its category/tag/campaign */
  readonly group?: InputMaybe<Scalars['String']['input']>;
  /** group of the hub used to identify its category/tag/campaign */
  readonly groupIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** group of the hub used to identify its category/tag/campaign */
  readonly groupNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** hub id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** hub id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** hub id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<HubSearchFieldsEnum>>>;
  /** order of the hubs */
  readonly postOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Search for Hubs by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for Hubs by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<HubSearchFieldsEnum>>>;
  /** The name (slug) for the post */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status of the post */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The status of the post */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** template of the hub */
  readonly template?: InputMaybe<HubTemplateEnum>;
  /** template of the hub */
  readonly templateIn?: InputMaybe<ReadonlyArray<InputMaybe<HubTemplateEnum>>>;
  /** template of the hub */
  readonly templateNotIn?: InputMaybe<ReadonlyArray<InputMaybe<HubTemplateEnum>>>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** User related to the hub */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
  /** User related to the hub */
  readonly userIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** User related to the hub */
  readonly userIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
};

/** Connection between the ConnectionHubToHp type and the HubPage type */
export type ConnectionHubToHpToHubPageConnectionEdge = Edge & HubPageConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'ConnectionHubToHpToHubPageConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: HubPage;
};

/** Arguments for filtering the ConnectionHubToHpToHubPageConnection connection */
export type ConnectionHubToHpToHubPageConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** page description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Form Id */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** Form Id */
  readonly formIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Form Id */
  readonly formIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** page id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** page id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** page id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<HubPageSearchFieldsEnum>>>;
  /** Search for HubPages by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for HubPages by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<HubPageSearchFieldsEnum>>>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status of the post */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The status of the post */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Zngly Contacts */
export type Contact = Node & ZnNode & {
  readonly __typename?: 'Contact';
  /** Contact address line 1 */
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  /** Contact address line 2 */
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  /** Contact address line 3 */
  readonly addressLine3?: Maybe<Scalars['String']['output']>;
  /** Contact city */
  readonly city?: Maybe<Scalars['String']['output']>;
  /** Contact company */
  readonly company?: Maybe<Scalars['String']['output']>;
  /** Contact country */
  readonly country?: Maybe<Scalars['String']['output']>;
  /** Contact county */
  readonly county?: Maybe<Scalars['String']['output']>;
  /** The date the post was created, in the site&#039;s timezone */
  readonly created?: Maybe<Scalars['String']['output']>;
  /** Connection between the Contact type and the CrmListToItem type */
  readonly crmListToItems?: Maybe<ContactToCrmListToItemsConnection>;
  /** The unique identifier stored in the database */
  readonly databaseId?: Maybe<Scalars['Int']['output']>;
  /** Contact email */
  readonly email: Scalars['String']['output'];
  /** Contact firstname */
  readonly firstname?: Maybe<Scalars['String']['output']>;
  /** Connection between the Contact type and the FormEntry type */
  readonly formEntries?: Maybe<ContactToFormEntriesConnection>;
  /** contact id */
  readonly id: Scalars['ID']['output'];
  /** Zngly ids */
  readonly ids?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** Contact job title */
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  /** Contact lastname */
  readonly lastname?: Maybe<Scalars['String']['output']>;
  /** The date the post was last modified, in the site&#039;s timezone */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** Contact phone */
  readonly phone?: Maybe<Scalars['String']['output']>;
  /** Contact postal code */
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  /** Contact properties */
  readonly properties?: Maybe<ReadonlyArray<Maybe<JsonKeyValue>>>;
  /** Contact region */
  readonly region?: Maybe<Scalars['String']['output']>;
};


/** Zngly Contacts */
export type ContactCrmListToItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactToCrmListToItemsConnectionWhereArgs>;
};


/** Zngly Contacts */
export type ContactFormEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactToFormEntriesConnectionWhereArgs>;
};

/** A paginated collection of Contact Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of Contact Nodes */
export type ContactConnection = {
  /** A list of edges (relational context) between RootQuery and connected Contact Nodes */
  readonly edges: ReadonlyArray<ContactConnectionEdge>;
  /** A list of connected Contact Nodes */
  readonly nodes: ReadonlyArray<Contact>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ContactConnectionPageInfo;
};

/** Represents a connection to a Contact. Contains both the Contact Node and metadata about the relationship. */
export type ContactConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Contact Node */
  readonly node: Contact;
};

/** Pagination metadata specific to &quot;ContactConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;ContactConnectionEdge&quot; Nodes. */
export type ContactConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** The type of ID for Contact */
export enum ContactIdType {
  Email = 'EMAIL',
  Id = 'ID'
}

/** Contacts Search Fields Enum */
export enum ContactSearchFieldsEnum {
  /** Contact address line 1 */
  AddressLine1 = 'AddressLine1',
  /** Contact address line 2 */
  AddressLine2 = 'AddressLine2',
  /** Contact address line 3 */
  AddressLine3 = 'AddressLine3',
  /** Contact city */
  City = 'City',
  /** Contact company */
  Company = 'Company',
  /** Contact country */
  Country = 'Country',
  /** Contact county */
  County = 'County',
  /** The date the post was created, in the site's timezone */
  Created = 'Created',
  /** Contact email */
  Email = 'Email',
  /** Contact firstname */
  Firstname = 'Firstname',
  /** contact id */
  Id = 'Id',
  /** Zngly ids */
  Ids = 'Ids',
  /** Contact job title */
  JobTitle = 'JobTitle',
  /** Contact lastname */
  Lastname = 'Lastname',
  /** The date the post was last modified, in the site's timezone */
  Modified = 'Modified',
  /** Contact phone */
  Phone = 'Phone',
  /** Contact postal code */
  PostalCode = 'PostalCode',
  /** Contact properties */
  Properties = 'Properties',
  /** Contact region */
  Region = 'Region'
}

/** Connection between the Contact type and the CrmListToItem type */
export type ContactToCrmListToItemsConnection = Connection & CrmListToItemConnection & {
  readonly __typename?: 'ContactToCrmListToItemsConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the ContactToCrmListToItemsConnection connection */
  readonly edges: ReadonlyArray<ContactToCrmListToItemsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<CrmListToItem>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ContactToCrmListToItemsConnectionPageInfo;
};

/** An edge in a connection */
export type ContactToCrmListToItemsConnectionEdge = CrmListToItemConnectionEdge & Edge & {
  readonly __typename?: 'ContactToCrmListToItemsConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: CrmListToItem;
};

/** Pagination metadata specific to &quot;ContactToCrmListToItemsConnection&quot; collections. Provides cursors and flags for navigating through sets of ContactToCrmListToItemsConnection Nodes. */
export type ContactToCrmListToItemsConnectionPageInfo = CrmListToItemConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'ContactToCrmListToItemsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the ContactToCrmListToItemsConnection connection */
export type ContactToCrmListToItemsConnectionWhereArgs = {
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** weak table id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** weak table id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** weak table id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Item Id */
  readonly itemId?: InputMaybe<Scalars['ID']['input']>;
  /** Item Id */
  readonly itemIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Item Id */
  readonly itemIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** List Id */
  readonly listId?: InputMaybe<Scalars['ID']['input']>;
  /** List Id */
  readonly listIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** List Id */
  readonly listIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** mode of list item */
  readonly mode?: InputMaybe<CrmListModeEnum>;
  /** mode of list item */
  readonly modeIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListModeEnum>>>;
  /** mode of list item */
  readonly modeNotIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListModeEnum>>>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<CrmListToItemSearchFieldsEnum>>>;
  /** Search for CrmListToItems by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for CrmListToItems by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<CrmListToItemSearchFieldsEnum>>>;
  /** type of list item */
  readonly type?: InputMaybe<CrmListTypeEnum>;
  /** type of list item */
  readonly typeIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListTypeEnum>>>;
  /** type of list item */
  readonly typeNotIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListTypeEnum>>>;
};

/** Connection between the Contact type and the FormEntry type */
export type ContactToFormEntriesConnection = Connection & FormEntryConnection & {
  readonly __typename?: 'ContactToFormEntriesConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the ContactToFormEntriesConnection connection */
  readonly edges: ReadonlyArray<ContactToFormEntriesConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<FormEntry>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ContactToFormEntriesConnectionPageInfo;
};

/** An edge in a connection */
export type ContactToFormEntriesConnectionEdge = Edge & FormEntryConnectionEdge & {
  readonly __typename?: 'ContactToFormEntriesConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: FormEntry;
};

/** Pagination metadata specific to &quot;ContactToFormEntriesConnection&quot; collections. Provides cursors and flags for navigating through sets of ContactToFormEntriesConnection Nodes. */
export type ContactToFormEntriesConnectionPageInfo = FormEntryConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'ContactToFormEntriesConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the ContactToFormEntriesConnection connection */
export type ContactToFormEntriesConnectionWhereArgs = {
  /** company name */
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  /** country */
  readonly country?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** Email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** first name */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** Parent Form Id */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** Parent Form Id */
  readonly formIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Parent Form Id */
  readonly formIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Form title from which the entry was submitted */
  readonly formTitle?: InputMaybe<Scalars['String']['input']>;
  /** Form entry id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** Form entry id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Form entry id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** job title */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** last name */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** marketing consent */
  readonly marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** message */
  readonly message?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<FormEntrySearchFieldsEnum>>>;
  /** phone number */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Search for FormEntries by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for FormEntries by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<FormEntrySearchFieldsEnum>>>;
  /** Zngly visitor id */
  readonly visitorId?: InputMaybe<Scalars['String']['input']>;
};

/** Base interface for content objects like posts, pages, and media items. Provides common fields available across these content types. */
export type ContentNode = {
  /** Connection between the ContentNode type and the ContentType type */
  readonly contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  readonly contentTypeName: Scalars['String']['output'];
  /** The ID of the node in the database. */
  readonly databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  readonly date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  readonly dateGmt?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  readonly desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  readonly editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  readonly enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  readonly guid?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  readonly isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  readonly lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  readonly modifiedGmt?: Maybe<Scalars['String']['output']>;
  /** The database id of the preview node */
  readonly previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  readonly previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  readonly status?: Maybe<Scalars['String']['output']>;
  /** The template assigned to a node of content */
  readonly template?: Maybe<ContentTemplate>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};


/** Base interface for content objects like posts, pages, and media items. Provides common fields available across these content types. */
export type ContentNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Base interface for content objects like posts, pages, and media items. Provides common fields available across these content types. */
export type ContentNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated collection of ContentNode Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of ContentNode Nodes */
export type ContentNodeConnection = {
  /** A list of edges (relational context) between ContentType and connected ContentNode Nodes */
  readonly edges: ReadonlyArray<ContentNodeConnectionEdge>;
  /** A list of connected ContentNode Nodes */
  readonly nodes: ReadonlyArray<ContentNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ContentNodeConnectionPageInfo;
};

/** Represents a connection to a ContentNode. Contains both the ContentNode Node and metadata about the relationship. */
export type ContentNodeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected ContentNode Node */
  readonly node: ContentNode;
};

/** Pagination metadata specific to &quot;ContentNodeConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;ContentNodeConnectionEdge&quot; Nodes. */
export type ContentNodeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifier types for retrieving specific content. Determines which property (global ID, database ID, URI) is used to locate content objects. */
export enum ContentNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Connection between the ContentNode type and the ContentType type */
export type ContentNodeToContentTypeConnectionEdge = ContentTypeConnectionEdge & Edge & OneToOneConnection & {
  readonly __typename?: 'ContentNodeToContentTypeConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: ContentType;
};

/** Connection between the ContentNode type and the User type */
export type ContentNodeToEditLastConnectionEdge = Edge & OneToOneConnection & UserConnectionEdge & {
  readonly __typename?: 'ContentNodeToEditLastConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: User;
};

/** Connection between the ContentNode type and the User type */
export type ContentNodeToEditLockConnectionEdge = Edge & OneToOneConnection & UserConnectionEdge & {
  readonly __typename?: 'ContentNodeToEditLockConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The timestamp for when the node was last edited */
  readonly lockTimestamp?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: User;
};

/** Connection between the ContentNode type and the EnqueuedScript type */
export type ContentNodeToEnqueuedScriptConnection = Connection & EnqueuedScriptConnection & {
  readonly __typename?: 'ContentNodeToEnqueuedScriptConnection';
  /** Edges for the ContentNodeToEnqueuedScriptConnection connection */
  readonly edges: ReadonlyArray<ContentNodeToEnqueuedScriptConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<EnqueuedScript>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ContentNodeToEnqueuedScriptConnectionPageInfo;
};

/** An edge in a connection */
export type ContentNodeToEnqueuedScriptConnectionEdge = Edge & EnqueuedScriptConnectionEdge & {
  readonly __typename?: 'ContentNodeToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: EnqueuedScript;
};

/** Pagination metadata specific to &quot;ContentNodeToEnqueuedScriptConnection&quot; collections. Provides cursors and flags for navigating through sets of ContentNodeToEnqueuedScriptConnection Nodes. */
export type ContentNodeToEnqueuedScriptConnectionPageInfo = EnqueuedScriptConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'ContentNodeToEnqueuedScriptConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the ContentNode type and the EnqueuedStylesheet type */
export type ContentNodeToEnqueuedStylesheetConnection = Connection & EnqueuedStylesheetConnection & {
  readonly __typename?: 'ContentNodeToEnqueuedStylesheetConnection';
  /** Edges for the ContentNodeToEnqueuedStylesheetConnection connection */
  readonly edges: ReadonlyArray<ContentNodeToEnqueuedStylesheetConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ContentNodeToEnqueuedStylesheetConnectionPageInfo;
};

/** An edge in a connection */
export type ContentNodeToEnqueuedStylesheetConnectionEdge = Edge & EnqueuedStylesheetConnectionEdge & {
  readonly __typename?: 'ContentNodeToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: EnqueuedStylesheet;
};

/** Pagination metadata specific to &quot;ContentNodeToEnqueuedStylesheetConnection&quot; collections. Provides cursors and flags for navigating through sets of ContentNodeToEnqueuedStylesheetConnection Nodes. */
export type ContentNodeToEnqueuedStylesheetConnectionPageInfo = EnqueuedStylesheetConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'ContentNodeToEnqueuedStylesheetConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** A layout pattern that can help inform how content might be structured and displayed. Templates can define specialized layouts for different types of content. */
export type ContentTemplate = {
  /** The name of the template */
  readonly templateName?: Maybe<Scalars['String']['output']>;
};

/** An Post Type object */
export type ContentType = Node & UniformResourceIdentifiable & {
  readonly __typename?: 'ContentType';
  /** Whether this content type should can be exported. */
  readonly canExport?: Maybe<Scalars['Boolean']['output']>;
  /** Connection between the ContentType type and the Taxonomy type */
  readonly connectedTaxonomies?: Maybe<ContentTypeToTaxonomyConnection>;
  /** Connection between the ContentType type and the ContentNode type */
  readonly contentNodes?: Maybe<ContentTypeToContentNodeConnection>;
  /** Whether content of this type should be deleted when the author of it is deleted from the system. */
  readonly deleteWithUser?: Maybe<Scalars['Boolean']['output']>;
  /** Description of the content type. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Whether to exclude nodes of this content type from front end search results. */
  readonly excludeFromSearch?: Maybe<Scalars['Boolean']['output']>;
  /** The plural name of the content type within the GraphQL Schema. */
  readonly graphqlPluralName?: Maybe<Scalars['String']['output']>;
  /** The singular name of the content type within the GraphQL Schema. */
  readonly graphqlSingleName?: Maybe<Scalars['String']['output']>;
  /** Whether this content type should have archives. Content archives are generated by type and by date. */
  readonly hasArchive?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the content type is hierarchical, for example pages. */
  readonly hierarchical?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the post-type object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether this page is set to the static front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether this page is set to the blog posts page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** Display name of the content type. */
  readonly label?: Maybe<Scalars['String']['output']>;
  /** Details about the content type labels. */
  readonly labels?: Maybe<PostTypeLabelDetails>;
  /** The name of the icon file to display as a menu icon. */
  readonly menuIcon?: Maybe<Scalars['String']['output']>;
  /** The position of this post type in the menu. Only applies if show_in_menu is true. */
  readonly menuPosition?: Maybe<Scalars['Int']['output']>;
  /** The internal name of the post type. This should not be used for display purposes. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Whether a content type is intended for use publicly either via the admin interface or by front-end users. While the default settings of exclude_from_search, publicly_queryable, show_ui, and show_in_nav_menus are inherited from public, each does not rely on this relationship and controls a very specific intention. */
  readonly public?: Maybe<Scalars['Boolean']['output']>;
  /** Whether queries can be performed on the front end for the content type as part of parse_request(). */
  readonly publiclyQueryable?: Maybe<Scalars['Boolean']['output']>;
  /** Name of content type to display in REST API &quot;wp/v2&quot; namespace. */
  readonly restBase?: Maybe<Scalars['String']['output']>;
  /** The REST Controller class assigned to handling this content type. */
  readonly restControllerClass?: Maybe<Scalars['String']['output']>;
  /** Makes this content type available via the admin bar. */
  readonly showInAdminBar?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to add the content type to the GraphQL Schema. */
  readonly showInGraphql?: Maybe<Scalars['Boolean']['output']>;
  /** Where to show the content type in the admin menu. To work, $show_ui must be true. If true, the post type is shown in its own top level menu. If false, no menu is shown. If a string of an existing top level menu (eg. &quot;tools.php&quot; or &quot;edit.php?post_type=page&quot;), the post type will be placed as a sub-menu of that. */
  readonly showInMenu?: Maybe<Scalars['Boolean']['output']>;
  /** Makes this content type available for selection in navigation menus. */
  readonly showInNavMenus?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the content type is associated with a route under the the REST API &quot;wp/v2&quot; namespace. */
  readonly showInRest?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to generate and allow a UI for managing this content type in the admin. */
  readonly showUi?: Maybe<Scalars['Boolean']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};


/** An Post Type object */
export type ContentTypeConnectedTaxonomiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Post Type object */
export type ContentTypeContentNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTypeToContentNodeConnectionWhereArgs>;
};

/** A paginated collection of ContentType Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of ContentType Nodes */
export type ContentTypeConnection = {
  /** A list of edges (relational context) between RootQuery and connected ContentType Nodes */
  readonly edges: ReadonlyArray<ContentTypeConnectionEdge>;
  /** A list of connected ContentType Nodes */
  readonly nodes: ReadonlyArray<ContentType>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ContentTypeConnectionPageInfo;
};

/** Represents a connection to a ContentType. Contains both the ContentType Node and metadata about the relationship. */
export type ContentTypeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected ContentType Node */
  readonly node: ContentType;
};

/** Pagination metadata specific to &quot;ContentTypeConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;ContentTypeConnectionEdge&quot; Nodes. */
export type ContentTypeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Available content entity types that can be queried or filtered. Identifies the primary content structures available in the system. */
export enum ContentTypeEnum {
  /** The Type of Content object */
  Attachment = 'ATTACHMENT',
  /** The Type of Content object */
  DittoVideos = 'DITTO_VIDEOS',
  /** The Type of Content object */
  GraphqlDocument = 'GRAPHQL_DOCUMENT',
  /** The Type of Content object */
  Page = 'PAGE',
  /** The Type of Content object */
  Post = 'POST',
  /** The Type of Content object */
  Znglist = 'ZNGLIST',
  /** The Type of Content object */
  ZnglyInfo = 'ZNGLY_INFO'
}

/** Identifier types for retrieving a specific content type definition. Determines whether to look up content types by ID or name. */
export enum ContentTypeIdTypeEnum {
  /** The globally unique ID */
  Id = 'ID',
  /** The name of the content type. */
  Name = 'NAME'
}

/** Connection between the ContentType type and the ContentNode type */
export type ContentTypeToContentNodeConnection = Connection & ContentNodeConnection & {
  readonly __typename?: 'ContentTypeToContentNodeConnection';
  /** Edges for the ContentTypeToContentNodeConnection connection */
  readonly edges: ReadonlyArray<ContentTypeToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ContentNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ContentTypeToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type ContentTypeToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  readonly __typename?: 'ContentTypeToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ContentNode;
};

/** Pagination metadata specific to &quot;ContentTypeToContentNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of ContentTypeToContentNodeConnection Nodes. */
export type ContentTypeToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'ContentTypeToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the ContentTypeToContentNodeConnection connection */
export type ContentTypeToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  readonly contentTypes?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the ContentType type and the Taxonomy type */
export type ContentTypeToTaxonomyConnection = Connection & TaxonomyConnection & {
  readonly __typename?: 'ContentTypeToTaxonomyConnection';
  /** Edges for the ContentTypeToTaxonomyConnection connection */
  readonly edges: ReadonlyArray<ContentTypeToTaxonomyConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Taxonomy>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ContentTypeToTaxonomyConnectionPageInfo;
};

/** An edge in a connection */
export type ContentTypeToTaxonomyConnectionEdge = Edge & TaxonomyConnectionEdge & {
  readonly __typename?: 'ContentTypeToTaxonomyConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Taxonomy;
};

/** Pagination metadata specific to &quot;ContentTypeToTaxonomyConnection&quot; collections. Provides cursors and flags for navigating through sets of ContentTypeToTaxonomyConnection Nodes. */
export type ContentTypeToTaxonomyConnectionPageInfo = PageInfo & TaxonomyConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'ContentTypeToTaxonomyConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Allowed Content Types of the Category taxonomy. */
export enum ContentTypesOfCategoryEnum {
  /** The Type of Content object */
  DittoVideos = 'DITTO_VIDEOS',
  /** The Type of Content object */
  Post = 'POST'
}

/** Allowed Content Types of the GraphqlDocumentGroup taxonomy. */
export enum ContentTypesOfGraphqlDocumentGroupEnum {
  /** The Type of Content object */
  GraphqlDocument = 'GRAPHQL_DOCUMENT'
}

/** Allowed Content Types of the PostFormat taxonomy. */
export enum ContentTypesOfPostFormatEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** Allowed Content Types of the Tag taxonomy. */
export enum ContentTypesOfTagEnum {
  /** The Type of Content object */
  DittoVideos = 'DITTO_VIDEOS',
  /** The Type of Content object */
  Post = 'POST'
}

export type ConversationHistory = {
  readonly __typename?: 'ConversationHistory';
  /** Conversation history data */
  readonly data: ConversationHistoryData;
};

/** Conversation history response data */
export type ConversationHistoryData = {
  readonly __typename?: 'ConversationHistoryData';
  /** List of conversation messages */
  readonly messages: ReadonlyArray<Maybe<ConversationMessage>>;
  /** Summary of conversation history for context */
  readonly summary?: Maybe<Scalars['String']['output']>;
  /** Total number of messages */
  readonly totalMessages?: Maybe<Scalars['Int']['output']>;
};

/** A single message in the conversation history */
export type ConversationMessage = {
  readonly __typename?: 'ConversationMessage';
  /** Unique message identifier */
  readonly id?: Maybe<Scalars['String']['output']>;
  /** The message content */
  readonly message?: Maybe<Scalars['String']['output']>;
  /** Session identifier */
  readonly sessionId?: Maybe<Scalars['String']['output']>;
  /** Message source (user/bot) */
  readonly source?: Maybe<Scalars['String']['output']>;
  /** Message timestamp */
  readonly timestamp?: Maybe<Scalars['String']['output']>;
};

/** Input for the createCategory mutation. */
export type CreateCategoryInput = {
  /** The slug that the category will be an alias of */
  readonly aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the category object */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the category object to mutate */
  readonly name: Scalars['String']['input'];
  /** The database ID of the category that should be set as the parent. This field cannot be used in conjunction with parentId */
  readonly parentDatabaseId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the category that should be set as the parent. This field cannot be used in conjunction with parentDatabaseId */
  readonly parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Main video to appear when this sub-category is selected | ACF Type: post_object | Graphql Type: {"list_of":"ID"} */
  readonly pinnedContent?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: number | Graphql Type: Int */
  readonly uxOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** The payload for the createCategory mutation. */
export type CreateCategoryPayload = {
  readonly __typename?: 'CreateCategoryPayload';
  /** The created category */
  readonly category?: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Input for the createComment mutation. */
export type CreateCommentInput = {
  /** The name of the comment's author. */
  readonly author?: InputMaybe<Scalars['String']['input']>;
  /** The email of the comment's author. */
  readonly authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** The url of the comment's author. */
  readonly authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The database ID of the post object the comment belongs to. */
  readonly commentOn?: InputMaybe<Scalars['Int']['input']>;
  /** Content of the comment. */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day ( e.g. 01/31/2017 ) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** Parent comment ID of current comment. */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** The approval status of the comment */
  readonly status?: InputMaybe<CommentStatusEnum>;
  /** Type of comment. */
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createComment mutation. */
export type CreateCommentPayload = {
  readonly __typename?: 'CreateCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The comment that was created */
  readonly comment?: Maybe<Comment>;
  /** Whether the mutation succeeded. If the comment is not approved, the server will not return the comment to a non authenticated user, but a success message can be returned if the create succeeded, and the client can optimistically add the comment to the client cache */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

/** Create Input Type: Contact */
export type CreateContactInput = {
  /** Contact address line 1 */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Contact address line 2 */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Contact address line 3 */
  readonly addressLine3?: InputMaybe<Scalars['String']['input']>;
  /** Contact city */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** Contact company */
  readonly company?: InputMaybe<Scalars['String']['input']>;
  /** Contact country */
  readonly country?: InputMaybe<Scalars['String']['input']>;
  /** Contact county */
  readonly county?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** Contact email */
  readonly email: Scalars['String']['input'];
  /** Contact firstname */
  readonly firstname?: InputMaybe<Scalars['String']['input']>;
  /** Zngly ids */
  readonly ids?: InputMaybe<StringArrayInput>;
  /** Contact job title */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Contact lastname */
  readonly lastname?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  /** Contact phone */
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  /** Contact postal code */
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Contact properties */
  readonly properties?: InputMaybe<JsonKeyValueInput>;
  /** Contact region */
  readonly region?: InputMaybe<Scalars['String']['input']>;
  readonly setCrmListToItems?: InputMaybe<SetCrmListToItemsInput>;
};

/** The payload for the createContact mutation. */
export type CreateContactPayload = {
  readonly __typename?: 'CreateContactPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Create Mutation Output. Zngly Contacts */
  readonly contact?: Maybe<Contact>;
};

/** Create Input Type: CrmList */
export type CreateCrmListInput = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** List Metadata */
  readonly metadata?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  readonly setCrmListToItems?: InputMaybe<SetCrmListToItemsInput>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status settings of the post */
  readonly statusSettings?: InputMaybe<StatusSettingsInput>;
  /** The title of the post */
  readonly title: Scalars['String']['input'];
  /** type of list */
  readonly type?: InputMaybe<CrmListTypeEnum>;
};

/** The payload for the createCrmList mutation. */
export type CreateCrmListPayload = {
  readonly __typename?: 'CreateCrmListPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Create Mutation Output. Crm Lists */
  readonly crmList?: Maybe<CrmList>;
};

/** Create Input Type: FormEntry */
export type CreateFormEntryInput = {
  /** company name */
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  /** country */
  readonly country?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Extra data */
  readonly extraData?: InputMaybe<JsonKeyValueInput>;
  /** first name */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** Parent Form Id */
  readonly formId: Scalars['ID']['input'];
  /** Form title from which the entry was submitted */
  readonly formTitle?: InputMaybe<Scalars['String']['input']>;
  /** job title */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** last name */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** marketing consent */
  readonly marketingConsent: Scalars['Boolean']['input'];
  /** message */
  readonly message?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  /** phone number */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Zngly visitor id */
  readonly visitorId?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createFormEntry mutation. */
export type CreateFormEntryPayload = {
  readonly __typename?: 'CreateFormEntryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Create Mutation Output. This is a form entry */
  readonly formEntry?: Maybe<FormEntry>;
};

/** Create Input Type: Form */
export type CreateFormInput = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** description of the form */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** email metadata */
  readonly email?: InputMaybe<EmailSettingsInput>;
  /** image url of the form */
  readonly imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** marketing consent */
  readonly marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** metadata of the form */
  readonly metadata?: InputMaybe<FormMetadataInput>;
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  /** The password to access the form */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** schema of the form */
  readonly schema?: InputMaybe<Scalars['String']['input']>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status settings of the post */
  readonly statusSettings?: InputMaybe<StatusSettingsInput>;
  /** The title of the post */
  readonly title: Scalars['String']['input'];
  /** ui schema of the form */
  readonly uiSchema?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createForm mutation. */
export type CreateFormPayload = {
  readonly __typename?: 'CreateFormPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Create Mutation Output. Zngly Forms */
  readonly form?: Maybe<Form>;
};

/** Input for the createGraphqlDocumentGroup mutation. */
export type CreateGraphqlDocumentGroupInput = {
  /** The slug that the graphql_document_group will be an alias of */
  readonly aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the graphql_document_group object */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the graphql_document_group object to mutate */
  readonly name: Scalars['String']['input'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createGraphqlDocumentGroup mutation. */
export type CreateGraphqlDocumentGroupPayload = {
  readonly __typename?: 'CreateGraphqlDocumentGroupPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created graphql_document_group */
  readonly graphqlDocumentGroup?: Maybe<GraphqlDocumentGroup>;
};

/** Input for the createGraphqlDocument mutation. */
export type CreateGraphqlDocumentInput = {
  /** Alias names for saved GraphQL query documents */
  readonly alias?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The content of the object */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** Description for the saved GraphQL document */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Allow, deny or default access grant for specific query */
  readonly grant?: InputMaybe<Scalars['String']['input']>;
  /** Set connections between the graphqlDocument and graphqlDocumentGroups */
  readonly graphqlDocumentGroups?: InputMaybe<GraphqlDocumentGraphqlDocumentGroupsInput>;
  /** HTTP Cache-Control max-age directive for a saved GraphQL document */
  readonly maxAgeHeader?: InputMaybe<Scalars['Int']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  readonly menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The password used to protect the content of the object */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the object */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createGraphqlDocument mutation. */
export type CreateGraphqlDocumentPayload = {
  readonly __typename?: 'CreateGraphqlDocumentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  readonly graphqlDocument?: Maybe<GraphqlDocument>;
};

/** Create Input Type: Hub */
export type CreateHubInput = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** description of the hub */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** group of the hub used to identify its category/tag/campaign */
  readonly group?: InputMaybe<Scalars['String']['input']>;
  /** metadata of the hub */
  readonly metadata?: InputMaybe<HubMetadataInput>;
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  /** order of the hubs */
  readonly postOrder?: InputMaybe<Scalars['Int']['input']>;
  readonly setConnectionHubToHps?: InputMaybe<SetConnectionHubToHpsInput>;
  /** The name (slug) for the post */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status settings of the post */
  readonly statusSettings?: InputMaybe<StatusSettingsInput>;
  /** template of the hub */
  readonly template?: InputMaybe<HubTemplateEnum>;
  /** The title of the post */
  readonly title: Scalars['String']['input'];
  /** User related to the hub */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
  /** User meta related to the hub */
  readonly userMeta?: InputMaybe<HubUserMetaInput>;
};

/** Create Input Type: HubPage */
export type CreateHubPageInput = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** page description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Form Id */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  readonly setConnectionHpToCs?: InputMaybe<SetConnectionHpToCsInput>;
  readonly setConnectionHubToHps?: InputMaybe<SetConnectionHubToHpsInput>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status settings of the post */
  readonly statusSettings?: InputMaybe<StatusSettingsInput>;
  /** The title of the post */
  readonly title: Scalars['String']['input'];
};

/** The payload for the createHubPage mutation. */
export type CreateHubPagePayload = {
  readonly __typename?: 'CreateHubPagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Create Mutation Output. Page for Hubs */
  readonly hubPage?: Maybe<HubPage>;
};

/** The payload for the createHub mutation. */
export type CreateHubPayload = {
  readonly __typename?: 'CreateHubPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Create Mutation Output. Hub */
  readonly hub?: Maybe<Hub>;
};

/** Input for the createMediaItem mutation. */
export type CreateMediaItemInput = {
  /** Alternative text to display when mediaItem is not displayed */
  readonly altText?: InputMaybe<Scalars['String']['input']>;
  /** The userId to assign as the author of the mediaItem */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The caption for the mediaItem */
  readonly caption?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment status for the mediaItem */
  readonly commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The date of the mediaItem */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** The date (in GMT zone) of the mediaItem */
  readonly dateGmt?: InputMaybe<Scalars['String']['input']>;
  /** Description of the mediaItem */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The file name of the mediaItem */
  readonly filePath?: InputMaybe<Scalars['String']['input']>;
  /** The file type of the mediaItem */
  readonly fileType?: InputMaybe<MimeTypeEnum>;
  /** The ID of the parent object */
  readonly parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The ping status for the mediaItem */
  readonly pingStatus?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the mediaItem */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the mediaItem */
  readonly status?: InputMaybe<MediaItemStatusEnum>;
  /** The title of the mediaItem */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createMediaItem mutation. */
export type CreateMediaItemPayload = {
  readonly __typename?: 'CreateMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The MediaItem object mutation type. */
  readonly mediaItem?: Maybe<MediaItem>;
};

/** Input for the createPage mutation. */
export type CreatePageInput = {
  /** The userId to assign as the author of the object */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment status for the object */
  readonly commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The content of the object */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  readonly menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the parent object */
  readonly parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The password used to protect the content of the object */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the object */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createPage mutation. */
export type CreatePagePayload = {
  readonly __typename?: 'CreatePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  readonly page?: Maybe<Page>;
};

/** Create Input Type: PostAccessRecipient */
export type CreatePostAccessRecipientInput = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** Email Domain */
  readonly domain: Scalars['String']['input'];
  /** Email */
  readonly email: Scalars['String']['input'];
  /** The date the post expires, in the site's timezone */
  readonly expiresAt?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the post this recipient has access to */
  readonly postId: Scalars['ID']['input'];
  /** Status of the post access recipient */
  readonly status: PostAccessRecipientStatusEnum;
  /** The type of the post */
  readonly type: Scalars['String']['input'];
};

/** The payload for the createPostAccessRecipient mutation. */
export type CreatePostAccessRecipientPayload = {
  readonly __typename?: 'CreatePostAccessRecipientPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Create Mutation Output. Table for storing post access recipients */
  readonly postAccessRecipient?: Maybe<PostAccessRecipient>;
};

/** Input for the createPostFormat mutation. */
export type CreatePostFormatInput = {
  /** The slug that the post_format will be an alias of */
  readonly aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the post_format object */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the post_format object to mutate */
  readonly name: Scalars['String']['input'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createPostFormat mutation. */
export type CreatePostFormatPayload = {
  readonly __typename?: 'CreatePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created post_format */
  readonly postFormat?: Maybe<PostFormat>;
};

/** Input for the createPost mutation. */
export type CreatePostInput = {
  /** The userId to assign as the author of the object */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** Set connections between the post and categories */
  readonly categories?: InputMaybe<PostCategoriesInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment status for the object */
  readonly commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The content of the object */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** The excerpt of the object */
  readonly excerpt?: InputMaybe<Scalars['String']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  readonly menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The password used to protect the content of the object */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** The ping status for the object */
  readonly pingStatus?: InputMaybe<Scalars['String']['input']>;
  /** URLs that have been pinged. */
  readonly pinged?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Set connections between the post and postFormats */
  readonly postFormats?: InputMaybe<PostPostFormatsInput>;
  /** The slug of the object */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** Set connections between the post and tags */
  readonly tags?: InputMaybe<PostTagsInput>;
  /** The title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** URLs queued to be pinged. */
  readonly toPing?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

/** The payload for the createPost mutation. */
export type CreatePostPayload = {
  readonly __typename?: 'CreatePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  readonly post?: Maybe<Post>;
};

/** Input for the createTag mutation. */
export type CreateTagInput = {
  /** The slug that the post_tag will be an alias of */
  readonly aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the post_tag object */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the post_tag object to mutate */
  readonly name: Scalars['String']['input'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createTag mutation. */
export type CreateTagPayload = {
  readonly __typename?: 'CreateTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created post_tag */
  readonly tag?: Maybe<Tag>;
};

/** Input for the createUser mutation. */
export type CreateUserInput = {
  /** User's AOL IM account. */
  readonly aim?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A string containing content about the user. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  readonly displayName?: InputMaybe<Scalars['String']['input']>;
  /** A string containing the user's email address. */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** The user's first name. */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** User's Jabber account. */
  readonly jabber?: InputMaybe<Scalars['String']['input']>;
  /** The title of the user's job role | ACF Type: text | Graphql Type: String */
  readonly jobRole?: InputMaybe<Scalars['String']['input']>;
  /** The user's last name. */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** User's locale. */
  readonly locale?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  readonly nicename?: InputMaybe<Scalars['String']['input']>;
  /** The user's nickname, defaults to the user's username. */
  readonly nickname?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains the plain text password for the user. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: repeater | Graphql Type: {"list_of":"User_Meta_ProfileArticleLinks_RepeaterInput"} */
  readonly profileArticleLinks?: InputMaybe<ReadonlyArray<InputMaybe<User_Meta_ProfileArticleLinks_RepeaterInput>>>;
  /** The profile image of the user | ACF Type: image | Graphql Type: ID */
  readonly profileImage?: InputMaybe<Scalars['ID']['input']>;
  /** ACF Type: repeater | Graphql Type: {"list_of":"User_Meta_ProfileSocialLinks_RepeaterInput"} */
  readonly profileSocialLinks?: InputMaybe<ReadonlyArray<InputMaybe<User_Meta_ProfileSocialLinks_RepeaterInput>>>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  readonly registered?: InputMaybe<Scalars['String']['input']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  readonly richEditing?: InputMaybe<Scalars['String']['input']>;
  /** An array of roles to be assigned to the user. */
  readonly roles?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** A string that contains the user's username for logging in. */
  readonly username: Scalars['String']['input'];
  /** A string containing the user's URL for the user's web site. */
  readonly websiteUrl?: InputMaybe<Scalars['String']['input']>;
  /** User's Yahoo IM account. */
  readonly yim?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createUser mutation. */
export type CreateUserPayload = {
  readonly __typename?: 'CreateUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The User object mutation type. */
  readonly user?: Maybe<User>;
};

/** Input for the createZnglist mutation. */
export type CreateZnglistInput = {
  /** The userId to assign as the author of the object */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** Restrict the content. A Form must be completed before the content can be accessed. | ACF Type: number | Graphql Type: ID */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  readonly menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** ACF Type: number | Graphql Type: Int */
  readonly order?: InputMaybe<Scalars['Int']['input']>;
  /** The password used to protect the content of the object */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the object */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly statusSettings?: InputMaybe<StatusSettingsInput>;
  /** ACF Type: select | Graphql Type: ZnglistTemplateTypeEnum */
  readonly templateType?: InputMaybe<ZnglistTemplateTypeEnum>;
  /** The title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: select | Graphql Type: ZnglistUserTypeEnum */
  readonly userType?: InputMaybe<ZnglistUserTypeEnum>;
  /** ACF Type: post_object | Graphql Type: {"list_of":"ID"} */
  readonly znglyContents?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
};

/** The payload for the createZnglist mutation. */
export type CreateZnglistPayload = {
  readonly __typename?: 'CreateZnglistPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  readonly znglist?: Maybe<Znglist>;
};

/** Input for the createZnglyVideo mutation. */
export type CreateZnglyVideoInput = {
  /** The AI Summary of the content. | ACF Type: text | Graphql Type: String */
  readonly aiSummary?: InputMaybe<Scalars['String']['input']>;
  /** The userId to assign as the author of the object */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** Set connections between the znglyVideo and categories */
  readonly categories?: InputMaybe<ZnglyVideoCategoriesInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The content of the object */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The HTML code for the embed. | ACF Type: text | Graphql Type: String */
  readonly contentEmbedHtml?: InputMaybe<Scalars['String']['input']>;
  /** File Must be one of [pdf, jpg, png, jpeg, gif, mp4] Types | ACF Type: file | Graphql Type: ID */
  readonly contentFile?: InputMaybe<Scalars['ID']['input']>;
  /** Link to the content. | ACF Type: text | Graphql Type: String */
  readonly contentLink?: InputMaybe<Scalars['String']['input']>;
  /** mp4/vimeo/png etc... | ACF Type: text | Graphql Type: ZnglyVideoMediaNameEnum */
  readonly contentMediaName?: InputMaybe<ZnglyVideoMediaNameEnum>;
  /** embed/file/external | ACF Type: text | Graphql Type: ZnglyVideoPostTypeEnum */
  readonly contentMediaType?: InputMaybe<ZnglyVideoPostTypeEnum>;
  /** ACF Type: text | Graphql Type: String */
  readonly ctaLink?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly ctaName?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** The excerpt of the object */
  readonly excerpt?: InputMaybe<Scalars['String']['input']>;
  /** File Must be one of [pdf, jpg, png, jpeg, gif, mp4] Types | ACF Type: file | Graphql Type: ID */
  readonly featuredImageFile?: InputMaybe<Scalars['ID']['input']>;
  /** Link to the Featured Image. | ACF Type: text | Graphql Type: String */
  readonly featuredImageLink?: InputMaybe<Scalars['String']['input']>;
  /** Restrict the content. A Form must be completed before the content can be accessed. | ACF Type: number | Graphql Type: ID */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** ACF Type: wysiwyg | Graphql Type: String */
  readonly htmlDesc?: InputMaybe<Scalars['String']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  readonly menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The password used to protect the content of the object */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: textarea | Graphql Type: String */
  readonly shortText?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the object */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly statusSettings?: InputMaybe<StatusSettingsInput>;
  /** Set connections between the znglyVideo and tags */
  readonly tags?: InputMaybe<ZnglyVideoTagsInput>;
  /** The title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** The Duration of a Video. | ACF Type: text | Graphql Type: String */
  readonly videoDuration?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createZnglyVideo mutation. */
export type CreateZnglyVideoPayload = {
  readonly __typename?: 'CreateZnglyVideoPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  readonly znglyVideo?: Maybe<ZnglyVideo>;
};

/** Crm Lists */
export type CrmList = Node & NodeWizAuthor & ZnNode & {
  readonly __typename?: 'CrmList';
  /** Connection between the NodeWizAuthor type and the User type */
  readonly author?: Maybe<NodeWizAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The ID of the author of the post */
  readonly authorId?: Maybe<Scalars['ID']['output']>;
  /** The content of the post */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** The date the post was created, in the site&#039;s timezone */
  readonly created?: Maybe<Scalars['String']['output']>;
  /** Connection between the CrmList type and the CrmListToItem type */
  readonly crmListToItems?: Maybe<CrmListToCrmListToItemsConnection>;
  /** The unique identifier stored in the database */
  readonly databaseId?: Maybe<Scalars['Int']['output']>;
  /** list id */
  readonly id: Scalars['ID']['output'];
  /** List Metadata */
  readonly metadata?: Maybe<Scalars['String']['output']>;
  /** The date the post was last modified, in the site&#039;s timezone */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The status of the post */
  readonly status?: Maybe<PostStatusEnum>;
  /** The status settings of the post */
  readonly statusSettings?: Maybe<StatusSettings>;
  /** The title of the post */
  readonly title: Scalars['String']['output'];
  /** type of list */
  readonly type?: Maybe<CrmListTypeEnum>;
};


/** Crm Lists */
export type CrmListCrmListToItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CrmListToCrmListToItemsConnectionWhereArgs>;
};

/** A paginated collection of CrmList Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of CrmList Nodes */
export type CrmListConnection = {
  /** A list of edges (relational context) between RootQuery and connected CrmList Nodes */
  readonly edges: ReadonlyArray<CrmListConnectionEdge>;
  /** A list of connected CrmList Nodes */
  readonly nodes: ReadonlyArray<CrmList>;
  /** Information about pagination in a connection. */
  readonly pageInfo: CrmListConnectionPageInfo;
};

/** Represents a connection to a CrmList. Contains both the CrmList Node and metadata about the relationship. */
export type CrmListConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected CrmList Node */
  readonly node: CrmList;
};

/** Pagination metadata specific to &quot;CrmListConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;CrmListConnectionEdge&quot; Nodes. */
export type CrmListConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** The type of ID for CrmList */
export enum CrmListIdType {
  Id = 'ID'
}

/** CRM List Mode Enum */
export enum CrmListModeEnum {
  /** FILTER type */
  Filter = 'FILTER',
  /** HANDPICK type */
  Handpick = 'HANDPICK',
  /** IMPORT type */
  Import = 'IMPORT'
}

/** CrmLists Search Fields Enum */
export enum CrmListSearchFieldsEnum {
  /** The ID of the author of the post */
  AuthorId = 'AuthorId',
  /** The content of the post */
  Content = 'Content',
  /** The date the post was created, in the site's timezone */
  Created = 'Created',
  /** list id */
  Id = 'Id',
  /** List Metadata */
  Metadata = 'Metadata',
  /** The date the post was last modified, in the site's timezone */
  Modified = 'Modified',
  /** The status of the post */
  Status = 'Status',
  /** The status settings of the post */
  StatusSettings = 'StatusSettings',
  /** The title of the post */
  Title = 'Title',
  /** type of list */
  Type = 'Type'
}

/** Connection between the CrmList type and the CrmListToItem type */
export type CrmListToCrmListToItemsConnection = Connection & CrmListToItemConnection & {
  readonly __typename?: 'CrmListToCrmListToItemsConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the CrmListToCrmListToItemsConnection connection */
  readonly edges: ReadonlyArray<CrmListToCrmListToItemsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<CrmListToItem>;
  /** Information about pagination in a connection. */
  readonly pageInfo: CrmListToCrmListToItemsConnectionPageInfo;
};

/** An edge in a connection */
export type CrmListToCrmListToItemsConnectionEdge = CrmListToItemConnectionEdge & Edge & {
  readonly __typename?: 'CrmListToCrmListToItemsConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: CrmListToItem;
};

/** Pagination metadata specific to &quot;CrmListToCrmListToItemsConnection&quot; collections. Provides cursors and flags for navigating through sets of CrmListToCrmListToItemsConnection Nodes. */
export type CrmListToCrmListToItemsConnectionPageInfo = CrmListToItemConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'CrmListToCrmListToItemsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the CrmListToCrmListToItemsConnection connection */
export type CrmListToCrmListToItemsConnectionWhereArgs = {
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** weak table id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** weak table id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** weak table id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Item Id */
  readonly itemId?: InputMaybe<Scalars['ID']['input']>;
  /** Item Id */
  readonly itemIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Item Id */
  readonly itemIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** List Id */
  readonly listId?: InputMaybe<Scalars['ID']['input']>;
  /** List Id */
  readonly listIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** List Id */
  readonly listIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** mode of list item */
  readonly mode?: InputMaybe<CrmListModeEnum>;
  /** mode of list item */
  readonly modeIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListModeEnum>>>;
  /** mode of list item */
  readonly modeNotIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListModeEnum>>>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<CrmListToItemSearchFieldsEnum>>>;
  /** Search for CrmListToItems by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for CrmListToItems by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<CrmListToItemSearchFieldsEnum>>>;
  /** type of list item */
  readonly type?: InputMaybe<CrmListTypeEnum>;
  /** type of list item */
  readonly typeIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListTypeEnum>>>;
  /** type of list item */
  readonly typeNotIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListTypeEnum>>>;
};

/** Crm List To Items Relationship */
export type CrmListToItem = Node & ZnNode & {
  readonly __typename?: 'CrmListToItem';
  /** Connection between the CrmListToItem type and the Contact type */
  readonly contact?: Maybe<CrmListToItemToContactConnectionEdge>;
  /** The date the post was created, in the site&#039;s timezone */
  readonly created?: Maybe<Scalars['String']['output']>;
  /** Connection between the CrmListToItem type and the CrmList type */
  readonly crmList?: Maybe<CrmListToItemToCrmListConnectionEdge>;
  /** The unique identifier stored in the database */
  readonly databaseId?: Maybe<Scalars['Int']['output']>;
  /** weak table id */
  readonly id: Scalars['ID']['output'];
  /** Item Id */
  readonly itemId?: Maybe<Scalars['ID']['output']>;
  /** List Id */
  readonly listId?: Maybe<Scalars['ID']['output']>;
  /** mode of list item */
  readonly mode?: Maybe<CrmListModeEnum>;
  /** The date the post was last modified, in the site&#039;s timezone */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** type of list item */
  readonly type: CrmListTypeEnum;
};


/** Crm List To Items Relationship */
export type CrmListToItemContactArgs = {
  where?: InputMaybe<CrmListToItemToContactConnectionWhereArgs>;
};


/** Crm List To Items Relationship */
export type CrmListToItemCrmListArgs = {
  where?: InputMaybe<CrmListToItemToCrmListConnectionWhereArgs>;
};

/** A paginated collection of CrmListToItem Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of CrmListToItem Nodes */
export type CrmListToItemConnection = {
  /** A list of edges (relational context) between Contact and connected CrmListToItem Nodes */
  readonly edges: ReadonlyArray<CrmListToItemConnectionEdge>;
  /** A list of connected CrmListToItem Nodes */
  readonly nodes: ReadonlyArray<CrmListToItem>;
  /** Information about pagination in a connection. */
  readonly pageInfo: CrmListToItemConnectionPageInfo;
};

/** Represents a connection to a CrmListToItem. Contains both the CrmListToItem Node and metadata about the relationship. */
export type CrmListToItemConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected CrmListToItem Node */
  readonly node: CrmListToItem;
};

/** Pagination metadata specific to &quot;CrmListToItemConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;CrmListToItemConnectionEdge&quot; Nodes. */
export type CrmListToItemConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** The type of ID for CrmListToItem */
export enum CrmListToItemIdType {
  Id = 'ID'
}

/** CrmListToItems Search Fields Enum */
export enum CrmListToItemSearchFieldsEnum {
  /** The date the post was created, in the site's timezone */
  Created = 'Created',
  /** weak table id */
  Id = 'Id',
  /** Item Id */
  ItemId = 'ItemId',
  /** List Id */
  ListId = 'ListId',
  /** mode of list item */
  Mode = 'Mode',
  /** The date the post was last modified, in the site's timezone */
  Modified = 'Modified',
  /** type of list item */
  Type = 'Type'
}

/** Connection between the CrmListToItem type and the Contact type */
export type CrmListToItemToContactConnectionEdge = ContactConnectionEdge & Edge & OneToOneConnection & {
  readonly __typename?: 'CrmListToItemToContactConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Contact;
};

/** Arguments for filtering the CrmListToItemToContactConnection connection */
export type CrmListToItemToContactConnectionWhereArgs = {
  /** Contact address line 1 */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Contact address line 2 */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Contact address line 3 */
  readonly addressLine3?: InputMaybe<Scalars['String']['input']>;
  /** Contact city */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** Contact company */
  readonly company?: InputMaybe<Scalars['String']['input']>;
  /** Contact country */
  readonly country?: InputMaybe<Scalars['String']['input']>;
  /** Contact county */
  readonly county?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** Contact email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Contact firstname */
  readonly firstname?: InputMaybe<Scalars['String']['input']>;
  /** contact id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** contact id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** contact id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Contact job title */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Contact lastname */
  readonly lastname?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<ContactSearchFieldsEnum>>>;
  /** Contact phone */
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  /** Contact postal code */
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Contact region */
  readonly region?: InputMaybe<Scalars['String']['input']>;
  /** Search for Contacts by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for Contacts by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<ContactSearchFieldsEnum>>>;
};

/** Connection between the CrmListToItem type and the CrmList type */
export type CrmListToItemToCrmListConnectionEdge = CrmListConnectionEdge & Edge & OneToOneConnection & {
  readonly __typename?: 'CrmListToItemToCrmListConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: CrmList;
};

/** Arguments for filtering the CrmListToItemToCrmListConnection connection */
export type CrmListToItemToCrmListConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** list id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** list id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** list id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** List Metadata */
  readonly metadata?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<CrmListSearchFieldsEnum>>>;
  /** Search for CrmLists by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for CrmLists by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<CrmListSearchFieldsEnum>>>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status of the post */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The status of the post */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** type of list */
  readonly type?: InputMaybe<CrmListTypeEnum>;
  /** type of list */
  readonly typeIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListTypeEnum>>>;
  /** type of list */
  readonly typeNotIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListTypeEnum>>>;
};

/** CRM List Type Enum */
export enum CrmListTypeEnum {
  /** CONTACT type */
  Contact = 'CONTACT'
}

export type CsvExport = {
  readonly __typename?: 'CsvExport';
  /** Get HubSpot ID */
  readonly csv?: Maybe<Scalars['String']['output']>;
};

export type CsvExportQueryInput = {
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly categoryIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** posts by date */
  readonly date?: InputMaybe<DateQueryInput>;
  /** Filter hubs by filter */
  readonly hubFilter?: InputMaybe<Scalars['String']['input']>;
  /** Filter hubs by group */
  readonly hubGroup?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Filter hubs by template */
  readonly hubTemplate?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** posts by ID */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Catalog, Znglist */
  readonly queryType: CsvExportQueryTypeEnum;
  /** Search for a post by title */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** posts by status */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
};

/** The type of query to run for the CSV export */
export enum CsvExportQueryTypeEnum {
  /** CATALOG type */
  Catalog = 'CATALOG',
  /** HUB type */
  Hub = 'HUB',
  /** HUB_PAGE type */
  HubPage = 'HUB_PAGE',
  /** ZNGLIST type */
  Znglist = 'ZNGLIST'
}

/** An object that has a unique numeric identifier in the database. Provides consistent access to the database ID across different object types. */
export type DatabaseIdentifier = {
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
};

/** Date values */
export type DateInput = {
  /** Day of the month (from 1 to 31) */
  readonly day?: InputMaybe<Scalars['Int']['input']>;
  /** Month number (from 1 to 12) */
  readonly month?: InputMaybe<Scalars['Int']['input']>;
  /** 4 digit year (e.g. 2017) */
  readonly year?: InputMaybe<Scalars['Int']['input']>;
};

/** Filter the connection based on input */
export type DateQueryInput = {
  /** Nodes should be returned after this date */
  readonly after?: InputMaybe<DateInput>;
  /** Nodes should be returned before this date */
  readonly before?: InputMaybe<DateInput>;
  /** Column to query against */
  readonly column?: InputMaybe<PostObjectsConnectionDateColumnEnum>;
  /** For after/before, whether exact value should be matched or not */
  readonly compare?: InputMaybe<Scalars['String']['input']>;
  /** Day of the month (from 1 to 31) */
  readonly day?: InputMaybe<Scalars['Int']['input']>;
  /** Hour (from 0 to 23) */
  readonly hour?: InputMaybe<Scalars['Int']['input']>;
  /** For after/before, whether exact value should be matched or not */
  readonly inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minute (from 0 to 59) */
  readonly minute?: InputMaybe<Scalars['Int']['input']>;
  /** Month number (from 1 to 12) */
  readonly month?: InputMaybe<Scalars['Int']['input']>;
  /** OR or AND, how the sub-arrays should be compared */
  readonly relation?: InputMaybe<RelationEnum>;
  /** Second (0 to 59) */
  readonly second?: InputMaybe<Scalars['Int']['input']>;
  /** Week of the year (from 0 to 53) */
  readonly week?: InputMaybe<Scalars['Int']['input']>;
  /** 4 digit year (e.g. 2017) */
  readonly year?: InputMaybe<Scalars['Int']['input']>;
};

/** The template assigned to the node */
export type DefaultTemplate = ContentTemplate & {
  readonly __typename?: 'DefaultTemplate';
  /** The name of the template */
  readonly templateName?: Maybe<Scalars['String']['output']>;
};

/** Input for the deleteCategory mutation. */
export type DeleteCategoryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the category to delete */
  readonly id: Scalars['ID']['input'];
};

/** The payload for the deleteCategory mutation. */
export type DeleteCategoryPayload = {
  readonly __typename?: 'DeleteCategoryPayload';
  /** The deleted term object */
  readonly category?: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Input for the deleteComment mutation. */
export type DeleteCommentInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the comment should be force deleted instead of being moved to the trash */
  readonly forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The deleted comment ID */
  readonly id: Scalars['ID']['input'];
};

/** The payload for the deleteComment mutation. */
export type DeleteCommentPayload = {
  readonly __typename?: 'DeleteCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The deleted comment object */
  readonly comment?: Maybe<Comment>;
  /** The deleted comment ID */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Input for the deleteContact mutation. */
export type DeleteContactInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Contact to delete */
  readonly id: Scalars['ID']['input'];
};

/** The payload for the deleteContact mutation. */
export type DeleteContactPayload = {
  readonly __typename?: 'DeleteContactPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The object before it was deleted. Zngly Contacts */
  readonly contact?: Maybe<Contact>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Input for the deleteCrmList mutation. */
export type DeleteCrmListInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the CrmList to delete */
  readonly id: Scalars['ID']['input'];
};

/** The payload for the deleteCrmList mutation. */
export type DeleteCrmListPayload = {
  readonly __typename?: 'DeleteCrmListPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The object before it was deleted. Crm Lists */
  readonly crmList?: Maybe<CrmList>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Input for the deleteFormEntry mutation. */
export type DeleteFormEntryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the FormEntry to delete */
  readonly id: Scalars['ID']['input'];
};

/** The payload for the deleteFormEntry mutation. */
export type DeleteFormEntryPayload = {
  readonly __typename?: 'DeleteFormEntryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The object before it was deleted. This is a form entry */
  readonly formEntry?: Maybe<FormEntry>;
};

/** Input for the deleteForm mutation. */
export type DeleteFormInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Form to delete */
  readonly id: Scalars['ID']['input'];
};

/** The payload for the deleteForm mutation. */
export type DeleteFormPayload = {
  readonly __typename?: 'DeleteFormPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The object before it was deleted. Zngly Forms */
  readonly form?: Maybe<Form>;
};

/** Input for the deleteGraphqlDocumentGroup mutation. */
export type DeleteGraphqlDocumentGroupInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the graphqlDocumentGroup to delete */
  readonly id: Scalars['ID']['input'];
};

/** The payload for the deleteGraphqlDocumentGroup mutation. */
export type DeleteGraphqlDocumentGroupPayload = {
  readonly __typename?: 'DeleteGraphqlDocumentGroupPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The deleted term object */
  readonly graphqlDocumentGroup?: Maybe<GraphqlDocumentGroup>;
};

/** Input for the deleteGraphqlDocument mutation. */
export type DeleteGraphqlDocumentInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  readonly forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the graphqlDocument to delete */
  readonly id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  readonly ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the deleteGraphqlDocument mutation. */
export type DeleteGraphqlDocumentPayload = {
  readonly __typename?: 'DeleteGraphqlDocumentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The object before it was deleted */
  readonly graphqlDocument?: Maybe<GraphqlDocument>;
};

/** Input for the deleteHub mutation. */
export type DeleteHubInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Hub to delete */
  readonly id: Scalars['ID']['input'];
};

/** Input for the deleteHubPage mutation. */
export type DeleteHubPageInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the HubPage to delete */
  readonly id: Scalars['ID']['input'];
};

/** The payload for the deleteHubPage mutation. */
export type DeleteHubPagePayload = {
  readonly __typename?: 'DeleteHubPagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The object before it was deleted. Page for Hubs */
  readonly hubPage?: Maybe<HubPage>;
};

/** The payload for the deleteHub mutation. */
export type DeleteHubPayload = {
  readonly __typename?: 'DeleteHubPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The object before it was deleted. Hub */
  readonly hub?: Maybe<Hub>;
};

/** Input for the deleteMediaItem mutation. */
export type DeleteMediaItemInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the mediaItem should be force deleted instead of being moved to the trash */
  readonly forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the mediaItem to delete */
  readonly id: Scalars['ID']['input'];
};

/** The payload for the deleteMediaItem mutation. */
export type DeleteMediaItemPayload = {
  readonly __typename?: 'DeleteMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted mediaItem */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The mediaItem before it was deleted */
  readonly mediaItem?: Maybe<MediaItem>;
};

/** Input for the deletePage mutation. */
export type DeletePageInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  readonly forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the page to delete */
  readonly id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  readonly ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the deletePage mutation. */
export type DeletePagePayload = {
  readonly __typename?: 'DeletePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The object before it was deleted */
  readonly page?: Maybe<Page>;
};

/** Input for the deletePostAccessRecipient mutation. */
export type DeletePostAccessRecipientInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the PostAccessRecipient to delete */
  readonly id: Scalars['ID']['input'];
};

/** The payload for the deletePostAccessRecipient mutation. */
export type DeletePostAccessRecipientPayload = {
  readonly __typename?: 'DeletePostAccessRecipientPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The object before it was deleted. Table for storing post access recipients */
  readonly postAccessRecipient?: Maybe<PostAccessRecipient>;
};

/** Input for the deletePostFormat mutation. */
export type DeletePostFormatInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the postFormat to delete */
  readonly id: Scalars['ID']['input'];
};

/** The payload for the deletePostFormat mutation. */
export type DeletePostFormatPayload = {
  readonly __typename?: 'DeletePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The deleted term object */
  readonly postFormat?: Maybe<PostFormat>;
};

/** Input for the deletePost mutation. */
export type DeletePostInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  readonly forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the post to delete */
  readonly id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  readonly ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the deletePost mutation. */
export type DeletePostPayload = {
  readonly __typename?: 'DeletePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The object before it was deleted */
  readonly post?: Maybe<Post>;
};

/** Input for the deleteTag mutation. */
export type DeleteTagInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the tag to delete */
  readonly id: Scalars['ID']['input'];
};

/** The payload for the deleteTag mutation. */
export type DeleteTagPayload = {
  readonly __typename?: 'DeleteTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The deleted term object */
  readonly tag?: Maybe<Tag>;
};

/** Input for the deleteUser mutation. */
export type DeleteUserInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user you want to delete */
  readonly id: Scalars['ID']['input'];
  /** Reassign posts and links to new User ID. */
  readonly reassignId?: InputMaybe<Scalars['ID']['input']>;
};

/** The payload for the deleteUser mutation. */
export type DeleteUserPayload = {
  readonly __typename?: 'DeleteUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the user that you just deleted */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The deleted user object */
  readonly user?: Maybe<User>;
};

/** Input for the deleteZnglist mutation. */
export type DeleteZnglistInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  readonly forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the znglist to delete */
  readonly id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  readonly ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the deleteZnglist mutation. */
export type DeleteZnglistPayload = {
  readonly __typename?: 'DeleteZnglistPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The object before it was deleted */
  readonly znglist?: Maybe<Znglist>;
};

/** Input for the deleteZnglyVideoExtra mutation. */
export type DeleteZnglyVideoExtraInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deleteFile?: InputMaybe<Scalars['Boolean']['input']>;
  readonly deleteImage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** The payload for the deleteZnglyVideoExtra mutation. */
export type DeleteZnglyVideoExtraPayload = {
  readonly __typename?: 'DeleteZnglyVideoExtraPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Input for the deleteZnglyVideo mutation. */
export type DeleteZnglyVideoInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  readonly forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the znglyVideo to delete */
  readonly id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  readonly ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the deleteZnglyVideo mutation. */
export type DeleteZnglyVideoPayload = {
  readonly __typename?: 'DeleteZnglyVideoPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The object before it was deleted */
  readonly znglyVideo?: Maybe<ZnglyVideo>;
};

/** The discussion setting type */
export type DiscussionSettings = {
  readonly __typename?: 'DiscussionSettings';
  /** Allow people to submit comments on new posts. */
  readonly defaultCommentStatus?: Maybe<Scalars['String']['output']>;
  /** Allow link notifications from other blogs (pingbacks and trackbacks) on new articles. */
  readonly defaultPingStatus?: Maybe<Scalars['String']['output']>;
};

/** Duplicate Input Type: CrmList */
export type DuplicateCrmListInput = {
  /** The ID of the item to duplicate */
  readonly id: Scalars['ID']['input'];
  /** The new item data */
  readonly node?: InputMaybe<CreateCrmListInput>;
  /** Options for the duplicate mutation */
  readonly options?: InputMaybe<DuplicateCrmList_OptionsInput>;
};

/** The payload for the duplicateCrmList mutation. */
export type DuplicateCrmListPayload = {
  readonly __typename?: 'DuplicateCrmListPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Duplicate Mutation Output. Crm Lists */
  readonly crmList?: Maybe<CrmList>;
};

/** Enum of all models that can be duplicated in this mutation */
export enum DuplicateCrmList_DbModelEnum {
  /** Zngly Contacts */
  Contact = 'Contact',
  /** Crm Lists */
  CrmList = 'CrmList',
  /** Crm List To Items Relationship */
  CrmListToItem = 'CrmListToItem',
  /** Zngly Forms */
  Form = 'Form',
  /** This is a form entry */
  FormEntry = 'FormEntry'
}

/** Options for the duplicate mutation */
export type DuplicateCrmList_OptionsInput = {
  readonly pathEnd?: InputMaybe<DuplicateCrmList_DbModelEnum>;
};

/** Duplicate Input Type: Hub */
export type DuplicateHubInput = {
  /** The ID of the item to duplicate */
  readonly id: Scalars['ID']['input'];
  /** The new item data */
  readonly node?: InputMaybe<CreateHubInput>;
  /** Options for the duplicate mutation */
  readonly options?: InputMaybe<DuplicateHub_OptionsInput>;
};

/** Duplicate Input Type: HubPage */
export type DuplicateHubPageInput = {
  /** The ID of the item to duplicate */
  readonly id: Scalars['ID']['input'];
  /** The new item data */
  readonly node?: InputMaybe<CreateHubPageInput>;
  /** Options for the duplicate mutation */
  readonly options?: InputMaybe<DuplicateHubPage_OptionsInput>;
};

/** The payload for the duplicateHubPage mutation. */
export type DuplicateHubPagePayload = {
  readonly __typename?: 'DuplicateHubPagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Duplicate Mutation Output. Page for Hubs */
  readonly hubPage?: Maybe<HubPage>;
};

/** Enum of all models that can be duplicated in this mutation */
export enum DuplicateHubPage_DbModelEnum {
  /** Hub Pages & Catalog Assets Connection */
  ConnectionHpToC = 'ConnectionHpToC',
  /** Hub to Hub Page Connection */
  ConnectionHubToHp = 'ConnectionHubToHp',
  /** Zngly Contacts */
  Contact = 'Contact',
  /** Crm Lists */
  CrmList = 'CrmList',
  /** Crm List To Items Relationship */
  CrmListToItem = 'CrmListToItem',
  /** Zngly Forms */
  Form = 'Form',
  /** This is a form entry */
  FormEntry = 'FormEntry',
  /** Hub */
  Hub = 'Hub',
  /** Page for Hubs */
  HubPage = 'HubPage',
  /** Table for storing post access recipients */
  PostAccessRecipient = 'PostAccessRecipient'
}

/** Options for the duplicate mutation */
export type DuplicateHubPage_OptionsInput = {
  readonly pathEnd?: InputMaybe<DuplicateHubPage_DbModelEnum>;
};

/** The payload for the duplicateHub mutation. */
export type DuplicateHubPayload = {
  readonly __typename?: 'DuplicateHubPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Duplicate Mutation Output. Hub */
  readonly hub?: Maybe<Hub>;
};

/** Enum of all models that can be duplicated in this mutation */
export enum DuplicateHub_DbModelEnum {
  /** Hub Pages & Catalog Assets Connection */
  ConnectionHpToC = 'ConnectionHpToC',
  /** Hub to Hub Page Connection */
  ConnectionHubToHp = 'ConnectionHubToHp',
  /** Zngly Contacts */
  Contact = 'Contact',
  /** Crm Lists */
  CrmList = 'CrmList',
  /** Crm List To Items Relationship */
  CrmListToItem = 'CrmListToItem',
  /** Zngly Forms */
  Form = 'Form',
  /** This is a form entry */
  FormEntry = 'FormEntry',
  /** Hub */
  Hub = 'Hub',
  /** Page for Hubs */
  HubPage = 'HubPage',
  /** Table for storing post access recipients */
  PostAccessRecipient = 'PostAccessRecipient'
}

/** Options for the duplicate mutation */
export type DuplicateHub_OptionsInput = {
  readonly pathEnd?: InputMaybe<DuplicateHub_DbModelEnum>;
};

/** Input for the duplicateZnglist mutation. */
export type DuplicateZnglistInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the item to duplicate */
  readonly id: Scalars['ID']['input'];
  /** The new item data */
  readonly node?: InputMaybe<CreateZnglistInput>;
};

/** The payload for the duplicateZnglist mutation. */
export type DuplicateZnglistPayload = {
  readonly __typename?: 'DuplicateZnglistPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  readonly znglist?: Maybe<Znglist>;
};

/** Input for the duplicateZnglyVideo mutation. */
export type DuplicateZnglyVideoInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the item to duplicate */
  readonly id: Scalars['ID']['input'];
  /** The new item data */
  readonly node?: InputMaybe<CreateZnglyVideoInput>;
};

/** The payload for the duplicateZnglyVideo mutation. */
export type DuplicateZnglyVideoPayload = {
  readonly __typename?: 'DuplicateZnglyVideoPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  readonly znglyVideo?: Maybe<ZnglyVideo>;
};

/** Represents a connection between two objects. Contains both the related object (node) and metadata about the relationship (cursor). */
export type Edge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected node */
  readonly node: Node;
};

/** Input for the emailSender mutation. */
export type EmailSenderInput = {
  /** Body of email */
  readonly body?: InputMaybe<Scalars['String']['input']>;
  /** CC address. Comma separated test1@test.com, test2@test.com */
  readonly cc?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** From address. From Test<test@test.com> */
  readonly from?: InputMaybe<Scalars['String']['input']>;
  /** Reply-to address. The default is the from address */
  readonly replyTo?: InputMaybe<Scalars['String']['input']>;
  /** Subject of email */
  readonly subject?: InputMaybe<Scalars['String']['input']>;
  /** Who to send the email to */
  readonly to?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Type of the email. Plain-Text or HTML */
  readonly type?: InputMaybe<EmailTypeEnum>;
};

/** The payload for the emailSender mutation. */
export type EmailSenderPayload = {
  readonly __typename?: 'EmailSenderPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Message */
  readonly message?: Maybe<Scalars['String']['output']>;
  /** Origin that sent the request */
  readonly origin?: Maybe<Scalars['String']['output']>;
  /** Was the email sent */
  readonly sent?: Maybe<Scalars['Boolean']['output']>;
  /** Who the email got sent to */
  readonly to?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** form email settings */
export type EmailSettings = {
  readonly __typename?: 'EmailSettings';
  /** form email settings field */
  readonly admins?: Maybe<EmailSettingsField>;
  /** form email settings field */
  readonly visitor?: Maybe<EmailSettingsField>;
};

/** form email settings field */
export type EmailSettingsField = {
  readonly __typename?: 'EmailSettingsField';
  readonly body?: Maybe<Scalars['String']['output']>;
  readonly emails?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly enabled?: Maybe<Scalars['Boolean']['output']>;
  readonly subject?: Maybe<Scalars['String']['output']>;
};

/** form email settings field */
export type EmailSettingsFieldInput = {
  readonly body?: InputMaybe<Scalars['String']['input']>;
  readonly emails?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly subject?: InputMaybe<Scalars['String']['input']>;
};

/** form email settings */
export type EmailSettingsInput = {
  /** form email settings field */
  readonly admins?: InputMaybe<EmailSettingsFieldInput>;
  /** form email settings field */
  readonly visitor?: InputMaybe<EmailSettingsFieldInput>;
};

/** Type of the email */
export enum EmailTypeEnum {
  Html = 'HTML',
  Plain = 'PLAIN'
}

/** Input for the emptyTrash mutation. */
export type EmptyTrashInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Type of the post */
  readonly postType: ZnglyPostTypeEnum;
};

/** The payload for the emptyTrash mutation. */
export type EmptyTrashPayload = {
  readonly __typename?: 'EmptyTrashPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** IDs */
  readonly ids?: Maybe<ReadonlyArray<Maybe<Scalars['ID']['output']>>>;
  /** Message */
  readonly message?: Maybe<Scalars['String']['output']>;
};

/** A script or stylesheet resource that should be loaded by the client. Contains information about the resource&#039;s location, dependencies, and loading behavior. */
export type EnqueuedAsset = {
  /** The inline code to be run after the asset is loaded. */
  readonly after?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /**
   * Deprecated
   * @deprecated Use `EnqueuedAsset.media` instead.
   */
  readonly args?: Maybe<Scalars['Boolean']['output']>;
  /** The inline code to be run before the asset is loaded. */
  readonly before?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** The HTML conditional comment for the enqueued asset. E.g. IE 6, lte IE 7, etc */
  readonly conditional?: Maybe<Scalars['String']['output']>;
  /** Dependencies needed to use this asset */
  readonly dependencies?: Maybe<ReadonlyArray<Maybe<EnqueuedAsset>>>;
  /**
   * Extra information needed for the script
   * @deprecated Use `EnqueuedScript.extraData` instead.
   */
  readonly extra?: Maybe<Scalars['String']['output']>;
  /** The loading group to which this asset belongs. */
  readonly group?: Maybe<Scalars['Int']['output']>;
  /** The handle of the enqueued asset */
  readonly handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the enqueued asset */
  readonly id: Scalars['ID']['output'];
  /** The source of the asset */
  readonly src?: Maybe<Scalars['String']['output']>;
  /** The version of the enqueued asset */
  readonly version?: Maybe<Scalars['String']['output']>;
};

/** Script enqueued by the CMS */
export type EnqueuedScript = EnqueuedAsset & Node & {
  readonly __typename?: 'EnqueuedScript';
  /** The inline code to be run after the asset is loaded. */
  readonly after?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /**
   * Deprecated
   * @deprecated Use `EnqueuedAsset.media` instead.
   */
  readonly args?: Maybe<Scalars['Boolean']['output']>;
  /** The inline code to be run before the asset is loaded. */
  readonly before?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** The HTML conditional comment for the enqueued asset. E.g. IE 6, lte IE 7, etc */
  readonly conditional?: Maybe<Scalars['String']['output']>;
  /** Dependencies needed to use this asset */
  readonly dependencies?: Maybe<ReadonlyArray<Maybe<EnqueuedScript>>>;
  /**
   * Extra information needed for the script
   * @deprecated Use `EnqueuedScript.extraData` instead.
   */
  readonly extra?: Maybe<Scalars['String']['output']>;
  /** Extra data supplied to the enqueued script */
  readonly extraData?: Maybe<Scalars['String']['output']>;
  /** The loading group to which this asset belongs. */
  readonly group?: Maybe<Scalars['Int']['output']>;
  /** The location where this script should be loaded */
  readonly groupLocation?: Maybe<ScriptLoadingGroupLocationEnum>;
  /** The handle of the enqueued asset */
  readonly handle?: Maybe<Scalars['String']['output']>;
  /** The global ID of the enqueued script */
  readonly id: Scalars['ID']['output'];
  /** The source of the asset */
  readonly src?: Maybe<Scalars['String']['output']>;
  /** The loading strategy to use on the script tag */
  readonly strategy?: Maybe<ScriptLoadingStrategyEnum>;
  /** The version of the enqueued script */
  readonly version?: Maybe<Scalars['String']['output']>;
};

/** A paginated collection of EnqueuedScript Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of EnqueuedScript Nodes */
export type EnqueuedScriptConnection = {
  /** A list of edges (relational context) between ContentNode and connected EnqueuedScript Nodes */
  readonly edges: ReadonlyArray<EnqueuedScriptConnectionEdge>;
  /** A list of connected EnqueuedScript Nodes */
  readonly nodes: ReadonlyArray<EnqueuedScript>;
  /** Information about pagination in a connection. */
  readonly pageInfo: EnqueuedScriptConnectionPageInfo;
};

/** Represents a connection to a EnqueuedScript. Contains both the EnqueuedScript Node and metadata about the relationship. */
export type EnqueuedScriptConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected EnqueuedScript Node */
  readonly node: EnqueuedScript;
};

/** Pagination metadata specific to &quot;EnqueuedScriptConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;EnqueuedScriptConnectionEdge&quot; Nodes. */
export type EnqueuedScriptConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Stylesheet enqueued by the CMS */
export type EnqueuedStylesheet = EnqueuedAsset & Node & {
  readonly __typename?: 'EnqueuedStylesheet';
  /** The inline code to be run after the asset is loaded. */
  readonly after?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /**
   * Deprecated
   * @deprecated Use `EnqueuedAsset.media` instead.
   */
  readonly args?: Maybe<Scalars['Boolean']['output']>;
  /** The inline code to be run before the asset is loaded. */
  readonly before?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** The HTML conditional comment for the enqueued asset. E.g. IE 6, lte IE 7, etc */
  readonly conditional?: Maybe<Scalars['String']['output']>;
  /** Dependencies needed to use this asset */
  readonly dependencies?: Maybe<ReadonlyArray<Maybe<EnqueuedStylesheet>>>;
  /**
   * Extra information needed for the script
   * @deprecated Use `EnqueuedScript.extraData` instead.
   */
  readonly extra?: Maybe<Scalars['String']['output']>;
  /** The loading group to which this asset belongs. */
  readonly group?: Maybe<Scalars['Int']['output']>;
  /** The handle of the enqueued asset */
  readonly handle?: Maybe<Scalars['String']['output']>;
  /** The global ID of the enqueued stylesheet */
  readonly id: Scalars['ID']['output'];
  /** Whether the enqueued style is RTL or not */
  readonly isRtl?: Maybe<Scalars['Boolean']['output']>;
  /** The media attribute to use for the link */
  readonly media?: Maybe<Scalars['String']['output']>;
  /** The absolute path to the enqueued style. Set when the stylesheet is meant to load inline. */
  readonly path?: Maybe<Scalars['String']['output']>;
  /** The `rel` attribute to use for the link */
  readonly rel?: Maybe<Scalars['String']['output']>;
  /** The source of the asset */
  readonly src?: Maybe<Scalars['String']['output']>;
  /** Optional suffix, used in combination with RTL */
  readonly suffix?: Maybe<Scalars['String']['output']>;
  /** The title of the enqueued style. Used for preferred/alternate stylesheets. */
  readonly title?: Maybe<Scalars['String']['output']>;
  /** The version of the enqueued style */
  readonly version?: Maybe<Scalars['String']['output']>;
};

/** A paginated collection of EnqueuedStylesheet Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of EnqueuedStylesheet Nodes */
export type EnqueuedStylesheetConnection = {
  /** A list of edges (relational context) between ContentNode and connected EnqueuedStylesheet Nodes */
  readonly edges: ReadonlyArray<EnqueuedStylesheetConnectionEdge>;
  /** A list of connected EnqueuedStylesheet Nodes */
  readonly nodes: ReadonlyArray<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  readonly pageInfo: EnqueuedStylesheetConnectionPageInfo;
};

/** Represents a connection to a EnqueuedStylesheet. Contains both the EnqueuedStylesheet Node and metadata about the relationship. */
export type EnqueuedStylesheetConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected EnqueuedStylesheet Node */
  readonly node: EnqueuedStylesheet;
};

/** Pagination metadata specific to &quot;EnqueuedStylesheetConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;EnqueuedStylesheetConnectionEdge&quot; Nodes. */
export type EnqueuedStylesheetConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Input for the existingUsersBioGlobalUpdate mutation. */
export type ExistingUsersBioGlobalUpdateInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description to set if empty */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Job role to set if empty */
  readonly jobRole?: InputMaybe<Scalars['String']['input']>;
  /** Profile image URL to set if empty */
  readonly profileImage?: InputMaybe<Scalars['String']['input']>;
  /** User ID to update */
  readonly userId: Scalars['ID']['input'];
};

/** The payload for the existingUsersBioGlobalUpdate mutation. */
export type ExistingUsersBioGlobalUpdatePayload = {
  readonly __typename?: 'ExistingUsersBioGlobalUpdatePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Message describing the result */
  readonly message?: Maybe<Scalars['String']['output']>;
  /** Whether the update was successful */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

/** Extractive Answer */
export type ExtractiveAnswer = {
  readonly __typename?: 'ExtractiveAnswer';
  /** Content */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** Page Number */
  readonly pageNumber?: Maybe<Scalars['String']['output']>;
};

/** The Login client options for the facebook provider. */
export type FacebookClientOptions = LoginClientOptions & {
  readonly __typename?: 'FacebookClientOptions';
  /** The client ID. */
  readonly clientId?: Maybe<Scalars['String']['output']>;
  /** The client Secret. */
  readonly clientSecret?: Maybe<Scalars['String']['output']>;
  /** Enable the Facebook Beta Tier. */
  readonly enableBetaTier?: Maybe<Scalars['Boolean']['output']>;
  /** The Facebook Graph API version. */
  readonly graphApiVersion?: Maybe<Scalars['String']['output']>;
  /** The client redirect URI. */
  readonly redirectUri?: Maybe<Scalars['String']['output']>;
  /** The fields to request from the Facebook Graph API. See https://developers.facebook.com/docs/graph-api/reference/user for a list of available fields. */
  readonly scope?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** This field exists solely to generate the  ClientOptions interface, in lieu of the shared custom fields that will be added in a future release */
  readonly todo?: Maybe<Scalars['Boolean']['output']>;
};

/** The Headless Login options for the facebook provider. */
export type FacebookLoginOptions = LoginOptions & {
  readonly __typename?: 'FacebookLoginOptions';
  /** Whether to create users if none exist. */
  readonly createUserIfNoneExists?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to link existing users. */
  readonly linkExistingUsers?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to set a WordPress authentication cookie on successful login. */
  readonly useAuthenticationCookie?: Maybe<Scalars['Boolean']['output']>;
};

/** Zngly Forms */
export type Form = Node & NodeWizAuthor & ZnNode & {
  readonly __typename?: 'Form';
  /** Connection between the NodeWizAuthor type and the User type */
  readonly author?: Maybe<NodeWizAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The ID of the author of the post */
  readonly authorId?: Maybe<Scalars['ID']['output']>;
  /** The content of the post */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** The date the post was created, in the site&#039;s timezone */
  readonly created?: Maybe<Scalars['String']['output']>;
  /** The unique identifier stored in the database */
  readonly databaseId?: Maybe<Scalars['Int']['output']>;
  /** description of the form */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** email metadata */
  readonly email?: Maybe<EmailSettings>;
  /** Connection between the Form type and the FormEntry type */
  readonly formEntries?: Maybe<FormToFormEntriesConnection>;
  /** form id */
  readonly id: Scalars['ID']['output'];
  /** image url of the form */
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  /** marketing consent */
  readonly marketingConsent?: Maybe<Scalars['Boolean']['output']>;
  /** metadata of the form */
  readonly metadata?: Maybe<FormMetadata>;
  /** The date the post was last modified, in the site&#039;s timezone */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The password to access the form */
  readonly password?: Maybe<Scalars['Boolean']['output']>;
  /** schema of the form */
  readonly schema?: Maybe<Scalars['String']['output']>;
  /** The status of the post */
  readonly status?: Maybe<PostStatusEnum>;
  /** The status settings of the post */
  readonly statusSettings?: Maybe<StatusSettings>;
  /** The title of the post */
  readonly title: Scalars['String']['output'];
  /** ui schema of the form */
  readonly uiSchema?: Maybe<Scalars['String']['output']>;
};


/** Zngly Forms */
export type FormFormEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormToFormEntriesConnectionWhereArgs>;
};

/** A paginated collection of Form Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of Form Nodes */
export type FormConnection = {
  /** A list of edges (relational context) between User and connected Form Nodes */
  readonly edges: ReadonlyArray<FormConnectionEdge>;
  /** A list of connected Form Nodes */
  readonly nodes: ReadonlyArray<Form>;
  /** Information about pagination in a connection. */
  readonly pageInfo: FormConnectionPageInfo;
};

/** Represents a connection to a Form. Contains both the Form Node and metadata about the relationship. */
export type FormConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Form Node */
  readonly node: Form;
};

/** Pagination metadata specific to &quot;FormConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;FormConnectionEdge&quot; Nodes. */
export type FormConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** This is a form entry */
export type FormEntry = Node & ZnNode & {
  readonly __typename?: 'FormEntry';
  /** company name */
  readonly companyName?: Maybe<Scalars['String']['output']>;
  /** Connection between the FormEntry type and the Contact type */
  readonly contact?: Maybe<FormEntryToContactConnectionEdge>;
  /** country */
  readonly country?: Maybe<Scalars['String']['output']>;
  /** The date the post was created, in the site&#039;s timezone */
  readonly created?: Maybe<Scalars['String']['output']>;
  /** The unique identifier stored in the database */
  readonly databaseId?: Maybe<Scalars['Int']['output']>;
  /** Email */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** Extra data */
  readonly extraData?: Maybe<ReadonlyArray<Maybe<JsonKeyValue>>>;
  /** first name */
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** Connection between the FormEntry type and the Form type */
  readonly form?: Maybe<FormEntryToFormConnectionEdge>;
  readonly formDatabaseId?: Maybe<Scalars['ID']['output']>;
  /** Parent Form Id */
  readonly formId: Scalars['ID']['output'];
  /** Form title from which the entry was submitted */
  readonly formTitle?: Maybe<Scalars['String']['output']>;
  /** Form entry id */
  readonly id: Scalars['ID']['output'];
  /** job title */
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  /** last name */
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** marketing consent */
  readonly marketingConsent: Scalars['Boolean']['output'];
  /** message */
  readonly message?: Maybe<Scalars['String']['output']>;
  /** The date the post was last modified, in the site&#039;s timezone */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** phone number */
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Zngly visitor id */
  readonly visitorId?: Maybe<Scalars['String']['output']>;
};


/** This is a form entry */
export type FormEntryContactArgs = {
  where?: InputMaybe<FormEntryToContactConnectionWhereArgs>;
};


/** This is a form entry */
export type FormEntryFormArgs = {
  where?: InputMaybe<FormEntryToFormConnectionWhereArgs>;
};

/** A paginated collection of FormEntry Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of FormEntry Nodes */
export type FormEntryConnection = {
  /** A list of edges (relational context) between Contact and connected FormEntry Nodes */
  readonly edges: ReadonlyArray<FormEntryConnectionEdge>;
  /** A list of connected FormEntry Nodes */
  readonly nodes: ReadonlyArray<FormEntry>;
  /** Information about pagination in a connection. */
  readonly pageInfo: FormEntryConnectionPageInfo;
};

/** Represents a connection to a FormEntry. Contains both the FormEntry Node and metadata about the relationship. */
export type FormEntryConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected FormEntry Node */
  readonly node: FormEntry;
};

/** Pagination metadata specific to &quot;FormEntryConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;FormEntryConnectionEdge&quot; Nodes. */
export type FormEntryConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** The type of ID for FormEntry */
export enum FormEntryIdType {
  Id = 'ID'
}

/** FormEntries Search Fields Enum */
export enum FormEntrySearchFieldsEnum {
  /** company name */
  CompanyName = 'CompanyName',
  /** country */
  Country = 'Country',
  /** The date the post was created, in the site's timezone */
  Created = 'Created',
  /** Email */
  Email = 'Email',
  /** Extra data */
  ExtraData = 'ExtraData',
  /** first name */
  FirstName = 'FirstName',
  /** Parent Form Id */
  FormId = 'FormId',
  /** Form title from which the entry was submitted */
  FormTitle = 'FormTitle',
  /** Form entry id */
  Id = 'Id',
  /** job title */
  JobTitle = 'JobTitle',
  /** last name */
  LastName = 'LastName',
  /** marketing consent */
  MarketingConsent = 'MarketingConsent',
  /** message */
  Message = 'Message',
  /** The date the post was last modified, in the site's timezone */
  Modified = 'Modified',
  /** phone number */
  PhoneNumber = 'PhoneNumber',
  /** Zngly visitor id */
  VisitorId = 'VisitorId'
}

/** Connection between the FormEntry type and the Contact type */
export type FormEntryToContactConnectionEdge = ContactConnectionEdge & Edge & OneToOneConnection & {
  readonly __typename?: 'FormEntryToContactConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Contact;
};

/** Arguments for filtering the FormEntryToContactConnection connection */
export type FormEntryToContactConnectionWhereArgs = {
  /** Contact address line 1 */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Contact address line 2 */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Contact address line 3 */
  readonly addressLine3?: InputMaybe<Scalars['String']['input']>;
  /** Contact city */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** Contact company */
  readonly company?: InputMaybe<Scalars['String']['input']>;
  /** Contact country */
  readonly country?: InputMaybe<Scalars['String']['input']>;
  /** Contact county */
  readonly county?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** Contact email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Contact firstname */
  readonly firstname?: InputMaybe<Scalars['String']['input']>;
  /** contact id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** contact id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** contact id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Contact job title */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Contact lastname */
  readonly lastname?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<ContactSearchFieldsEnum>>>;
  /** Contact phone */
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  /** Contact postal code */
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Contact region */
  readonly region?: InputMaybe<Scalars['String']['input']>;
  /** Search for Contacts by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for Contacts by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<ContactSearchFieldsEnum>>>;
};

/** Connection between the FormEntry type and the Form type */
export type FormEntryToFormConnectionEdge = Edge & FormConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'FormEntryToFormConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Form;
};

/** Arguments for filtering the FormEntryToFormConnection connection */
export type FormEntryToFormConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** description of the form */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** form id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** form id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** form id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** image url of the form */
  readonly imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** marketing consent */
  readonly marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<FormSearchFieldsEnum>>>;
  /** schema of the form */
  readonly schema?: InputMaybe<Scalars['String']['input']>;
  /** Search for Forms by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for Forms by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<FormSearchFieldsEnum>>>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status of the post */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The status of the post */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** ui schema of the form */
  readonly uiSchema?: InputMaybe<Scalars['String']['input']>;
};

/** The type of ID for Form */
export enum FormIdType {
  Id = 'ID'
}

/** form metadata */
export type FormMetadata = {
  readonly __typename?: 'FormMetadata';
  readonly cookieExpiration?: Maybe<Scalars['String']['output']>;
  readonly formStyle?: Maybe<FormMetadataStyleEnum>;
  readonly formTemplate?: Maybe<FormMetadataTemplateEnum>;
  readonly submitSuccessText?: Maybe<Scalars['String']['output']>;
};

/** form metadata */
export type FormMetadataInput = {
  readonly cookieExpiration?: InputMaybe<Scalars['String']['input']>;
  readonly formStyle?: InputMaybe<FormMetadataStyleEnum>;
  readonly formTemplate?: InputMaybe<FormMetadataTemplateEnum>;
  readonly submitSuccessText?: InputMaybe<Scalars['String']['input']>;
};

/** All the form metadata styles */
export enum FormMetadataStyleEnum {
  ImageCenter = 'ImageCenter',
  ImageLeft = 'ImageLeft',
  NoImage = 'NoImage'
}

/** All the form templates */
export enum FormMetadataTemplateEnum {
  Basic = 'Basic',
  CompanyLong = 'CompanyLong',
  CompanyShort = 'CompanyShort',
  PasswordProtected = 'PasswordProtected',
  PasswordProtectedShort = 'PasswordProtectedShort'
}

/** Forms Search Fields Enum */
export enum FormSearchFieldsEnum {
  /** The ID of the author of the post */
  AuthorId = 'AuthorId',
  /** The content of the post */
  Content = 'Content',
  /** The date the post was created, in the site's timezone */
  Created = 'Created',
  /** description of the form */
  Description = 'Description',
  /** email metadata */
  Email = 'Email',
  /** form id */
  Id = 'Id',
  /** image url of the form */
  ImageUrl = 'ImageUrl',
  /** marketing consent */
  MarketingConsent = 'MarketingConsent',
  /** metadata of the form */
  Metadata = 'Metadata',
  /** The date the post was last modified, in the site's timezone */
  Modified = 'Modified',
  /** The password to access the form */
  Password = 'Password',
  /** schema of the form */
  Schema = 'Schema',
  /** The status of the post */
  Status = 'Status',
  /** The status settings of the post */
  StatusSettings = 'StatusSettings',
  /** The title of the post */
  Title = 'Title',
  /** ui schema of the form */
  UiSchema = 'UiSchema'
}

/** Connection between the Form type and the FormEntry type */
export type FormToFormEntriesConnection = Connection & FormEntryConnection & {
  readonly __typename?: 'FormToFormEntriesConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the FormToFormEntriesConnection connection */
  readonly edges: ReadonlyArray<FormToFormEntriesConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<FormEntry>;
  /** Information about pagination in a connection. */
  readonly pageInfo: FormToFormEntriesConnectionPageInfo;
};

/** An edge in a connection */
export type FormToFormEntriesConnectionEdge = Edge & FormEntryConnectionEdge & {
  readonly __typename?: 'FormToFormEntriesConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: FormEntry;
};

/** Pagination metadata specific to &quot;FormToFormEntriesConnection&quot; collections. Provides cursors and flags for navigating through sets of FormToFormEntriesConnection Nodes. */
export type FormToFormEntriesConnectionPageInfo = FormEntryConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'FormToFormEntriesConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the FormToFormEntriesConnection connection */
export type FormToFormEntriesConnectionWhereArgs = {
  /** company name */
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  /** country */
  readonly country?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** Email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** first name */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** Parent Form Id */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** Parent Form Id */
  readonly formIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Parent Form Id */
  readonly formIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Form title from which the entry was submitted */
  readonly formTitle?: InputMaybe<Scalars['String']['input']>;
  /** Form entry id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** Form entry id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Form entry id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** job title */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** last name */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** marketing consent */
  readonly marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** message */
  readonly message?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<FormEntrySearchFieldsEnum>>>;
  /** phone number */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Search for FormEntries by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for FormEntries by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<FormEntrySearchFieldsEnum>>>;
  /** Zngly visitor id */
  readonly visitorId?: InputMaybe<Scalars['String']['input']>;
};

/** The general setting type */
export type GeneralSettings = {
  readonly __typename?: 'GeneralSettings';
  /** A date format for all date strings. */
  readonly dateFormat?: Maybe<Scalars['String']['output']>;
  /** Site tagline. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** This address is used for admin purposes, like new user notification. */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** WordPress locale code. */
  readonly language?: Maybe<Scalars['String']['output']>;
  /** A day number of the week that the week should start on. */
  readonly startOfWeek?: Maybe<Scalars['Int']['output']>;
  /** A time format for all time strings. */
  readonly timeFormat?: Maybe<Scalars['String']['output']>;
  /** A city in the same timezone as you. */
  readonly timezone?: Maybe<Scalars['String']['output']>;
  /** Site title. */
  readonly title?: Maybe<Scalars['String']['output']>;
  /** Site URL. */
  readonly url?: Maybe<Scalars['String']['output']>;
};

/** The Login client options for the github provider. */
export type GithubClientOptions = LoginClientOptions & {
  readonly __typename?: 'GithubClientOptions';
  /** The client ID. */
  readonly clientId?: Maybe<Scalars['String']['output']>;
  /** The client Secret. */
  readonly clientSecret?: Maybe<Scalars['String']['output']>;
  /** The client redirect URI. */
  readonly redirectUri?: Maybe<Scalars['String']['output']>;
  /** The scope to request from the provider. See https://docs.github.com/en/apps/oauth-apps/building-oauth-apps/scopes-for-oauth-apps#available-scopes for a list of available scopes. */
  readonly scope?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** This field exists solely to generate the  ClientOptions interface, in lieu of the shared custom fields that will be added in a future release */
  readonly todo?: Maybe<Scalars['Boolean']['output']>;
};

/** The Headless Login options for the github provider. */
export type GithubLoginOptions = LoginOptions & {
  readonly __typename?: 'GithubLoginOptions';
  /** Whether to create users if none exist. */
  readonly createUserIfNoneExists?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to link existing users. */
  readonly linkExistingUsers?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to set a WordPress authentication cookie on successful login. */
  readonly useAuthenticationCookie?: Maybe<Scalars['Boolean']['output']>;
};

/** The Login client options for the google-multi-tenant provider. */
export type GoogleMultiTenantClientOptions = LoginClientOptions & {
  readonly __typename?: 'GoogleMultiTenantClientOptions';
  /** The client ID. */
  readonly clientId?: Maybe<Scalars['String']['output']>;
  /** The client Secret. */
  readonly clientSecret?: Maybe<Scalars['String']['output']>;
  /** The Google Cloud organization the OAuth prompt is optimized for. If `*` the prompt is optimized for general use with any Google Cloud organization. */
  readonly hostedDomain?: Maybe<Scalars['String']['output']>;
  /** The prompt used for authentication and consent. Defaults to `consent`. */
  readonly promptType?: Maybe<GoogleProviderPromptTypeEnum>;
  /** The client redirect URI. */
  readonly redirectUri?: Maybe<Scalars['String']['output']>;
  /** The scope to request from the Google Graph API. See https://developers.facebook.com/docs/graph-api/reference/user for a list of available scopes. */
  readonly scope?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** This field exists solely to generate the  ClientOptions interface, in lieu of the shared custom fields that will be added in a future release */
  readonly todo?: Maybe<Scalars['Boolean']['output']>;
};

/** The Headless Login options for the google-multi-tenant provider. */
export type GoogleMultiTenantLoginOptions = LoginOptions & {
  readonly __typename?: 'GoogleMultiTenantLoginOptions';
  /** Whether to create users if none exist. */
  readonly createUserIfNoneExists?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to link existing users. */
  readonly linkExistingUsers?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to set a WordPress authentication cookie on successful login. */
  readonly useAuthenticationCookie?: Maybe<Scalars['Boolean']['output']>;
};

/** The Google OAuth2 Provider prompt type. */
export enum GoogleProviderPromptTypeEnum {
  /** The authorization server prompts the user for consent before returning information to the client. */
  Consent = 'CONSENT',
  /** The authorization server does not display any authentication or user consent screens; it will return an error if the user is not already authenticated and has not pre-configured consent for the requested scopes. You can use none to check for existing authentication and/or consent. */
  None = 'NONE',
  /** The authorization server prompts the user to select a user account. This allows a user who has multiple accounts at the authorization server to select amongst the multiple accounts that they may have current sessions for. */
  SelectAccount = 'SELECT_ACCOUNT'
}

/** Saved GraphQL Documents */
export type GraphqlDocument = ContentNode & DatabaseIdentifier & Node & NodeWithContentEditor & NodeWithTemplate & NodeWithTitle & UniformResourceIdentifiable & {
  readonly __typename?: 'GraphqlDocument';
  /** Alias names for saved GraphQL query documents */
  readonly alias?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /**
   * The ancestors of the content node.
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly ancestors?: Maybe<GraphqlDocumentToGraphqlDocumentConnection>;
  /** The content of the post. */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the ContentType type */
  readonly contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  readonly contentTypeName: Scalars['String']['output'];
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  readonly date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  readonly dateGmt?: Maybe<Scalars['String']['output']>;
  /** Description for the saved GraphQL document */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  readonly desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  readonly editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  readonly enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** Allow, deny or default access grant for specific query */
  readonly grant?: Maybe<Scalars['String']['output']>;
  /** Connection between the GraphqlDocument type and the graphqlDocumentGroup type */
  readonly graphqlDocumentGroups?: Maybe<GraphqlDocumentToGraphqlDocumentGroupConnection>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of the databaseId field
   */
  readonly graphqlDocumentId: Scalars['Int']['output'];
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  readonly guid?: Maybe<Scalars['String']['output']>;
  /** Whether the graphql_document object is password protected. */
  readonly hasPassword?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the graphql_document object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  readonly isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  readonly lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** HTTP Cache-Control max-age directive for a saved GraphQL document */
  readonly maxAgeHeader?: Maybe<Scalars['Int']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  readonly modifiedGmt?: Maybe<Scalars['String']['output']>;
  /**
   * The parent of the content node.
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  readonly parent?: Maybe<GraphqlDocumentToParentConnectionEdge>;
  /** The password for the graphql_document object. */
  readonly password?: Maybe<Scalars['String']['output']>;
  /**
   * Connection between the GraphqlDocument type and the graphqlDocument type
   * @deprecated The &quot;GraphqlDocument&quot; Type is not publicly queryable and does not support previews. This field will be removed in the future.
   */
  readonly preview?: Maybe<GraphqlDocumentToPreviewConnectionEdge>;
  /** The database id of the preview node */
  readonly previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  readonly previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  readonly status?: Maybe<Scalars['String']['output']>;
  /** The template assigned to the node */
  readonly template?: Maybe<ContentTemplate>;
  /** Connection between the GraphqlDocument type and the TermNode type */
  readonly terms?: Maybe<GraphqlDocumentToTermNodeConnection>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly unencodedContent?: Maybe<Scalars['String']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};


/** Saved GraphQL Documents */
export type GraphqlDocumentAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Saved GraphQL Documents */
export type GraphqlDocumentContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** Saved GraphQL Documents */
export type GraphqlDocumentEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Saved GraphQL Documents */
export type GraphqlDocumentEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Saved GraphQL Documents */
export type GraphqlDocumentGraphqlDocumentGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GraphqlDocumentToGraphqlDocumentGroupConnectionWhereArgs>;
};


/** Saved GraphQL Documents */
export type GraphqlDocumentTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GraphqlDocumentToTermNodeConnectionWhereArgs>;
};


/** Saved GraphQL Documents */
export type GraphqlDocumentTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A paginated collection of graphqlDocument Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of graphqlDocument Nodes */
export type GraphqlDocumentConnection = {
  /** A list of edges (relational context) between RootQuery and connected graphqlDocument Nodes */
  readonly edges: ReadonlyArray<GraphqlDocumentConnectionEdge>;
  /** A list of connected graphqlDocument Nodes */
  readonly nodes: ReadonlyArray<GraphqlDocument>;
  /** Information about pagination in a connection. */
  readonly pageInfo: GraphqlDocumentConnectionPageInfo;
};

/** Represents a connection to a graphqlDocument. Contains both the graphqlDocument Node and metadata about the relationship. */
export type GraphqlDocumentConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected graphqlDocument Node */
  readonly node: GraphqlDocument;
};

/** Pagination metadata specific to &quot;GraphqlDocumentConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;GraphqlDocumentConnectionEdge&quot; Nodes. */
export type GraphqlDocumentConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Set relationships between the graphqlDocument to graphqlDocumentGroups */
export type GraphqlDocumentGraphqlDocumentGroupsInput = {
  /** If true, this will append the graphqlDocumentGroup to existing related graphqlDocumentGroups. If false, this will replace existing relationships. Default true. */
  readonly append?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input list of items to set. */
  readonly nodes?: InputMaybe<ReadonlyArray<InputMaybe<GraphqlDocumentGraphqlDocumentGroupsNodeInput>>>;
};

/** List of graphqlDocumentGroups to connect the graphqlDocument to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type GraphqlDocumentGraphqlDocumentGroupsNodeInput = {
  /** The description of the graphqlDocumentGroup. This field is used to set a description of the graphqlDocumentGroup if a new one is created during the mutation. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the graphqlDocumentGroup. If present, this will be used to connect to the graphqlDocument. If no existing graphqlDocumentGroup exists with this ID, no connection will be made. */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the graphqlDocumentGroup. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the graphqlDocumentGroup. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
};

/** Tag the saved query document with other queries as a &quot;group&quot;. */
export type GraphqlDocumentGroup = DatabaseIdentifier & Node & TermNode & UniformResourceIdentifiable & {
  readonly __typename?: 'GraphqlDocumentGroup';
  /** Connection between the GraphqlDocumentGroup type and the ContentNode type */
  readonly contentNodes?: Maybe<GraphqlDocumentGroupToContentNodeConnection>;
  /** The number of objects connected to the object */
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** The description of the object */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  readonly graphqlDocumentGroupId?: Maybe<Scalars['Int']['output']>;
  /** Connection between the GraphqlDocumentGroup type and the graphqlDocument type */
  readonly graphqlDocuments?: Maybe<GraphqlDocumentGroupToGraphqlDocumentConnection>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The link to the term */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** The human friendly name of the object. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** An alphanumeric identifier for the object unique to its type. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** Connection between the GraphqlDocumentGroup type and the Taxonomy type */
  readonly taxonomy?: Maybe<GraphqlDocumentGroupToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  readonly taxonomyName?: Maybe<Scalars['String']['output']>;
  /** The ID of the term group that this term object belongs to */
  readonly termGroupId?: Maybe<Scalars['Int']['output']>;
  /** The taxonomy ID that the object is associated with */
  readonly termTaxonomyId?: Maybe<Scalars['Int']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};


/** Tag the saved query document with other queries as a &quot;group&quot;. */
export type GraphqlDocumentGroupContentNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GraphqlDocumentGroupToContentNodeConnectionWhereArgs>;
};


/** Tag the saved query document with other queries as a &quot;group&quot;. */
export type GraphqlDocumentGroupEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Tag the saved query document with other queries as a &quot;group&quot;. */
export type GraphqlDocumentGroupEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Tag the saved query document with other queries as a &quot;group&quot;. */
export type GraphqlDocumentGroupGraphqlDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GraphqlDocumentGroupToGraphqlDocumentConnectionWhereArgs>;
};

/** A paginated collection of graphqlDocumentGroup Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of graphqlDocumentGroup Nodes */
export type GraphqlDocumentGroupConnection = {
  /** A list of edges (relational context) between RootQuery and connected graphqlDocumentGroup Nodes */
  readonly edges: ReadonlyArray<GraphqlDocumentGroupConnectionEdge>;
  /** A list of connected graphqlDocumentGroup Nodes */
  readonly nodes: ReadonlyArray<GraphqlDocumentGroup>;
  /** Information about pagination in a connection. */
  readonly pageInfo: GraphqlDocumentGroupConnectionPageInfo;
};

/** Represents a connection to a graphqlDocumentGroup. Contains both the graphqlDocumentGroup Node and metadata about the relationship. */
export type GraphqlDocumentGroupConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected graphqlDocumentGroup Node */
  readonly node: GraphqlDocumentGroup;
};

/** Pagination metadata specific to &quot;GraphqlDocumentGroupConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;GraphqlDocumentGroupConnectionEdge&quot; Nodes. */
export type GraphqlDocumentGroupConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifier types for retrieving a specific GraphqlDocumentGroup. Determines which unique property (global ID, database ID, slug, etc.) is used to locate the GraphqlDocumentGroup. */
export enum GraphqlDocumentGroupIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the GraphqlDocumentGroup type and the ContentNode type */
export type GraphqlDocumentGroupToContentNodeConnection = Connection & ContentNodeConnection & {
  readonly __typename?: 'GraphqlDocumentGroupToContentNodeConnection';
  /** Edges for the GraphqlDocumentGroupToContentNodeConnection connection */
  readonly edges: ReadonlyArray<GraphqlDocumentGroupToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ContentNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: GraphqlDocumentGroupToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type GraphqlDocumentGroupToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  readonly __typename?: 'GraphqlDocumentGroupToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ContentNode;
};

/** Pagination metadata specific to &quot;GraphqlDocumentGroupToContentNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of GraphqlDocumentGroupToContentNodeConnection Nodes. */
export type GraphqlDocumentGroupToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'GraphqlDocumentGroupToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the GraphqlDocumentGroupToContentNodeConnection connection */
export type GraphqlDocumentGroupToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  readonly contentTypes?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypesOfGraphqlDocumentGroupEnum>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the GraphqlDocumentGroup type and the graphqlDocument type */
export type GraphqlDocumentGroupToGraphqlDocumentConnection = Connection & GraphqlDocumentConnection & {
  readonly __typename?: 'GraphqlDocumentGroupToGraphqlDocumentConnection';
  /** Edges for the GraphqlDocumentGroupToGraphqlDocumentConnection connection */
  readonly edges: ReadonlyArray<GraphqlDocumentGroupToGraphqlDocumentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<GraphqlDocument>;
  /** Information about pagination in a connection. */
  readonly pageInfo: GraphqlDocumentGroupToGraphqlDocumentConnectionPageInfo;
};

/** An edge in a connection */
export type GraphqlDocumentGroupToGraphqlDocumentConnectionEdge = Edge & GraphqlDocumentConnectionEdge & {
  readonly __typename?: 'GraphqlDocumentGroupToGraphqlDocumentConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: GraphqlDocument;
};

/** Pagination metadata specific to &quot;GraphqlDocumentGroupToGraphqlDocumentConnection&quot; collections. Provides cursors and flags for navigating through sets of GraphqlDocumentGroupToGraphqlDocumentConnection Nodes. */
export type GraphqlDocumentGroupToGraphqlDocumentConnectionPageInfo = GraphqlDocumentConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'GraphqlDocumentGroupToGraphqlDocumentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the GraphqlDocumentGroupToGraphqlDocumentConnection connection */
export type GraphqlDocumentGroupToGraphqlDocumentConnectionWhereArgs = {
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the GraphqlDocumentGroup type and the Taxonomy type */
export type GraphqlDocumentGroupToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  readonly __typename?: 'GraphqlDocumentGroupToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Taxonomy;
};

/** Identifier types for retrieving a specific GraphqlDocument. Specifies which unique attribute is used to find an exact GraphqlDocument. */
export enum GraphqlDocumentIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Connection between the GraphqlDocument type and the graphqlDocument type */
export type GraphqlDocumentToGraphqlDocumentConnection = Connection & GraphqlDocumentConnection & {
  readonly __typename?: 'GraphqlDocumentToGraphqlDocumentConnection';
  /** Edges for the GraphqlDocumentToGraphqlDocumentConnection connection */
  readonly edges: ReadonlyArray<GraphqlDocumentToGraphqlDocumentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<GraphqlDocument>;
  /** Information about pagination in a connection. */
  readonly pageInfo: GraphqlDocumentToGraphqlDocumentConnectionPageInfo;
};

/** An edge in a connection */
export type GraphqlDocumentToGraphqlDocumentConnectionEdge = Edge & GraphqlDocumentConnectionEdge & {
  readonly __typename?: 'GraphqlDocumentToGraphqlDocumentConnectionEdge';
  /**
   * A cursor for use in pagination
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /**
   * The item at the end of the edge
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly node: GraphqlDocument;
};

/** Pagination metadata specific to &quot;GraphqlDocumentToGraphqlDocumentConnection&quot; collections. Provides cursors and flags for navigating through sets of GraphqlDocumentToGraphqlDocumentConnection Nodes. */
export type GraphqlDocumentToGraphqlDocumentConnectionPageInfo = GraphqlDocumentConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'GraphqlDocumentToGraphqlDocumentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the GraphqlDocument type and the graphqlDocumentGroup type */
export type GraphqlDocumentToGraphqlDocumentGroupConnection = Connection & GraphqlDocumentGroupConnection & {
  readonly __typename?: 'GraphqlDocumentToGraphqlDocumentGroupConnection';
  /** Edges for the GraphqlDocumentToGraphqlDocumentGroupConnection connection */
  readonly edges: ReadonlyArray<GraphqlDocumentToGraphqlDocumentGroupConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<GraphqlDocumentGroup>;
  /** Information about pagination in a connection. */
  readonly pageInfo: GraphqlDocumentToGraphqlDocumentGroupConnectionPageInfo;
};

/** An edge in a connection */
export type GraphqlDocumentToGraphqlDocumentGroupConnectionEdge = Edge & GraphqlDocumentGroupConnectionEdge & {
  readonly __typename?: 'GraphqlDocumentToGraphqlDocumentGroupConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: GraphqlDocumentGroup;
};

/** Pagination metadata specific to &quot;GraphqlDocumentToGraphqlDocumentGroupConnection&quot; collections. Provides cursors and flags for navigating through sets of GraphqlDocumentToGraphqlDocumentGroupConnection Nodes. */
export type GraphqlDocumentToGraphqlDocumentGroupConnectionPageInfo = GraphqlDocumentGroupConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'GraphqlDocumentToGraphqlDocumentGroupConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the GraphqlDocumentToGraphqlDocumentGroupConnection connection */
export type GraphqlDocumentToGraphqlDocumentGroupConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the GraphqlDocument type and the graphqlDocument type */
export type GraphqlDocumentToParentConnectionEdge = Edge & GraphqlDocumentConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'GraphqlDocumentToParentConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /**
   * The node of the connection, without the edges
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  readonly node: GraphqlDocument;
};

/** Connection between the GraphqlDocument type and the graphqlDocument type */
export type GraphqlDocumentToPreviewConnectionEdge = Edge & GraphqlDocumentConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'GraphqlDocumentToPreviewConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /**
   * The node of the connection, without the edges
   * @deprecated The &quot;GraphqlDocument&quot; Type is not publicly queryable and does not support previews. This field will be removed in the future.
   */
  readonly node: GraphqlDocument;
};

/** Connection between the GraphqlDocument type and the TermNode type */
export type GraphqlDocumentToTermNodeConnection = Connection & TermNodeConnection & {
  readonly __typename?: 'GraphqlDocumentToTermNodeConnection';
  /** Edges for the GraphqlDocumentToTermNodeConnection connection */
  readonly edges: ReadonlyArray<GraphqlDocumentToTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<TermNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: GraphqlDocumentToTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type GraphqlDocumentToTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  readonly __typename?: 'GraphqlDocumentToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: TermNode;
};

/** Pagination metadata specific to &quot;GraphqlDocumentToTermNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of GraphqlDocumentToTermNodeConnection Nodes. */
export type GraphqlDocumentToTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'GraphqlDocumentToTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the GraphqlDocumentToTermNodeConnection connection */
export type GraphqlDocumentToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** The Taxonomy to filter terms by */
  readonly taxonomies?: InputMaybe<ReadonlyArray<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Content that can be organized in a parent-child structure. Provides fields for navigating up and down the hierarchy and maintaining structured relationships. */
export type HierarchicalContentNode = {
  /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  readonly ancestors?: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
  /** Connection between the HierarchicalContentNode type and the ContentNode type */
  readonly children?: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
  /** Connection between the ContentNode type and the ContentType type */
  readonly contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  readonly contentTypeName: Scalars['String']['output'];
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  readonly date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  readonly dateGmt?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  readonly desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  readonly editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  readonly enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  readonly guid?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  readonly isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  readonly lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  readonly modifiedGmt?: Maybe<Scalars['String']['output']>;
  /** The parent of the node. The parent object can be of various types */
  readonly parent?: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
  /** Database id of the parent node */
  readonly parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent node. */
  readonly parentId?: Maybe<Scalars['ID']['output']>;
  /** The database id of the preview node */
  readonly previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  readonly previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  readonly status?: Maybe<Scalars['String']['output']>;
  /** The template assigned to a node of content */
  readonly template?: Maybe<ContentTemplate>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};


/** Content that can be organized in a parent-child structure. Provides fields for navigating up and down the hierarchy and maintaining structured relationships. */
export type HierarchicalContentNodeAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};


/** Content that can be organized in a parent-child structure. Provides fields for navigating up and down the hierarchy and maintaining structured relationships. */
export type HierarchicalContentNodeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};


/** Content that can be organized in a parent-child structure. Provides fields for navigating up and down the hierarchy and maintaining structured relationships. */
export type HierarchicalContentNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Content that can be organized in a parent-child structure. Provides fields for navigating up and down the hierarchy and maintaining structured relationships. */
export type HierarchicalContentNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToContentNodeAncestorsConnection = Connection & ContentNodeConnection & {
  readonly __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnection';
  /** Edges for the HierarchicalContentNodeToContentNodeAncestorsConnection connection */
  readonly edges: ReadonlyArray<HierarchicalContentNodeToContentNodeAncestorsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ContentNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: HierarchicalContentNodeToContentNodeAncestorsConnectionPageInfo;
};

/** An edge in a connection */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionEdge = ContentNodeConnectionEdge & Edge & {
  readonly __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ContentNode;
};

/** Pagination metadata specific to &quot;HierarchicalContentNodeToContentNodeAncestorsConnection&quot; collections. Provides cursors and flags for navigating through sets of HierarchicalContentNodeToContentNodeAncestorsConnection Nodes. */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the HierarchicalContentNodeToContentNodeAncestorsConnection connection */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs = {
  /** The Types of content to filter */
  readonly contentTypes?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToContentNodeChildrenConnection = Connection & ContentNodeConnection & {
  readonly __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnection';
  /** Edges for the HierarchicalContentNodeToContentNodeChildrenConnection connection */
  readonly edges: ReadonlyArray<HierarchicalContentNodeToContentNodeChildrenConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ContentNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: HierarchicalContentNodeToContentNodeChildrenConnectionPageInfo;
};

/** An edge in a connection */
export type HierarchicalContentNodeToContentNodeChildrenConnectionEdge = ContentNodeConnectionEdge & Edge & {
  readonly __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ContentNode;
};

/** Pagination metadata specific to &quot;HierarchicalContentNodeToContentNodeChildrenConnection&quot; collections. Provides cursors and flags for navigating through sets of HierarchicalContentNodeToContentNodeChildrenConnection Nodes. */
export type HierarchicalContentNodeToContentNodeChildrenConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the HierarchicalContentNodeToContentNodeChildrenConnection connection */
export type HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs = {
  /** The Types of content to filter */
  readonly contentTypes?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToParentContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & OneToOneConnection & {
  readonly __typename?: 'HierarchicalContentNodeToParentContentNodeConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: ContentNode;
};

/** Content that can exist in a parent-child structure. Provides fields for navigating up (parent) and down (children) through the hierarchy. */
export type HierarchicalNode = {
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** Database id of the parent node */
  readonly parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent node. */
  readonly parentId?: Maybe<Scalars['ID']['output']>;
};

/** Term node with hierarchical (parent/child) relationships */
export type HierarchicalTermNode = {
  /** The number of objects connected to the object */
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** The description of the object */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The link to the term */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** The human friendly name of the object. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Database id of the parent node */
  readonly parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent node. */
  readonly parentId?: Maybe<Scalars['ID']['output']>;
  /** An alphanumeric identifier for the object unique to its type. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** The name of the taxonomy that the object is associated with */
  readonly taxonomyName?: Maybe<Scalars['String']['output']>;
  /** The ID of the term group that this term object belongs to */
  readonly termGroupId?: Maybe<Scalars['Int']['output']>;
  /** The taxonomy ID that the object is associated with */
  readonly termTaxonomyId?: Maybe<Scalars['Int']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};


/** Term node with hierarchical (parent/child) relationships */
export type HierarchicalTermNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Term node with hierarchical (parent/child) relationships */
export type HierarchicalTermNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for the hsDeleteConnection mutation. */
export type HsDeleteConnectionInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to remove all contacts from HubSpot */
  readonly removeContacts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the hsDeleteConnection mutation. */
export type HsDeleteConnectionPayload = {
  readonly __typename?: 'HsDeleteConnectionPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the delete mutation was successful */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type HsInfo = {
  readonly __typename?: 'HsInfo';
  /** Get allowed fields */
  readonly allowedContactProperties?: Maybe<ReadonlyArray<Maybe<JsonKeyValue>>>;
  /** Get allowed fields */
  readonly contactProperties?: Maybe<ReadonlyArray<Maybe<JsonKeyValue>>>;
  /** Get default owner id */
  readonly defaultOwner?: Maybe<HubspotOwnerType>;
  /** Get HubSpot domain */
  readonly hubDomain?: Maybe<Scalars['String']['output']>;
  /** Get HubSpot ID */
  readonly hubId?: Maybe<Scalars['String']['output']>;
  /** Check if token is valid */
  readonly isValidToken?: Maybe<Scalars['Boolean']['output']>;
  /** Get HubSpot owners */
  readonly owners?: Maybe<ReadonlyArray<Maybe<HubspotOwnerType>>>;
  /** Get HubSpot scopes */
  readonly scopes?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** Get HubSpot user */
  readonly user?: Maybe<Scalars['String']['output']>;
};

/** Input for the hsRegisterOauthTokens mutation. */
export type HsRegisterOauthTokensInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** hs code token for registering new Oauth credentials */
  readonly code?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the hsRegisterOauthTokens mutation. */
export type HsRegisterOauthTokensPayload = {
  readonly __typename?: 'HsRegisterOauthTokensPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** whether the mutation was successful */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for the hsSyncUserToken mutation. */
export type HsSyncUserTokenInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hubspot user token */
  readonly hubspotutk: Scalars['String']['input'];
  /** If true, will attempt to identify contact again based on new lead info */
  readonly newLeadInfo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Zngly visitor id */
  readonly visitorId: Scalars['String']['input'];
};

/** The payload for the hsSyncUserToken mutation. */
export type HsSyncUserTokenPayload = {
  readonly __typename?: 'HsSyncUserTokenPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Status */
  readonly status?: Maybe<Scalars['String']['output']>;
};

export type HsTest = {
  readonly __typename?: 'HsTest';
  /** Get HubSpot contacts */
  readonly res?: Maybe<Scalars['String']['output']>;
};

/** Input for the hsUpdateSettings mutation. */
export type HsUpdateSettingsInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** update sync contact properties fields */
  readonly contactProperties?: InputMaybe<ReadonlyArray<InputMaybe<JsonKeyValueArrayInput>>>;
  /** update default owner id */
  readonly defaultOwnerId?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the hsUpdateSettings mutation. */
export type HsUpdateSettingsPayload = {
  readonly __typename?: 'HsUpdateSettingsPayload';
  readonly allowedContactProperties?: Maybe<ReadonlyArray<Maybe<JsonKeyValue>>>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contactProperties?: Maybe<ReadonlyArray<Maybe<JsonKeyValue>>>;
  readonly defaultOwnerId?: Maybe<Scalars['String']['output']>;
};

/** Hub */
export type Hub = Node & NodeWizAuthor & NodeWizUser & ZnNode & {
  readonly __typename?: 'Hub';
  /** Connection between the NodeWizAuthor type and the User type */
  readonly author?: Maybe<NodeWizAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The ID of the author of the post */
  readonly authorId?: Maybe<Scalars['ID']['output']>;
  /** Connection between the Hub type and the ConnectionHubToHp type */
  readonly connectionHubToHps?: Maybe<HubToConnectionHubToHpsConnection>;
  /** The content of the post */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** The date the post was created, in the site&#039;s timezone */
  readonly created?: Maybe<Scalars['String']['output']>;
  /** The unique identifier stored in the database */
  readonly databaseId?: Maybe<Scalars['Int']['output']>;
  /** description of the hub */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** group of the hub used to identify its category/tag/campaign */
  readonly group?: Maybe<Scalars['String']['output']>;
  /** hub id */
  readonly id: Scalars['ID']['output'];
  /** metadata of the hub */
  readonly metadata?: Maybe<HubMetadata>;
  /** The date the post was last modified, in the site&#039;s timezone */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** Connection between the Hub type and the PostAccessRecipient type */
  readonly postAccessRecipients?: Maybe<HubToPostAccessRecipientsConnection>;
  /** order of the hubs */
  readonly postOrder?: Maybe<Scalars['Int']['output']>;
  /** The name (slug) for the post */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** The status of the post */
  readonly status?: Maybe<PostStatusEnum>;
  /** The status settings of the post */
  readonly statusSettings?: Maybe<StatusSettings>;
  /** template of the hub */
  readonly template?: Maybe<HubTemplateEnum>;
  /** The title of the post */
  readonly title: Scalars['String']['output'];
  /** Connection between the NodeWizUser type and the User type */
  readonly user?: Maybe<NodeWizUserToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly userDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** User related to the hub */
  readonly userId?: Maybe<Scalars['ID']['output']>;
  /** User meta related to the hub */
  readonly userMeta?: Maybe<HubUserMeta>;
};


/** Hub */
export type HubConnectionHubToHpsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubToConnectionHubToHpsConnectionWhereArgs>;
};


/** Hub */
export type HubPostAccessRecipientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubToPostAccessRecipientsConnectionWhereArgs>;
};

/** A paginated collection of Hub Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of Hub Nodes */
export type HubConnection = {
  /** A list of edges (relational context) between RootQuery and connected Hub Nodes */
  readonly edges: ReadonlyArray<HubConnectionEdge>;
  /** A list of connected Hub Nodes */
  readonly nodes: ReadonlyArray<Hub>;
  /** Information about pagination in a connection. */
  readonly pageInfo: HubConnectionPageInfo;
};

/** Represents a connection to a Hub. Contains both the Hub Node and metadata about the relationship. */
export type HubConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Hub Node */
  readonly node: Hub;
};

/** Pagination metadata specific to &quot;HubConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;HubConnectionEdge&quot; Nodes. */
export type HubConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** The type of ID for Hub */
export enum HubIdType {
  Id = 'ID',
  Slug = 'SLUG'
}

/** Hub metadata */
export type HubMetadata = {
  readonly __typename?: 'HubMetadata';
  /** Hub metadata design */
  readonly design?: Maybe<HubMetadataDesign>;
  /** Hub metadata nav metadata */
  readonly navMeta?: Maybe<ReadonlyArray<Maybe<HubMetadataNavMeta>>>;
  /** Hub metadata share icons */
  readonly shareIcons?: Maybe<ReadonlyArray<Maybe<HubMetadataShareIcons>>>;
};

/** Hub metadata design */
export type HubMetadataDesign = {
  readonly __typename?: 'HubMetadataDesign';
  readonly borderRadius?: Maybe<Scalars['Int']['output']>;
};

/** Hub metadata design */
export type HubMetadataDesignInput = {
  readonly borderRadius?: InputMaybe<Scalars['Int']['input']>;
};

/** Hub metadata */
export type HubMetadataInput = {
  /** Hub metadata design */
  readonly design?: InputMaybe<HubMetadataDesignInput>;
  /** Hub metadata nav metadata */
  readonly navMeta?: InputMaybe<ReadonlyArray<InputMaybe<HubMetadataNavMetaInput>>>;
  /** Hub metadata share icons */
  readonly shareIcons?: InputMaybe<ReadonlyArray<InputMaybe<HubMetadataShareIconsInput>>>;
};

/** Hub metadata nav metadata */
export type HubMetadataNavMeta = {
  readonly __typename?: 'HubMetadataNavMeta';
  readonly icon?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  /** Nav Meta Znglist Object */
  readonly znglist?: Maybe<Znglist>;
  readonly znglistId?: Maybe<Scalars['ID']['output']>;
};

/** Hub metadata nav metadata */
export type HubMetadataNavMetaInput = {
  readonly icon?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly znglistId?: InputMaybe<Scalars['ID']['input']>;
};

/** Hub metadata share icons */
export type HubMetadataShareIcons = {
  readonly __typename?: 'HubMetadataShareIcons';
  /** Shareicon */
  readonly icon?: Maybe<Scalars['String']['output']>;
  /** Sharetitle */
  readonly title?: Maybe<Scalars['String']['output']>;
  /** Shareurl */
  readonly url?: Maybe<Scalars['String']['output']>;
};

/** Hub metadata share icons */
export type HubMetadataShareIconsInput = {
  /** Shareicon */
  readonly icon?: InputMaybe<Scalars['String']['input']>;
  /** Sharetitle */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** Shareurl */
  readonly url?: InputMaybe<Scalars['String']['input']>;
};

/** Page for Hubs */
export type HubPage = Node & NodeWizAuthor & ZnNode & {
  readonly __typename?: 'HubPage';
  /** Connection between the NodeWizAuthor type and the User type */
  readonly author?: Maybe<NodeWizAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The ID of the author of the post */
  readonly authorId?: Maybe<Scalars['ID']['output']>;
  /** Connection between the HubPage type and the ConnectionHpToC type */
  readonly connectionHpToCs?: Maybe<HubPageToConnectionHpToCsConnection>;
  /** Connection between the HubPage type and the ConnectionHubToHp type */
  readonly connectionHubToHps?: Maybe<HubPageToConnectionHubToHpsConnection>;
  /** The content of the post */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** The date the post was created, in the site&#039;s timezone */
  readonly created?: Maybe<Scalars['String']['output']>;
  /** The unique identifier stored in the database */
  readonly databaseId?: Maybe<Scalars['Int']['output']>;
  /** page description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Connection between the HubPage type and the Form type */
  readonly form?: Maybe<HubPageToFormConnectionEdge>;
  /** Form Id */
  readonly formId?: Maybe<Scalars['ID']['output']>;
  /** page id */
  readonly id: Scalars['ID']['output'];
  /** The date the post was last modified, in the site&#039;s timezone */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The status of the post */
  readonly status?: Maybe<PostStatusEnum>;
  /** The status settings of the post */
  readonly statusSettings?: Maybe<StatusSettings>;
  /** The title of the post */
  readonly title: Scalars['String']['output'];
};


/** Page for Hubs */
export type HubPageConnectionHpToCsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubPageToConnectionHpToCsConnectionWhereArgs>;
};


/** Page for Hubs */
export type HubPageConnectionHubToHpsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubPageToConnectionHubToHpsConnectionWhereArgs>;
};


/** Page for Hubs */
export type HubPageFormArgs = {
  where?: InputMaybe<HubPageToFormConnectionWhereArgs>;
};

/** A paginated collection of HubPage Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of HubPage Nodes */
export type HubPageConnection = {
  /** A list of edges (relational context) between RootQuery and connected HubPage Nodes */
  readonly edges: ReadonlyArray<HubPageConnectionEdge>;
  /** A list of connected HubPage Nodes */
  readonly nodes: ReadonlyArray<HubPage>;
  /** Information about pagination in a connection. */
  readonly pageInfo: HubPageConnectionPageInfo;
};

/** Represents a connection to a HubPage. Contains both the HubPage Node and metadata about the relationship. */
export type HubPageConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected HubPage Node */
  readonly node: HubPage;
};

/** Pagination metadata specific to &quot;HubPageConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;HubPageConnectionEdge&quot; Nodes. */
export type HubPageConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** The type of ID for HubPage */
export enum HubPageIdType {
  Id = 'ID'
}

/** HubPages Search Fields Enum */
export enum HubPageSearchFieldsEnum {
  /** The ID of the author of the post */
  AuthorId = 'AuthorId',
  /** The content of the post */
  Content = 'Content',
  /** The date the post was created, in the site's timezone */
  Created = 'Created',
  /** page description */
  Description = 'Description',
  /** Form Id */
  FormId = 'FormId',
  /** page id */
  Id = 'Id',
  /** The date the post was last modified, in the site's timezone */
  Modified = 'Modified',
  /** The status of the post */
  Status = 'Status',
  /** The status settings of the post */
  StatusSettings = 'StatusSettings',
  /** The title of the post */
  Title = 'Title'
}

/** Connection between the HubPage type and the ConnectionHpToC type */
export type HubPageToConnectionHpToCsConnection = Connection & ConnectionHpToCConnection & {
  readonly __typename?: 'HubPageToConnectionHpToCsConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the HubPageToConnectionHpToCsConnection connection */
  readonly edges: ReadonlyArray<HubPageToConnectionHpToCsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ConnectionHpToC>;
  /** Information about pagination in a connection. */
  readonly pageInfo: HubPageToConnectionHpToCsConnectionPageInfo;
};

/** An edge in a connection */
export type HubPageToConnectionHpToCsConnectionEdge = ConnectionHpToCConnectionEdge & Edge & {
  readonly __typename?: 'HubPageToConnectionHpToCsConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ConnectionHpToC;
};

/** Pagination metadata specific to &quot;HubPageToConnectionHpToCsConnection&quot; collections. Provides cursors and flags for navigating through sets of HubPageToConnectionHpToCsConnection Nodes. */
export type HubPageToConnectionHpToCsConnectionPageInfo = ConnectionHpToCConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'HubPageToConnectionHpToCsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the HubPageToConnectionHpToCsConnection connection */
export type HubPageToConnectionHpToCsConnectionWhereArgs = {
  /** Catalog Id */
  readonly catalogId?: InputMaybe<Scalars['ID']['input']>;
  /** Catalog Id */
  readonly catalogIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Catalog Id */
  readonly catalogIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** order of the catalog items */
  readonly catalogOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Hub Page Id */
  readonly hubPageId?: InputMaybe<Scalars['ID']['input']>;
  /** Hub Page Id */
  readonly hubPageIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Hub Page Id */
  readonly hubPageIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** weak table id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** weak table id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** weak table id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<ConnectionHpToCSearchFieldsEnum>>>;
  /** Search for ConnectionHpToCs by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for ConnectionHpToCs by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<ConnectionHpToCSearchFieldsEnum>>>;
};

/** Connection between the HubPage type and the ConnectionHubToHp type */
export type HubPageToConnectionHubToHpsConnection = Connection & ConnectionHubToHpConnection & {
  readonly __typename?: 'HubPageToConnectionHubToHpsConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the HubPageToConnectionHubToHpsConnection connection */
  readonly edges: ReadonlyArray<HubPageToConnectionHubToHpsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ConnectionHubToHp>;
  /** Information about pagination in a connection. */
  readonly pageInfo: HubPageToConnectionHubToHpsConnectionPageInfo;
};

/** An edge in a connection */
export type HubPageToConnectionHubToHpsConnectionEdge = ConnectionHubToHpConnectionEdge & Edge & {
  readonly __typename?: 'HubPageToConnectionHubToHpsConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ConnectionHubToHp;
};

/** Pagination metadata specific to &quot;HubPageToConnectionHubToHpsConnection&quot; collections. Provides cursors and flags for navigating through sets of HubPageToConnectionHubToHpsConnection Nodes. */
export type HubPageToConnectionHubToHpsConnectionPageInfo = ConnectionHubToHpConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'HubPageToConnectionHubToHpsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the HubPageToConnectionHubToHpsConnection connection */
export type HubPageToConnectionHubToHpsConnectionWhereArgs = {
  /** Hub Id */
  readonly hubId?: InputMaybe<Scalars['ID']['input']>;
  /** Hub Id */
  readonly hubIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Hub Id */
  readonly hubIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** weak table id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** weak table id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** weak table id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<ConnectionHubToHpSearchFieldsEnum>>>;
  /** Page Icon */
  readonly pageIcon?: InputMaybe<Scalars['String']['input']>;
  /** Page Id */
  readonly pageId?: InputMaybe<Scalars['ID']['input']>;
  /** Page Id */
  readonly pageIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Page Id */
  readonly pageIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** order of the pages */
  readonly pageOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Page Title */
  readonly pageTitle?: InputMaybe<Scalars['String']['input']>;
  /** Search for ConnectionHubToHps by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for ConnectionHubToHps by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<ConnectionHubToHpSearchFieldsEnum>>>;
};

/** Connection between the HubPage type and the Form type */
export type HubPageToFormConnectionEdge = Edge & FormConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'HubPageToFormConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Form;
};

/** Arguments for filtering the HubPageToFormConnection connection */
export type HubPageToFormConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** description of the form */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** form id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** form id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** form id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** image url of the form */
  readonly imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** marketing consent */
  readonly marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<FormSearchFieldsEnum>>>;
  /** schema of the form */
  readonly schema?: InputMaybe<Scalars['String']['input']>;
  /** Search for Forms by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for Forms by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<FormSearchFieldsEnum>>>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status of the post */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The status of the post */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** ui schema of the form */
  readonly uiSchema?: InputMaybe<Scalars['String']['input']>;
};

/** Hubs Search Fields Enum */
export enum HubSearchFieldsEnum {
  /** The ID of the author of the post */
  AuthorId = 'AuthorId',
  /** The content of the post */
  Content = 'Content',
  /** The date the post was created, in the site's timezone */
  Created = 'Created',
  /** description of the hub */
  Description = 'Description',
  /** group of the hub used to identify its category/tag/campaign */
  Group = 'Group',
  /** hub id */
  Id = 'Id',
  /** metadata of the hub */
  Metadata = 'Metadata',
  /** The date the post was last modified, in the site's timezone */
  Modified = 'Modified',
  /** order of the hubs */
  PostOrder = 'PostOrder',
  /** The name (slug) for the post */
  Slug = 'Slug',
  /** The status of the post */
  Status = 'Status',
  /** The status settings of the post */
  StatusSettings = 'StatusSettings',
  /** template of the hub */
  Template = 'Template',
  /** The title of the post */
  Title = 'Title',
  /** User related to the hub */
  UserId = 'UserId',
  /** User meta related to the hub */
  UserMeta = 'UserMeta'
}

/** Hub template */
export enum HubTemplateEnum {
  /** Hub template for home landing page */
  HomeLandingPage = 'HOME_LANDING_PAGE',
  /** Hub template 03 */
  HubTemplate_03 = 'HUB_TEMPLATE_03',
  /** Hub template for landing page */
  SalesLandingPage = 'SALES_LANDING_PAGE'
}

/** Connection between the Hub type and the ConnectionHubToHp type */
export type HubToConnectionHubToHpsConnection = Connection & ConnectionHubToHpConnection & {
  readonly __typename?: 'HubToConnectionHubToHpsConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the HubToConnectionHubToHpsConnection connection */
  readonly edges: ReadonlyArray<HubToConnectionHubToHpsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ConnectionHubToHp>;
  /** Information about pagination in a connection. */
  readonly pageInfo: HubToConnectionHubToHpsConnectionPageInfo;
};

/** An edge in a connection */
export type HubToConnectionHubToHpsConnectionEdge = ConnectionHubToHpConnectionEdge & Edge & {
  readonly __typename?: 'HubToConnectionHubToHpsConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ConnectionHubToHp;
};

/** Pagination metadata specific to &quot;HubToConnectionHubToHpsConnection&quot; collections. Provides cursors and flags for navigating through sets of HubToConnectionHubToHpsConnection Nodes. */
export type HubToConnectionHubToHpsConnectionPageInfo = ConnectionHubToHpConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'HubToConnectionHubToHpsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the HubToConnectionHubToHpsConnection connection */
export type HubToConnectionHubToHpsConnectionWhereArgs = {
  /** Hub Id */
  readonly hubId?: InputMaybe<Scalars['ID']['input']>;
  /** Hub Id */
  readonly hubIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Hub Id */
  readonly hubIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** weak table id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** weak table id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** weak table id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<ConnectionHubToHpSearchFieldsEnum>>>;
  /** Page Icon */
  readonly pageIcon?: InputMaybe<Scalars['String']['input']>;
  /** Page Id */
  readonly pageId?: InputMaybe<Scalars['ID']['input']>;
  /** Page Id */
  readonly pageIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Page Id */
  readonly pageIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** order of the pages */
  readonly pageOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Page Title */
  readonly pageTitle?: InputMaybe<Scalars['String']['input']>;
  /** Search for ConnectionHubToHps by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for ConnectionHubToHps by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<ConnectionHubToHpSearchFieldsEnum>>>;
};

/** Connection between the Hub type and the PostAccessRecipient type */
export type HubToPostAccessRecipientsConnection = Connection & PostAccessRecipientConnection & {
  readonly __typename?: 'HubToPostAccessRecipientsConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the HubToPostAccessRecipientsConnection connection */
  readonly edges: ReadonlyArray<HubToPostAccessRecipientsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<PostAccessRecipient>;
  /** Information about pagination in a connection. */
  readonly pageInfo: HubToPostAccessRecipientsConnectionPageInfo;
};

/** An edge in a connection */
export type HubToPostAccessRecipientsConnectionEdge = Edge & PostAccessRecipientConnectionEdge & {
  readonly __typename?: 'HubToPostAccessRecipientsConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: PostAccessRecipient;
};

/** Pagination metadata specific to &quot;HubToPostAccessRecipientsConnection&quot; collections. Provides cursors and flags for navigating through sets of HubToPostAccessRecipientsConnection Nodes. */
export type HubToPostAccessRecipientsConnectionPageInfo = PageInfo & PostAccessRecipientConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'HubToPostAccessRecipientsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the HubToPostAccessRecipientsConnection connection */
export type HubToPostAccessRecipientsConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** Email Domain */
  readonly domain?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** The date the post expires, in the site's timezone */
  readonly expiresAtDateQuery?: InputMaybe<DateQueryInput>;
  /** access recipient id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** access recipient id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** access recipient id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<PostAccessRecipientSearchFieldsEnum>>>;
  /** Search for PostAccessRecipients by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for PostAccessRecipients by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<PostAccessRecipientSearchFieldsEnum>>>;
  /** Status of the post access recipient */
  readonly status?: InputMaybe<PostAccessRecipientStatusEnum>;
  /** Status of the post access recipient */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostAccessRecipientStatusEnum>>>;
  /** Status of the post access recipient */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostAccessRecipientStatusEnum>>>;
};

/** Hub user metadata */
export type HubUserMeta = {
  readonly __typename?: 'HubUserMeta';
  /** UserDescription */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** User meta image */
  readonly image?: Maybe<MediaItem>;
  /** Image */
  readonly imageId?: Maybe<Scalars['ID']['output']>;
  /** Username */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** UserRole */
  readonly role?: Maybe<Scalars['String']['output']>;
};

/** Hub user metadata */
export type HubUserMetaInput = {
  /** UserDescription */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Image */
  readonly imageId?: InputMaybe<Scalars['ID']['input']>;
  /** Username */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** UserRole */
  readonly role?: InputMaybe<Scalars['String']['input']>;
};

/** Hubspot owner type */
export type HubspotOwnerType = {
  readonly __typename?: 'HubspotOwnerType';
  /** Owner archived */
  readonly archived?: Maybe<Scalars['Boolean']['output']>;
  /** Owner created at */
  readonly created_at?: Maybe<Scalars['String']['output']>;
  /** Owner email */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** Owner first name */
  readonly first_name?: Maybe<Scalars['String']['output']>;
  /** Owner id */
  readonly id?: Maybe<Scalars['String']['output']>;
  /** Owner last name */
  readonly last_name?: Maybe<Scalars['String']['output']>;
  /** Owner updated at */
  readonly updated_at?: Maybe<Scalars['String']['output']>;
  /** Owner user id */
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** Input for the importContacts mutation. */
export type ImportContactsInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The file to import */
  readonly file?: InputMaybe<Scalars['Upload']['input']>;
  /** The mapping of the file columns to the contact fields */
  readonly mapping?: InputMaybe<JsonKeyValueInput>;
};

/** The payload for the importContacts mutation. */
export type ImportContactsPayload = {
  readonly __typename?: 'ImportContactsPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The number of failed rows */
  readonly failedRows?: Maybe<ReadonlyArray<Maybe<JsonKeyValue>>>;
  /** The number of inserted rows */
  readonly insertedRows?: Maybe<Scalars['Int']['output']>;
  /** The number of updated rows */
  readonly updatedRows?: Maybe<Scalars['Int']['output']>;
};

/** The Login client options for the instagram provider. */
export type InstagramClientOptions = LoginClientOptions & {
  readonly __typename?: 'InstagramClientOptions';
  /** The client ID. */
  readonly clientId?: Maybe<Scalars['String']['output']>;
  /** The client Secret. */
  readonly clientSecret?: Maybe<Scalars['String']['output']>;
  /** The client redirect URI. */
  readonly redirectUri?: Maybe<Scalars['String']['output']>;
  /** The scope to request from the Instagram Graph API. See https://developers.facebook.com/docs/instagram-basic-display-api/overview#permissions for a list of available scopes. */
  readonly scope?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** This field exists solely to generate the  ClientOptions interface, in lieu of the shared custom fields that will be added in a future release */
  readonly todo?: Maybe<Scalars['Boolean']['output']>;
};

/** The Headless Login options for the instagram provider. */
export type InstagramLoginOptions = LoginOptions & {
  readonly __typename?: 'InstagramLoginOptions';
  /** Whether to create users if none exist. */
  readonly createUserIfNoneExists?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to link existing users. */
  readonly linkExistingUsers?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to set a WordPress authentication cookie on successful login. */
  readonly useAuthenticationCookie?: Maybe<Scalars['Boolean']['output']>;
};

/** All the integrations */
export enum IntegrationsEnum {
  Bigquery = 'BIGQUERY',
  Hubspot = 'HUBSPOT',
  Marketo = 'MARKETO',
  Zoho = 'ZOHO'
}

export type IntegrationsManager = {
  readonly __typename?: 'IntegrationsManager';
  /** Active integrations */
  readonly activeIntegrations?: Maybe<ReadonlyArray<Maybe<IntegrationsEnum>>>;
  /** All the integrations */
  readonly integrations?: Maybe<ReadonlyArray<Maybe<IntegrationsEnum>>>;
};

/** Key Value Pair */
export type JsonKeyValue = {
  readonly __typename?: 'JSONKeyValue';
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** Key Value Pair */
export type JsonKeyValueArrayInput = {
  readonly key?: InputMaybe<Scalars['String']['input']>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Key Value Pair */
export type JsonKeyValueInput = {
  readonly append?: InputMaybe<Scalars['Boolean']['input']>;
  readonly nodes?: InputMaybe<ReadonlyArray<InputMaybe<JsonKeyValueArrayInput>>>;
};

/** Input for the LinkUserIdentity mutation. */
export type LinkUserIdentityInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The user identity to use when logging in. Required by the SiteToken provider. */
  readonly identity?: InputMaybe<Scalars['String']['input']>;
  /** The parsed response from an OAuth2 Authentication Provider. */
  readonly oauthResponse?: InputMaybe<OAuthProviderResponseInput>;
  /** The Headless Login provider to use when logging in. */
  readonly provider: LoginProviderEnum;
  /** The user ID to link the identity to. Accepts either a global or database ID. */
  readonly userId: Scalars['ID']['input'];
};

/** The payload for the LinkUserIdentity mutation. */
export type LinkUserIdentityPayload = {
  readonly __typename?: 'LinkUserIdentityPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the identity was successfully linked to the user. */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
  /** The user that was logged in. */
  readonly user?: Maybe<User>;
};

/** The linked identity from the login provider. */
export type LinkedIdentity = {
  readonly __typename?: 'LinkedIdentity';
  /** The internal user identifier from the login provider. */
  readonly id?: Maybe<Scalars['ID']['output']>;
  /** The login provider which provided the identity. */
  readonly provider?: Maybe<LoginProviderEnum>;
};

/** The Login client options for the linkedin provider. */
export type LinkedinClientOptions = LoginClientOptions & {
  readonly __typename?: 'LinkedinClientOptions';
  /** The client ID. */
  readonly clientId?: Maybe<Scalars['String']['output']>;
  /** The client Secret. */
  readonly clientSecret?: Maybe<Scalars['String']['output']>;
  /** The client redirect URI. */
  readonly redirectUri?: Maybe<Scalars['String']['output']>;
  /** The scope to request from the provider. See https://learn.microsoft.com/en-us/linkedin/shared/authentication/authentication?context=linkedin%2Fcontext#permission-types for a list of available scopes. */
  readonly scope?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** This field exists solely to generate the  ClientOptions interface, in lieu of the shared custom fields that will be added in a future release */
  readonly todo?: Maybe<Scalars['Boolean']['output']>;
};

/** The Headless Login options for the linkedin provider. */
export type LinkedinLoginOptions = LoginOptions & {
  readonly __typename?: 'LinkedinLoginOptions';
  /** Whether to create users if none exist. */
  readonly createUserIfNoneExists?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to link existing users. */
  readonly linkExistingUsers?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to set a WordPress authentication cookie on successful login. */
  readonly useAuthenticationCookie?: Maybe<Scalars['Boolean']['output']>;
};

/** The Headless Login client. */
export type LoginClient = {
  readonly __typename?: 'LoginClient';
  /** The authorization URL. */
  readonly authorizationUrl?: Maybe<Scalars['String']['output']>;
  /** The client ID. */
  readonly clientId?: Maybe<Scalars['ID']['output']>;
  /** The client options. */
  readonly clientOptions?: Maybe<LoginClientOptions>;
  /** The domains associated with the OAuth provider. */
  readonly domains?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** Whether the client is enabled. */
  readonly isEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The login options. */
  readonly loginOptions?: Maybe<LoginOptions>;
  /** The client name. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** A field used for ordering clients. */
  readonly order?: Maybe<Scalars['Int']['output']>;
  /** The provider type. */
  readonly provider?: Maybe<LoginProviderEnum>;
};

/** The Client Options for the Headless Login provider. */
export type LoginClientOptions = {
  /** This field exists solely to generate the  ClientOptions interface, in lieu of the shared custom fields that will be added in a future release */
  readonly todo?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for the Login mutation. */
export type LoginInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The WordPress user credentials. Required by the Password provider. */
  readonly credentials?: InputMaybe<PasswordProviderResponseInput>;
  /** The user identity to use when logging in. Required by the SiteToken provider. */
  readonly identity?: InputMaybe<Scalars['String']['input']>;
  /** The parsed response from an OAuth2 Authentication Provider. */
  readonly oauthResponse?: InputMaybe<OAuthProviderResponseInput>;
  /** The Headless Login provider to use when logging in. */
  readonly provider: LoginProviderEnum;
};

/** The login options for the Headless Login provider. */
export type LoginOptions = {
  /** Whether to set a WordPress authentication cookie on successful login. */
  readonly useAuthenticationCookie?: Maybe<Scalars['Boolean']['output']>;
};

/** The payload for the Login mutation. */
export type LoginPayload = {
  readonly __typename?: 'LoginPayload';
  /** JWT Token that can be used in future requests for Authentication. */
  readonly authToken?: Maybe<Scalars['String']['output']>;
  /** The authentication token expiration timestamp. */
  readonly authTokenExpiration?: Maybe<Scalars['String']['output']>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Refresh Token that can be used to refresh the JWT Token. */
  readonly refreshToken?: Maybe<Scalars['String']['output']>;
  /** The refresh token expiration timestamp. */
  readonly refreshTokenExpiration?: Maybe<Scalars['String']['output']>;
  /** The user that was logged in. */
  readonly user?: Maybe<User>;
};

/** The Headless Login Provider. */
export enum LoginProviderEnum {
  /** The Azure (Multi Tenant) provider. */
  AzureMultiTenant = 'AZURE_MULTI_TENANT',
  /** The Azure (Single Tenant) provider. */
  AzureSingleTenant = 'AZURE_SINGLE_TENANT',
  /** The Facebook provider. */
  Facebook = 'FACEBOOK',
  /** The GitHub provider. */
  Github = 'GITHUB',
  /** The Google SSO provider. */
  GoogleMultiTenant = 'GOOGLE_MULTI_TENANT',
  /** The Instagram provider. */
  Instagram = 'INSTAGRAM',
  /** The LinkedIn provider. */
  Linkedin = 'LINKEDIN',
  /** The OAuth2 (Generic) provider. */
  Oauth2Generic = 'OAUTH2_GENERIC',
  /** The Password provider. */
  Password = 'PASSWORD',
  /** The Site Token provider. */
  Sitetoken = 'SITETOKEN'
}

/** Input for the Logout mutation. */
export type LogoutInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the Logout mutation. */
export type LogoutPayload = {
  readonly __typename?: 'LogoutPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the user was successfully logged out. Will return null if the user is not logged in. */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type MarketoInfo = {
  readonly __typename?: 'MarketoInfo';
  /** Marketo settings */
  readonly settings?: Maybe<MarketoSettings>;
  /** Marketo static lists */
  readonly staticLists?: Maybe<MarketoStaticListObject>;
};


export type MarketoInfoStaticListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  listId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  programName?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  workspaceName?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

/** Marketo settings */
export type MarketoSettings = {
  readonly __typename?: 'MarketoSettings';
  readonly clientId?: Maybe<Scalars['String']['output']>;
  readonly clientSecret?: Maybe<Scalars['String']['output']>;
  readonly formsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly hasClientSecret?: Maybe<Scalars['Boolean']['output']>;
  readonly marketoApiActive?: Maybe<Scalars['Boolean']['output']>;
  readonly munchkinId?: Maybe<Scalars['String']['output']>;
  readonly staticListIds?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
};

/** Marketo static list node */
export type MarketoStaticListNode = {
  readonly __typename?: 'MarketoStaticListNode';
  /** Static list created at */
  readonly createdAt?: Maybe<Scalars['String']['output']>;
  /** Static list id */
  readonly id?: Maybe<Scalars['ID']['output']>;
  /** Static list name */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Static list program name */
  readonly programName?: Maybe<Scalars['String']['output']>;
  /** Static list updated at */
  readonly updatedAt?: Maybe<Scalars['String']['output']>;
  /** Static list workspace id */
  readonly workspaceId?: Maybe<Scalars['ID']['output']>;
  /** Static list workspace name */
  readonly workspaceName?: Maybe<Scalars['String']['output']>;
};

/** Marketo static list object */
export type MarketoStaticListObject = {
  readonly __typename?: 'MarketoStaticListObject';
  /** Next page token */
  readonly nextPageToken?: Maybe<Scalars['String']['output']>;
  /** Static list nodes */
  readonly result?: Maybe<ReadonlyArray<Maybe<MarketoStaticListNode>>>;
};

/** Input for the marketoUpdateSettings mutation. */
export type MarketoUpdateSettingsInput = {
  readonly clientId?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly clientSecret?: InputMaybe<Scalars['String']['input']>;
  readonly formsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasClientSecret?: InputMaybe<Scalars['Boolean']['input']>;
  readonly marketoApiActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly munchkinId?: InputMaybe<Scalars['String']['input']>;
  /** Set the client secret */
  readonly setClientSecret?: InputMaybe<Scalars['String']['input']>;
  readonly staticListIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

/** The payload for the marketoUpdateSettings mutation. */
export type MarketoUpdateSettingsPayload = {
  readonly __typename?: 'MarketoUpdateSettingsPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Marketo settings */
  readonly settings?: Maybe<MarketoSettings>;
};

/** File details for a Media Item */
export type MediaDetails = {
  readonly __typename?: 'MediaDetails';
  /** The filename of the mediaItem */
  readonly file?: Maybe<Scalars['String']['output']>;
  /** The path to the mediaItem relative to the uploads directory */
  readonly filePath?: Maybe<Scalars['String']['output']>;
  /** The height of the mediaItem */
  readonly height?: Maybe<Scalars['Int']['output']>;
  /** Meta information associated with the mediaItem */
  readonly meta?: Maybe<MediaItemMeta>;
  /** The available sizes of the mediaItem */
  readonly sizes?: Maybe<ReadonlyArray<Maybe<MediaSize>>>;
  /** The width of the mediaItem */
  readonly width?: Maybe<Scalars['Int']['output']>;
};


/** File details for a Media Item */
export type MediaDetailsSizesArgs = {
  exclude?: InputMaybe<ReadonlyArray<InputMaybe<MediaItemSizeEnum>>>;
  include?: InputMaybe<ReadonlyArray<InputMaybe<MediaItemSizeEnum>>>;
};

/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItem = ContentNode & DatabaseIdentifier & HierarchicalContentNode & HierarchicalNode & Node & NodeWithAuthor & NodeWithComments & NodeWithTemplate & NodeWithTitle & UniformResourceIdentifiable & {
  readonly __typename?: 'MediaItem';
  /** Alternative text to display when resource is not displayed */
  readonly altText?: Maybe<Scalars['String']['output']>;
  /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  readonly ancestors?: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
  /** Connection between the NodeWithAuthor type and the User type */
  readonly author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the author of the node */
  readonly authorId?: Maybe<Scalars['ID']['output']>;
  /** GCP Storage Bucket */
  readonly bucket?: Maybe<BucketStorage>;
  /** The caption for the resource */
  readonly caption?: Maybe<Scalars['String']['output']>;
  /** Number of catalogs where this media item is used */
  readonly catalogCount?: Maybe<Scalars['Int']['output']>;
  /** Connection between the HierarchicalContentNode type and the ContentNode type */
  readonly children?: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  readonly commentCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the comments are open or closed for this particular post. */
  readonly commentStatus?: Maybe<Scalars['String']['output']>;
  /** Connection between the MediaItem type and the Comment type */
  readonly comments?: Maybe<MediaItemToCommentConnection>;
  /** Connection between the ContentNode type and the ContentType type */
  readonly contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  readonly contentTypeName: Scalars['String']['output'];
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  readonly date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  readonly dateGmt?: Maybe<Scalars['String']['output']>;
  /** Description of the image (stored as post_content) */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  readonly desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  readonly editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  readonly enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The filename of the mediaItem for the specified size (default size is full) */
  readonly file?: Maybe<Scalars['String']['output']>;
  /** The path to the original file relative to the uploads directory */
  readonly filePath?: Maybe<Scalars['String']['output']>;
  /** The filesize in bytes of the resource */
  readonly fileSize?: Maybe<Scalars['Int']['output']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  readonly guid?: Maybe<Scalars['String']['output']>;
  /** Whether the attachment object is password protected. */
  readonly hasPassword?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the attachment object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  readonly isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  readonly lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** List of linked catalog items */
  readonly linkedCatalog?: Maybe<ReadonlyArray<Maybe<ZnglyVideo>>>;
  /** Details about the mediaItem */
  readonly mediaDetails?: Maybe<MediaDetails>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of the databaseId field
   */
  readonly mediaItemId: Scalars['Int']['output'];
  /** Url of the mediaItem */
  readonly mediaItemUrl?: Maybe<Scalars['String']['output']>;
  /** Type of resource */
  readonly mediaType?: Maybe<Scalars['String']['output']>;
  /** The mime type of the mediaItem */
  readonly mimeType?: Maybe<Scalars['String']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  readonly modifiedGmt?: Maybe<Scalars['String']['output']>;
  /** The parent of the node. The parent object can be of various types */
  readonly parent?: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
  /** Database id of the parent node */
  readonly parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent node. */
  readonly parentId?: Maybe<Scalars['ID']['output']>;
  /** The password for the attachment object. */
  readonly password?: Maybe<Scalars['String']['output']>;
  /** The database id of the preview node */
  readonly previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  readonly previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** The sizes attribute value for an image. */
  readonly sizes?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** Url of the mediaItem */
  readonly sourceUrl?: Maybe<Scalars['String']['output']>;
  /** The srcset attribute specifies the URL of the image to use in different situations. It is a comma separated string of urls and their widths. */
  readonly srcSet?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  readonly status?: Maybe<Scalars['String']['output']>;
  /** The template assigned to a node of content */
  readonly template?: Maybe<ContentTemplate>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  readonly title?: Maybe<Scalars['String']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemCaptionArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MediaItemToCommentConnectionWhereArgs>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemDescriptionArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemFileArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemFilePathArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemFileSizeArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemSizesArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemSourceUrlArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemSrcSetArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A paginated collection of mediaItem Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of mediaItem Nodes */
export type MediaItemConnection = {
  /** A list of edges (relational context) between RootQuery and connected mediaItem Nodes */
  readonly edges: ReadonlyArray<MediaItemConnectionEdge>;
  /** A list of connected mediaItem Nodes */
  readonly nodes: ReadonlyArray<MediaItem>;
  /** Information about pagination in a connection. */
  readonly pageInfo: MediaItemConnectionPageInfo;
};

/** Represents a connection to a mediaItem. Contains both the mediaItem Node and metadata about the relationship. */
export type MediaItemConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected mediaItem Node */
  readonly node: MediaItem;
};

/** Pagination metadata specific to &quot;MediaItemConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;MediaItemConnectionEdge&quot; Nodes. */
export type MediaItemConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifier types for retrieving a specific MediaItem. Specifies which unique attribute is used to find an exact MediaItem. */
export enum MediaItemIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a media item by its source url */
  SourceUrl = 'SOURCE_URL',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Meta connected to a MediaItem */
export type MediaItemMeta = {
  readonly __typename?: 'MediaItemMeta';
  /** Aperture measurement of the media item. */
  readonly aperture?: Maybe<Scalars['Float']['output']>;
  /** Information about the camera used to create the media item. */
  readonly camera?: Maybe<Scalars['String']['output']>;
  /** The text string description associated with the media item. */
  readonly caption?: Maybe<Scalars['String']['output']>;
  /** Copyright information associated with the media item. */
  readonly copyright?: Maybe<Scalars['String']['output']>;
  /** The date/time when the media was created. */
  readonly createdTimestamp?: Maybe<Scalars['Int']['output']>;
  /** The original creator of the media item. */
  readonly credit?: Maybe<Scalars['String']['output']>;
  /** The focal length value of the media item. */
  readonly focalLength?: Maybe<Scalars['Float']['output']>;
  /** The ISO (International Organization for Standardization) value of the media item. */
  readonly iso?: Maybe<Scalars['Int']['output']>;
  /** List of keywords used to describe or identfy the media item. */
  readonly keywords?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** The vertical or horizontal aspect of the media item. */
  readonly orientation?: Maybe<Scalars['String']['output']>;
  /** The shutter speed information of the media item. */
  readonly shutterSpeed?: Maybe<Scalars['Float']['output']>;
  /** A useful title for the media item. */
  readonly title?: Maybe<Scalars['String']['output']>;
};

/** Predefined image size variations. Represents the standard image dimensions available for media assets. */
export enum MediaItemSizeEnum {
  /** Large image preview suitable for detail views. (1024x1024) */
  Large = 'LARGE',
  /** Medium image preview typically suitable for listings and detail views. (300x300) */
  Medium = 'MEDIUM',
  /** Medium-to-large image preview suitable for listings and detail views. (768x0) */
  MediumLarge = 'MEDIUM_LARGE',
  /** Small image preview suitable for thumbnails and listings. (150x150) */
  Thumbnail = 'THUMBNAIL',
  /** Custom Image Size. (1536x1536) */
  '1536X1536' = '_1536X1536',
  /** Custom Image Size. (2048x2048) */
  '2048X2048' = '_2048X2048'
}

/** Publication status for media items. Controls whether media is publicly accessible, private, or in another state. */
export enum MediaItemStatusEnum {
  /** Automatically created media that has not been finalized */
  AutoDraft = 'AUTO_DRAFT',
  /** Media that inherits its publication status from the parent content */
  Inherit = 'INHERIT',
  /** Media visible only to users with appropriate permissions */
  Private = 'PRIVATE',
  /** Media marked for deletion but still recoverable */
  Trash = 'TRASH'
}

/** Connection between the MediaItem type and the Comment type */
export type MediaItemToCommentConnection = CommentConnection & Connection & {
  readonly __typename?: 'MediaItemToCommentConnection';
  /** Edges for the MediaItemToCommentConnection connection */
  readonly edges: ReadonlyArray<MediaItemToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Comment>;
  /** Information about pagination in a connection. */
  readonly pageInfo: MediaItemToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type MediaItemToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  readonly __typename?: 'MediaItemToCommentConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Comment;
};

/** Pagination metadata specific to &quot;MediaItemToCommentConnection&quot; collections. Provides cursors and flags for navigating through sets of MediaItemToCommentConnection Nodes. */
export type MediaItemToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'MediaItemToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the MediaItemToCommentConnection connection */
export type MediaItemToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  readonly authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  readonly authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  readonly commentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  readonly commentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  readonly commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  readonly commentTypeIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  readonly commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  readonly contentAuthor?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  readonly contentAuthorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  readonly contentAuthorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  readonly contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  readonly contentIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  readonly contentIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  readonly contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  readonly contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentStatus?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentType?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  readonly includeUnapproved?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  readonly karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  readonly orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Details of an available size for a media item */
export type MediaSize = {
  readonly __typename?: 'MediaSize';
  /** The filename of the referenced size */
  readonly file?: Maybe<Scalars['String']['output']>;
  /** The path of the file for the referenced size (default size is full) */
  readonly filePath?: Maybe<Scalars['String']['output']>;
  /** The filesize of the resource */
  readonly fileSize?: Maybe<Scalars['Int']['output']>;
  /** The height of the referenced size */
  readonly height?: Maybe<Scalars['String']['output']>;
  /** The mime type of the referenced size */
  readonly mimeType?: Maybe<Scalars['String']['output']>;
  /** The referenced size name */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** The url of the referenced size */
  readonly sourceUrl?: Maybe<Scalars['String']['output']>;
  /** The width of the referenced size */
  readonly width?: Maybe<Scalars['String']['output']>;
};

/** Collections of navigation links. Menus can be assigned to designated locations and used to build site navigation structures. */
export type Menu = DatabaseIdentifier & Node & {
  readonly __typename?: 'Menu';
  /** The number of items in the menu */
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** The globally unique identifier of the nav menu object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** The locations a menu is assigned to */
  readonly locations?: Maybe<ReadonlyArray<Maybe<MenuLocationEnum>>>;
  /**
   * WP ID of the nav menu.
   * @deprecated Deprecated in favor of the databaseId field
   */
  readonly menuId?: Maybe<Scalars['Int']['output']>;
  /** Connection between the Menu type and the MenuItem type */
  readonly menuItems?: Maybe<MenuToMenuItemConnection>;
  /** Display name of the menu. Equivalent to WP_Term-&gt;name. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** The url friendly name of the menu. Equivalent to WP_Term-&gt;slug */
  readonly slug?: Maybe<Scalars['String']['output']>;
};


/** Collections of navigation links. Menus can be assigned to designated locations and used to build site navigation structures. */
export type MenuMenuItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MenuToMenuItemConnectionWhereArgs>;
};

/** A paginated collection of Menu Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of Menu Nodes */
export type MenuConnection = {
  /** A list of edges (relational context) between RootQuery and connected Menu Nodes */
  readonly edges: ReadonlyArray<MenuConnectionEdge>;
  /** A list of connected Menu Nodes */
  readonly nodes: ReadonlyArray<Menu>;
  /** Information about pagination in a connection. */
  readonly pageInfo: MenuConnectionPageInfo;
};

/** Represents a connection to a Menu. Contains both the Menu Node and metadata about the relationship. */
export type MenuConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Menu Node */
  readonly node: Menu;
};

/** Pagination metadata specific to &quot;MenuConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;MenuConnectionEdge&quot; Nodes. */
export type MenuConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Navigation menu items are the individual items assigned to a menu. These are rendered as the links in a navigation menu. */
export type MenuItem = DatabaseIdentifier & Node & {
  readonly __typename?: 'MenuItem';
  /** Connection between the MenuItem type and the MenuItem type */
  readonly childItems?: Maybe<MenuItemToMenuItemConnection>;
  /** Connection from MenuItem to it&#039;s connected node */
  readonly connectedNode?: Maybe<MenuItemToMenuItemLinkableConnectionEdge>;
  /**
   * The object connected to this menu item.
   * @deprecated Deprecated in favor of the connectedNode field
   */
  readonly connectedObject?: Maybe<MenuItemObjectUnion>;
  /** Class attribute for the menu item link */
  readonly cssClasses?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** Description of the menu item. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier of the nav menu item object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Label or title of the menu item. */
  readonly label?: Maybe<Scalars['String']['output']>;
  /** Link relationship (XFN) of the menu item. */
  readonly linkRelationship?: Maybe<Scalars['String']['output']>;
  /** The locations the menu item&#039;s Menu is assigned to */
  readonly locations?: Maybe<ReadonlyArray<Maybe<MenuLocationEnum>>>;
  /** The Menu a MenuItem is part of */
  readonly menu?: Maybe<MenuItemToMenuConnectionEdge>;
  /**
   * WP ID of the menu item.
   * @deprecated Deprecated in favor of the databaseId field
   */
  readonly menuItemId?: Maybe<Scalars['Int']['output']>;
  /** Menu item order */
  readonly order?: Maybe<Scalars['Int']['output']>;
  /** The database id of the parent menu item or null if it is the root */
  readonly parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent nav menu item object. */
  readonly parentId?: Maybe<Scalars['ID']['output']>;
  /** Path for the resource. Relative path for internal resources. Absolute path for external resources. */
  readonly path?: Maybe<Scalars['String']['output']>;
  /** Target attribute for the menu item link. */
  readonly target?: Maybe<Scalars['String']['output']>;
  /** Title attribute for the menu item link */
  readonly title?: Maybe<Scalars['String']['output']>;
  /** The uri of the resource the menu item links to */
  readonly uri?: Maybe<Scalars['String']['output']>;
  /** URL or destination of the menu item. */
  readonly url?: Maybe<Scalars['String']['output']>;
};


/** Navigation menu items are the individual items assigned to a menu. These are rendered as the links in a navigation menu. */
export type MenuItemChildItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MenuItemToMenuItemConnectionWhereArgs>;
};

/** A paginated collection of MenuItem Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of MenuItem Nodes */
export type MenuItemConnection = {
  /** A list of edges (relational context) between RootQuery and connected MenuItem Nodes */
  readonly edges: ReadonlyArray<MenuItemConnectionEdge>;
  /** A list of connected MenuItem Nodes */
  readonly nodes: ReadonlyArray<MenuItem>;
  /** Information about pagination in a connection. */
  readonly pageInfo: MenuItemConnectionPageInfo;
};

/** Represents a connection to a MenuItem. Contains both the MenuItem Node and metadata about the relationship. */
export type MenuItemConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected MenuItem Node */
  readonly node: MenuItem;
};

/** Pagination metadata specific to &quot;MenuItemConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;MenuItemConnectionEdge&quot; Nodes. */
export type MenuItemConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Content that can be referenced by navigation menu items. Provides the essential fields needed to create links within navigation structures. */
export type MenuItemLinkable = {
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};

/** Represents a connection to a MenuItemLinkable. Contains both the MenuItemLinkable Node and metadata about the relationship. */
export type MenuItemLinkableConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected MenuItemLinkable Node */
  readonly node: MenuItemLinkable;
};

/** Identifier types for retrieving a specific menu item. Determines whether to look up menu items by global ID or database ID. */
export enum MenuItemNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID'
}

/** Deprecated in favor of MenuItemLinkeable Interface */
export type MenuItemObjectUnion = Category | Page | Post | Tag | Znglist | ZnglyInfo | ZnglyVideo;

/** Connection between the MenuItem type and the Menu type */
export type MenuItemToMenuConnectionEdge = Edge & MenuConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'MenuItemToMenuConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Menu;
};

/** Connection between the MenuItem type and the MenuItem type */
export type MenuItemToMenuItemConnection = Connection & MenuItemConnection & {
  readonly __typename?: 'MenuItemToMenuItemConnection';
  /** Edges for the MenuItemToMenuItemConnection connection */
  readonly edges: ReadonlyArray<MenuItemToMenuItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<MenuItem>;
  /** Information about pagination in a connection. */
  readonly pageInfo: MenuItemToMenuItemConnectionPageInfo;
};

/** An edge in a connection */
export type MenuItemToMenuItemConnectionEdge = Edge & MenuItemConnectionEdge & {
  readonly __typename?: 'MenuItemToMenuItemConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: MenuItem;
};

/** Pagination metadata specific to &quot;MenuItemToMenuItemConnection&quot; collections. Provides cursors and flags for navigating through sets of MenuItemToMenuItemConnection Nodes. */
export type MenuItemToMenuItemConnectionPageInfo = MenuItemConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'MenuItemToMenuItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the MenuItemToMenuItemConnection connection */
export type MenuItemToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** The menu location for the menu being queried */
  readonly location?: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  readonly parentDatabaseId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the parent menu object */
  readonly parentId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the MenuItem type and the MenuItemLinkable type */
export type MenuItemToMenuItemLinkableConnectionEdge = Edge & MenuItemLinkableConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'MenuItemToMenuItemLinkableConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: MenuItemLinkable;
};

/** Designated areas where navigation menus can be displayed. Represents the named regions in the interface where menus can be assigned. */
export enum MenuLocationEnum {
  /** Empty menu location */
  Empty = 'EMPTY'
}

/** Identifier types for retrieving a specific navigation menu. Specifies which property (ID, name, location) is used to locate a particular menu. */
export enum MenuNodeIdTypeEnum {
  /** Identify a menu node by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a menu node by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a menu node by the slug of menu location to which it is assigned */
  Location = 'LOCATION',
  /** Identify a menu node by its name */
  Name = 'NAME',
  /** Identify a menu node by its slug */
  Slug = 'SLUG'
}

/** Connection between the Menu type and the MenuItem type */
export type MenuToMenuItemConnection = Connection & MenuItemConnection & {
  readonly __typename?: 'MenuToMenuItemConnection';
  /** Edges for the MenuToMenuItemConnection connection */
  readonly edges: ReadonlyArray<MenuToMenuItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<MenuItem>;
  /** Information about pagination in a connection. */
  readonly pageInfo: MenuToMenuItemConnectionPageInfo;
};

/** An edge in a connection */
export type MenuToMenuItemConnectionEdge = Edge & MenuItemConnectionEdge & {
  readonly __typename?: 'MenuToMenuItemConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: MenuItem;
};

/** Pagination metadata specific to &quot;MenuToMenuItemConnection&quot; collections. Provides cursors and flags for navigating through sets of MenuToMenuItemConnection Nodes. */
export type MenuToMenuItemConnectionPageInfo = MenuItemConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'MenuToMenuItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the MenuToMenuItemConnection connection */
export type MenuToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** The menu location for the menu being queried */
  readonly location?: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  readonly parentDatabaseId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the parent menu object */
  readonly parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type MetaArray = {
  /** Custom field value */
  readonly compare?: InputMaybe<MetaCompareEnum>;
  /** Custom field key */
  readonly key?: InputMaybe<Scalars['String']['input']>;
  /** Custom field value */
  readonly type?: InputMaybe<MetaTypeEnum>;
  /** Custom field value */
  readonly value?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export enum MetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE'
}

export type MetaQuery = {
  readonly metaArray?: InputMaybe<ReadonlyArray<InputMaybe<MetaArray>>>;
  readonly relation?: InputMaybe<RelationEnum>;
};

export enum MetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED'
}

/** Media file type classification based on MIME standards. Used to identify and filter media items by their format and content type. */
export enum MimeTypeEnum {
  /** application/java mime type. */
  ApplicationJava = 'APPLICATION_JAVA',
  /** application/msword mime type. */
  ApplicationMsword = 'APPLICATION_MSWORD',
  /** application/octet-stream mime type. */
  ApplicationOctetStream = 'APPLICATION_OCTET_STREAM',
  /** application/onenote mime type. */
  ApplicationOnenote = 'APPLICATION_ONENOTE',
  /** application/oxps mime type. */
  ApplicationOxps = 'APPLICATION_OXPS',
  /** application/pdf mime type. */
  ApplicationPdf = 'APPLICATION_PDF',
  /** application/rar mime type. */
  ApplicationRar = 'APPLICATION_RAR',
  /** application/rtf mime type. */
  ApplicationRtf = 'APPLICATION_RTF',
  /** application/ttaf+xml mime type. */
  ApplicationTtafXml = 'APPLICATION_TTAF_XML',
  /** application/vnd.apple.keynote mime type. */
  ApplicationVndAppleKeynote = 'APPLICATION_VND_APPLE_KEYNOTE',
  /** application/vnd.apple.numbers mime type. */
  ApplicationVndAppleNumbers = 'APPLICATION_VND_APPLE_NUMBERS',
  /** application/vnd.apple.pages mime type. */
  ApplicationVndApplePages = 'APPLICATION_VND_APPLE_PAGES',
  /** application/vnd.ms-access mime type. */
  ApplicationVndMsAccess = 'APPLICATION_VND_MS_ACCESS',
  /** application/vnd.ms-excel mime type. */
  ApplicationVndMsExcel = 'APPLICATION_VND_MS_EXCEL',
  /** application/vnd.ms-excel.addin.macroEnabled.12 mime type. */
  ApplicationVndMsExcelAddinMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12',
  /** application/vnd.ms-excel.sheet.binary.macroEnabled.12 mime type. */
  ApplicationVndMsExcelSheetBinaryMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12',
  /** application/vnd.ms-excel.sheet.macroEnabled.12 mime type. */
  ApplicationVndMsExcelSheetMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12',
  /** application/vnd.ms-excel.template.macroEnabled.12 mime type. */
  ApplicationVndMsExcelTemplateMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12',
  /** application/vnd.ms-powerpoint mime type. */
  ApplicationVndMsPowerpoint = 'APPLICATION_VND_MS_POWERPOINT',
  /** application/vnd.ms-powerpoint.addin.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointAddinMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.presentation.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointPresentationMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.slideshow.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointSlideshowMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.slide.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointSlideMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_SLIDE_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.template.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointTemplateMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACROENABLED_12',
  /** application/vnd.ms-project mime type. */
  ApplicationVndMsProject = 'APPLICATION_VND_MS_PROJECT',
  /** application/vnd.ms-word.document.macroEnabled.12 mime type. */
  ApplicationVndMsWordDocumentMacroenabled_12 = 'APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12',
  /** application/vnd.ms-word.template.macroEnabled.12 mime type. */
  ApplicationVndMsWordTemplateMacroenabled_12 = 'APPLICATION_VND_MS_WORD_TEMPLATE_MACROENABLED_12',
  /** application/vnd.ms-write mime type. */
  ApplicationVndMsWrite = 'APPLICATION_VND_MS_WRITE',
  /** application/vnd.ms-xpsdocument mime type. */
  ApplicationVndMsXpsdocument = 'APPLICATION_VND_MS_XPSDOCUMENT',
  /** application/vnd.oasis.opendocument.chart mime type. */
  ApplicationVndOasisOpendocumentChart = 'APPLICATION_VND_OASIS_OPENDOCUMENT_CHART',
  /** application/vnd.oasis.opendocument.database mime type. */
  ApplicationVndOasisOpendocumentDatabase = 'APPLICATION_VND_OASIS_OPENDOCUMENT_DATABASE',
  /** application/vnd.oasis.opendocument.formula mime type. */
  ApplicationVndOasisOpendocumentFormula = 'APPLICATION_VND_OASIS_OPENDOCUMENT_FORMULA',
  /** application/vnd.oasis.opendocument.graphics mime type. */
  ApplicationVndOasisOpendocumentGraphics = 'APPLICATION_VND_OASIS_OPENDOCUMENT_GRAPHICS',
  /** application/vnd.oasis.opendocument.presentation mime type. */
  ApplicationVndOasisOpendocumentPresentation = 'APPLICATION_VND_OASIS_OPENDOCUMENT_PRESENTATION',
  /** application/vnd.oasis.opendocument.spreadsheet mime type. */
  ApplicationVndOasisOpendocumentSpreadsheet = 'APPLICATION_VND_OASIS_OPENDOCUMENT_SPREADSHEET',
  /** application/vnd.oasis.opendocument.text mime type. */
  ApplicationVndOasisOpendocumentText = 'APPLICATION_VND_OASIS_OPENDOCUMENT_TEXT',
  /** application/vnd.openxmlformats-officedocument.presentationml.presentation mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlPresentation = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION',
  /** application/vnd.openxmlformats-officedocument.presentationml.slide mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlSlide = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDE',
  /** application/vnd.openxmlformats-officedocument.presentationml.slideshow mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlSlideshow = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW',
  /** application/vnd.openxmlformats-officedocument.presentationml.template mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE',
  /** application/vnd.openxmlformats-officedocument.spreadsheetml.sheet mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET',
  /** application/vnd.openxmlformats-officedocument.spreadsheetml.template mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE',
  /** application/vnd.openxmlformats-officedocument.wordprocessingml.document mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlDocument = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT',
  /** application/vnd.openxmlformats-officedocument.wordprocessingml.template mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE',
  /** application/wordperfect mime type. */
  ApplicationWordperfect = 'APPLICATION_WORDPERFECT',
  /** application/x-7z-compressed mime type. */
  ApplicationX_7ZCompressed = 'APPLICATION_X_7Z_COMPRESSED',
  /** application/x-gzip mime type. */
  ApplicationXGzip = 'APPLICATION_X_GZIP',
  /** application/x-tar mime type. */
  ApplicationXTar = 'APPLICATION_X_TAR',
  /** application/zip mime type. */
  ApplicationZip = 'APPLICATION_ZIP',
  /** audio/aac mime type. */
  AudioAac = 'AUDIO_AAC',
  /** audio/flac mime type. */
  AudioFlac = 'AUDIO_FLAC',
  /** audio/midi mime type. */
  AudioMidi = 'AUDIO_MIDI',
  /** audio/mpeg mime type. */
  AudioMpeg = 'AUDIO_MPEG',
  /** audio/ogg mime type. */
  AudioOgg = 'AUDIO_OGG',
  /** audio/wav mime type. */
  AudioWav = 'AUDIO_WAV',
  /** audio/x-matroska mime type. */
  AudioXMatroska = 'AUDIO_X_MATROSKA',
  /** audio/x-ms-wax mime type. */
  AudioXMsWax = 'AUDIO_X_MS_WAX',
  /** audio/x-ms-wma mime type. */
  AudioXMsWma = 'AUDIO_X_MS_WMA',
  /** audio/x-realaudio mime type. */
  AudioXRealaudio = 'AUDIO_X_REALAUDIO',
  /** font/otf mime type. */
  FontOtf = 'FONT_OTF',
  /** font/ttf mime type. */
  FontTtf = 'FONT_TTF',
  /** font/woff mime type. */
  FontWoff = 'FONT_WOFF',
  /** font/woff2 mime type. */
  FontWoff2 = 'FONT_WOFF2',
  /** image/avif mime type. */
  ImageAvif = 'IMAGE_AVIF',
  /** image/bmp mime type. */
  ImageBmp = 'IMAGE_BMP',
  /** image/gif mime type. */
  ImageGif = 'IMAGE_GIF',
  /** image/heic mime type. */
  ImageHeic = 'IMAGE_HEIC',
  /** image/heic-sequence mime type. */
  ImageHeicSequence = 'IMAGE_HEIC_SEQUENCE',
  /** image/heif mime type. */
  ImageHeif = 'IMAGE_HEIF',
  /** image/heif-sequence mime type. */
  ImageHeifSequence = 'IMAGE_HEIF_SEQUENCE',
  /** image/jpeg mime type. */
  ImageJpeg = 'IMAGE_JPEG',
  /** image/png mime type. */
  ImagePng = 'IMAGE_PNG',
  /** image/tiff mime type. */
  ImageTiff = 'IMAGE_TIFF',
  /** image/webp mime type. */
  ImageWebp = 'IMAGE_WEBP',
  /** image/x-icon mime type. */
  ImageXIcon = 'IMAGE_X_ICON',
  /** text/calendar mime type. */
  TextCalendar = 'TEXT_CALENDAR',
  /** text/css mime type. */
  TextCss = 'TEXT_CSS',
  /** text/csv mime type. */
  TextCsv = 'TEXT_CSV',
  /** text/plain mime type. */
  TextPlain = 'TEXT_PLAIN',
  /** text/richtext mime type. */
  TextRichtext = 'TEXT_RICHTEXT',
  /** text/tab-separated-values mime type. */
  TextTabSeparatedValues = 'TEXT_TAB_SEPARATED_VALUES',
  /** text/vtt mime type. */
  TextVtt = 'TEXT_VTT',
  /** video/3gpp mime type. */
  Video_3Gpp = 'VIDEO_3GPP',
  /** video/3gpp2 mime type. */
  Video_3Gpp2 = 'VIDEO_3GPP2',
  /** video/avi mime type. */
  VideoAvi = 'VIDEO_AVI',
  /** video/divx mime type. */
  VideoDivx = 'VIDEO_DIVX',
  /** video/mp4 mime type. */
  VideoMp4 = 'VIDEO_MP4',
  /** video/mpeg mime type. */
  VideoMpeg = 'VIDEO_MPEG',
  /** video/ogg mime type. */
  VideoOgg = 'VIDEO_OGG',
  /** video/quicktime mime type. */
  VideoQuicktime = 'VIDEO_QUICKTIME',
  /** video/webm mime type. */
  VideoWebm = 'VIDEO_WEBM',
  /** video/x-flv mime type. */
  VideoXFlv = 'VIDEO_X_FLV',
  /** video/x-matroska mime type. */
  VideoXMatroska = 'VIDEO_X_MATROSKA',
  /** video/x-ms-asf mime type. */
  VideoXMsAsf = 'VIDEO_X_MS_ASF',
  /** video/x-ms-wm mime type. */
  VideoXMsWm = 'VIDEO_X_MS_WM',
  /** video/x-ms-wmv mime type. */
  VideoXMsWmv = 'VIDEO_X_MS_WMV',
  /** video/x-ms-wmx mime type. */
  VideoXMsWmx = 'VIDEO_X_MS_WMX'
}

/** Input for the msAuthenticateTenant mutation. */
export type MsAuthenticateTenantInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The tenant ID */
  readonly tenantId?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the msAuthenticateTenant mutation. */
export type MsAuthenticateTenantPayload = {
  readonly __typename?: 'MsAuthenticateTenantPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** whether the mutation was successful */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type MsInfo = {
  readonly __typename?: 'MsInfo';
  /** Do an action */
  readonly isAuthenticated?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for the msRemoveTenant mutation. */
export type MsRemoveTenantInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Remove the tenant */
  readonly remove?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the msRemoveTenant mutation. */
export type MsRemoveTenantPayload = {
  readonly __typename?: 'MsRemoveTenantPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** whether the mutation was successful */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type MsSharePoint = {
  readonly __typename?: 'MsSharePoint';
  /** Do an action */
  readonly data?: Maybe<Scalars['String']['output']>;
};

/** Input for the newMediaItem mutation. */
export type NewMediaItemInput = {
  /** Alternative text to display when mediaItem is not displayed */
  readonly altText?: InputMaybe<Scalars['String']['input']>;
  /** The userId to assign as the author of the mediaItem */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The caption for the mediaItem */
  readonly caption?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment status for the mediaItem */
  readonly commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The date of the mediaItem */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** The date (in GMT zone) of the mediaItem */
  readonly dateGmt?: InputMaybe<Scalars['String']['input']>;
  /** Description of the mediaItem */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The mediaItem files to upload. Only One File will be accepted */
  readonly file?: InputMaybe<Scalars['Upload']['input']>;
  /** The file type of the mediaItem */
  readonly fileType?: InputMaybe<MimeTypeEnum>;
  /** The ID of the parent object */
  readonly parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The ping status for the mediaItem */
  readonly pingStatus?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the mediaItem */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the mediaItem */
  readonly status?: InputMaybe<MediaItemStatusEnum>;
  /** The title of the mediaItem */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the newMediaItem mutation. */
export type NewMediaItemPayload = {
  readonly __typename?: 'NewMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The MediaItem object mutation type. */
  readonly mediaItem?: Maybe<MediaItem>;
};

/** An object with a globally unique identifier. All objects that can be identified by a unique ID implement this interface. */
export type Node = {
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
};

/** Content that can be attributed to a specific user. Provides fields for accessing the author&#039;s information and establishing content ownership. */
export type NodeWithAuthor = {
  /** Connection between the NodeWithAuthor type and the User type */
  readonly author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the author of the node */
  readonly authorId?: Maybe<Scalars['ID']['output']>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
};

/** Connection between the NodeWithAuthor type and the User type */
export type NodeWithAuthorToUserConnectionEdge = Edge & OneToOneConnection & UserConnectionEdge & {
  readonly __typename?: 'NodeWithAuthorToUserConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: User;
};

/** Content that can receive and display user-submitted comments. Provides fields for accessing comment counts and managing comment status. */
export type NodeWithComments = {
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  readonly commentCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the comments are open or closed for this particular post. */
  readonly commentStatus?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
};

/** Content that has a main body field which can contain formatted text and media. Provides access to both raw (with appropriate permissions) and rendered versions of the content. */
export type NodeWithContentEditor = {
  /** The content of the post. */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  readonly unencodedContent?: Maybe<Scalars['String']['output']>;
};


/** Content that has a main body field which can contain formatted text and media. Provides access to both raw (with appropriate permissions) and rendered versions of the content. */
export type NodeWithContentEditorContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A node which provides an excerpt field, which is a condensed summary of the main content. Excerpts can be manually created or automatically generated and are often used in content listings and search results. */
export type NodeWithExcerpt = {
  /** The excerpt of the post. */
  readonly excerpt?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
};


/** A node which provides an excerpt field, which is a condensed summary of the main content. Excerpts can be manually created or automatically generated and are often used in content listings and search results. */
export type NodeWithExcerptExcerptArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Content that can have a primary image attached. This image is typically used for thumbnails, social sharing, and prominent display in the presentation layer. */
export type NodeWithFeaturedImage = {
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  readonly featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  readonly featuredImageDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Globally unique ID of the featured image assigned to the node */
  readonly featuredImageId?: Maybe<Scalars['ID']['output']>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
};

/** Connection between the NodeWithFeaturedImage type and the MediaItem type */
export type NodeWithFeaturedImageToMediaItemConnectionEdge = Edge & MediaItemConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: MediaItem;
};

/** Content that supports ordering metadata. Includes a menu order field which can be used for custom sorting in navigation menus and other ordered collections. */
export type NodeWithPageAttributes = {
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  readonly menuOrder?: Maybe<Scalars['Int']['output']>;
};

/** Content that maintains a history of changes. Provides access to previous versions of the content and the ability to restore earlier revisions. */
export type NodeWithRevisions = {
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** True if the node is a revision of another node */
  readonly isRevision?: Maybe<Scalars['Boolean']['output']>;
  /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
  readonly revisionOf?: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
};

/** Connection between the NodeWithRevisions type and the ContentNode type */
export type NodeWithRevisionsToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & OneToOneConnection & {
  readonly __typename?: 'NodeWithRevisionsToContentNodeConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: ContentNode;
};

/** Content that provides template metadata. The template can help inform how the content is might be structured, styled, and presented to the user. */
export type NodeWithTemplate = {
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** The template assigned to the node */
  readonly template?: Maybe<ContentTemplate>;
};

/** Content with a dedicated title field. The title typically serves as the main heading and identifier for the content. */
export type NodeWithTitle = {
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  readonly title?: Maybe<Scalars['String']['output']>;
};


/** Content with a dedicated title field. The title typically serves as the main heading and identifier for the content. */
export type NodeWithTitleTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Content that supports cross-site notifications when linked to by other sites. Includes fields for pingback status and linked URLs. */
export type NodeWithTrackbacks = {
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** Whether the pings are open or closed for this particular post. */
  readonly pingStatus?: Maybe<Scalars['String']['output']>;
  /** URLs that have been pinged. */
  readonly pinged?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** URLs queued to be pinged. */
  readonly toPing?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
};

/** A node that can have an author assigned to it */
export type NodeWizAuthor = {
  /** Connection between the NodeWizAuthor type and the User type */
  readonly author?: Maybe<NodeWizAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the author of the node */
  readonly authorId?: Maybe<Scalars['ID']['output']>;
};

/** Connection between the NodeWizAuthor type and the User type */
export type NodeWizAuthorToUserConnectionEdge = Edge & OneToOneConnection & UserConnectionEdge & {
  readonly __typename?: 'NodeWizAuthorToUserConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: User;
};

/** A node that can have an author assigned to it */
export type NodeWizUser = {
  /** Connection between the NodeWizUser type and the User type */
  readonly user?: Maybe<NodeWizUserToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly userDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the author of the node */
  readonly userId?: Maybe<Scalars['ID']['output']>;
};

/** Connection between the NodeWizUser type and the User type */
export type NodeWizUserToUserConnectionEdge = Edge & OneToOneConnection & UserConnectionEdge & {
  readonly __typename?: 'NodeWizUserToUserConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: User;
};

/** The parsed response from the OAuth Provider. */
export type OAuthProviderResponseInput = {
  /** The authorization code returned from the OAuth provider. */
  readonly code: Scalars['String']['input'];
  /** The code verifier used to generate the authorization code. */
  readonly code_verifier?: InputMaybe<Scalars['String']['input']>;
  /** The state returned from the OAuth provider. */
  readonly state?: InputMaybe<Scalars['String']['input']>;
};

/** The Login client options for the oauth2-generic provider. */
export type Oauth2GenericClientOptions = LoginClientOptions & {
  readonly __typename?: 'Oauth2GenericClientOptions';
  /** The URL to request an access token. */
  readonly accessTokenUrl?: Maybe<Scalars['String']['output']>;
  /** The URL to redirect the user to in order to authorize the client. */
  readonly authorizationUrl?: Maybe<Scalars['String']['output']>;
  /** The client ID. */
  readonly clientId?: Maybe<Scalars['String']['output']>;
  /** The client Secret. */
  readonly clientSecret?: Maybe<Scalars['String']['output']>;
  /** The client redirect URI. */
  readonly redirectUri?: Maybe<Scalars['String']['output']>;
  /** The URL to request the resource owner details. */
  readonly resourceOwnerUrl?: Maybe<Scalars['String']['output']>;
  /** The different scopes to request from the Generic OAuth2 API. */
  readonly scope?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** The scope separator to use when building the authorization URL. Defaults to `,`. */
  readonly scopeSeparator?: Maybe<Scalars['String']['output']>;
  /** This field exists solely to generate the  ClientOptions interface, in lieu of the shared custom fields that will be added in a future release */
  readonly todo?: Maybe<Scalars['Boolean']['output']>;
};

/** The Headless Login options for the oauth2-generic provider. */
export type Oauth2GenericLoginOptions = LoginOptions & {
  readonly __typename?: 'Oauth2GenericLoginOptions';
  /** Whether to create users if none exist. */
  readonly createUserIfNoneExists?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to link existing users. */
  readonly linkExistingUsers?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to set a WordPress authentication cookie on successful login. */
  readonly useAuthenticationCookie?: Maybe<Scalars['Boolean']['output']>;
};

export type OembedV2 = {
  readonly __typename?: 'OembedV2';
  /** The resource author name */
  readonly authorName?: Maybe<Scalars['String']['output']>;
  /** The resource author url */
  readonly authorUrl?: Maybe<Scalars['String']['output']>;
  /** The CMS used */
  readonly cms?: Maybe<Scalars['String']['output']>;
  /** The page description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The mime type of the embed code */
  readonly embedMimeType?: Maybe<Scalars['String']['output']>;
  /** The favicon of the site */
  readonly favicon?: Maybe<Scalars['String']['output']>;
  /** The RSS/Atom feeds */
  readonly feed?: Maybe<Scalars['String']['output']>;
  /** The exact height of the embed code (if exists) */
  readonly height?: Maybe<Scalars['Int']['output']>;
  /** The code to embed the image, video, etc */
  readonly html?: Maybe<Scalars['String']['output']>;
  /** The big icon of the site */
  readonly icon?: Maybe<Scalars['String']['output']>;
  /** The thumbnail or main image */
  readonly image?: Maybe<Scalars['String']['output']>;
  /** The page keywords */
  readonly keywords?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** The language of the page */
  readonly language?: Maybe<Scalars['String']['output']>;
  /** The alternative languages */
  readonly languages?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** The license of the resource */
  readonly license?: Maybe<Scalars['String']['output']>;
  /** The provider name of the page (Youtube, Twitter, Instagram, etc) */
  readonly providerName?: Maybe<Scalars['String']['output']>;
  /** The provider url  */
  readonly providerUrl?: Maybe<Scalars['String']['output']>;
  /** The published timestamp of the resource */
  readonly publishedTime?: Maybe<Scalars['Int']['output']>;
  /** The aspect ratio (width/height) */
  readonly ratio?: Maybe<Scalars['String']['output']>;
  /** The page title */
  readonly title?: Maybe<Scalars['String']['output']>;
  /** The canonical url */
  readonly url?: Maybe<Scalars['String']['output']>;
  /** The exact width of the embed code (if exists) */
  readonly width?: Maybe<Scalars['Int']['output']>;
};

/** A direct one-to-one relationship between objects. Unlike plural connections, this represents a single related object rather than a collection. */
export type OneToOneConnection = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected node */
  readonly node: Node;
};

/** Sort direction for ordered results. Determines whether items are returned in ascending or descending order. */
export enum OrderEnum {
  /** Results ordered from lowest to highest values (i.e. A-Z, oldest-newest) */
  Asc = 'ASC',
  /** Results ordered from highest to lowest values (i.e. Z-A, newest-oldest) */
  Desc = 'DESC'
}

/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type Page = ContentNode & DatabaseIdentifier & HierarchicalContentNode & HierarchicalNode & MenuItemLinkable & Node & NodeWithAuthor & NodeWithComments & NodeWithContentEditor & NodeWithFeaturedImage & NodeWithPageAttributes & NodeWithRevisions & NodeWithTemplate & NodeWithTitle & Previewable & UniformResourceIdentifiable & {
  readonly __typename?: 'Page';
  /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  readonly ancestors?: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
  /** Connection between the NodeWithAuthor type and the User type */
  readonly author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the author of the node */
  readonly authorId?: Maybe<Scalars['ID']['output']>;
  /** Connection between the HierarchicalContentNode type and the ContentNode type */
  readonly children?: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  readonly commentCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the comments are open or closed for this particular post. */
  readonly commentStatus?: Maybe<Scalars['String']['output']>;
  /** Connection between the Page type and the Comment type */
  readonly comments?: Maybe<PageToCommentConnection>;
  /** The content of the post. */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the ContentType type */
  readonly contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  readonly contentTypeName: Scalars['String']['output'];
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  readonly date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  readonly dateGmt?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  readonly desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  readonly editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  readonly enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  readonly featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  readonly featuredImageDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Globally unique ID of the featured image assigned to the node */
  readonly featuredImageId?: Maybe<Scalars['ID']['output']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  readonly guid?: Maybe<Scalars['String']['output']>;
  /** Whether the page object is password protected. */
  readonly hasPassword?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the page object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether this page is set to the static front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether this page is set to the blog posts page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  readonly isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this page is set to the privacy page. */
  readonly isPrivacyPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** True if the node is a revision of another node */
  readonly isRevision?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  readonly lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  readonly menuOrder?: Maybe<Scalars['Int']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  readonly modifiedGmt?: Maybe<Scalars['String']['output']>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of the databaseId field
   */
  readonly pageId: Scalars['Int']['output'];
  /** The parent of the node. The parent object can be of various types */
  readonly parent?: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
  /** Database id of the parent node */
  readonly parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent node. */
  readonly parentId?: Maybe<Scalars['ID']['output']>;
  /** The password for the page object. */
  readonly password?: Maybe<Scalars['String']['output']>;
  /** Connection between the Page type and the page type */
  readonly preview?: Maybe<PageToPreviewConnectionEdge>;
  /** The database id of the preview node */
  readonly previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  readonly previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
  readonly revisionOf?: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
  /** Connection between the Page type and the page type */
  readonly revisions?: Maybe<PageToRevisionConnection>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  readonly status?: Maybe<Scalars['String']['output']>;
  /** The template assigned to a node of content */
  readonly template?: Maybe<ContentTemplate>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly unencodedContent?: Maybe<Scalars['String']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageToCommentConnectionWhereArgs>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageRevisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageToRevisionConnectionWhereArgs>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A paginated collection of page Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of page Nodes */
export type PageConnection = {
  /** A list of edges (relational context) between RootQuery and connected page Nodes */
  readonly edges: ReadonlyArray<PageConnectionEdge>;
  /** A list of connected page Nodes */
  readonly nodes: ReadonlyArray<Page>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PageConnectionPageInfo;
};

/** Represents a connection to a page. Contains both the page Node and metadata about the relationship. */
export type PageConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected page Node */
  readonly node: Page;
};

/** Pagination metadata specific to &quot;PageConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;PageConnectionEdge&quot; Nodes. */
export type PageConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifier types for retrieving a specific Page. Specifies which unique attribute is used to find an exact Page. */
export enum PageIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Metadata for cursor-based pagination. Provides cursors for continuing pagination and boolean flags indicating if more items exist in either direction. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the Page type and the Comment type */
export type PageToCommentConnection = CommentConnection & Connection & {
  readonly __typename?: 'PageToCommentConnection';
  /** Edges for the PageToCommentConnection connection */
  readonly edges: ReadonlyArray<PageToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Comment>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PageToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type PageToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  readonly __typename?: 'PageToCommentConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Comment;
};

/** Pagination metadata specific to &quot;PageToCommentConnection&quot; collections. Provides cursors and flags for navigating through sets of PageToCommentConnection Nodes. */
export type PageToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'PageToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the PageToCommentConnection connection */
export type PageToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  readonly authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  readonly authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  readonly commentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  readonly commentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  readonly commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  readonly commentTypeIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  readonly commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  readonly contentAuthor?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  readonly contentAuthorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  readonly contentAuthorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  readonly contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  readonly contentIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  readonly contentIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  readonly contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  readonly contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentStatus?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentType?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  readonly includeUnapproved?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  readonly karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  readonly orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the Page type and the page type */
export type PageToPreviewConnectionEdge = Edge & OneToOneConnection & PageConnectionEdge & {
  readonly __typename?: 'PageToPreviewConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Page;
};

/** Connection between the Page type and the page type */
export type PageToRevisionConnection = Connection & PageConnection & {
  readonly __typename?: 'PageToRevisionConnection';
  /** Edges for the PageToRevisionConnection connection */
  readonly edges: ReadonlyArray<PageToRevisionConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Page>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PageToRevisionConnectionPageInfo;
};

/** An edge in a connection */
export type PageToRevisionConnectionEdge = Edge & PageConnectionEdge & {
  readonly __typename?: 'PageToRevisionConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Page;
};

/** Pagination metadata specific to &quot;PageToRevisionConnection&quot; collections. Provides cursors and flags for navigating through sets of PageToRevisionConnection Nodes. */
export type PageToRevisionConnectionPageInfo = PageConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'PageToRevisionConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the PageToRevisionConnection connection */
export type PageToRevisionConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** The Login client options for the password provider. */
export type PasswordClientOptions = LoginClientOptions & {
  readonly __typename?: 'PasswordClientOptions';
  /** This field exists solely to generate the  ClientOptions interface, in lieu of the shared custom fields that will be added in a future release */
  readonly todo?: Maybe<Scalars['Boolean']['output']>;
};

/** The Headless Login options for the password provider. */
export type PasswordLoginOptions = LoginOptions & {
  readonly __typename?: 'PasswordLoginOptions';
  /** Whether to set a WordPress authentication cookie on successful login. */
  readonly useAuthenticationCookie?: Maybe<Scalars['Boolean']['output']>;
};

/** The parsed response from the Password Provider. */
export type PasswordProviderResponseInput = {
  /** The password for the WordPress user. */
  readonly password: Scalars['String']['input'];
  /** The WordPress username to authenticate ass */
  readonly username: Scalars['String']['input'];
};

/** An plugin object */
export type Plugin = Node & {
  readonly __typename?: 'Plugin';
  /** Name of the plugin author(s), may also be a company name. */
  readonly author?: Maybe<Scalars['String']['output']>;
  /** URI for the related author(s)/company website. */
  readonly authorUri?: Maybe<Scalars['String']['output']>;
  /** Description of the plugin. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier of the plugin object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Display name of the plugin. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Plugin path. */
  readonly path?: Maybe<Scalars['String']['output']>;
  /** URI for the plugin website. This is useful for directing users for support requests etc. */
  readonly pluginUri?: Maybe<Scalars['String']['output']>;
  /** Current version of the plugin. */
  readonly version?: Maybe<Scalars['String']['output']>;
};

/** A paginated collection of Plugin Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of Plugin Nodes */
export type PluginConnection = {
  /** A list of edges (relational context) between RootQuery and connected Plugin Nodes */
  readonly edges: ReadonlyArray<PluginConnectionEdge>;
  /** A list of connected Plugin Nodes */
  readonly nodes: ReadonlyArray<Plugin>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PluginConnectionPageInfo;
};

/** Represents a connection to a Plugin. Contains both the Plugin Node and metadata about the relationship. */
export type PluginConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Plugin Node */
  readonly node: Plugin;
};

/** Pagination metadata specific to &quot;PluginConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;PluginConnectionEdge&quot; Nodes. */
export type PluginConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Operational status of a plugin. Indicates whether a plugin is active, inactive, or in another state that affects its functionality. */
export enum PluginStatusEnum {
  /** The plugin is currently active. */
  Active = 'ACTIVE',
  /** The plugin is a drop-in plugin. */
  DropIn = 'DROP_IN',
  /** The plugin is currently inactive. */
  Inactive = 'INACTIVE',
  /** The plugin is a must-use plugin. */
  MustUse = 'MUST_USE',
  /** The plugin is technically active but was paused while loading. */
  Paused = 'PAUSED',
  /** The plugin was active recently. */
  RecentlyActive = 'RECENTLY_ACTIVE',
  /** The plugin has an upgrade available. */
  Upgrade = 'UPGRADE'
}

/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type Post = ContentNode & DatabaseIdentifier & MenuItemLinkable & Node & NodeWithAuthor & NodeWithComments & NodeWithContentEditor & NodeWithExcerpt & NodeWithFeaturedImage & NodeWithRevisions & NodeWithTemplate & NodeWithTitle & NodeWithTrackbacks & Previewable & UniformResourceIdentifiable & {
  readonly __typename?: 'Post';
  /**
   * The ancestors of the content node.
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly ancestors?: Maybe<PostToPostConnection>;
  /** Connection between the NodeWithAuthor type and the User type */
  readonly author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the author of the node */
  readonly authorId?: Maybe<Scalars['ID']['output']>;
  /** Connection between the Post type and the category type */
  readonly categories?: Maybe<PostToCategoryConnection>;
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  readonly commentCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the comments are open or closed for this particular post. */
  readonly commentStatus?: Maybe<Scalars['String']['output']>;
  /** Connection between the Post type and the Comment type */
  readonly comments?: Maybe<PostToCommentConnection>;
  /** The content of the post. */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the ContentType type */
  readonly contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  readonly contentTypeName: Scalars['String']['output'];
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  readonly date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  readonly dateGmt?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  readonly desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  readonly editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  readonly enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The excerpt of the post. */
  readonly excerpt?: Maybe<Scalars['String']['output']>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  readonly featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  readonly featuredImageDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Globally unique ID of the featured image assigned to the node */
  readonly featuredImageId?: Maybe<Scalars['ID']['output']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  readonly guid?: Maybe<Scalars['String']['output']>;
  /** Whether the post object is password protected. */
  readonly hasPassword?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the post object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  readonly isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** True if the node is a revision of another node */
  readonly isRevision?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this page is sticky */
  readonly isSticky: Scalars['Boolean']['output'];
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  readonly lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  readonly modifiedGmt?: Maybe<Scalars['String']['output']>;
  /**
   * The parent of the content node.
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  readonly parent?: Maybe<PostToParentConnectionEdge>;
  /** The password for the post object. */
  readonly password?: Maybe<Scalars['String']['output']>;
  /** Whether the pings are open or closed for this particular post. */
  readonly pingStatus?: Maybe<Scalars['String']['output']>;
  /** URLs that have been pinged. */
  readonly pinged?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** Connection between the Post type and the postFormat type */
  readonly postFormats?: Maybe<PostToPostFormatConnection>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of the databaseId field
   */
  readonly postId: Scalars['Int']['output'];
  /** Connection between the Post type and the post type */
  readonly preview?: Maybe<PostToPreviewConnectionEdge>;
  /** The database id of the preview node */
  readonly previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  readonly previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
  readonly revisionOf?: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
  /** Connection between the Post type and the post type */
  readonly revisions?: Maybe<PostToRevisionConnection>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  readonly status?: Maybe<Scalars['String']['output']>;
  /** Connection between the Post type and the tag type */
  readonly tags?: Maybe<PostToTagConnection>;
  /** The template assigned to the node */
  readonly template?: Maybe<ContentTemplate>;
  /** Connection between the Post type and the TermNode type */
  readonly terms?: Maybe<PostToTermNodeConnection>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  readonly title?: Maybe<Scalars['String']['output']>;
  /** URLs queued to be pinged. */
  readonly toPing?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly unencodedContent?: Maybe<Scalars['String']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostToCategoryConnectionWhereArgs>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostToCommentConnectionWhereArgs>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostExcerptArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostPostFormatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostToPostFormatConnectionWhereArgs>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostRevisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostToRevisionConnectionWhereArgs>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostToTagConnectionWhereArgs>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostToTermNodeConnectionWhereArgs>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Table for storing post access recipients */
export type PostAccessRecipient = Node & NodeWizAuthor & ZnNode & {
  readonly __typename?: 'PostAccessRecipient';
  /** Connection between the NodeWizAuthor type and the User type */
  readonly author?: Maybe<NodeWizAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The ID of the author of the post */
  readonly authorId?: Maybe<Scalars['ID']['output']>;
  /** The date the post was created, in the site&#039;s timezone */
  readonly created?: Maybe<Scalars['String']['output']>;
  /** The unique identifier stored in the database */
  readonly databaseId?: Maybe<Scalars['Int']['output']>;
  /** Email Domain */
  readonly domain: Scalars['String']['output'];
  /** Email */
  readonly email: Scalars['String']['output'];
  /** The date the post expires, in the site&#039;s timezone */
  readonly expiresAt?: Maybe<Scalars['String']['output']>;
  /** Connection between the PostAccessRecipient type and the Hub type */
  readonly hub?: Maybe<PostAccessRecipientToHubConnectionEdge>;
  /** access recipient id */
  readonly id: Scalars['ID']['output'];
  /** The date the post was last modified, in the site&#039;s timezone */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The ID of the post this recipient has access to */
  readonly postId: Scalars['ID']['output'];
  /** Status of the post access recipient */
  readonly status: PostAccessRecipientStatusEnum;
  /** The type of the post */
  readonly type: Scalars['String']['output'];
};


/** Table for storing post access recipients */
export type PostAccessRecipientHubArgs = {
  where?: InputMaybe<PostAccessRecipientToHubConnectionWhereArgs>;
};

/** A paginated collection of PostAccessRecipient Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of PostAccessRecipient Nodes */
export type PostAccessRecipientConnection = {
  /** A list of edges (relational context) between Znglist and connected PostAccessRecipient Nodes */
  readonly edges: ReadonlyArray<PostAccessRecipientConnectionEdge>;
  /** A list of connected PostAccessRecipient Nodes */
  readonly nodes: ReadonlyArray<PostAccessRecipient>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PostAccessRecipientConnectionPageInfo;
};

/** Represents a connection to a PostAccessRecipient. Contains both the PostAccessRecipient Node and metadata about the relationship. */
export type PostAccessRecipientConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected PostAccessRecipient Node */
  readonly node: PostAccessRecipient;
};

/** Pagination metadata specific to &quot;PostAccessRecipientConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;PostAccessRecipientConnectionEdge&quot; Nodes. */
export type PostAccessRecipientConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** The type of ID for PostAccessRecipient */
export enum PostAccessRecipientIdType {
  Id = 'ID'
}

/** PostAccessRecipients Search Fields Enum */
export enum PostAccessRecipientSearchFieldsEnum {
  /** The ID of the author of the post */
  AuthorId = 'AuthorId',
  /** The date the post was created, in the site's timezone */
  Created = 'Created',
  /** Email Domain */
  Domain = 'Domain',
  /** Email */
  Email = 'Email',
  /** The date the post expires, in the site's timezone */
  ExpiresAt = 'ExpiresAt',
  /** access recipient id */
  Id = 'Id',
  /** The date the post was last modified, in the site's timezone */
  Modified = 'Modified',
  /** The ID of the post this recipient has access to */
  PostId = 'PostId',
  /** Status of the post access recipient */
  Status = 'Status',
  /** The type of the post */
  Type = 'Type'
}

/** Status of the post access recipient */
export enum PostAccessRecipientStatusEnum {
  /** ACTIVE type */
  Active = 'ACTIVE',
  /** EXPIRED type */
  Expired = 'EXPIRED',
  /** REVOKED type */
  Revoked = 'REVOKED'
}

/** Connection between the PostAccessRecipient type and the Hub type */
export type PostAccessRecipientToHubConnectionEdge = Edge & HubConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'PostAccessRecipientToHubConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Hub;
};

/** Arguments for filtering the PostAccessRecipientToHubConnection connection */
export type PostAccessRecipientToHubConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** description of the hub */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** group of the hub used to identify its category/tag/campaign */
  readonly group?: InputMaybe<Scalars['String']['input']>;
  /** group of the hub used to identify its category/tag/campaign */
  readonly groupIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** group of the hub used to identify its category/tag/campaign */
  readonly groupNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** hub id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** hub id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** hub id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<HubSearchFieldsEnum>>>;
  /** order of the hubs */
  readonly postOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Search for Hubs by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for Hubs by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<HubSearchFieldsEnum>>>;
  /** The name (slug) for the post */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status of the post */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The status of the post */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** template of the hub */
  readonly template?: InputMaybe<HubTemplateEnum>;
  /** template of the hub */
  readonly templateIn?: InputMaybe<ReadonlyArray<InputMaybe<HubTemplateEnum>>>;
  /** template of the hub */
  readonly templateNotIn?: InputMaybe<ReadonlyArray<InputMaybe<HubTemplateEnum>>>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** User related to the hub */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
  /** User related to the hub */
  readonly userIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** User related to the hub */
  readonly userIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
};

/** Set relationships between the post to categories */
export type PostCategoriesInput = {
  /** If true, this will append the category to existing related categories. If false, this will replace existing relationships. Default true. */
  readonly append?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input list of items to set. */
  readonly nodes?: InputMaybe<ReadonlyArray<InputMaybe<PostCategoriesNodeInput>>>;
};

/** List of categories to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostCategoriesNodeInput = {
  /** The description of the category. This field is used to set a description of the category if a new one is created during the mutation. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the category. If present, this will be used to connect to the post. If no existing category exists with this ID, no connection will be made. */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the category. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the category. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
};

/** A paginated collection of post Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of post Nodes */
export type PostConnection = {
  /** A list of edges (relational context) between RootQuery and connected post Nodes */
  readonly edges: ReadonlyArray<PostConnectionEdge>;
  /** A list of connected post Nodes */
  readonly nodes: ReadonlyArray<Post>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PostConnectionPageInfo;
};

/** Represents a connection to a post. Contains both the post Node and metadata about the relationship. */
export type PostConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected post Node */
  readonly node: Post;
};

/** Pagination metadata specific to &quot;PostConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;PostConnectionEdge&quot; Nodes. */
export type PostConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** A standardized classification system for content presentation styles. These formats can be used to display content differently based on type, such as &quot;standard&quot;, &quot;gallery&quot;, &quot;video&quot;, etc. */
export type PostFormat = DatabaseIdentifier & Node & TermNode & UniformResourceIdentifiable & {
  readonly __typename?: 'PostFormat';
  /** Connection between the PostFormat type and the ContentNode type */
  readonly contentNodes?: Maybe<PostFormatToContentNodeConnection>;
  /** The number of objects connected to the object */
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** The description of the object */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The link to the term */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** The human friendly name of the object. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  readonly postFormatId?: Maybe<Scalars['Int']['output']>;
  /** Connection between the PostFormat type and the post type */
  readonly posts?: Maybe<PostFormatToPostConnection>;
  /** An alphanumeric identifier for the object unique to its type. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** Connection between the PostFormat type and the Taxonomy type */
  readonly taxonomy?: Maybe<PostFormatToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  readonly taxonomyName?: Maybe<Scalars['String']['output']>;
  /** The ID of the term group that this term object belongs to */
  readonly termGroupId?: Maybe<Scalars['Int']['output']>;
  /** The taxonomy ID that the object is associated with */
  readonly termTaxonomyId?: Maybe<Scalars['Int']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};


/** A standardized classification system for content presentation styles. These formats can be used to display content differently based on type, such as &quot;standard&quot;, &quot;gallery&quot;, &quot;video&quot;, etc. */
export type PostFormatContentNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostFormatToContentNodeConnectionWhereArgs>;
};


/** A standardized classification system for content presentation styles. These formats can be used to display content differently based on type, such as &quot;standard&quot;, &quot;gallery&quot;, &quot;video&quot;, etc. */
export type PostFormatEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A standardized classification system for content presentation styles. These formats can be used to display content differently based on type, such as &quot;standard&quot;, &quot;gallery&quot;, &quot;video&quot;, etc. */
export type PostFormatEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A standardized classification system for content presentation styles. These formats can be used to display content differently based on type, such as &quot;standard&quot;, &quot;gallery&quot;, &quot;video&quot;, etc. */
export type PostFormatPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostFormatToPostConnectionWhereArgs>;
};

/** A paginated collection of postFormat Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of postFormat Nodes */
export type PostFormatConnection = {
  /** A list of edges (relational context) between RootQuery and connected postFormat Nodes */
  readonly edges: ReadonlyArray<PostFormatConnectionEdge>;
  /** A list of connected postFormat Nodes */
  readonly nodes: ReadonlyArray<PostFormat>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PostFormatConnectionPageInfo;
};

/** Represents a connection to a postFormat. Contains both the postFormat Node and metadata about the relationship. */
export type PostFormatConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected postFormat Node */
  readonly node: PostFormat;
};

/** Pagination metadata specific to &quot;PostFormatConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;PostFormatConnectionEdge&quot; Nodes. */
export type PostFormatConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifier types for retrieving a specific PostFormat. Determines which unique property (global ID, database ID, slug, etc.) is used to locate the PostFormat. */
export enum PostFormatIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the PostFormat type and the ContentNode type */
export type PostFormatToContentNodeConnection = Connection & ContentNodeConnection & {
  readonly __typename?: 'PostFormatToContentNodeConnection';
  /** Edges for the PostFormatToContentNodeConnection connection */
  readonly edges: ReadonlyArray<PostFormatToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ContentNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PostFormatToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type PostFormatToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  readonly __typename?: 'PostFormatToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ContentNode;
};

/** Pagination metadata specific to &quot;PostFormatToContentNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of PostFormatToContentNodeConnection Nodes. */
export type PostFormatToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'PostFormatToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the PostFormatToContentNodeConnection connection */
export type PostFormatToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  readonly contentTypes?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypesOfPostFormatEnum>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the PostFormat type and the post type */
export type PostFormatToPostConnection = Connection & PostConnection & {
  readonly __typename?: 'PostFormatToPostConnection';
  /** Edges for the PostFormatToPostConnection connection */
  readonly edges: ReadonlyArray<PostFormatToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Post>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PostFormatToPostConnectionPageInfo;
};

/** An edge in a connection */
export type PostFormatToPostConnectionEdge = Edge & PostConnectionEdge & {
  readonly __typename?: 'PostFormatToPostConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Post;
};

/** Pagination metadata specific to &quot;PostFormatToPostConnection&quot; collections. Provides cursors and flags for navigating through sets of PostFormatToPostConnection Nodes. */
export type PostFormatToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'PostFormatToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the PostFormatToPostConnection connection */
export type PostFormatToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  readonly categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  readonly categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  readonly tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  readonly tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  readonly tagSlugAnd?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  readonly tagSlugIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the PostFormat type and the Taxonomy type */
export type PostFormatToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  readonly __typename?: 'PostFormatToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Taxonomy;
};

/** Identifier types for retrieving a specific Post. Specifies which unique attribute is used to find an exact Post. */
export enum PostIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Content field rendering options. Determines whether content fields are returned as raw data or with applied formatting and transformations. Default is RENDERED. */
export enum PostObjectFieldFormatEnum {
  /** Unprocessed content exactly as stored in the database, requires appropriate permissions. */
  Raw = 'RAW',
  /** Content with all formatting and transformations applied, ready for display. */
  Rendered = 'RENDERED'
}

/** Date field selectors for content filtering. Specifies which date attribute (creation date, modification date) should be used for date-based queries. */
export enum PostObjectsConnectionDateColumnEnum {
  /** The date the comment was created in local time. */
  Date = 'DATE',
  /** The most recent modification date of the comment. */
  Modified = 'MODIFIED'
}

/** Content sorting attributes for post-type objects. Identifies which content property should be used to determine result order. */
export enum PostObjectsConnectionOrderbyEnum {
  /** Ordering by content author (typically by author name). */
  Author = 'AUTHOR',
  /** Ordering by popularity based on number of comments. */
  CommentCount = 'COMMENT_COUNT',
  /** Chronological ordering by publication date. */
  Date = 'DATE',
  /** Order by file size (TypeScript/Relay compatible) */
  FileSize = 'FILE_SIZE',
  /** Maintain custom order of IDs exactly as specified in the query with the IN field. */
  In = 'IN',
  /** Ordering by manually defined sort position. */
  MenuOrder = 'MENU_ORDER',
  /** Chronological ordering by modified date. */
  Modified = 'MODIFIED',
  /** Maintain custom order of IDs exactly as specified in the query with the NAME_IN field. */
  NameIn = 'NAME_IN',
  /** Ordering by parent-child relationship in hierarchical content. */
  Parent = 'PARENT',
  /** Alphabetical ordering by URL-friendly name. */
  Slug = 'SLUG',
  /** Alphabetical ordering by content title */
  Title = 'TITLE'
}

/** Options for ordering the connection */
export type PostObjectsConnectionOrderbyInput = {
  /** The field to order the connection by */
  readonly field: PostObjectsConnectionOrderbyEnum;
  /** Possible directions in which to order a list of items */
  readonly order: OrderEnum;
};

/** Set relationships between the post to postFormats */
export type PostPostFormatsInput = {
  /** If true, this will append the postFormat to existing related postFormats. If false, this will replace existing relationships. Default true. */
  readonly append?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input list of items to set. */
  readonly nodes?: InputMaybe<ReadonlyArray<InputMaybe<PostPostFormatsNodeInput>>>;
};

/** List of postFormats to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostPostFormatsNodeInput = {
  /** The description of the postFormat. This field is used to set a description of the postFormat if a new one is created during the mutation. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the postFormat. If present, this will be used to connect to the post. If no existing postFormat exists with this ID, no connection will be made. */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the postFormat. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the postFormat. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
};

/** Publishing status that controls the visibility and editorial state of content. Determines whether content is published, pending review, in draft state, or private. */
export enum PostStatusEnum {
  /** Objects with the acf-disabled status */
  AcfDisabled = 'ACF_DISABLED',
  /** Automatically saved content that has not been manually saved */
  AutoDraft = 'AUTO_DRAFT',
  /** Content that is saved but not yet published or visible to the public */
  Draft = 'DRAFT',
  /** Objects with the future status */
  Future = 'FUTURE',
  /** Objects with the hidden status */
  Hidden = 'HIDDEN',
  /** Objects with the hidden_b_s status */
  HiddenBS = 'HIDDEN_B_S',
  /** Content that inherits its status from a parent object */
  Inherit = 'INHERIT',
  /** Content awaiting review before publication */
  Pending = 'PENDING',
  /** Content only visible to authorized users with appropriate permissions */
  Private = 'PRIVATE',
  /** Content that is publicly visible to all visitors */
  Publish = 'PUBLISH',
  /** Objects with the request-completed status */
  RequestCompleted = 'REQUEST_COMPLETED',
  /** Objects with the request-confirmed status */
  RequestConfirmed = 'REQUEST_CONFIRMED',
  /** Objects with the request-failed status */
  RequestFailed = 'REQUEST_FAILED',
  /** Objects with the request-pending status */
  RequestPending = 'REQUEST_PENDING',
  /** Content marked for deletion but still recoverable */
  Trash = 'TRASH'
}

/** Set relationships between the post to tags */
export type PostTagsInput = {
  /** If true, this will append the tag to existing related tags. If false, this will replace existing relationships. Default true. */
  readonly append?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input list of items to set. */
  readonly nodes?: InputMaybe<ReadonlyArray<InputMaybe<PostTagsNodeInput>>>;
};

/** List of tags to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostTagsNodeInput = {
  /** The description of the tag. This field is used to set a description of the tag if a new one is created during the mutation. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the tag. If present, this will be used to connect to the post. If no existing tag exists with this ID, no connection will be made. */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the tag. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the tag. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the Post type and the category type */
export type PostToCategoryConnection = CategoryConnection & Connection & {
  readonly __typename?: 'PostToCategoryConnection';
  /** Edges for the PostToCategoryConnection connection */
  readonly edges: ReadonlyArray<PostToCategoryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Category>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PostToCategoryConnectionPageInfo;
};

/** An edge in a connection */
export type PostToCategoryConnectionEdge = CategoryConnectionEdge & Edge & {
  readonly __typename?: 'PostToCategoryConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Category;
};

/** Pagination metadata specific to &quot;PostToCategoryConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToCategoryConnection Nodes. */
export type PostToCategoryConnectionPageInfo = CategoryConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'PostToCategoryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the PostToCategoryConnection connection */
export type PostToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the Post type and the Comment type */
export type PostToCommentConnection = CommentConnection & Connection & {
  readonly __typename?: 'PostToCommentConnection';
  /** Edges for the PostToCommentConnection connection */
  readonly edges: ReadonlyArray<PostToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Comment>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PostToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type PostToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  readonly __typename?: 'PostToCommentConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Comment;
};

/** Pagination metadata specific to &quot;PostToCommentConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToCommentConnection Nodes. */
export type PostToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'PostToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the PostToCommentConnection connection */
export type PostToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  readonly authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  readonly authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  readonly commentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  readonly commentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  readonly commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  readonly commentTypeIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  readonly commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  readonly contentAuthor?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  readonly contentAuthorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  readonly contentAuthorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  readonly contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  readonly contentIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  readonly contentIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  readonly contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  readonly contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentStatus?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentType?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  readonly includeUnapproved?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  readonly karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  readonly orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the Post type and the post type */
export type PostToParentConnectionEdge = Edge & OneToOneConnection & PostConnectionEdge & {
  readonly __typename?: 'PostToParentConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /**
   * The node of the connection, without the edges
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  readonly node: Post;
};

/** Connection between the Post type and the post type */
export type PostToPostConnection = Connection & PostConnection & {
  readonly __typename?: 'PostToPostConnection';
  /** Edges for the PostToPostConnection connection */
  readonly edges: ReadonlyArray<PostToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Post>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PostToPostConnectionPageInfo;
};

/** An edge in a connection */
export type PostToPostConnectionEdge = Edge & PostConnectionEdge & {
  readonly __typename?: 'PostToPostConnectionEdge';
  /**
   * A cursor for use in pagination
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /**
   * The item at the end of the edge
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly node: Post;
};

/** Pagination metadata specific to &quot;PostToPostConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToPostConnection Nodes. */
export type PostToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'PostToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the Post type and the postFormat type */
export type PostToPostFormatConnection = Connection & PostFormatConnection & {
  readonly __typename?: 'PostToPostFormatConnection';
  /** Edges for the PostToPostFormatConnection connection */
  readonly edges: ReadonlyArray<PostToPostFormatConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<PostFormat>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PostToPostFormatConnectionPageInfo;
};

/** An edge in a connection */
export type PostToPostFormatConnectionEdge = Edge & PostFormatConnectionEdge & {
  readonly __typename?: 'PostToPostFormatConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: PostFormat;
};

/** Pagination metadata specific to &quot;PostToPostFormatConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToPostFormatConnection Nodes. */
export type PostToPostFormatConnectionPageInfo = PageInfo & PostFormatConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'PostToPostFormatConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the PostToPostFormatConnection connection */
export type PostToPostFormatConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the Post type and the post type */
export type PostToPreviewConnectionEdge = Edge & OneToOneConnection & PostConnectionEdge & {
  readonly __typename?: 'PostToPreviewConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Post;
};

/** Connection between the Post type and the post type */
export type PostToRevisionConnection = Connection & PostConnection & {
  readonly __typename?: 'PostToRevisionConnection';
  /** Edges for the PostToRevisionConnection connection */
  readonly edges: ReadonlyArray<PostToRevisionConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Post>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PostToRevisionConnectionPageInfo;
};

/** An edge in a connection */
export type PostToRevisionConnectionEdge = Edge & PostConnectionEdge & {
  readonly __typename?: 'PostToRevisionConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Post;
};

/** Pagination metadata specific to &quot;PostToRevisionConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToRevisionConnection Nodes. */
export type PostToRevisionConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'PostToRevisionConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the PostToRevisionConnection connection */
export type PostToRevisionConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  readonly categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  readonly categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  readonly tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  readonly tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  readonly tagSlugAnd?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  readonly tagSlugIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the Post type and the tag type */
export type PostToTagConnection = Connection & TagConnection & {
  readonly __typename?: 'PostToTagConnection';
  /** Edges for the PostToTagConnection connection */
  readonly edges: ReadonlyArray<PostToTagConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Tag>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PostToTagConnectionPageInfo;
};

/** An edge in a connection */
export type PostToTagConnectionEdge = Edge & TagConnectionEdge & {
  readonly __typename?: 'PostToTagConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Tag;
};

/** Pagination metadata specific to &quot;PostToTagConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToTagConnection Nodes. */
export type PostToTagConnectionPageInfo = PageInfo & TagConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'PostToTagConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the PostToTagConnection connection */
export type PostToTagConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the Post type and the TermNode type */
export type PostToTermNodeConnection = Connection & TermNodeConnection & {
  readonly __typename?: 'PostToTermNodeConnection';
  /** Edges for the PostToTermNodeConnection connection */
  readonly edges: ReadonlyArray<PostToTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<TermNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: PostToTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type PostToTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  readonly __typename?: 'PostToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: TermNode;
};

/** Pagination metadata specific to &quot;PostToTermNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToTermNodeConnection Nodes. */
export type PostToTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'PostToTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the PostToTermNodeConnection connection */
export type PostToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** The Taxonomy to filter terms by */
  readonly taxonomies?: InputMaybe<ReadonlyArray<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Details for labels of the PostType */
export type PostTypeLabelDetails = {
  readonly __typename?: 'PostTypeLabelDetails';
  /** Default is ‘Add New’ for both hierarchical and non-hierarchical types. */
  readonly addNew?: Maybe<Scalars['String']['output']>;
  /** Label for adding a new singular item. */
  readonly addNewItem?: Maybe<Scalars['String']['output']>;
  /** Label to signify all items in a submenu link. */
  readonly allItems?: Maybe<Scalars['String']['output']>;
  /** Label for archives in nav menus */
  readonly archives?: Maybe<Scalars['String']['output']>;
  /** Label for the attributes meta box. */
  readonly attributes?: Maybe<Scalars['String']['output']>;
  /** Label for editing a singular item. */
  readonly editItem?: Maybe<Scalars['String']['output']>;
  /** Label for the Featured Image meta box title. */
  readonly featuredImage?: Maybe<Scalars['String']['output']>;
  /** Label for the table views hidden heading. */
  readonly filterItemsList?: Maybe<Scalars['String']['output']>;
  /** Label for the media frame button. */
  readonly insertIntoItem?: Maybe<Scalars['String']['output']>;
  /** Label for the table hidden heading. */
  readonly itemsList?: Maybe<Scalars['String']['output']>;
  /** Label for the table pagination hidden heading. */
  readonly itemsListNavigation?: Maybe<Scalars['String']['output']>;
  /** Label for the menu name. */
  readonly menuName?: Maybe<Scalars['String']['output']>;
  /** General name for the post type, usually plural. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Label for the new item page title. */
  readonly newItem?: Maybe<Scalars['String']['output']>;
  /** Label used when no items are found. */
  readonly notFound?: Maybe<Scalars['String']['output']>;
  /** Label used when no items are in the trash. */
  readonly notFoundInTrash?: Maybe<Scalars['String']['output']>;
  /** Label used to prefix parents of hierarchical items. */
  readonly parentItemColon?: Maybe<Scalars['String']['output']>;
  /** Label for removing the featured image. */
  readonly removeFeaturedImage?: Maybe<Scalars['String']['output']>;
  /** Label for searching plural items. */
  readonly searchItems?: Maybe<Scalars['String']['output']>;
  /** Label for setting the featured image. */
  readonly setFeaturedImage?: Maybe<Scalars['String']['output']>;
  /** Name for one object of this post type. */
  readonly singularName?: Maybe<Scalars['String']['output']>;
  /** Label for the media frame filter. */
  readonly uploadedToThisItem?: Maybe<Scalars['String']['output']>;
  /** Label in the media frame for using a featured image. */
  readonly useFeaturedImage?: Maybe<Scalars['String']['output']>;
  /** Label for viewing a singular item. */
  readonly viewItem?: Maybe<Scalars['String']['output']>;
  /** Label for viewing post type archives. */
  readonly viewItems?: Maybe<Scalars['String']['output']>;
};

/** Content that supports a draft preview mode. Allows viewing unpublished changes before they are made publicly available. Previewing unpublished changes requires appropriate permissions. */
export type Previewable = {
  /** Whether the object is a node in the preview state */
  readonly isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** The database id of the preview node */
  readonly previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  readonly previewRevisionId?: Maybe<Scalars['ID']['output']>;
};

export type ProductLicense = {
  readonly __typename?: 'ProductLicense';
  /** Product License Information */
  readonly result?: Maybe<ProductLicenseType>;
};

/** Product License Information */
export type ProductLicenseType = {
  readonly __typename?: 'ProductLicenseType';
  /** bigqueryId : bigquery_id */
  readonly bigqueryId?: Maybe<Scalars['String']['output']>;
  /** gcpVertexEnabled : gcp_vertex_enabled */
  readonly gcpVertexEnabled?: Maybe<Scalars['String']['output']>;
  /** group : group */
  readonly group?: Maybe<Scalars['String']['output']>;
  /** hubs : hubs */
  readonly hubs?: Maybe<Scalars['String']['output']>;
  /** instanceId : instance_id */
  readonly instanceId?: Maybe<Scalars['String']['output']>;
  /** instanceName : instance_name */
  readonly instanceName?: Maybe<Scalars['String']['output']>;
  /** licenseType : license_type */
  readonly licenseType?: Maybe<Scalars['String']['output']>;
  /** users : users */
  readonly users?: Maybe<Scalars['String']['output']>;
};

/** The reading setting type */
export type ReadingSettings = {
  readonly __typename?: 'ReadingSettings';
  /** The ID of the page that should display the latest posts */
  readonly pageForPosts?: Maybe<Scalars['Int']['output']>;
  /** The ID of the page that should be displayed on the front page */
  readonly pageOnFront?: Maybe<Scalars['Int']['output']>;
  /** Blog pages show at most. */
  readonly postsPerPage?: Maybe<Scalars['Int']['output']>;
  /** What to show on the front page */
  readonly showOnFront?: Maybe<Scalars['String']['output']>;
};

/** Input for the RefreshToken mutation. */
export type RefreshTokenInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A valid, previously issued JWT refresh token. If valid, a new JWT authentication token will be provided. If invalid, expired, revoked or otherwise invalid, the `authToken` will return null, and the `success` field will return `false`. */
  readonly refreshToken: Scalars['String']['input'];
};

/** The payload for the RefreshToken mutation. */
export type RefreshTokenPayload = {
  readonly __typename?: 'RefreshTokenPayload';
  /** JWT Token that can be used in future requests for Authentication. */
  readonly authToken?: Maybe<Scalars['String']['output']>;
  /** The authentication token expiration timestamp. */
  readonly authTokenExpiration?: Maybe<Scalars['String']['output']>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the auth token was successfully refreshed. */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for the RefreshUserSecret mutation. */
export type RefreshUserSecretInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The current WordPress user ID. Accepts either a global or database ID. */
  readonly userId: Scalars['ID']['input'];
};

/** The payload for the RefreshUserSecret mutation. */
export type RefreshUserSecretPayload = {
  readonly __typename?: 'RefreshUserSecretPayload';
  /** JWT Token that can be used in future requests for Authentication. */
  readonly authToken?: Maybe<Scalars['String']['output']>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** JWT Token that can be used in future requests for Authentication. */
  readonly refreshToken?: Maybe<Scalars['String']['output']>;
  /** The revoked user secret. */
  readonly revokedUserSecret?: Maybe<Scalars['String']['output']>;
  /** Whether the User secret was successfully revoked. */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
  /** The new user secret. */
  readonly userSecret?: Maybe<Scalars['String']['output']>;
};

/** Input for the registerUser mutation. */
export type RegisterUserInput = {
  /** User's AOL IM account. */
  readonly aim?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A string containing content about the user. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  readonly displayName?: InputMaybe<Scalars['String']['input']>;
  /** A string containing the user's email address. */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** The user's first name. */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** User's Jabber account. */
  readonly jabber?: InputMaybe<Scalars['String']['input']>;
  /** The user's last name. */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** User's locale. */
  readonly locale?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  readonly nicename?: InputMaybe<Scalars['String']['input']>;
  /** The user's nickname, defaults to the user's username. */
  readonly nickname?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains the plain text password for the user. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  readonly registered?: InputMaybe<Scalars['String']['input']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  readonly richEditing?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains the user's username. */
  readonly username: Scalars['String']['input'];
  /** A string containing the user's URL for the user's web site. */
  readonly websiteUrl?: InputMaybe<Scalars['String']['input']>;
  /** User's Yahoo IM account. */
  readonly yim?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the registerUser mutation. */
export type RegisterUserPayload = {
  readonly __typename?: 'RegisterUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The User object mutation type. */
  readonly user?: Maybe<User>;
};

/** Logical operators for filter conditions. Determines whether multiple filtering criteria should be combined with AND (all must match) or OR (any can match). */
export enum RelationEnum {
  /** All conditions must match (more restrictive filtering) */
  And = 'AND',
  /** Any condition can match (more inclusive filtering) */
  Or = 'OR'
}

/** Input for the requestPostAccess mutation. */
export type RequestPostAccessInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Verification code to verify the recipient */
  readonly code?: InputMaybe<Scalars['String']['input']>;
  /** Email address to send the verification to */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** ID of the post to request access for */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** ID type of the post to request access for */
  readonly idType?: InputMaybe<PostIdType>;
  /** Type of the post to request access for */
  readonly postType?: InputMaybe<ZnglyPostTypeEnum>;
  readonly zncid?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the requestPostAccess mutation. */
export type RequestPostAccessPayload = {
  readonly __typename?: 'RequestPostAccessPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Input for the resetUserPassword mutation. */
export type ResetUserPasswordInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Password reset key */
  readonly key?: InputMaybe<Scalars['String']['input']>;
  /** The user's login (username). */
  readonly login?: InputMaybe<Scalars['String']['input']>;
  /** The new password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the resetUserPassword mutation. */
export type ResetUserPasswordPayload = {
  readonly __typename?: 'ResetUserPasswordPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The User object mutation type. */
  readonly user?: Maybe<User>;
};

/** Input for the restoreComment mutation. */
export type RestoreCommentInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the comment to be restored */
  readonly id: Scalars['ID']['input'];
};

/** The payload for the restoreComment mutation. */
export type RestoreCommentPayload = {
  readonly __typename?: 'RestoreCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The restored comment object */
  readonly comment?: Maybe<Comment>;
  /** The ID of the restored comment */
  readonly restoredId?: Maybe<Scalars['ID']['output']>;
};

export type ReviewUsage = {
  readonly __typename?: 'ReviewUsage';
  /** List of dependencies for the given posts */
  readonly results?: Maybe<ReadonlyArray<Maybe<ReviewUsageResult>>>;
};

export type ReviewUsageDependency = {
  readonly __typename?: 'ReviewUsageDependency';
  /** The created date of the post */
  readonly created?: Maybe<Scalars['String']['output']>;
  /** The ID of the post */
  readonly depKey?: Maybe<Scalars['ID']['output']>;
  /** The modified date of the post */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The title of the post */
  readonly postType?: Maybe<ZnglyPostTypeEnum>;
  /** The status of the post */
  readonly status?: Maybe<PostStatusEnum>;
  /** The title of the post */
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type ReviewUsageQueryInput = {
  /** The IDs of the posts to fetch dependencies for */
  readonly postIds: ReadonlyArray<InputMaybe<Scalars['ID']['input']>>;
  /** The post type of the posts to fetch dependencies for */
  readonly postType: ZnglyPostTypeEnum;
};

export type ReviewUsageResult = {
  readonly __typename?: 'ReviewUsageResult';
  /** The dependencies of the post */
  readonly dependencies?: Maybe<ReadonlyArray<Maybe<ReviewUsageDependency>>>;
  /** The ID of the post */
  readonly resKey?: Maybe<Scalars['ID']['output']>;
};

/** Input for the RevokeUserSecret mutation. */
export type RevokeUserSecretInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The WordPress user ID. Accepts either a database or global ID. */
  readonly userId: Scalars['ID']['input'];
};

/** The payload for the RevokeUserSecret mutation. */
export type RevokeUserSecretPayload = {
  readonly __typename?: 'RevokeUserSecretPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The revoked user secret. */
  readonly revokedUserSecret?: Maybe<Scalars['String']['output']>;
  /** Whether the User secret was successfully revoked. */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

/** The root mutation */
export type RootMutation = {
  readonly __typename?: 'RootMutation';
  /** The batchPostMutation mutation */
  readonly batchPostMutation?: Maybe<BatchPostMutationPayload>;
  /** The createCategory mutation */
  readonly createCategory?: Maybe<CreateCategoryPayload>;
  /** The createComment mutation */
  readonly createComment?: Maybe<CreateCommentPayload>;
  /** The createContact mutation */
  readonly createContact?: Maybe<CreateContactPayload>;
  /** The createCrmList mutation */
  readonly createCrmList?: Maybe<CreateCrmListPayload>;
  /** The createForm mutation */
  readonly createForm?: Maybe<CreateFormPayload>;
  /** The createFormEntry mutation */
  readonly createFormEntry?: Maybe<CreateFormEntryPayload>;
  /** The createGraphqlDocument mutation */
  readonly createGraphqlDocument?: Maybe<CreateGraphqlDocumentPayload>;
  /** The createGraphqlDocumentGroup mutation */
  readonly createGraphqlDocumentGroup?: Maybe<CreateGraphqlDocumentGroupPayload>;
  /** The createHub mutation */
  readonly createHub?: Maybe<CreateHubPayload>;
  /** The createHubPage mutation */
  readonly createHubPage?: Maybe<CreateHubPagePayload>;
  /** The createMediaItem mutation */
  readonly createMediaItem?: Maybe<CreateMediaItemPayload>;
  /** The createPage mutation */
  readonly createPage?: Maybe<CreatePagePayload>;
  /** The createPost mutation */
  readonly createPost?: Maybe<CreatePostPayload>;
  /** The createPostAccessRecipient mutation */
  readonly createPostAccessRecipient?: Maybe<CreatePostAccessRecipientPayload>;
  /** The createPostFormat mutation */
  readonly createPostFormat?: Maybe<CreatePostFormatPayload>;
  /** The createTag mutation */
  readonly createTag?: Maybe<CreateTagPayload>;
  /** The createUser mutation */
  readonly createUser?: Maybe<CreateUserPayload>;
  /** The createZnglist mutation */
  readonly createZnglist?: Maybe<CreateZnglistPayload>;
  /** The createZnglyVideo mutation */
  readonly createZnglyVideo?: Maybe<CreateZnglyVideoPayload>;
  /** The deleteCategory mutation */
  readonly deleteCategory?: Maybe<DeleteCategoryPayload>;
  /** The deleteComment mutation */
  readonly deleteComment?: Maybe<DeleteCommentPayload>;
  /** The deleteContact mutation */
  readonly deleteContact?: Maybe<DeleteContactPayload>;
  /** The deleteCrmList mutation */
  readonly deleteCrmList?: Maybe<DeleteCrmListPayload>;
  /** The deleteForm mutation */
  readonly deleteForm?: Maybe<DeleteFormPayload>;
  /** The deleteFormEntry mutation */
  readonly deleteFormEntry?: Maybe<DeleteFormEntryPayload>;
  /** The deleteGraphqlDocument mutation */
  readonly deleteGraphqlDocument?: Maybe<DeleteGraphqlDocumentPayload>;
  /** The deleteGraphqlDocumentGroup mutation */
  readonly deleteGraphqlDocumentGroup?: Maybe<DeleteGraphqlDocumentGroupPayload>;
  /** The deleteHub mutation */
  readonly deleteHub?: Maybe<DeleteHubPayload>;
  /** The deleteHubPage mutation */
  readonly deleteHubPage?: Maybe<DeleteHubPagePayload>;
  /** The deleteMediaItem mutation */
  readonly deleteMediaItem?: Maybe<DeleteMediaItemPayload>;
  /** The deletePage mutation */
  readonly deletePage?: Maybe<DeletePagePayload>;
  /** The deletePost mutation */
  readonly deletePost?: Maybe<DeletePostPayload>;
  /** The deletePostAccessRecipient mutation */
  readonly deletePostAccessRecipient?: Maybe<DeletePostAccessRecipientPayload>;
  /** The deletePostFormat mutation */
  readonly deletePostFormat?: Maybe<DeletePostFormatPayload>;
  /** The deleteTag mutation */
  readonly deleteTag?: Maybe<DeleteTagPayload>;
  /** The deleteUser mutation */
  readonly deleteUser?: Maybe<DeleteUserPayload>;
  /** The deleteZnglist mutation */
  readonly deleteZnglist?: Maybe<DeleteZnglistPayload>;
  /** The deleteZnglyVideo mutation */
  readonly deleteZnglyVideo?: Maybe<DeleteZnglyVideoPayload>;
  /** The deleteZnglyVideoExtra mutation */
  readonly deleteZnglyVideoExtra?: Maybe<DeleteZnglyVideoExtraPayload>;
  /** The duplicateCrmList mutation */
  readonly duplicateCrmList?: Maybe<DuplicateCrmListPayload>;
  /** The duplicateHub mutation */
  readonly duplicateHub?: Maybe<DuplicateHubPayload>;
  /** The duplicateHubPage mutation */
  readonly duplicateHubPage?: Maybe<DuplicateHubPagePayload>;
  /** The duplicateZnglist mutation */
  readonly duplicateZnglist?: Maybe<DuplicateZnglistPayload>;
  /** The duplicateZnglyVideo mutation */
  readonly duplicateZnglyVideo?: Maybe<DuplicateZnglyVideoPayload>;
  /** The emailSender mutation */
  readonly emailSender?: Maybe<EmailSenderPayload>;
  /** The emptyTrash mutation */
  readonly emptyTrash?: Maybe<EmptyTrashPayload>;
  /** The existingUsersBioGlobalUpdate mutation */
  readonly existingUsersBioGlobalUpdate?: Maybe<ExistingUsersBioGlobalUpdatePayload>;
  /** The hsDeleteConnection mutation */
  readonly hsDeleteConnection?: Maybe<HsDeleteConnectionPayload>;
  /** The hsRegisterOauthTokens mutation */
  readonly hsRegisterOauthTokens?: Maybe<HsRegisterOauthTokensPayload>;
  /** The hsSyncUserToken mutation */
  readonly hsSyncUserToken?: Maybe<HsSyncUserTokenPayload>;
  /** The hsUpdateSettings mutation */
  readonly hsUpdateSettings?: Maybe<HsUpdateSettingsPayload>;
  /** The importContacts mutation */
  readonly importContacts?: Maybe<ImportContactsPayload>;
  /** Increase the count. */
  readonly increaseCount?: Maybe<Scalars['Int']['output']>;
  /** Links an identity to a WordPress user. */
  readonly linkUserIdentity?: Maybe<LinkUserIdentityPayload>;
  /** Logs a user in using the specified provider. */
  readonly login?: Maybe<LoginPayload>;
  /** Logs the user out of the site. */
  readonly logout?: Maybe<LogoutPayload>;
  /** The marketoUpdateSettings mutation */
  readonly marketoUpdateSettings?: Maybe<MarketoUpdateSettingsPayload>;
  /** The msAuthenticateTenant mutation */
  readonly msAuthenticateTenant?: Maybe<MsAuthenticateTenantPayload>;
  /** The msRemoveTenant mutation */
  readonly msRemoveTenant?: Maybe<MsRemoveTenantPayload>;
  /** The newMediaItem mutation */
  readonly newMediaItem?: Maybe<NewMediaItemPayload>;
  /** Refreshes the JWT authentication token using a valid refresh token. */
  readonly refreshToken?: Maybe<RefreshTokenPayload>;
  /** Refreshes the user secret and generates a new JWT authentication token. */
  readonly refreshUserSecret?: Maybe<RefreshUserSecretPayload>;
  /** The registerUser mutation */
  readonly registerUser?: Maybe<RegisterUserPayload>;
  /** The requestPostAccess mutation */
  readonly requestPostAccess?: Maybe<RequestPostAccessPayload>;
  /** The resetUserPassword mutation */
  readonly resetUserPassword?: Maybe<ResetUserPasswordPayload>;
  /** The restoreComment mutation */
  readonly restoreComment?: Maybe<RestoreCommentPayload>;
  /** Revokes the user secret and invalidates the JWT authentication token. */
  readonly revokeUserSecret?: Maybe<RevokeUserSecretPayload>;
  /** Send password reset email to user */
  readonly sendPasswordResetEmail?: Maybe<SendPasswordResetEmailPayload>;
  /** The settingsForceSyncTagsList mutation */
  readonly settingsForceSyncTagsList?: Maybe<SettingsForceSyncTagsListPayload>;
  /** The syncService mutation */
  readonly syncService?: Maybe<SyncServicePayload>;
  /** The telemetryIntegrationsSync mutation */
  readonly telemetryIntegrationsSync?: Maybe<TelemetryIntegrationsSyncPayload>;
  /** The updateCategory mutation */
  readonly updateCategory?: Maybe<UpdateCategoryPayload>;
  /** The updateComment mutation */
  readonly updateComment?: Maybe<UpdateCommentPayload>;
  /** The updateContact mutation */
  readonly updateContact?: Maybe<UpdateContactPayload>;
  /** The updateCrmList mutation */
  readonly updateCrmList?: Maybe<UpdateCrmListPayload>;
  /** The updateForm mutation */
  readonly updateForm?: Maybe<UpdateFormPayload>;
  /** The updateFormEntry mutation */
  readonly updateFormEntry?: Maybe<UpdateFormEntryPayload>;
  /** The updateGraphqlDocument mutation */
  readonly updateGraphqlDocument?: Maybe<UpdateGraphqlDocumentPayload>;
  /** The updateGraphqlDocumentGroup mutation */
  readonly updateGraphqlDocumentGroup?: Maybe<UpdateGraphqlDocumentGroupPayload>;
  /** The updateHub mutation */
  readonly updateHub?: Maybe<UpdateHubPayload>;
  /** The updateHubPage mutation */
  readonly updateHubPage?: Maybe<UpdateHubPagePayload>;
  /** The updateMediaItem mutation */
  readonly updateMediaItem?: Maybe<UpdateMediaItemPayload>;
  /** The updatePage mutation */
  readonly updatePage?: Maybe<UpdatePagePayload>;
  /** The updatePost mutation */
  readonly updatePost?: Maybe<UpdatePostPayload>;
  /** The updatePostAccessRecipient mutation */
  readonly updatePostAccessRecipient?: Maybe<UpdatePostAccessRecipientPayload>;
  /** The updatePostFormat mutation */
  readonly updatePostFormat?: Maybe<UpdatePostFormatPayload>;
  /** The updateSettings mutation */
  readonly updateSettings?: Maybe<UpdateSettingsPayload>;
  /** The updateSiteSettings mutation */
  readonly updateSiteSettings?: Maybe<UpdateSiteSettingsPayload>;
  /** The updateTag mutation */
  readonly updateTag?: Maybe<UpdateTagPayload>;
  /** The updateUser mutation */
  readonly updateUser?: Maybe<UpdateUserPayload>;
  /** The updateZnglist mutation */
  readonly updateZnglist?: Maybe<UpdateZnglistPayload>;
  /** The updateZnglyInfo mutation */
  readonly updateZnglyInfo?: Maybe<UpdateZnglyInfoPayload>;
  /** The updateZnglyVideo mutation */
  readonly updateZnglyVideo?: Maybe<UpdateZnglyVideoPayload>;
  /** The uploadVideoPost mutation */
  readonly uploadVideoPost?: Maybe<UploadVideoPostPayload>;
  /** The verifyFormPassword mutation */
  readonly verifyFormPassword?: Maybe<VerifyFormPasswordPayload>;
  /** The verifyPostAccess mutation */
  readonly verifyPostAccess?: Maybe<VerifyPostAccessPayload>;
  /** The znSendPasswordResetEmail mutation */
  readonly znSendPasswordResetEmail?: Maybe<ZnSendPasswordResetEmailPayload>;
  /** The zohoDeleteAuth mutation */
  readonly zohoDeleteAuth?: Maybe<ZohoDeleteAuthPayload>;
  /** The zohoRegisterAuth mutation */
  readonly zohoRegisterAuth?: Maybe<ZohoRegisterAuthPayload>;
  /** The zohoUpdateSettings mutation */
  readonly zohoUpdateSettings?: Maybe<ZohoUpdateSettingsPayload>;
};


/** The root mutation */
export type RootMutationBatchPostMutationArgs = {
  input: BatchPostMutationInput;
};


/** The root mutation */
export type RootMutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


/** The root mutation */
export type RootMutationCreateCommentArgs = {
  input: CreateCommentInput;
};


/** The root mutation */
export type RootMutationCreateContactArgs = {
  input: CreateContactInput;
};


/** The root mutation */
export type RootMutationCreateCrmListArgs = {
  input: CreateCrmListInput;
};


/** The root mutation */
export type RootMutationCreateFormArgs = {
  input: CreateFormInput;
};


/** The root mutation */
export type RootMutationCreateFormEntryArgs = {
  input: CreateFormEntryInput;
};


/** The root mutation */
export type RootMutationCreateGraphqlDocumentArgs = {
  input: CreateGraphqlDocumentInput;
};


/** The root mutation */
export type RootMutationCreateGraphqlDocumentGroupArgs = {
  input: CreateGraphqlDocumentGroupInput;
};


/** The root mutation */
export type RootMutationCreateHubArgs = {
  input: CreateHubInput;
};


/** The root mutation */
export type RootMutationCreateHubPageArgs = {
  input: CreateHubPageInput;
};


/** The root mutation */
export type RootMutationCreateMediaItemArgs = {
  input: CreateMediaItemInput;
};


/** The root mutation */
export type RootMutationCreatePageArgs = {
  input: CreatePageInput;
};


/** The root mutation */
export type RootMutationCreatePostArgs = {
  input: CreatePostInput;
};


/** The root mutation */
export type RootMutationCreatePostAccessRecipientArgs = {
  input: CreatePostAccessRecipientInput;
};


/** The root mutation */
export type RootMutationCreatePostFormatArgs = {
  input: CreatePostFormatInput;
};


/** The root mutation */
export type RootMutationCreateTagArgs = {
  input: CreateTagInput;
};


/** The root mutation */
export type RootMutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation */
export type RootMutationCreateZnglistArgs = {
  input: CreateZnglistInput;
};


/** The root mutation */
export type RootMutationCreateZnglyVideoArgs = {
  input: CreateZnglyVideoInput;
};


/** The root mutation */
export type RootMutationDeleteCategoryArgs = {
  input: DeleteCategoryInput;
};


/** The root mutation */
export type RootMutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


/** The root mutation */
export type RootMutationDeleteContactArgs = {
  input: DeleteContactInput;
};


/** The root mutation */
export type RootMutationDeleteCrmListArgs = {
  input: DeleteCrmListInput;
};


/** The root mutation */
export type RootMutationDeleteFormArgs = {
  input: DeleteFormInput;
};


/** The root mutation */
export type RootMutationDeleteFormEntryArgs = {
  input: DeleteFormEntryInput;
};


/** The root mutation */
export type RootMutationDeleteGraphqlDocumentArgs = {
  input: DeleteGraphqlDocumentInput;
};


/** The root mutation */
export type RootMutationDeleteGraphqlDocumentGroupArgs = {
  input: DeleteGraphqlDocumentGroupInput;
};


/** The root mutation */
export type RootMutationDeleteHubArgs = {
  input: DeleteHubInput;
};


/** The root mutation */
export type RootMutationDeleteHubPageArgs = {
  input: DeleteHubPageInput;
};


/** The root mutation */
export type RootMutationDeleteMediaItemArgs = {
  input: DeleteMediaItemInput;
};


/** The root mutation */
export type RootMutationDeletePageArgs = {
  input: DeletePageInput;
};


/** The root mutation */
export type RootMutationDeletePostArgs = {
  input: DeletePostInput;
};


/** The root mutation */
export type RootMutationDeletePostAccessRecipientArgs = {
  input: DeletePostAccessRecipientInput;
};


/** The root mutation */
export type RootMutationDeletePostFormatArgs = {
  input: DeletePostFormatInput;
};


/** The root mutation */
export type RootMutationDeleteTagArgs = {
  input: DeleteTagInput;
};


/** The root mutation */
export type RootMutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation */
export type RootMutationDeleteZnglistArgs = {
  input: DeleteZnglistInput;
};


/** The root mutation */
export type RootMutationDeleteZnglyVideoArgs = {
  input: DeleteZnglyVideoInput;
};


/** The root mutation */
export type RootMutationDeleteZnglyVideoExtraArgs = {
  input: DeleteZnglyVideoExtraInput;
};


/** The root mutation */
export type RootMutationDuplicateCrmListArgs = {
  input: DuplicateCrmListInput;
};


/** The root mutation */
export type RootMutationDuplicateHubArgs = {
  input: DuplicateHubInput;
};


/** The root mutation */
export type RootMutationDuplicateHubPageArgs = {
  input: DuplicateHubPageInput;
};


/** The root mutation */
export type RootMutationDuplicateZnglistArgs = {
  input: DuplicateZnglistInput;
};


/** The root mutation */
export type RootMutationDuplicateZnglyVideoArgs = {
  input: DuplicateZnglyVideoInput;
};


/** The root mutation */
export type RootMutationEmailSenderArgs = {
  input: EmailSenderInput;
};


/** The root mutation */
export type RootMutationEmptyTrashArgs = {
  input: EmptyTrashInput;
};


/** The root mutation */
export type RootMutationExistingUsersBioGlobalUpdateArgs = {
  input: ExistingUsersBioGlobalUpdateInput;
};


/** The root mutation */
export type RootMutationHsDeleteConnectionArgs = {
  input: HsDeleteConnectionInput;
};


/** The root mutation */
export type RootMutationHsRegisterOauthTokensArgs = {
  input: HsRegisterOauthTokensInput;
};


/** The root mutation */
export type RootMutationHsSyncUserTokenArgs = {
  input: HsSyncUserTokenInput;
};


/** The root mutation */
export type RootMutationHsUpdateSettingsArgs = {
  input: HsUpdateSettingsInput;
};


/** The root mutation */
export type RootMutationImportContactsArgs = {
  input: ImportContactsInput;
};


/** The root mutation */
export type RootMutationIncreaseCountArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


/** The root mutation */
export type RootMutationLinkUserIdentityArgs = {
  input: LinkUserIdentityInput;
};


/** The root mutation */
export type RootMutationLoginArgs = {
  input: LoginInput;
};


/** The root mutation */
export type RootMutationLogoutArgs = {
  input: LogoutInput;
};


/** The root mutation */
export type RootMutationMarketoUpdateSettingsArgs = {
  input: MarketoUpdateSettingsInput;
};


/** The root mutation */
export type RootMutationMsAuthenticateTenantArgs = {
  input: MsAuthenticateTenantInput;
};


/** The root mutation */
export type RootMutationMsRemoveTenantArgs = {
  input: MsRemoveTenantInput;
};


/** The root mutation */
export type RootMutationNewMediaItemArgs = {
  input: NewMediaItemInput;
};


/** The root mutation */
export type RootMutationRefreshTokenArgs = {
  input: RefreshTokenInput;
};


/** The root mutation */
export type RootMutationRefreshUserSecretArgs = {
  input: RefreshUserSecretInput;
};


/** The root mutation */
export type RootMutationRegisterUserArgs = {
  input: RegisterUserInput;
};


/** The root mutation */
export type RootMutationRequestPostAccessArgs = {
  input: RequestPostAccessInput;
};


/** The root mutation */
export type RootMutationResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


/** The root mutation */
export type RootMutationRestoreCommentArgs = {
  input: RestoreCommentInput;
};


/** The root mutation */
export type RootMutationRevokeUserSecretArgs = {
  input: RevokeUserSecretInput;
};


/** The root mutation */
export type RootMutationSendPasswordResetEmailArgs = {
  input: SendPasswordResetEmailInput;
};


/** The root mutation */
export type RootMutationSettingsForceSyncTagsListArgs = {
  input: SettingsForceSyncTagsListInput;
};


/** The root mutation */
export type RootMutationSyncServiceArgs = {
  input: SyncServiceInput;
};


/** The root mutation */
export type RootMutationTelemetryIntegrationsSyncArgs = {
  input: TelemetryIntegrationsSyncInput;
};


/** The root mutation */
export type RootMutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


/** The root mutation */
export type RootMutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


/** The root mutation */
export type RootMutationUpdateContactArgs = {
  input: UpdateContactInput;
};


/** The root mutation */
export type RootMutationUpdateCrmListArgs = {
  input: UpdateCrmListInput;
};


/** The root mutation */
export type RootMutationUpdateFormArgs = {
  input: UpdateFormInput;
};


/** The root mutation */
export type RootMutationUpdateFormEntryArgs = {
  input: UpdateFormEntryInput;
};


/** The root mutation */
export type RootMutationUpdateGraphqlDocumentArgs = {
  input: UpdateGraphqlDocumentInput;
};


/** The root mutation */
export type RootMutationUpdateGraphqlDocumentGroupArgs = {
  input: UpdateGraphqlDocumentGroupInput;
};


/** The root mutation */
export type RootMutationUpdateHubArgs = {
  input: UpdateHubInput;
};


/** The root mutation */
export type RootMutationUpdateHubPageArgs = {
  input: UpdateHubPageInput;
};


/** The root mutation */
export type RootMutationUpdateMediaItemArgs = {
  input: UpdateMediaItemInput;
};


/** The root mutation */
export type RootMutationUpdatePageArgs = {
  input: UpdatePageInput;
};


/** The root mutation */
export type RootMutationUpdatePostArgs = {
  input: UpdatePostInput;
};


/** The root mutation */
export type RootMutationUpdatePostAccessRecipientArgs = {
  input: UpdatePostAccessRecipientInput;
};


/** The root mutation */
export type RootMutationUpdatePostFormatArgs = {
  input: UpdatePostFormatInput;
};


/** The root mutation */
export type RootMutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};


/** The root mutation */
export type RootMutationUpdateSiteSettingsArgs = {
  input: UpdateSiteSettingsInput;
};


/** The root mutation */
export type RootMutationUpdateTagArgs = {
  input: UpdateTagInput;
};


/** The root mutation */
export type RootMutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation */
export type RootMutationUpdateZnglistArgs = {
  input: UpdateZnglistInput;
};


/** The root mutation */
export type RootMutationUpdateZnglyInfoArgs = {
  input: UpdateZnglyInfoInput;
};


/** The root mutation */
export type RootMutationUpdateZnglyVideoArgs = {
  input: UpdateZnglyVideoInput;
};


/** The root mutation */
export type RootMutationUploadVideoPostArgs = {
  input: UploadVideoPostInput;
};


/** The root mutation */
export type RootMutationVerifyFormPasswordArgs = {
  input: VerifyFormPasswordInput;
};


/** The root mutation */
export type RootMutationVerifyPostAccessArgs = {
  input: VerifyPostAccessInput;
};


/** The root mutation */
export type RootMutationZnSendPasswordResetEmailArgs = {
  input: ZnSendPasswordResetEmailInput;
};


/** The root mutation */
export type RootMutationZohoDeleteAuthArgs = {
  input: ZohoDeleteAuthInput;
};


/** The root mutation */
export type RootMutationZohoRegisterAuthArgs = {
  input: ZohoRegisterAuthInput;
};


/** The root mutation */
export type RootMutationZohoUpdateSettingsArgs = {
  input: ZohoUpdateSettingsInput;
};

/** The root entry point into the Graph */
export type RootQuery = {
  readonly __typename?: 'RootQuery';
  /** Entry point to get all settings for the site */
  readonly allSettings?: Maybe<Settings>;
  /** Query BigQuery Dashboard */
  readonly bqDashboard?: Maybe<BqDashboard>;
  /** BigQuery Root */
  readonly bqRoot?: Maybe<BqRoot>;
  /** Connection between the RootQuery type and the category type */
  readonly categories?: Maybe<RootQueryToCategoryConnection>;
  /** A 0bject */
  readonly category?: Maybe<Category>;
  /** Returns a Comment */
  readonly comment?: Maybe<Comment>;
  /** Connection between the RootQuery type and the Comment type */
  readonly comments?: Maybe<RootQueryToCommentConnection>;
  /** Single id of ConnectionHpToC */
  readonly connectionHpToC?: Maybe<ConnectionHpToC>;
  /** Connection between the RootQuery type and the ConnectionHpToC type */
  readonly connectionHpToCs?: Maybe<RootQueryToConnectionHpToCConnection>;
  /** Single id of ConnectionHubToHp */
  readonly connectionHubToHp?: Maybe<ConnectionHubToHp>;
  /** Connection between the RootQuery type and the ConnectionHubToHp type */
  readonly connectionHubToHps?: Maybe<RootQueryToConnectionHubToHpConnection>;
  /** Single id of Contact */
  readonly contact?: Maybe<Contact>;
  /** Connection between the RootQuery type and the Contact type */
  readonly contacts?: Maybe<RootQueryToContactConnection>;
  /** A node used to manage content */
  readonly contentNode?: Maybe<ContentNode>;
  /** Connection between the RootQuery type and the ContentNode type */
  readonly contentNodes?: Maybe<RootQueryToContentNodeConnection>;
  /** Fetch a Content Type node by unique Identifier */
  readonly contentType?: Maybe<ContentType>;
  /** Connection between the RootQuery type and the ContentType type */
  readonly contentTypes?: Maybe<RootQueryToContentTypeConnection>;
  /** Query conversation history from BigQuery */
  readonly conversationHistory?: Maybe<ConversationHistory>;
  /** Single id of CrmList */
  readonly crmList?: Maybe<CrmList>;
  /** Single id of CrmListToItem */
  readonly crmListToItem?: Maybe<CrmListToItem>;
  /** Connection between the RootQuery type and the CrmListToItem type */
  readonly crmListToItems?: Maybe<RootQueryToCrmListToItemConnection>;
  /** Connection between the RootQuery type and the CrmList type */
  readonly crmLists?: Maybe<RootQueryToCrmListConnection>;
  /** Get CSV Export */
  readonly csvExport?: Maybe<CsvExport>;
  /** Fields of the &#039;DiscussionSettings&#039; settings group */
  readonly discussionSettings?: Maybe<DiscussionSettings>;
  /** Single id of Form */
  readonly form?: Maybe<Form>;
  /** Connection between the RootQuery type and the FormEntry type */
  readonly formEntries?: Maybe<RootQueryToFormEntryConnection>;
  /** Single id of FormEntry */
  readonly formEntry?: Maybe<FormEntry>;
  /** Connection between the RootQuery type and the Form type */
  readonly forms?: Maybe<RootQueryToFormConnection>;
  /** Fields of the &#039;GeneralSettings&#039; settings group */
  readonly generalSettings?: Maybe<GeneralSettings>;
  /** An object of the graphqlDocument Type. Saved GraphQL Documents */
  readonly graphqlDocument?: Maybe<GraphqlDocument>;
  /**
   * A graphqlDocument object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  readonly graphqlDocumentBy?: Maybe<GraphqlDocument>;
  /** A 0bject */
  readonly graphqlDocumentGroup?: Maybe<GraphqlDocumentGroup>;
  /** Connection between the RootQuery type and the graphqlDocumentGroup type */
  readonly graphqlDocumentGroups?: Maybe<RootQueryToGraphqlDocumentGroupConnection>;
  /** Connection between the RootQuery type and the graphqlDocument type */
  readonly graphqlDocuments?: Maybe<RootQueryToGraphqlDocumentConnection>;
  /** Hubspot info query */
  readonly hsInfo?: Maybe<HsInfo>;
  /** Hubspot test query */
  readonly hsTest?: Maybe<HsTest>;
  /** Single id of Hub */
  readonly hub?: Maybe<Hub>;
  /** Single id of HubPage */
  readonly hubPage?: Maybe<HubPage>;
  /** Connection between the RootQuery type and the HubPage type */
  readonly hubPages?: Maybe<RootQueryToHubPageConnection>;
  /** Connection between the RootQuery type and the Hub type */
  readonly hubs?: Maybe<RootQueryToHubConnection>;
  /** Integrations manager query */
  readonly integrationsManager?: Maybe<IntegrationsManager>;
  /** The Headless Login client for the provided client ID. */
  readonly loginClient?: Maybe<LoginClient>;
  /** The registered Headless Login clients. */
  readonly loginClients?: Maybe<ReadonlyArray<Maybe<LoginClient>>>;
  /** Marketo info query */
  readonly marketoInfo?: Maybe<MarketoInfo>;
  /** An object of the mediaItem Type.  */
  readonly mediaItem?: Maybe<MediaItem>;
  /**
   * A mediaItem object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  readonly mediaItemBy?: Maybe<MediaItem>;
  /** Connection between the RootQuery type and the mediaItem type */
  readonly mediaItems?: Maybe<RootQueryToMediaItemConnection>;
  /** A WordPress navigation menu */
  readonly menu?: Maybe<Menu>;
  /** A WordPress navigation menu item */
  readonly menuItem?: Maybe<MenuItem>;
  /** Connection between the RootQuery type and the MenuItem type */
  readonly menuItems?: Maybe<RootQueryToMenuItemConnection>;
  /** Connection between the RootQuery type and the Menu type */
  readonly menus?: Maybe<RootQueryToMenuConnection>;
  /** Microsoft info query */
  readonly msInfo?: Maybe<MsInfo>;
  /** Microsoft sharepoint query */
  readonly msSharePoint?: Maybe<MsSharePoint>;
  /** Fetches an object given its ID */
  readonly node?: Maybe<Node>;
  /** Fetches an object given its Unique Resource Identifier */
  readonly nodeByUri?: Maybe<UniformResourceIdentifiable>;
  readonly oembedV2?: Maybe<OembedV2>;
  /** An object of the page Type.  */
  readonly page?: Maybe<Page>;
  /**
   * A page object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  readonly pageBy?: Maybe<Page>;
  /** Connection between the RootQuery type and the page type */
  readonly pages?: Maybe<RootQueryToPageConnection>;
  /** A WordPress plugin */
  readonly plugin?: Maybe<Plugin>;
  /** Connection between the RootQuery type and the Plugin type */
  readonly plugins?: Maybe<RootQueryToPluginConnection>;
  /** An object of the post Type.  */
  readonly post?: Maybe<Post>;
  /** Single id of PostAccessRecipient */
  readonly postAccessRecipient?: Maybe<PostAccessRecipient>;
  /** Connection between the RootQuery type and the PostAccessRecipient type */
  readonly postAccessRecipients?: Maybe<RootQueryToPostAccessRecipientConnection>;
  /**
   * A post object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  readonly postBy?: Maybe<Post>;
  /** A 0bject */
  readonly postFormat?: Maybe<PostFormat>;
  /** Connection between the RootQuery type and the postFormat type */
  readonly postFormats?: Maybe<RootQueryToPostFormatConnection>;
  /** Connection between the RootQuery type and the post type */
  readonly posts?: Maybe<RootQueryToPostConnection>;
  /** Get Product License Information */
  readonly productLicense?: Maybe<ProductLicense>;
  /** Fields of the &#039;ReadingSettings&#039; settings group */
  readonly readingSettings?: Maybe<ReadingSettings>;
  /** Connection between the RootQuery type and the EnqueuedScript type */
  readonly registeredScripts?: Maybe<RootQueryToEnqueuedScriptConnection>;
  /** Connection between the RootQuery type and the EnqueuedStylesheet type */
  readonly registeredStylesheets?: Maybe<RootQueryToEnqueuedStylesheetConnection>;
  /** Review Post Dependencies */
  readonly reviewUsage?: Maybe<ReviewUsage>;
  /** Connection between the RootQuery type and the ContentNode type */
  readonly revisions?: Maybe<RootQueryToRevisionsConnection>;
  /** Site settings query */
  readonly siteSettings?: Maybe<SiteSettings>;
  /** A 0bject */
  readonly tag?: Maybe<Tag>;
  /** Connection between the RootQuery type and the tag type */
  readonly tags?: Maybe<RootQueryToTagConnection>;
  /** Connection between the RootQuery type and the Taxonomy type */
  readonly taxonomies?: Maybe<RootQueryToTaxonomyConnection>;
  /** Fetch a Taxonomy node by unique Identifier */
  readonly taxonomy?: Maybe<Taxonomy>;
  /** A node in a taxonomy used to group and relate content nodes */
  readonly termNode?: Maybe<TermNode>;
  /** Connection between the RootQuery type and the TermNode type */
  readonly terms?: Maybe<RootQueryToTermNodeConnection>;
  /** A Theme object */
  readonly theme?: Maybe<Theme>;
  /** Connection between the RootQuery type and the Theme type */
  readonly themes?: Maybe<RootQueryToThemeConnection>;
  /** Returns a user */
  readonly user?: Maybe<User>;
  /** Returns a user role */
  readonly userRole?: Maybe<UserRole>;
  /** Connection between the RootQuery type and the UserRole type */
  readonly userRoles?: Maybe<RootQueryToUserRoleConnection>;
  /** Connection between the RootQuery type and the User type */
  readonly users?: Maybe<RootQueryToUserConnection>;
  /** Validate records in the database. e.g. check if record exists by property */
  readonly validateContacts?: Maybe<ReadonlyArray<Maybe<ValidateContacts>>>;
  /** GCP Gen AI Summary - Vertex AI */
  readonly vertexGenAi?: Maybe<VertexGenAi>;
  /** Connection between the RootQuery type and the znglyVideo type */
  readonly vertexSearchAgent?: Maybe<VertexSearchAgentConnection>;
  /** Returns the current user */
  readonly viewer?: Maybe<User>;
  /** Fields of the &#039;WritingSettings&#039; settings group */
  readonly writingSettings?: Maybe<WritingSettings>;
  /** An object of the znglist Type. Custom Post type for adding Zngly Playlists */
  readonly znglist?: Maybe<Znglist>;
  /**
   * A znglist object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  readonly znglistBy?: Maybe<Znglist>;
  /** Connection between the RootQuery type and the znglist type */
  readonly znglists?: Maybe<RootQueryToZnglistConnection>;
  /** An object of the znglyInfo Type. Custom Post type for adding Zngly Site Information */
  readonly znglyInfo?: Maybe<ZnglyInfo>;
  /**
   * A znglyInfo object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  readonly znglyInfoBy?: Maybe<ZnglyInfo>;
  /** Connection between the RootQuery type and the znglyInfo type */
  readonly znglyInfos?: Maybe<RootQueryToZnglyInfoConnection>;
  /** An object of the znglyVideo Type. Custom Post type for adding Zngly content */
  readonly znglyVideo?: Maybe<ZnglyVideo>;
  /**
   * A znglyVideo object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  readonly znglyVideoBy?: Maybe<ZnglyVideo>;
  /** Connection between the RootQuery type and the znglyVideo type */
  readonly znglyVideos?: Maybe<RootQueryToZnglyVideoConnection>;
  /** Decode zntrk */
  readonly zntrkDecode?: Maybe<ZntrkDecode>;
  /** Zoho Root Query */
  readonly zohoInfo?: Maybe<ZohoInfo>;
};


/** The root entry point into the Graph */
export type RootQueryBqDashboardArgs = {
  after: DateInput;
  before: DateInput;
};


/** The root entry point into the Graph */
export type RootQueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToCategoryConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryCategoryArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<CategoryIdType>;
};


/** The root entry point into the Graph */
export type RootQueryCommentArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<CommentNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToCommentConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryConnectionHpToCArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<ConnectionHpToCIdType>;
};


/** The root entry point into the Graph */
export type RootQueryConnectionHpToCsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToConnectionHpToCConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryConnectionHubToHpArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<ConnectionHubToHpIdType>;
};


/** The root entry point into the Graph */
export type RootQueryConnectionHubToHpsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToConnectionHubToHpConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryContactArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<ContactIdType>;
};


/** The root entry point into the Graph */
export type RootQueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToContactConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryContentNodeArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']['input']>;
  contentType?: InputMaybe<ContentTypeEnum>;
  id: Scalars['ID']['input'];
  idType?: InputMaybe<ContentNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryContentNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToContentNodeConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryContentTypeArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<ContentTypeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryContentTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryConversationHistoryArgs = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryCrmListArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<CrmListIdType>;
};


/** The root entry point into the Graph */
export type RootQueryCrmListToItemArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<CrmListToItemIdType>;
};


/** The root entry point into the Graph */
export type RootQueryCrmListToItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToCrmListToItemConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryCrmListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToCrmListConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryCsvExportArgs = {
  input?: InputMaybe<CsvExportQueryInput>;
};


/** The root entry point into the Graph */
export type RootQueryFormArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<FormIdType>;
};


/** The root entry point into the Graph */
export type RootQueryFormEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToFormEntryConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryFormEntryArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<FormEntryIdType>;
};


/** The root entry point into the Graph */
export type RootQueryFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToFormConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryGraphqlDocumentArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  idType?: InputMaybe<GraphqlDocumentIdType>;
};


/** The root entry point into the Graph */
export type RootQueryGraphqlDocumentByArgs = {
  graphqlDocumentId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryGraphqlDocumentGroupArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<GraphqlDocumentGroupIdType>;
};


/** The root entry point into the Graph */
export type RootQueryGraphqlDocumentGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToGraphqlDocumentGroupConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryGraphqlDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToGraphqlDocumentConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryHubArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<HubIdType>;
};


/** The root entry point into the Graph */
export type RootQueryHubPageArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<HubPageIdType>;
};


/** The root entry point into the Graph */
export type RootQueryHubPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToHubPageConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryHubsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToHubConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryLoginClientArgs = {
  provider: LoginProviderEnum;
};


/** The root entry point into the Graph */
export type RootQueryMediaItemArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  idType?: InputMaybe<MediaItemIdType>;
};


/** The root entry point into the Graph */
export type RootQueryMediaItemByArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  mediaItemId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryMediaItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToMediaItemConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryMenuArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<MenuNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryMenuItemArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<MenuItemNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryMenuItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToMenuItemConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryMenusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToMenuConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryMsSharePointArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryNodeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryNodeByUriArgs = {
  uri: Scalars['String']['input'];
};


/** The root entry point into the Graph */
export type RootQueryOembedV2Args = {
  url?: InputMaybe<Scalars['String']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryPageArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  idType?: InputMaybe<PageIdType>;
};


/** The root entry point into the Graph */
export type RootQueryPageByArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  pageId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToPageConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryPluginArgs = {
  id: Scalars['ID']['input'];
};


/** The root entry point into the Graph */
export type RootQueryPluginsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToPluginConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryPostArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  idType?: InputMaybe<PostIdType>;
};


/** The root entry point into the Graph */
export type RootQueryPostAccessRecipientArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<PostAccessRecipientIdType>;
};


/** The root entry point into the Graph */
export type RootQueryPostAccessRecipientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToPostAccessRecipientConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryPostByArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  postId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryPostFormatArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<PostFormatIdType>;
};


/** The root entry point into the Graph */
export type RootQueryPostFormatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToPostFormatConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToPostConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryProductLicenseArgs = {
  purgeCache?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryRegisteredScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryRegisteredStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryReviewUsageArgs = {
  input?: InputMaybe<ReviewUsageQueryInput>;
};


/** The root entry point into the Graph */
export type RootQueryRevisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToRevisionsConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryTagArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<TagIdType>;
};


/** The root entry point into the Graph */
export type RootQueryTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToTagConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryTaxonomiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryTaxonomyArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<TaxonomyIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryTermNodeArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<TermNodeIdTypeEnum>;
  taxonomy?: InputMaybe<TaxonomyEnum>;
};


/** The root entry point into the Graph */
export type RootQueryTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToTermNodeConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryThemeArgs = {
  id: Scalars['ID']['input'];
};


/** The root entry point into the Graph */
export type RootQueryThemesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryUserArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<UserNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryUserRoleArgs = {
  id: Scalars['ID']['input'];
};


/** The root entry point into the Graph */
export type RootQueryUserRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToUserConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryValidateContactsArgs = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']['input']>;
  field: ValidateContactsFieldEnum;
  inputBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  inputNumberArray?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']['input']>>>;
  inputStringArray?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


/** The root entry point into the Graph */
export type RootQueryVertexGenAiArgs = {
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  mediaItemId?: InputMaybe<Scalars['ID']['input']>;
  promptType?: InputMaybe<VertexGenAiPromptType>;
  textContent?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryVertexSearchAgentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VertexSearchAgentConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryZnglistArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  idType?: InputMaybe<ZnglistIdType>;
};


/** The root entry point into the Graph */
export type RootQueryZnglistByArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
  znglistId?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryZnglistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToZnglistConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryZnglyInfoArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  idType?: InputMaybe<ZnglyInfoIdType>;
};


/** The root entry point into the Graph */
export type RootQueryZnglyInfoByArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
  znglyInfoId?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryZnglyInfosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToZnglyInfoConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryZnglyVideoArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  idType?: InputMaybe<ZnglyVideoIdType>;
};


/** The root entry point into the Graph */
export type RootQueryZnglyVideoByArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
  znglyVideoId?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryZnglyVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToZnglyVideoConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryZntrkDecodeArgs = {
  zntrk?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

/** Connection between the RootQuery type and the category type */
export type RootQueryToCategoryConnection = CategoryConnection & Connection & {
  readonly __typename?: 'RootQueryToCategoryConnection';
  /** Edges for the RootQueryToCategoryConnection connection */
  readonly edges: ReadonlyArray<RootQueryToCategoryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Category>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToCategoryConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToCategoryConnectionEdge = CategoryConnectionEdge & Edge & {
  readonly __typename?: 'RootQueryToCategoryConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Category;
};

/** Pagination metadata specific to &quot;RootQueryToCategoryConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToCategoryConnection Nodes. */
export type RootQueryToCategoryConnectionPageInfo = CategoryConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToCategoryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToCategoryConnection connection */
export type RootQueryToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the RootQuery type and the Comment type */
export type RootQueryToCommentConnection = CommentConnection & Connection & {
  readonly __typename?: 'RootQueryToCommentConnection';
  /** Edges for the RootQueryToCommentConnection connection */
  readonly edges: ReadonlyArray<RootQueryToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Comment>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  readonly __typename?: 'RootQueryToCommentConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Comment;
};

/** Pagination metadata specific to &quot;RootQueryToCommentConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToCommentConnection Nodes. */
export type RootQueryToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToCommentConnection connection */
export type RootQueryToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  readonly authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  readonly authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  readonly commentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  readonly commentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  readonly commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  readonly commentTypeIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  readonly commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  readonly contentAuthor?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  readonly contentAuthorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  readonly contentAuthorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  readonly contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  readonly contentIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  readonly contentIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  readonly contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  readonly contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentStatus?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentType?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  readonly includeUnapproved?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  readonly karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  readonly orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the RootQuery type and the ConnectionHpToC type */
export type RootQueryToConnectionHpToCConnection = Connection & ConnectionHpToCConnection & {
  readonly __typename?: 'RootQueryToConnectionHpToCConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the RootQueryToConnectionHpToCConnection connection */
  readonly edges: ReadonlyArray<RootQueryToConnectionHpToCConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ConnectionHpToC>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToConnectionHpToCConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToConnectionHpToCConnectionEdge = ConnectionHpToCConnectionEdge & Edge & {
  readonly __typename?: 'RootQueryToConnectionHpToCConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ConnectionHpToC;
};

/** Pagination metadata specific to &quot;RootQueryToConnectionHpToCConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToConnectionHpToCConnection Nodes. */
export type RootQueryToConnectionHpToCConnectionPageInfo = ConnectionHpToCConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToConnectionHpToCConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToConnectionHpToCConnection connection */
export type RootQueryToConnectionHpToCConnectionWhereArgs = {
  /** Catalog Id */
  readonly catalogId?: InputMaybe<Scalars['ID']['input']>;
  /** Catalog Id */
  readonly catalogIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Catalog Id */
  readonly catalogIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** order of the catalog items */
  readonly catalogOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Hub Page Id */
  readonly hubPageId?: InputMaybe<Scalars['ID']['input']>;
  /** Hub Page Id */
  readonly hubPageIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Hub Page Id */
  readonly hubPageIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** weak table id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** weak table id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** weak table id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<ConnectionHpToCSearchFieldsEnum>>>;
  /** Search for ConnectionHpToCs by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for ConnectionHpToCs by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<ConnectionHpToCSearchFieldsEnum>>>;
};

/** Connection between the RootQuery type and the ConnectionHubToHp type */
export type RootQueryToConnectionHubToHpConnection = Connection & ConnectionHubToHpConnection & {
  readonly __typename?: 'RootQueryToConnectionHubToHpConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the RootQueryToConnectionHubToHpConnection connection */
  readonly edges: ReadonlyArray<RootQueryToConnectionHubToHpConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ConnectionHubToHp>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToConnectionHubToHpConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToConnectionHubToHpConnectionEdge = ConnectionHubToHpConnectionEdge & Edge & {
  readonly __typename?: 'RootQueryToConnectionHubToHpConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ConnectionHubToHp;
};

/** Pagination metadata specific to &quot;RootQueryToConnectionHubToHpConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToConnectionHubToHpConnection Nodes. */
export type RootQueryToConnectionHubToHpConnectionPageInfo = ConnectionHubToHpConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToConnectionHubToHpConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToConnectionHubToHpConnection connection */
export type RootQueryToConnectionHubToHpConnectionWhereArgs = {
  /** Hub Id */
  readonly hubId?: InputMaybe<Scalars['ID']['input']>;
  /** Hub Id */
  readonly hubIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Hub Id */
  readonly hubIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** weak table id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** weak table id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** weak table id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<ConnectionHubToHpSearchFieldsEnum>>>;
  /** Page Icon */
  readonly pageIcon?: InputMaybe<Scalars['String']['input']>;
  /** Page Id */
  readonly pageId?: InputMaybe<Scalars['ID']['input']>;
  /** Page Id */
  readonly pageIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Page Id */
  readonly pageIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** order of the pages */
  readonly pageOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Page Title */
  readonly pageTitle?: InputMaybe<Scalars['String']['input']>;
  /** Search for ConnectionHubToHps by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for ConnectionHubToHps by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<ConnectionHubToHpSearchFieldsEnum>>>;
};

/** Connection between the RootQuery type and the Contact type */
export type RootQueryToContactConnection = Connection & ContactConnection & {
  readonly __typename?: 'RootQueryToContactConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the RootQueryToContactConnection connection */
  readonly edges: ReadonlyArray<RootQueryToContactConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Contact>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToContactConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToContactConnectionEdge = ContactConnectionEdge & Edge & {
  readonly __typename?: 'RootQueryToContactConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Contact;
};

/** Pagination metadata specific to &quot;RootQueryToContactConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToContactConnection Nodes. */
export type RootQueryToContactConnectionPageInfo = ContactConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToContactConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToContactConnection connection */
export type RootQueryToContactConnectionWhereArgs = {
  /** Contact address line 1 */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Contact address line 2 */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Contact address line 3 */
  readonly addressLine3?: InputMaybe<Scalars['String']['input']>;
  /** Contact city */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** Contact company */
  readonly company?: InputMaybe<Scalars['String']['input']>;
  /** Contact country */
  readonly country?: InputMaybe<Scalars['String']['input']>;
  /** Contact county */
  readonly county?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** Contact email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Contact firstname */
  readonly firstname?: InputMaybe<Scalars['String']['input']>;
  /** contact id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** contact id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** contact id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Contact job title */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Contact lastname */
  readonly lastname?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<ContactSearchFieldsEnum>>>;
  /** Contact phone */
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  /** Contact postal code */
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Contact region */
  readonly region?: InputMaybe<Scalars['String']['input']>;
  /** Search for Contacts by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for Contacts by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<ContactSearchFieldsEnum>>>;
};

/** Connection between the RootQuery type and the ContentNode type */
export type RootQueryToContentNodeConnection = Connection & ContentNodeConnection & {
  readonly __typename?: 'RootQueryToContentNodeConnection';
  /** Edges for the RootQueryToContentNodeConnection connection */
  readonly edges: ReadonlyArray<RootQueryToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ContentNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  readonly __typename?: 'RootQueryToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ContentNode;
};

/** Pagination metadata specific to &quot;RootQueryToContentNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToContentNodeConnection Nodes. */
export type RootQueryToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToContentNodeConnection connection */
export type RootQueryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  readonly contentTypes?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the ContentType type */
export type RootQueryToContentTypeConnection = Connection & ContentTypeConnection & {
  readonly __typename?: 'RootQueryToContentTypeConnection';
  /** Edges for the RootQueryToContentTypeConnection connection */
  readonly edges: ReadonlyArray<RootQueryToContentTypeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ContentType>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToContentTypeConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToContentTypeConnectionEdge = ContentTypeConnectionEdge & Edge & {
  readonly __typename?: 'RootQueryToContentTypeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ContentType;
};

/** Pagination metadata specific to &quot;RootQueryToContentTypeConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToContentTypeConnection Nodes. */
export type RootQueryToContentTypeConnectionPageInfo = ContentTypeConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToContentTypeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the RootQuery type and the CrmList type */
export type RootQueryToCrmListConnection = Connection & CrmListConnection & {
  readonly __typename?: 'RootQueryToCrmListConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the RootQueryToCrmListConnection connection */
  readonly edges: ReadonlyArray<RootQueryToCrmListConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<CrmList>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToCrmListConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToCrmListConnectionEdge = CrmListConnectionEdge & Edge & {
  readonly __typename?: 'RootQueryToCrmListConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: CrmList;
};

/** Pagination metadata specific to &quot;RootQueryToCrmListConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToCrmListConnection Nodes. */
export type RootQueryToCrmListConnectionPageInfo = CrmListConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToCrmListConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToCrmListConnection connection */
export type RootQueryToCrmListConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** list id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** list id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** list id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** List Metadata */
  readonly metadata?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<CrmListSearchFieldsEnum>>>;
  /** Search for CrmLists by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for CrmLists by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<CrmListSearchFieldsEnum>>>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status of the post */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The status of the post */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** type of list */
  readonly type?: InputMaybe<CrmListTypeEnum>;
  /** type of list */
  readonly typeIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListTypeEnum>>>;
  /** type of list */
  readonly typeNotIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListTypeEnum>>>;
};

/** Connection between the RootQuery type and the CrmListToItem type */
export type RootQueryToCrmListToItemConnection = Connection & CrmListToItemConnection & {
  readonly __typename?: 'RootQueryToCrmListToItemConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the RootQueryToCrmListToItemConnection connection */
  readonly edges: ReadonlyArray<RootQueryToCrmListToItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<CrmListToItem>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToCrmListToItemConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToCrmListToItemConnectionEdge = CrmListToItemConnectionEdge & Edge & {
  readonly __typename?: 'RootQueryToCrmListToItemConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: CrmListToItem;
};

/** Pagination metadata specific to &quot;RootQueryToCrmListToItemConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToCrmListToItemConnection Nodes. */
export type RootQueryToCrmListToItemConnectionPageInfo = CrmListToItemConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToCrmListToItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToCrmListToItemConnection connection */
export type RootQueryToCrmListToItemConnectionWhereArgs = {
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** weak table id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** weak table id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** weak table id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Item Id */
  readonly itemId?: InputMaybe<Scalars['ID']['input']>;
  /** Item Id */
  readonly itemIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Item Id */
  readonly itemIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** List Id */
  readonly listId?: InputMaybe<Scalars['ID']['input']>;
  /** List Id */
  readonly listIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** List Id */
  readonly listIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** mode of list item */
  readonly mode?: InputMaybe<CrmListModeEnum>;
  /** mode of list item */
  readonly modeIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListModeEnum>>>;
  /** mode of list item */
  readonly modeNotIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListModeEnum>>>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<CrmListToItemSearchFieldsEnum>>>;
  /** Search for CrmListToItems by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for CrmListToItems by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<CrmListToItemSearchFieldsEnum>>>;
  /** type of list item */
  readonly type?: InputMaybe<CrmListTypeEnum>;
  /** type of list item */
  readonly typeIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListTypeEnum>>>;
  /** type of list item */
  readonly typeNotIn?: InputMaybe<ReadonlyArray<InputMaybe<CrmListTypeEnum>>>;
};

/** Connection between the RootQuery type and the EnqueuedScript type */
export type RootQueryToEnqueuedScriptConnection = Connection & EnqueuedScriptConnection & {
  readonly __typename?: 'RootQueryToEnqueuedScriptConnection';
  /** Edges for the RootQueryToEnqueuedScriptConnection connection */
  readonly edges: ReadonlyArray<RootQueryToEnqueuedScriptConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<EnqueuedScript>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToEnqueuedScriptConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToEnqueuedScriptConnectionEdge = Edge & EnqueuedScriptConnectionEdge & {
  readonly __typename?: 'RootQueryToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: EnqueuedScript;
};

/** Pagination metadata specific to &quot;RootQueryToEnqueuedScriptConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToEnqueuedScriptConnection Nodes. */
export type RootQueryToEnqueuedScriptConnectionPageInfo = EnqueuedScriptConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToEnqueuedScriptConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the RootQuery type and the EnqueuedStylesheet type */
export type RootQueryToEnqueuedStylesheetConnection = Connection & EnqueuedStylesheetConnection & {
  readonly __typename?: 'RootQueryToEnqueuedStylesheetConnection';
  /** Edges for the RootQueryToEnqueuedStylesheetConnection connection */
  readonly edges: ReadonlyArray<RootQueryToEnqueuedStylesheetConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToEnqueuedStylesheetConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToEnqueuedStylesheetConnectionEdge = Edge & EnqueuedStylesheetConnectionEdge & {
  readonly __typename?: 'RootQueryToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: EnqueuedStylesheet;
};

/** Pagination metadata specific to &quot;RootQueryToEnqueuedStylesheetConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToEnqueuedStylesheetConnection Nodes. */
export type RootQueryToEnqueuedStylesheetConnectionPageInfo = EnqueuedStylesheetConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToEnqueuedStylesheetConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the RootQuery type and the Form type */
export type RootQueryToFormConnection = Connection & FormConnection & {
  readonly __typename?: 'RootQueryToFormConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the RootQueryToFormConnection connection */
  readonly edges: ReadonlyArray<RootQueryToFormConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Form>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToFormConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToFormConnectionEdge = Edge & FormConnectionEdge & {
  readonly __typename?: 'RootQueryToFormConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Form;
};

/** Pagination metadata specific to &quot;RootQueryToFormConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToFormConnection Nodes. */
export type RootQueryToFormConnectionPageInfo = FormConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToFormConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToFormConnection connection */
export type RootQueryToFormConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** description of the form */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** form id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** form id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** form id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** image url of the form */
  readonly imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** marketing consent */
  readonly marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<FormSearchFieldsEnum>>>;
  /** schema of the form */
  readonly schema?: InputMaybe<Scalars['String']['input']>;
  /** Search for Forms by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for Forms by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<FormSearchFieldsEnum>>>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status of the post */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The status of the post */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** ui schema of the form */
  readonly uiSchema?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the FormEntry type */
export type RootQueryToFormEntryConnection = Connection & FormEntryConnection & {
  readonly __typename?: 'RootQueryToFormEntryConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the RootQueryToFormEntryConnection connection */
  readonly edges: ReadonlyArray<RootQueryToFormEntryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<FormEntry>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToFormEntryConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToFormEntryConnectionEdge = Edge & FormEntryConnectionEdge & {
  readonly __typename?: 'RootQueryToFormEntryConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: FormEntry;
};

/** Pagination metadata specific to &quot;RootQueryToFormEntryConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToFormEntryConnection Nodes. */
export type RootQueryToFormEntryConnectionPageInfo = FormEntryConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToFormEntryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToFormEntryConnection connection */
export type RootQueryToFormEntryConnectionWhereArgs = {
  /** company name */
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  /** country */
  readonly country?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** Email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** first name */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** Parent Form Id */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** Parent Form Id */
  readonly formIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Parent Form Id */
  readonly formIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Form title from which the entry was submitted */
  readonly formTitle?: InputMaybe<Scalars['String']['input']>;
  /** Form entry id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** Form entry id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Form entry id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** job title */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** last name */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** marketing consent */
  readonly marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** message */
  readonly message?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<FormEntrySearchFieldsEnum>>>;
  /** phone number */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Search for FormEntries by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for FormEntries by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<FormEntrySearchFieldsEnum>>>;
  /** Zngly visitor id */
  readonly visitorId?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the graphqlDocument type */
export type RootQueryToGraphqlDocumentConnection = Connection & GraphqlDocumentConnection & {
  readonly __typename?: 'RootQueryToGraphqlDocumentConnection';
  /** Edges for the RootQueryToGraphqlDocumentConnection connection */
  readonly edges: ReadonlyArray<RootQueryToGraphqlDocumentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<GraphqlDocument>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToGraphqlDocumentConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToGraphqlDocumentConnectionEdge = Edge & GraphqlDocumentConnectionEdge & {
  readonly __typename?: 'RootQueryToGraphqlDocumentConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: GraphqlDocument;
};

/** Pagination metadata specific to &quot;RootQueryToGraphqlDocumentConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToGraphqlDocumentConnection Nodes. */
export type RootQueryToGraphqlDocumentConnectionPageInfo = GraphqlDocumentConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToGraphqlDocumentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToGraphqlDocumentConnection connection */
export type RootQueryToGraphqlDocumentConnectionWhereArgs = {
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the graphqlDocumentGroup type */
export type RootQueryToGraphqlDocumentGroupConnection = Connection & GraphqlDocumentGroupConnection & {
  readonly __typename?: 'RootQueryToGraphqlDocumentGroupConnection';
  /** Edges for the RootQueryToGraphqlDocumentGroupConnection connection */
  readonly edges: ReadonlyArray<RootQueryToGraphqlDocumentGroupConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<GraphqlDocumentGroup>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToGraphqlDocumentGroupConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToGraphqlDocumentGroupConnectionEdge = Edge & GraphqlDocumentGroupConnectionEdge & {
  readonly __typename?: 'RootQueryToGraphqlDocumentGroupConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: GraphqlDocumentGroup;
};

/** Pagination metadata specific to &quot;RootQueryToGraphqlDocumentGroupConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToGraphqlDocumentGroupConnection Nodes. */
export type RootQueryToGraphqlDocumentGroupConnectionPageInfo = GraphqlDocumentGroupConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToGraphqlDocumentGroupConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToGraphqlDocumentGroupConnection connection */
export type RootQueryToGraphqlDocumentGroupConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the RootQuery type and the Hub type */
export type RootQueryToHubConnection = Connection & HubConnection & {
  readonly __typename?: 'RootQueryToHubConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the RootQueryToHubConnection connection */
  readonly edges: ReadonlyArray<RootQueryToHubConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Hub>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToHubConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToHubConnectionEdge = Edge & HubConnectionEdge & {
  readonly __typename?: 'RootQueryToHubConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Hub;
};

/** Pagination metadata specific to &quot;RootQueryToHubConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToHubConnection Nodes. */
export type RootQueryToHubConnectionPageInfo = HubConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToHubConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToHubConnection connection */
export type RootQueryToHubConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** description of the hub */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** group of the hub used to identify its category/tag/campaign */
  readonly group?: InputMaybe<Scalars['String']['input']>;
  /** group of the hub used to identify its category/tag/campaign */
  readonly groupIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** group of the hub used to identify its category/tag/campaign */
  readonly groupNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** hub id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** hub id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** hub id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<HubSearchFieldsEnum>>>;
  /** order of the hubs */
  readonly postOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Search for Hubs by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for Hubs by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<HubSearchFieldsEnum>>>;
  /** The name (slug) for the post */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status of the post */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The status of the post */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** template of the hub */
  readonly template?: InputMaybe<HubTemplateEnum>;
  /** template of the hub */
  readonly templateIn?: InputMaybe<ReadonlyArray<InputMaybe<HubTemplateEnum>>>;
  /** template of the hub */
  readonly templateNotIn?: InputMaybe<ReadonlyArray<InputMaybe<HubTemplateEnum>>>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** User related to the hub */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
  /** User related to the hub */
  readonly userIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** User related to the hub */
  readonly userIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
};

/** Connection between the RootQuery type and the HubPage type */
export type RootQueryToHubPageConnection = Connection & HubPageConnection & {
  readonly __typename?: 'RootQueryToHubPageConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the RootQueryToHubPageConnection connection */
  readonly edges: ReadonlyArray<RootQueryToHubPageConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<HubPage>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToHubPageConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToHubPageConnectionEdge = Edge & HubPageConnectionEdge & {
  readonly __typename?: 'RootQueryToHubPageConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: HubPage;
};

/** Pagination metadata specific to &quot;RootQueryToHubPageConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToHubPageConnection Nodes. */
export type RootQueryToHubPageConnectionPageInfo = HubPageConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToHubPageConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToHubPageConnection connection */
export type RootQueryToHubPageConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** page description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Form Id */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** Form Id */
  readonly formIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Form Id */
  readonly formIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** page id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** page id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** page id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<HubPageSearchFieldsEnum>>>;
  /** Search for HubPages by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for HubPages by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<HubPageSearchFieldsEnum>>>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status of the post */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The status of the post */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the mediaItem type */
export type RootQueryToMediaItemConnection = Connection & MediaItemConnection & {
  readonly __typename?: 'RootQueryToMediaItemConnection';
  /** Edges for the RootQueryToMediaItemConnection connection */
  readonly edges: ReadonlyArray<RootQueryToMediaItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<MediaItem>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToMediaItemConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToMediaItemConnectionEdge = Edge & MediaItemConnectionEdge & {
  readonly __typename?: 'RootQueryToMediaItemConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: MediaItem;
};

/** Pagination metadata specific to &quot;RootQueryToMediaItemConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToMediaItemConnection Nodes. */
export type RootQueryToMediaItemConnectionPageInfo = MediaItemConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToMediaItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToMediaItemConnection connection */
export type RootQueryToMediaItemConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** Filter media items that are not used in any catalog */
  readonly excludeMediaItemsInCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter media items that are not used in any catalog */
  readonly excludedMediaItemsInCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** List of Mime Types */
  readonly mimeTypes?: InputMaybe<ReadonlyArray<InputMaybe<MimeTypeEnum>>>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the Menu type */
export type RootQueryToMenuConnection = Connection & MenuConnection & {
  readonly __typename?: 'RootQueryToMenuConnection';
  /** Edges for the RootQueryToMenuConnection connection */
  readonly edges: ReadonlyArray<RootQueryToMenuConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Menu>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToMenuConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToMenuConnectionEdge = Edge & MenuConnectionEdge & {
  readonly __typename?: 'RootQueryToMenuConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Menu;
};

/** Pagination metadata specific to &quot;RootQueryToMenuConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToMenuConnection Nodes. */
export type RootQueryToMenuConnectionPageInfo = MenuConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToMenuConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToMenuConnection connection */
export type RootQueryToMenuConnectionWhereArgs = {
  /** The database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** The menu location for the menu being queried */
  readonly location?: InputMaybe<MenuLocationEnum>;
  /** The slug of the menu to query items for */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the MenuItem type */
export type RootQueryToMenuItemConnection = Connection & MenuItemConnection & {
  readonly __typename?: 'RootQueryToMenuItemConnection';
  /** Edges for the RootQueryToMenuItemConnection connection */
  readonly edges: ReadonlyArray<RootQueryToMenuItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<MenuItem>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToMenuItemConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToMenuItemConnectionEdge = Edge & MenuItemConnectionEdge & {
  readonly __typename?: 'RootQueryToMenuItemConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: MenuItem;
};

/** Pagination metadata specific to &quot;RootQueryToMenuItemConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToMenuItemConnection Nodes. */
export type RootQueryToMenuItemConnectionPageInfo = MenuItemConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToMenuItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToMenuItemConnection connection */
export type RootQueryToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** The menu location for the menu being queried */
  readonly location?: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  readonly parentDatabaseId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the parent menu object */
  readonly parentId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the RootQuery type and the page type */
export type RootQueryToPageConnection = Connection & PageConnection & {
  readonly __typename?: 'RootQueryToPageConnection';
  /** Edges for the RootQueryToPageConnection connection */
  readonly edges: ReadonlyArray<RootQueryToPageConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Page>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToPageConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToPageConnectionEdge = Edge & PageConnectionEdge & {
  readonly __typename?: 'RootQueryToPageConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Page;
};

/** Pagination metadata specific to &quot;RootQueryToPageConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToPageConnection Nodes. */
export type RootQueryToPageConnectionPageInfo = PageConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToPageConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToPageConnection connection */
export type RootQueryToPageConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the Plugin type */
export type RootQueryToPluginConnection = Connection & PluginConnection & {
  readonly __typename?: 'RootQueryToPluginConnection';
  /** Edges for the RootQueryToPluginConnection connection */
  readonly edges: ReadonlyArray<RootQueryToPluginConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Plugin>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToPluginConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToPluginConnectionEdge = Edge & PluginConnectionEdge & {
  readonly __typename?: 'RootQueryToPluginConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Plugin;
};

/** Pagination metadata specific to &quot;RootQueryToPluginConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToPluginConnection Nodes. */
export type RootQueryToPluginConnectionPageInfo = PageInfo & PluginConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToPluginConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToPluginConnection connection */
export type RootQueryToPluginConnectionWhereArgs = {
  /** Show plugin based on a keyword search. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve plugins where plugin status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PluginStatusEnum>>>;
  /** Show plugins with a specific status. */
  readonly status?: InputMaybe<PluginStatusEnum>;
};

/** Connection between the RootQuery type and the PostAccessRecipient type */
export type RootQueryToPostAccessRecipientConnection = Connection & PostAccessRecipientConnection & {
  readonly __typename?: 'RootQueryToPostAccessRecipientConnection';
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the RootQueryToPostAccessRecipientConnection connection */
  readonly edges: ReadonlyArray<RootQueryToPostAccessRecipientConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<PostAccessRecipient>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToPostAccessRecipientConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToPostAccessRecipientConnectionEdge = Edge & PostAccessRecipientConnectionEdge & {
  readonly __typename?: 'RootQueryToPostAccessRecipientConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: PostAccessRecipient;
};

/** Pagination metadata specific to &quot;RootQueryToPostAccessRecipientConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToPostAccessRecipientConnection Nodes. */
export type RootQueryToPostAccessRecipientConnectionPageInfo = PageInfo & PostAccessRecipientConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToPostAccessRecipientConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToPostAccessRecipientConnection connection */
export type RootQueryToPostAccessRecipientConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** Email Domain */
  readonly domain?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** The date the post expires, in the site's timezone */
  readonly expiresAtDateQuery?: InputMaybe<DateQueryInput>;
  /** access recipient id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** access recipient id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** access recipient id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<PostAccessRecipientSearchFieldsEnum>>>;
  /** The ID of the post this recipient has access to */
  readonly postId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the post this recipient has access to */
  readonly postIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the post this recipient has access to */
  readonly postIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Search for PostAccessRecipients by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for PostAccessRecipients by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<PostAccessRecipientSearchFieldsEnum>>>;
  /** Status of the post access recipient */
  readonly status?: InputMaybe<PostAccessRecipientStatusEnum>;
  /** Status of the post access recipient */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostAccessRecipientStatusEnum>>>;
  /** Status of the post access recipient */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostAccessRecipientStatusEnum>>>;
  /** The type of the post */
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the post type */
export type RootQueryToPostConnection = Connection & PostConnection & {
  readonly __typename?: 'RootQueryToPostConnection';
  /** Edges for the RootQueryToPostConnection connection */
  readonly edges: ReadonlyArray<RootQueryToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Post>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToPostConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToPostConnectionEdge = Edge & PostConnectionEdge & {
  readonly __typename?: 'RootQueryToPostConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Post;
};

/** Pagination metadata specific to &quot;RootQueryToPostConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToPostConnection Nodes. */
export type RootQueryToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToPostConnection connection */
export type RootQueryToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  readonly categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  readonly categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  readonly tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  readonly tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  readonly tagSlugAnd?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  readonly tagSlugIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the postFormat type */
export type RootQueryToPostFormatConnection = Connection & PostFormatConnection & {
  readonly __typename?: 'RootQueryToPostFormatConnection';
  /** Edges for the RootQueryToPostFormatConnection connection */
  readonly edges: ReadonlyArray<RootQueryToPostFormatConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<PostFormat>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToPostFormatConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToPostFormatConnectionEdge = Edge & PostFormatConnectionEdge & {
  readonly __typename?: 'RootQueryToPostFormatConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: PostFormat;
};

/** Pagination metadata specific to &quot;RootQueryToPostFormatConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToPostFormatConnection Nodes. */
export type RootQueryToPostFormatConnectionPageInfo = PageInfo & PostFormatConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToPostFormatConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToPostFormatConnection connection */
export type RootQueryToPostFormatConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the RootQuery type and the ContentNode type */
export type RootQueryToRevisionsConnection = Connection & ContentNodeConnection & {
  readonly __typename?: 'RootQueryToRevisionsConnection';
  /** Edges for the RootQueryToRevisionsConnection connection */
  readonly edges: ReadonlyArray<RootQueryToRevisionsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ContentNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToRevisionsConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToRevisionsConnectionEdge = ContentNodeConnectionEdge & Edge & {
  readonly __typename?: 'RootQueryToRevisionsConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ContentNode;
};

/** Pagination metadata specific to &quot;RootQueryToRevisionsConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToRevisionsConnection Nodes. */
export type RootQueryToRevisionsConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToRevisionsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToRevisionsConnection connection */
export type RootQueryToRevisionsConnectionWhereArgs = {
  /** The Types of content to filter */
  readonly contentTypes?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the tag type */
export type RootQueryToTagConnection = Connection & TagConnection & {
  readonly __typename?: 'RootQueryToTagConnection';
  /** Edges for the RootQueryToTagConnection connection */
  readonly edges: ReadonlyArray<RootQueryToTagConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Tag>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToTagConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToTagConnectionEdge = Edge & TagConnectionEdge & {
  readonly __typename?: 'RootQueryToTagConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Tag;
};

/** Pagination metadata specific to &quot;RootQueryToTagConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToTagConnection Nodes. */
export type RootQueryToTagConnectionPageInfo = PageInfo & TagConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToTagConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToTagConnection connection */
export type RootQueryToTagConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the RootQuery type and the Taxonomy type */
export type RootQueryToTaxonomyConnection = Connection & TaxonomyConnection & {
  readonly __typename?: 'RootQueryToTaxonomyConnection';
  /** Edges for the RootQueryToTaxonomyConnection connection */
  readonly edges: ReadonlyArray<RootQueryToTaxonomyConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Taxonomy>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToTaxonomyConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToTaxonomyConnectionEdge = Edge & TaxonomyConnectionEdge & {
  readonly __typename?: 'RootQueryToTaxonomyConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Taxonomy;
};

/** Pagination metadata specific to &quot;RootQueryToTaxonomyConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToTaxonomyConnection Nodes. */
export type RootQueryToTaxonomyConnectionPageInfo = PageInfo & TaxonomyConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToTaxonomyConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the RootQuery type and the TermNode type */
export type RootQueryToTermNodeConnection = Connection & TermNodeConnection & {
  readonly __typename?: 'RootQueryToTermNodeConnection';
  /** Edges for the RootQueryToTermNodeConnection connection */
  readonly edges: ReadonlyArray<RootQueryToTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<TermNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  readonly __typename?: 'RootQueryToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: TermNode;
};

/** Pagination metadata specific to &quot;RootQueryToTermNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToTermNodeConnection Nodes. */
export type RootQueryToTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToTermNodeConnection connection */
export type RootQueryToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** The Taxonomy to filter terms by */
  readonly taxonomies?: InputMaybe<ReadonlyArray<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the RootQuery type and the Theme type */
export type RootQueryToThemeConnection = Connection & ThemeConnection & {
  readonly __typename?: 'RootQueryToThemeConnection';
  /** Edges for the RootQueryToThemeConnection connection */
  readonly edges: ReadonlyArray<RootQueryToThemeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Theme>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToThemeConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToThemeConnectionEdge = Edge & ThemeConnectionEdge & {
  readonly __typename?: 'RootQueryToThemeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Theme;
};

/** Pagination metadata specific to &quot;RootQueryToThemeConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToThemeConnection Nodes. */
export type RootQueryToThemeConnectionPageInfo = PageInfo & ThemeConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToThemeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the RootQuery type and the User type */
export type RootQueryToUserConnection = Connection & UserConnection & {
  readonly __typename?: 'RootQueryToUserConnection';
  /** Edges for the RootQueryToUserConnection connection */
  readonly edges: ReadonlyArray<RootQueryToUserConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<User>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToUserConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToUserConnectionEdge = Edge & UserConnectionEdge & {
  readonly __typename?: 'RootQueryToUserConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: User;
};

/** Pagination metadata specific to &quot;RootQueryToUserConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToUserConnection Nodes. */
export type RootQueryToUserConnectionPageInfo = PageInfo & UserConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToUserConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToUserConnection connection */
export type RootQueryToUserConnectionWhereArgs = {
  /** Array of userIds to exclude. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']['input']>>>;
  /** Pass an array of post types to filter results to users who have published posts in those post types. */
  readonly hasPublishedPosts?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Array of userIds to include. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']['input']>>>;
  /** The user login. */
  readonly login?: InputMaybe<Scalars['String']['input']>;
  /** An array of logins to include. Users matching one of these logins will be included in results. */
  readonly loginIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** An array of logins to exclude. Users matching one of these logins will not be included in results. */
  readonly loginNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** The user nicename. */
  readonly nicename?: InputMaybe<Scalars['String']['input']>;
  /** An array of nicenames to include. Users matching one of these nicenames will be included in results. */
  readonly nicenameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** An array of nicenames to exclude. Users matching one of these nicenames will not be included in results. */
  readonly nicenameNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<UsersConnectionOrderbyInput>>>;
  /** An array of role names that users must match to be included in results. Note that this is an inclusive list: users must match *each* role. */
  readonly role?: InputMaybe<UserRoleEnum>;
  /** An array of role names. Matched users must have at least one of these roles. */
  readonly roleIn?: InputMaybe<ReadonlyArray<InputMaybe<UserRoleEnum>>>;
  /** An array of role names to exclude. Users matching one or more of these roles will not be included in results. */
  readonly roleNotIn?: InputMaybe<ReadonlyArray<InputMaybe<UserRoleEnum>>>;
  /** Search keyword. Searches for possible string matches on columns. When "searchColumns" is left empty, it tries to determine which column to search in based on search string. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of column names to be searched. Accepts 'ID', 'login', 'nicename', 'email', 'url'. */
  readonly searchColumns?: InputMaybe<ReadonlyArray<InputMaybe<UsersConnectionSearchColumnEnum>>>;
};

/** Connection between the RootQuery type and the UserRole type */
export type RootQueryToUserRoleConnection = Connection & UserRoleConnection & {
  readonly __typename?: 'RootQueryToUserRoleConnection';
  /** Edges for the RootQueryToUserRoleConnection connection */
  readonly edges: ReadonlyArray<RootQueryToUserRoleConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<UserRole>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToUserRoleConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToUserRoleConnectionEdge = Edge & UserRoleConnectionEdge & {
  readonly __typename?: 'RootQueryToUserRoleConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: UserRole;
};

/** Pagination metadata specific to &quot;RootQueryToUserRoleConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToUserRoleConnection Nodes. */
export type RootQueryToUserRoleConnectionPageInfo = PageInfo & UserRoleConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'RootQueryToUserRoleConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the RootQuery type and the znglist type */
export type RootQueryToZnglistConnection = Connection & ZnglistConnection & {
  readonly __typename?: 'RootQueryToZnglistConnection';
  /** Edges for the RootQueryToZnglistConnection connection */
  readonly edges: ReadonlyArray<RootQueryToZnglistConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Znglist>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToZnglistConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToZnglistConnectionEdge = Edge & ZnglistConnectionEdge & {
  readonly __typename?: 'RootQueryToZnglistConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Znglist;
};

/** Pagination metadata specific to &quot;RootQueryToZnglistConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToZnglistConnection Nodes. */
export type RootQueryToZnglistConnectionPageInfo = PageInfo & WpPageInfo & ZnglistConnectionPageInfo & {
  readonly __typename?: 'RootQueryToZnglistConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToZnglistConnection connection */
export type RootQueryToZnglistConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** The user thats connected to the object. */
  readonly authorId?: InputMaybe<Scalars['String']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** The template type of the Znglist */
  readonly templateType?: InputMaybe<ReadonlyArray<InputMaybe<ZnglistTemplateTypeEnum>>>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** Can Retrieve Admin only posts */
  readonly userType?: InputMaybe<ZnglistUserTypeEnum>;
};

/** Connection between the RootQuery type and the znglyInfo type */
export type RootQueryToZnglyInfoConnection = Connection & ZnglyInfoConnection & {
  readonly __typename?: 'RootQueryToZnglyInfoConnection';
  /** Edges for the RootQueryToZnglyInfoConnection connection */
  readonly edges: ReadonlyArray<RootQueryToZnglyInfoConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ZnglyInfo>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToZnglyInfoConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToZnglyInfoConnectionEdge = Edge & ZnglyInfoConnectionEdge & {
  readonly __typename?: 'RootQueryToZnglyInfoConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ZnglyInfo;
};

/** Pagination metadata specific to &quot;RootQueryToZnglyInfoConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToZnglyInfoConnection Nodes. */
export type RootQueryToZnglyInfoConnectionPageInfo = PageInfo & WpPageInfo & ZnglyInfoConnectionPageInfo & {
  readonly __typename?: 'RootQueryToZnglyInfoConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToZnglyInfoConnection connection */
export type RootQueryToZnglyInfoConnectionWhereArgs = {
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the znglyVideo type */
export type RootQueryToZnglyVideoConnection = Connection & ZnglyVideoConnection & {
  readonly __typename?: 'RootQueryToZnglyVideoConnection';
  /** Edges for the RootQueryToZnglyVideoConnection connection */
  readonly edges: ReadonlyArray<RootQueryToZnglyVideoConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ZnglyVideo>;
  /** Information about pagination in a connection. */
  readonly pageInfo: RootQueryToZnglyVideoConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToZnglyVideoConnectionEdge = Edge & ZnglyVideoConnectionEdge & {
  readonly __typename?: 'RootQueryToZnglyVideoConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ZnglyVideo;
};

/** Pagination metadata specific to &quot;RootQueryToZnglyVideoConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToZnglyVideoConnection Nodes. */
export type RootQueryToZnglyVideoConnectionPageInfo = PageInfo & WpPageInfo & ZnglyVideoConnectionPageInfo & {
  readonly __typename?: 'RootQueryToZnglyVideoConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the RootQueryToZnglyVideoConnection connection */
export type RootQueryToZnglyVideoConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Retrieve this post first */
  readonly c?: InputMaybe<Scalars['ID']['input']>;
  /** Category ID */
  readonly categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  readonly categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** List of Content Media Name for a single Zngly Content */
  readonly mediaName?: InputMaybe<ReadonlyArray<InputMaybe<ZnglyVideoMediaNameEnum>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** List of Post Types for a single Zngly Content */
  readonly postTypes?: InputMaybe<ReadonlyArray<InputMaybe<ZnglyVideoPostTypeEnum>>>;
  /** Type of the query */
  readonly queryType?: InputMaybe<ZnglyVideoQueryTypeEnum>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  readonly tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  readonly tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  readonly tagSlugAnd?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  readonly tagSlugIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Script insertion positions in the document structure. Determines whether scripts are placed in the document head or before the closing body tag. */
export enum ScriptLoadingGroupLocationEnum {
  /** Delayed loading at end of document, right before the closing `<body>` tag. (allows content to render first) */
  Footer = 'FOOTER',
  /** Early loading in document `<head>` tag. (executes before page content renders) */
  Header = 'HEADER'
}

/** Script loading optimization attributes. Controls browser behavior for script loading to improve page performance (async or defer). */
export enum ScriptLoadingStrategyEnum {
  /** Load script in parallel with page rendering, executing as soon as downloaded */
  Async = 'ASYNC',
  /** Download script in parallel but defer execution until page is fully parsed */
  Defer = 'DEFER'
}

/** Input for the sendPasswordResetEmail mutation. */
export type SendPasswordResetEmailInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains the user's username or email address. */
  readonly username: Scalars['String']['input'];
};

/** The payload for the sendPasswordResetEmail mutation. */
export type SendPasswordResetEmailPayload = {
  readonly __typename?: 'SendPasswordResetEmailPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the mutation completed successfully. This does NOT necessarily mean that an email was sent. */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The user that the password reset email was sent to
   * @deprecated This field will be removed in a future version of WPGraphQL
   */
  readonly user?: Maybe<User>;
};

/** The type of ID for setConnectionHpToCs */
export enum SetConnectionHpToCsFromKeysEnum {
  CatalogId = 'catalogId',
  HubPageId = 'hubPageId'
}

/** Weak Entity Input Type: ConnectionHpToC */
export type SetConnectionHpToCsInput = {
  /** Delete all entries that are not included in the mutation */
  readonly deleteNonIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the weak entity to modify. This must be provided if calling this mutation directly and not from a connection. */
  readonly fromId?: InputMaybe<Scalars['ID']['input']>;
  /** The base weak entity key to use for the mutation. This must be provided if calling this mutation directly and not from a connection. */
  readonly fromKey?: InputMaybe<SetConnectionHpToCsFromKeysEnum>;
  /** The data to create, update or delete if not found */
  readonly nodes?: InputMaybe<ReadonlyArray<InputMaybe<SetConnectionHpToCsNodeInput>>>;
};

/** Weak Entity Node Input Type: ConnectionHpToC */
export type SetConnectionHpToCsNodeInput = {
  /** Catalog Id */
  readonly catalogId?: InputMaybe<Scalars['ID']['input']>;
  /** order of the catalog items */
  readonly catalogOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Hub Page Id */
  readonly hubPageId?: InputMaybe<Scalars['ID']['input']>;
};

/** The type of ID for setConnectionHubToHps */
export enum SetConnectionHubToHpsFromKeysEnum {
  HubId = 'hubId',
  PageId = 'pageId'
}

/** Weak Entity Input Type: ConnectionHubToHp */
export type SetConnectionHubToHpsInput = {
  /** Delete all entries that are not included in the mutation */
  readonly deleteNonIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the weak entity to modify. This must be provided if calling this mutation directly and not from a connection. */
  readonly fromId?: InputMaybe<Scalars['ID']['input']>;
  /** The base weak entity key to use for the mutation. This must be provided if calling this mutation directly and not from a connection. */
  readonly fromKey?: InputMaybe<SetConnectionHubToHpsFromKeysEnum>;
  /** The data to create, update or delete if not found */
  readonly nodes?: InputMaybe<ReadonlyArray<InputMaybe<SetConnectionHubToHpsNodeInput>>>;
};

/** Weak Entity Node Input Type: ConnectionHubToHp */
export type SetConnectionHubToHpsNodeInput = {
  /** Hub Id */
  readonly hubId?: InputMaybe<Scalars['ID']['input']>;
  /** Page Icon */
  readonly pageIcon?: InputMaybe<Scalars['String']['input']>;
  /** Page Id */
  readonly pageId?: InputMaybe<Scalars['ID']['input']>;
  /** order of the pages */
  readonly pageOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Page Title */
  readonly pageTitle?: InputMaybe<Scalars['String']['input']>;
};

/** The type of ID for setCrmListToItems */
export enum SetCrmListToItemsFromKeysEnum {
  ItemId = 'itemId',
  ListId = 'listId'
}

/** Weak Entity Input Type: CrmListToItem */
export type SetCrmListToItemsInput = {
  /** Delete all entries that are not included in the mutation */
  readonly deleteNonIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the weak entity to modify. This must be provided if calling this mutation directly and not from a connection. */
  readonly fromId?: InputMaybe<Scalars['ID']['input']>;
  /** The base weak entity key to use for the mutation. This must be provided if calling this mutation directly and not from a connection. */
  readonly fromKey?: InputMaybe<SetCrmListToItemsFromKeysEnum>;
  /** The data to create, update or delete if not found */
  readonly nodes?: InputMaybe<ReadonlyArray<InputMaybe<SetCrmListToItemsNodeInput>>>;
};

/** Weak Entity Node Input Type: CrmListToItem */
export type SetCrmListToItemsNodeInput = {
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** Item Id */
  readonly itemId?: InputMaybe<Scalars['ID']['input']>;
  /** List Id */
  readonly listId?: InputMaybe<Scalars['ID']['input']>;
  /** mode of list item */
  readonly mode?: InputMaybe<CrmListModeEnum>;
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  /** type of list item */
  readonly type?: InputMaybe<CrmListTypeEnum>;
};

/** All of the registered settings */
export type Settings = {
  readonly __typename?: 'Settings';
  /** Settings of the the string Settings Group */
  readonly discussionSettingsDefaultCommentStatus?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  readonly discussionSettingsDefaultPingStatus?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  readonly generalSettingsDateFormat?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  readonly generalSettingsDescription?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  readonly generalSettingsEmail?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  readonly generalSettingsLanguage?: Maybe<Scalars['String']['output']>;
  /** Settings of the the integer Settings Group */
  readonly generalSettingsStartOfWeek?: Maybe<Scalars['Int']['output']>;
  /** Settings of the the string Settings Group */
  readonly generalSettingsTimeFormat?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  readonly generalSettingsTimezone?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  readonly generalSettingsTitle?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  readonly generalSettingsUrl?: Maybe<Scalars['String']['output']>;
  /** Settings of the the integer Settings Group */
  readonly readingSettingsPageForPosts?: Maybe<Scalars['Int']['output']>;
  /** Settings of the the integer Settings Group */
  readonly readingSettingsPageOnFront?: Maybe<Scalars['Int']['output']>;
  /** Settings of the the integer Settings Group */
  readonly readingSettingsPostsPerPage?: Maybe<Scalars['Int']['output']>;
  /** Settings of the the string Settings Group */
  readonly readingSettingsShowOnFront?: Maybe<Scalars['String']['output']>;
  /** Settings of the the integer Settings Group */
  readonly writingSettingsDefaultCategory?: Maybe<Scalars['Int']['output']>;
  /** Settings of the the string Settings Group */
  readonly writingSettingsDefaultPostFormat?: Maybe<Scalars['String']['output']>;
  /** Settings of the the boolean Settings Group */
  readonly writingSettingsUseSmilies?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for the settingsForceSyncTagsList mutation. */
export type SettingsForceSyncTagsListInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the settingsForceSyncTagsList mutation. */
export type SettingsForceSyncTagsListPayload = {
  readonly __typename?: 'SettingsForceSyncTagsListPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Indicates if the tags list was successfully synced */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
  /** The number of tags that were created */
  readonly tagsCreated?: Maybe<Scalars['Int']['output']>;
  /** The number of tags that were deleted */
  readonly tagsDeleted?: Maybe<Scalars['Int']['output']>;
};

export type SiteSettings = {
  readonly __typename?: 'SiteSettings';
  /** ThestatustoindicateifAIsearchispossible */
  readonly canDoAiSearch?: Maybe<Scalars['Boolean']['output']>;
  /** TheUImetafieldforthelogo */
  readonly hdLogo?: Maybe<SiteSettingsUiMetaField>;
  /** TheUImetafieldforthelogotext */
  readonly hdLogoText?: Maybe<SiteSettingsUiMetaField>;
  /** The ID of the site settings */
  readonly id?: Maybe<Scalars['ID']['output']>;
  /** Mailersettings */
  readonly mailer?: Maybe<SiteSettingsMailer>;
  /** Thetypeoftagfunctionality */
  readonly tagFunctionalityType?: Maybe<SiteSettingsTagFunctionalityTypeEnum>;
  /** Thelistofstatictags */
  readonly tagStaticList?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
};

/** The mailer settings */
export type SiteSettingsMailer = {
  readonly __typename?: 'SiteSettingsMailer';
  /** Thecompanynamefortheemailsender */
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly logo?: Maybe<MediaItem>;
};

/** The mailer settings input */
export type SiteSettingsMailerInput = {
  /** Thecompanynamefortheemailsender */
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  readonly logoId?: InputMaybe<Scalars['ID']['input']>;
};

/** All the site settings */
export enum SiteSettingsTagFunctionalityTypeEnum {
  /** DYNAMIC type */
  Dynamic = 'DYNAMIC',
  /** STATIC type */
  Static = 'STATIC'
}

/** The UI meta field */
export type SiteSettingsUiMetaField = {
  readonly __typename?: 'SiteSettingsUiMetaField';
  readonly classes?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly conditions?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly darkStyles?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly mediaItem?: Maybe<MediaItem>;
  readonly primaryStyles?: Maybe<Scalars['String']['output']>;
  readonly style?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** The UI meta field input */
export type SiteSettingsUiMetaFieldInput = {
  readonly classes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly conditions?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly darkStyles?: InputMaybe<Scalars['String']['input']>;
  readonly mediaItemId?: InputMaybe<Scalars['ID']['input']>;
  readonly primaryStyles?: InputMaybe<Scalars['String']['input']>;
  readonly style?: InputMaybe<Scalars['String']['input']>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** The Login client options for the siteToken provider. */
export type SiteTokenClientOptions = LoginClientOptions & {
  readonly __typename?: 'SiteTokenClientOptions';
  /** This field exists solely to generate the  ClientOptions interface, in lieu of the shared custom fields that will be added in a future release */
  readonly todo?: Maybe<Scalars['Boolean']['output']>;
};

/** The Headless Login options for the siteToken provider. */
export type SiteTokenLoginOptions = LoginOptions & {
  readonly __typename?: 'SiteTokenLoginOptions';
  /** Whether to set a WordPress authentication cookie on successful login. */
  readonly useAuthenticationCookie?: Maybe<Scalars['Boolean']['output']>;
};

/** Snippet */
export type Snippet = {
  readonly __typename?: 'Snippet';
  readonly snippet?: Maybe<Scalars['String']['output']>;
  readonly snippetStatus?: Maybe<Scalars['String']['output']>;
};

/** State When Approved */
export type StateWhenApproved = {
  readonly __typename?: 'StateWhenApproved';
  readonly status?: Maybe<PostStatusEnum>;
  /** UI Permission */
  readonly uiPermission?: Maybe<UiPermission>;
};

/** State When Approved */
export type StateWhenApprovedInput = {
  readonly status?: InputMaybe<PostStatusEnum>;
  /** UI Permission */
  readonly uiPermission?: InputMaybe<UiPermissionInput>;
};

/** Status Settings */
export type StatusSettings = {
  readonly __typename?: 'StatusSettings';
  /** Approved State */
  readonly approved?: Maybe<ApprovedState>;
  /** State When Approved */
  readonly stateWhenApproved?: Maybe<StateWhenApproved>;
  readonly status?: Maybe<PostStatusEnum>;
  /** UI Permission */
  readonly uiPermission?: Maybe<UiPermission>;
};

/** Status Settings */
export type StatusSettingsInput = {
  /** Approved State */
  readonly approved?: InputMaybe<ApprovedStateInput>;
  /** State When Approved */
  readonly stateWhenApproved?: InputMaybe<StateWhenApprovedInput>;
  readonly status?: InputMaybe<PostStatusEnum>;
  /** UI Permission */
  readonly uiPermission?: InputMaybe<UiPermissionInput>;
};

/** Post Permissions Enum */
export enum StatusUiPermissionEnum {
  /** OTP type */
  Otp = 'OTP',
  /** PUBLIC type */
  Public = 'PUBLIC',
  /** RESTRICTED type */
  Restricted = 'RESTRICTED',
  /** TOKEN type */
  Token = 'TOKEN'
}

/** array of strings */
export type StringArrayInput = {
  readonly append?: InputMaybe<Scalars['Boolean']['input']>;
  readonly nodes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

/** Summary */
export type Summary = {
  readonly __typename?: 'Summary';
  readonly summaryText?: Maybe<Scalars['String']['output']>;
  readonly summaryWithMetadata?: Maybe<SummaryWithMetadata>;
};

/** Summary Reference */
export type SummaryReference = {
  readonly __typename?: 'SummaryReference';
  readonly document?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

/** Summary */
export type SummaryWithMetadata = {
  readonly __typename?: 'SummaryWithMetadata';
  readonly citationMetadata?: Maybe<CitationMetadata>;
  readonly references?: Maybe<ReadonlyArray<Maybe<SummaryReference>>>;
  readonly summary?: Maybe<Scalars['String']['output']>;
};

/** Input for the syncService mutation. */
export type SyncServiceInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Force sync - uses a shorter timeout */
  readonly forceSync?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of the sync operation */
  readonly type: SyncServiceTypeEnum;
};

/** The payload for the syncService mutation. */
export type SyncServicePayload = {
  readonly __typename?: 'SyncServicePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** TimeStamp: Next available time to run the operation */
  readonly nextAvailableTime?: Maybe<Scalars['Int']['output']>;
  /** Relative time: Next available time to run the operation */
  readonly nextRelativeAvailableTime?: Maybe<Scalars['String']['output']>;
  /** Status of the operation */
  readonly status?: Maybe<Scalars['String']['output']>;
};

/** Type of the sync operation */
export enum SyncServiceTypeEnum {
  BqContacts = 'BQ_CONTACTS',
  BqDashboard = 'BQ_DASHBOARD',
  BqFormEntries = 'BQ_FORM_ENTRIES',
  GcpSearchSync = 'GCP_SEARCH_SYNC',
  HsContacts = 'HS_CONTACTS',
  HsContactsFormRepair = 'HS_CONTACTS_FORM_REPAIR',
  HsUtkQueue = 'HS_UTK_QUEUE',
  Integrations = 'INTEGRATIONS',
  MarketoLeads = 'MARKETO_LEADS',
  ZohoContacts = 'ZOHO_CONTACTS'
}

/** A taxonomy term used to organize and classify content. Tags do not have a hierarchy and are generally used for more specific classifications. */
export type Tag = DatabaseIdentifier & MenuItemLinkable & Node & TermNode & UniformResourceIdentifiable & {
  readonly __typename?: 'Tag';
  /** Connection between the Tag type and the ContentNode type */
  readonly contentNodes?: Maybe<TagToContentNodeConnection>;
  /** The number of objects connected to the object */
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** The description of the object */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The link to the term */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** The human friendly name of the object. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Connection between the Tag type and the post type */
  readonly posts?: Maybe<TagToPostConnection>;
  /** An alphanumeric identifier for the object unique to its type. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  readonly tagId?: Maybe<Scalars['Int']['output']>;
  /** Connection between the Tag type and the Taxonomy type */
  readonly taxonomy?: Maybe<TagToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  readonly taxonomyName?: Maybe<Scalars['String']['output']>;
  /** The ID of the term group that this term object belongs to */
  readonly termGroupId?: Maybe<Scalars['Int']['output']>;
  /** The taxonomy ID that the object is associated with */
  readonly termTaxonomyId?: Maybe<Scalars['Int']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
  /** Connection between the Tag type and the znglyVideo type */
  readonly znglyVideos?: Maybe<TagToZnglyVideoConnection>;
};


/** A taxonomy term used to organize and classify content. Tags do not have a hierarchy and are generally used for more specific classifications. */
export type TagContentNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagToContentNodeConnectionWhereArgs>;
};


/** A taxonomy term used to organize and classify content. Tags do not have a hierarchy and are generally used for more specific classifications. */
export type TagEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A taxonomy term used to organize and classify content. Tags do not have a hierarchy and are generally used for more specific classifications. */
export type TagEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A taxonomy term used to organize and classify content. Tags do not have a hierarchy and are generally used for more specific classifications. */
export type TagPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagToPostConnectionWhereArgs>;
};


/** A taxonomy term used to organize and classify content. Tags do not have a hierarchy and are generally used for more specific classifications. */
export type TagZnglyVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagToZnglyVideoConnectionWhereArgs>;
};

/** A paginated collection of tag Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of tag Nodes */
export type TagConnection = {
  /** A list of edges (relational context) between RootQuery and connected tag Nodes */
  readonly edges: ReadonlyArray<TagConnectionEdge>;
  /** A list of connected tag Nodes */
  readonly nodes: ReadonlyArray<Tag>;
  /** Information about pagination in a connection. */
  readonly pageInfo: TagConnectionPageInfo;
};

/** Represents a connection to a tag. Contains both the tag Node and metadata about the relationship. */
export type TagConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected tag Node */
  readonly node: Tag;
};

/** Pagination metadata specific to &quot;TagConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;TagConnectionEdge&quot; Nodes. */
export type TagConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifier types for retrieving a specific Tag. Determines which unique property (global ID, database ID, slug, etc.) is used to locate the Tag. */
export enum TagIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the Tag type and the ContentNode type */
export type TagToContentNodeConnection = Connection & ContentNodeConnection & {
  readonly __typename?: 'TagToContentNodeConnection';
  /** Edges for the TagToContentNodeConnection connection */
  readonly edges: ReadonlyArray<TagToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ContentNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: TagToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type TagToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  readonly __typename?: 'TagToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ContentNode;
};

/** Pagination metadata specific to &quot;TagToContentNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of TagToContentNodeConnection Nodes. */
export type TagToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'TagToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the TagToContentNodeConnection connection */
export type TagToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  readonly contentTypes?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypesOfTagEnum>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the Tag type and the post type */
export type TagToPostConnection = Connection & PostConnection & {
  readonly __typename?: 'TagToPostConnection';
  /** Edges for the TagToPostConnection connection */
  readonly edges: ReadonlyArray<TagToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Post>;
  /** Information about pagination in a connection. */
  readonly pageInfo: TagToPostConnectionPageInfo;
};

/** An edge in a connection */
export type TagToPostConnectionEdge = Edge & PostConnectionEdge & {
  readonly __typename?: 'TagToPostConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Post;
};

/** Pagination metadata specific to &quot;TagToPostConnection&quot; collections. Provides cursors and flags for navigating through sets of TagToPostConnection Nodes. */
export type TagToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'TagToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the TagToPostConnection connection */
export type TagToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  readonly categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  readonly categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  readonly tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  readonly tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  readonly tagSlugAnd?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  readonly tagSlugIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the Tag type and the Taxonomy type */
export type TagToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  readonly __typename?: 'TagToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Taxonomy;
};

/** Connection between the Tag type and the znglyVideo type */
export type TagToZnglyVideoConnection = Connection & ZnglyVideoConnection & {
  readonly __typename?: 'TagToZnglyVideoConnection';
  /** Edges for the TagToZnglyVideoConnection connection */
  readonly edges: ReadonlyArray<TagToZnglyVideoConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ZnglyVideo>;
  /** Information about pagination in a connection. */
  readonly pageInfo: TagToZnglyVideoConnectionPageInfo;
};

/** An edge in a connection */
export type TagToZnglyVideoConnectionEdge = Edge & ZnglyVideoConnectionEdge & {
  readonly __typename?: 'TagToZnglyVideoConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ZnglyVideo;
};

/** Pagination metadata specific to &quot;TagToZnglyVideoConnection&quot; collections. Provides cursors and flags for navigating through sets of TagToZnglyVideoConnection Nodes. */
export type TagToZnglyVideoConnectionPageInfo = PageInfo & WpPageInfo & ZnglyVideoConnectionPageInfo & {
  readonly __typename?: 'TagToZnglyVideoConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the TagToZnglyVideoConnection connection */
export type TagToZnglyVideoConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  readonly categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  readonly categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  readonly tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  readonly tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  readonly tagSlugAnd?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  readonly tagSlugIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

export type TaxArray = {
  readonly field?: InputMaybe<TaxQueryField>;
  /** Whether or not to include children for hierarchical taxonomies. Defaults to false to improve performance (note that this is opposite of the default for WP_Query). */
  readonly includeChildren?: InputMaybe<Scalars['Boolean']['input']>;
  readonly operator?: InputMaybe<TaxQueryOperator>;
  readonly taxonomy?: InputMaybe<TaxonomyEnum>;
  /** A list of term slugs */
  readonly terms?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

/** Query objects based on taxonomy parameters */
export type TaxQuery = {
  readonly relation?: InputMaybe<RelationEnum>;
  readonly taxArray?: InputMaybe<ReadonlyArray<InputMaybe<TaxArray>>>;
};

/** Which field to select taxonomy term by. Default value is "term_id" */
export enum TaxQueryField {
  Id = 'ID',
  Name = 'NAME',
  Slug = 'SLUG',
  TaxonomyId = 'TAXONOMY_ID'
}

export enum TaxQueryOperator {
  And = 'AND',
  Exists = 'EXISTS',
  In = 'IN',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN'
}

/** A taxonomy object */
export type Taxonomy = Node & {
  readonly __typename?: 'Taxonomy';
  /** List of Content Types associated with the Taxonomy */
  readonly connectedContentTypes?: Maybe<TaxonomyToContentTypeConnection>;
  /** List of Term Nodes associated with the Taxonomy */
  readonly connectedTerms?: Maybe<TaxonomyToTermNodeConnection>;
  /** Description of the taxonomy. This field is equivalent to WP_Taxonomy-&gt;description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The plural name of the post type within the GraphQL Schema. */
  readonly graphqlPluralName?: Maybe<Scalars['String']['output']>;
  /** The singular name of the post type within the GraphQL Schema. */
  readonly graphqlSingleName?: Maybe<Scalars['String']['output']>;
  /** Whether the taxonomy is hierarchical */
  readonly hierarchical?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the taxonomy object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the taxonomy shown in the menu. Usually plural. */
  readonly label?: Maybe<Scalars['String']['output']>;
  /** The display name of the taxonomy. This field is equivalent to WP_Taxonomy-&gt;label */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Whether the taxonomy is publicly queryable */
  readonly public?: Maybe<Scalars['Boolean']['output']>;
  /** Name of content type to display in REST API &quot;wp/v2&quot; namespace. */
  readonly restBase?: Maybe<Scalars['String']['output']>;
  /** The REST Controller class assigned to handling this content type. */
  readonly restControllerClass?: Maybe<Scalars['String']['output']>;
  /** Whether to show the taxonomy as part of a tag cloud widget. This field is equivalent to WP_Taxonomy-&gt;show_tagcloud */
  readonly showCloud?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to display a column for the taxonomy on its post type listing screens. */
  readonly showInAdminColumn?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to add the post type to the GraphQL Schema. */
  readonly showInGraphql?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the taxonomy in the admin menu */
  readonly showInMenu?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the taxonomy is available for selection in navigation menus. */
  readonly showInNavMenus?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the taxonomy in the quick/bulk edit panel. */
  readonly showInQuickEdit?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to add the post type route in the REST API &quot;wp/v2&quot; namespace. */
  readonly showInRest?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to generate and allow a UI for managing terms in this taxonomy in the admin */
  readonly showUi?: Maybe<Scalars['Boolean']['output']>;
};


/** A taxonomy object */
export type TaxonomyConnectedContentTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A taxonomy object */
export type TaxonomyConnectedTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated collection of Taxonomy Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of Taxonomy Nodes */
export type TaxonomyConnection = {
  /** A list of edges (relational context) between RootQuery and connected Taxonomy Nodes */
  readonly edges: ReadonlyArray<TaxonomyConnectionEdge>;
  /** A list of connected Taxonomy Nodes */
  readonly nodes: ReadonlyArray<Taxonomy>;
  /** Information about pagination in a connection. */
  readonly pageInfo: TaxonomyConnectionPageInfo;
};

/** Represents a connection to a Taxonomy. Contains both the Taxonomy Node and metadata about the relationship. */
export type TaxonomyConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Taxonomy Node */
  readonly node: Taxonomy;
};

/** Pagination metadata specific to &quot;TaxonomyConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;TaxonomyConnectionEdge&quot; Nodes. */
export type TaxonomyConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Available classification systems for organizing content. Identifies the different taxonomy types that can be used for content categorization. */
export enum TaxonomyEnum {
  /** Taxonomy enum category */
  Category = 'CATEGORY',
  /** Taxonomy enum graphql_document_group */
  Graphqldocumentgroup = 'GRAPHQLDOCUMENTGROUP',
  /** Taxonomy enum post_format */
  Postformat = 'POSTFORMAT',
  /** Taxonomy enum post_tag */
  Tag = 'TAG'
}

/** Identifier types for retrieving a taxonomy definition. Determines whether to look up taxonomies by ID or name. */
export enum TaxonomyIdTypeEnum {
  /** The globally unique ID */
  Id = 'ID',
  /** The name of the taxonomy */
  Name = 'NAME'
}

/** Connection between the Taxonomy type and the ContentType type */
export type TaxonomyToContentTypeConnection = Connection & ContentTypeConnection & {
  readonly __typename?: 'TaxonomyToContentTypeConnection';
  /** Edges for the TaxonomyToContentTypeConnection connection */
  readonly edges: ReadonlyArray<TaxonomyToContentTypeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ContentType>;
  /** Information about pagination in a connection. */
  readonly pageInfo: TaxonomyToContentTypeConnectionPageInfo;
};

/** An edge in a connection */
export type TaxonomyToContentTypeConnectionEdge = ContentTypeConnectionEdge & Edge & {
  readonly __typename?: 'TaxonomyToContentTypeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ContentType;
};

/** Pagination metadata specific to &quot;TaxonomyToContentTypeConnection&quot; collections. Provides cursors and flags for navigating through sets of TaxonomyToContentTypeConnection Nodes. */
export type TaxonomyToContentTypeConnectionPageInfo = ContentTypeConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'TaxonomyToContentTypeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the Taxonomy type and the TermNode type */
export type TaxonomyToTermNodeConnection = Connection & TermNodeConnection & {
  readonly __typename?: 'TaxonomyToTermNodeConnection';
  /** Edges for the TaxonomyToTermNodeConnection connection */
  readonly edges: ReadonlyArray<TaxonomyToTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<TermNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: TaxonomyToTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type TaxonomyToTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  readonly __typename?: 'TaxonomyToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: TermNode;
};

/** Pagination metadata specific to &quot;TaxonomyToTermNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of TaxonomyToTermNodeConnection Nodes. */
export type TaxonomyToTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'TaxonomyToTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Input for the telemetryIntegrationsSync mutation. */
export type TelemetryIntegrationsSyncInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Data to be used in the sync */
  readonly data?: InputMaybe<ReadonlyArray<InputMaybe<JsonKeyValueArrayInput>>>;
  /** If true, will attempt to identify contact again based on new lead info */
  readonly newLeadInfo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Zngly visitor id */
  readonly visitorId: Scalars['String']['input'];
};

/** The payload for the telemetryIntegrationsSync mutation. */
export type TelemetryIntegrationsSyncPayload = {
  readonly __typename?: 'TelemetryIntegrationsSyncPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** data */
  readonly data?: Maybe<ReadonlyArray<Maybe<JsonKeyValue>>>;
};

/** The template assigned to the node */
export type Template_404 = ContentTemplate & {
  readonly __typename?: 'Template_404';
  /** The name of the template */
  readonly templateName?: Maybe<Scalars['String']['output']>;
};

/** Base interface for taxonomy terms such as categories and tags. Terms are used to organize and classify content. */
export type TermNode = {
  /** The number of objects connected to the object */
  readonly count?: Maybe<Scalars['Int']['output']>;
  /** Identifies the primary key from the database. */
  readonly databaseId: Scalars['Int']['output'];
  /** The description of the object */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The link to the term */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** The human friendly name of the object. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** An alphanumeric identifier for the object unique to its type. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** The name of the taxonomy that the object is associated with */
  readonly taxonomyName?: Maybe<Scalars['String']['output']>;
  /** The ID of the term group that this term object belongs to */
  readonly termGroupId?: Maybe<Scalars['Int']['output']>;
  /** The taxonomy ID that the object is associated with */
  readonly termTaxonomyId?: Maybe<Scalars['Int']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};


/** Base interface for taxonomy terms such as categories and tags. Terms are used to organize and classify content. */
export type TermNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Base interface for taxonomy terms such as categories and tags. Terms are used to organize and classify content. */
export type TermNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated collection of TermNode Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of TermNode Nodes */
export type TermNodeConnection = {
  /** A list of edges (relational context) between RootQuery and connected TermNode Nodes */
  readonly edges: ReadonlyArray<TermNodeConnectionEdge>;
  /** A list of connected TermNode Nodes */
  readonly nodes: ReadonlyArray<TermNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: TermNodeConnectionPageInfo;
};

/** Represents a connection to a TermNode. Contains both the TermNode Node and metadata about the relationship. */
export type TermNodeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected TermNode Node */
  readonly node: TermNode;
};

/** Pagination metadata specific to &quot;TermNodeConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;TermNodeConnectionEdge&quot; Nodes. */
export type TermNodeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** The Type of Identifier used to fetch a single resource. Default is "ID". To be used along with the "id" field. */
export enum TermNodeIdTypeEnum {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the TermNode type and the EnqueuedScript type */
export type TermNodeToEnqueuedScriptConnection = Connection & EnqueuedScriptConnection & {
  readonly __typename?: 'TermNodeToEnqueuedScriptConnection';
  /** Edges for the TermNodeToEnqueuedScriptConnection connection */
  readonly edges: ReadonlyArray<TermNodeToEnqueuedScriptConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<EnqueuedScript>;
  /** Information about pagination in a connection. */
  readonly pageInfo: TermNodeToEnqueuedScriptConnectionPageInfo;
};

/** An edge in a connection */
export type TermNodeToEnqueuedScriptConnectionEdge = Edge & EnqueuedScriptConnectionEdge & {
  readonly __typename?: 'TermNodeToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: EnqueuedScript;
};

/** Pagination metadata specific to &quot;TermNodeToEnqueuedScriptConnection&quot; collections. Provides cursors and flags for navigating through sets of TermNodeToEnqueuedScriptConnection Nodes. */
export type TermNodeToEnqueuedScriptConnectionPageInfo = EnqueuedScriptConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'TermNodeToEnqueuedScriptConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the TermNode type and the EnqueuedStylesheet type */
export type TermNodeToEnqueuedStylesheetConnection = Connection & EnqueuedStylesheetConnection & {
  readonly __typename?: 'TermNodeToEnqueuedStylesheetConnection';
  /** Edges for the TermNodeToEnqueuedStylesheetConnection connection */
  readonly edges: ReadonlyArray<TermNodeToEnqueuedStylesheetConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  readonly pageInfo: TermNodeToEnqueuedStylesheetConnectionPageInfo;
};

/** An edge in a connection */
export type TermNodeToEnqueuedStylesheetConnectionEdge = Edge & EnqueuedStylesheetConnectionEdge & {
  readonly __typename?: 'TermNodeToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: EnqueuedStylesheet;
};

/** Pagination metadata specific to &quot;TermNodeToEnqueuedStylesheetConnection&quot; collections. Provides cursors and flags for navigating through sets of TermNodeToEnqueuedStylesheetConnection Nodes. */
export type TermNodeToEnqueuedStylesheetConnectionPageInfo = EnqueuedStylesheetConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'TermNodeToEnqueuedStylesheetConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Sorting attributes for taxonomy term collections. Determines which property of taxonomy terms is used for ordering results. */
export enum TermObjectsConnectionOrderbyEnum {
  /** Ordering by number of associated content items. */
  Count = 'COUNT',
  /** Alphabetical ordering by term description text. */
  Description = 'DESCRIPTION',
  /** Alphabetical ordering by term name. */
  Name = 'NAME',
  /** Alphabetical ordering by URL-friendly name. */
  Slug = 'SLUG',
  /** Ordering by assigned term grouping value. */
  TermGroup = 'TERM_GROUP',
  /** Ordering by internal identifier. */
  TermId = 'TERM_ID',
  /** Ordering by manually defined sort position. */
  TermOrder = 'TERM_ORDER'
}

/** A theme object */
export type Theme = Node & {
  readonly __typename?: 'Theme';
  /** Name of the theme author(s), could also be a company name. This field is equivalent to WP_Theme-&gt;get( &quot;Author&quot; ). */
  readonly author?: Maybe<Scalars['String']['output']>;
  /** URI for the author/company website. This field is equivalent to WP_Theme-&gt;get( &quot;AuthorURI&quot; ). */
  readonly authorUri?: Maybe<Scalars['String']['output']>;
  /** The description of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Description&quot; ). */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier of the theme object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Display name of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Name&quot; ). */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** The URL of the screenshot for the theme. The screenshot is intended to give an overview of what the theme looks like. This field is equivalent to WP_Theme-&gt;get_screenshot(). */
  readonly screenshot?: Maybe<Scalars['String']['output']>;
  /** The theme slug is used to internally match themes. Theme slugs can have subdirectories like: my-theme/sub-theme. This field is equivalent to WP_Theme-&gt;get_stylesheet(). */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** URI for the author/company website. This field is equivalent to WP_Theme-&gt;get( &quot;Tags&quot; ). */
  readonly tags?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** A URI if the theme has a website associated with it. The Theme URI is handy for directing users to a theme site for support etc. This field is equivalent to WP_Theme-&gt;get( &quot;ThemeURI&quot; ). */
  readonly themeUri?: Maybe<Scalars['String']['output']>;
  /** The current version of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Version&quot; ). */
  readonly version?: Maybe<Scalars['String']['output']>;
};

/** A paginated collection of Theme Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of Theme Nodes */
export type ThemeConnection = {
  /** A list of edges (relational context) between RootQuery and connected Theme Nodes */
  readonly edges: ReadonlyArray<ThemeConnectionEdge>;
  /** A list of connected Theme Nodes */
  readonly nodes: ReadonlyArray<Theme>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ThemeConnectionPageInfo;
};

/** Represents a connection to a Theme. Contains both the Theme Node and metadata about the relationship. */
export type ThemeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Theme Node */
  readonly node: Theme;
};

/** Pagination metadata specific to &quot;ThemeConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;ThemeConnectionEdge&quot; Nodes. */
export type ThemeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** UI Permission */
export type UiPermission = {
  readonly __typename?: 'UIPermission';
  readonly token?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<StatusUiPermissionEnum>;
};

/** UI Permission */
export type UiPermissionInput = {
  readonly token?: InputMaybe<Scalars['String']['input']>;
  readonly type?: InputMaybe<StatusUiPermissionEnum>;
};

/** An interface for content that can be accessed via a unique URI/URL path. Implemented by content types that have their own permalinks. */
export type UniformResourceIdentifiable = {
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
};

/** Input for the updateCategory mutation. */
export type UpdateCategoryInput = {
  /** The slug that the category will be an alias of */
  readonly aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the category object */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the category object to update */
  readonly id: Scalars['ID']['input'];
  /** The name of the category object to mutate */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** The database ID of the category that should be set as the parent. This field cannot be used in conjunction with parentId */
  readonly parentDatabaseId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the category that should be set as the parent. This field cannot be used in conjunction with parentDatabaseId */
  readonly parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Main video to appear when this sub-category is selected | ACF Type: post_object | Graphql Type: {"list_of":"ID"} */
  readonly pinnedContent?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: number | Graphql Type: Int */
  readonly uxOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** The payload for the updateCategory mutation. */
export type UpdateCategoryPayload = {
  readonly __typename?: 'UpdateCategoryPayload';
  /** The created category */
  readonly category?: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Input for the updateComment mutation. */
export type UpdateCommentInput = {
  /** The name of the comment's author. */
  readonly author?: InputMaybe<Scalars['String']['input']>;
  /** The email of the comment's author. */
  readonly authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** The url of the comment's author. */
  readonly authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The database ID of the post object the comment belongs to. */
  readonly commentOn?: InputMaybe<Scalars['Int']['input']>;
  /** Content of the comment. */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day ( e.g. 01/31/2017 ) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the comment being updated. */
  readonly id: Scalars['ID']['input'];
  /** Parent comment ID of current comment. */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** The approval status of the comment */
  readonly status?: InputMaybe<CommentStatusEnum>;
  /** Type of comment. */
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateComment mutation. */
export type UpdateCommentPayload = {
  readonly __typename?: 'UpdateCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The comment that was created */
  readonly comment?: Maybe<Comment>;
  /** Whether the mutation succeeded. If the comment is not approved, the server will not return the comment to a non authenticated user, but a success message can be returned if the create succeeded, and the client can optimistically add the comment to the client cache */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

/** Update Input Type: Contact */
export type UpdateContactInput = {
  /** Contact address line 1 */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Contact address line 2 */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Contact address line 3 */
  readonly addressLine3?: InputMaybe<Scalars['String']['input']>;
  /** Contact city */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** Contact company */
  readonly company?: InputMaybe<Scalars['String']['input']>;
  /** Contact country */
  readonly country?: InputMaybe<Scalars['String']['input']>;
  /** Contact county */
  readonly county?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** Contact email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Contact firstname */
  readonly firstname?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Contact object */
  readonly id: Scalars['ID']['input'];
  /** Zngly ids */
  readonly ids?: InputMaybe<StringArrayInput>;
  /** Contact job title */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Contact lastname */
  readonly lastname?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  /** Contact phone */
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  /** Contact postal code */
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Contact properties */
  readonly properties?: InputMaybe<JsonKeyValueInput>;
  /** Contact region */
  readonly region?: InputMaybe<Scalars['String']['input']>;
  readonly setCrmListToItems?: InputMaybe<SetCrmListToItemsInput>;
};

/** The payload for the updateContact mutation. */
export type UpdateContactPayload = {
  readonly __typename?: 'UpdateContactPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Update Mutation. Zngly Contacts */
  readonly contact?: Maybe<Contact>;
};

/** Update Input Type: CrmList */
export type UpdateCrmListInput = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the CrmList object */
  readonly id: Scalars['ID']['input'];
  /** List Metadata */
  readonly metadata?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  readonly setCrmListToItems?: InputMaybe<SetCrmListToItemsInput>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status settings of the post */
  readonly statusSettings?: InputMaybe<StatusSettingsInput>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** type of list */
  readonly type?: InputMaybe<CrmListTypeEnum>;
};

/** The payload for the updateCrmList mutation. */
export type UpdateCrmListPayload = {
  readonly __typename?: 'UpdateCrmListPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Update Mutation. Crm Lists */
  readonly crmList?: Maybe<CrmList>;
};

/** Update Input Type: FormEntry */
export type UpdateFormEntryInput = {
  /** company name */
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  /** country */
  readonly country?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Extra data */
  readonly extraData?: InputMaybe<JsonKeyValueInput>;
  /** first name */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** Parent Form Id */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** Form title from which the entry was submitted */
  readonly formTitle?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the FormEntry object */
  readonly id: Scalars['ID']['input'];
  /** job title */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** last name */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** marketing consent */
  readonly marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** message */
  readonly message?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  /** phone number */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Zngly visitor id */
  readonly visitorId?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateFormEntry mutation. */
export type UpdateFormEntryPayload = {
  readonly __typename?: 'UpdateFormEntryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Update Mutation. This is a form entry */
  readonly formEntry?: Maybe<FormEntry>;
};

/** Update Input Type: Form */
export type UpdateFormInput = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** description of the form */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** email metadata */
  readonly email?: InputMaybe<EmailSettingsInput>;
  /** The ID of the Form object */
  readonly id: Scalars['ID']['input'];
  /** image url of the form */
  readonly imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** marketing consent */
  readonly marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** metadata of the form */
  readonly metadata?: InputMaybe<FormMetadataInput>;
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  /** The password to access the form */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** schema of the form */
  readonly schema?: InputMaybe<Scalars['String']['input']>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status settings of the post */
  readonly statusSettings?: InputMaybe<StatusSettingsInput>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** ui schema of the form */
  readonly uiSchema?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateForm mutation. */
export type UpdateFormPayload = {
  readonly __typename?: 'UpdateFormPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Update Mutation. Zngly Forms */
  readonly form?: Maybe<Form>;
};

/** Input for the updateGraphqlDocumentGroup mutation. */
export type UpdateGraphqlDocumentGroupInput = {
  /** The slug that the graphql_document_group will be an alias of */
  readonly aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the graphql_document_group object */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the graphqlDocumentGroup object to update */
  readonly id: Scalars['ID']['input'];
  /** The name of the graphql_document_group object to mutate */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateGraphqlDocumentGroup mutation. */
export type UpdateGraphqlDocumentGroupPayload = {
  readonly __typename?: 'UpdateGraphqlDocumentGroupPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created graphql_document_group */
  readonly graphqlDocumentGroup?: Maybe<GraphqlDocumentGroup>;
};

/** Input for the updateGraphqlDocument mutation. */
export type UpdateGraphqlDocumentInput = {
  /** Alias names for saved GraphQL query documents */
  readonly alias?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The content of the object */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** Description for the saved GraphQL document */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Allow, deny or default access grant for specific query */
  readonly grant?: InputMaybe<Scalars['String']['input']>;
  /** Set connections between the graphqlDocument and graphqlDocumentGroups */
  readonly graphqlDocumentGroups?: InputMaybe<GraphqlDocumentGraphqlDocumentGroupsInput>;
  /** The ID of the graphqlDocument object */
  readonly id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  readonly ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
  /** HTTP Cache-Control max-age directive for a saved GraphQL document */
  readonly maxAgeHeader?: InputMaybe<Scalars['Int']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  readonly menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The password used to protect the content of the object */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the object */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateGraphqlDocument mutation. */
export type UpdateGraphqlDocumentPayload = {
  readonly __typename?: 'UpdateGraphqlDocumentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  readonly graphqlDocument?: Maybe<GraphqlDocument>;
};

/** Update Input Type: Hub */
export type UpdateHubInput = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** description of the hub */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** group of the hub used to identify its category/tag/campaign */
  readonly group?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Hub object */
  readonly id: Scalars['ID']['input'];
  /** metadata of the hub */
  readonly metadata?: InputMaybe<HubMetadataInput>;
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  /** order of the hubs */
  readonly postOrder?: InputMaybe<Scalars['Int']['input']>;
  readonly setConnectionHubToHps?: InputMaybe<SetConnectionHubToHpsInput>;
  /** The name (slug) for the post */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status settings of the post */
  readonly statusSettings?: InputMaybe<StatusSettingsInput>;
  /** template of the hub */
  readonly template?: InputMaybe<HubTemplateEnum>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** User related to the hub */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
  /** User meta related to the hub */
  readonly userMeta?: InputMaybe<HubUserMetaInput>;
};

/** Update Input Type: HubPage */
export type UpdateHubPageInput = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The content of the post */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** page description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Form Id */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the HubPage object */
  readonly id: Scalars['ID']['input'];
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  readonly setConnectionHpToCs?: InputMaybe<SetConnectionHpToCsInput>;
  readonly setConnectionHubToHps?: InputMaybe<SetConnectionHubToHpsInput>;
  /** The status of the post */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The status settings of the post */
  readonly statusSettings?: InputMaybe<StatusSettingsInput>;
  /** The title of the post */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateHubPage mutation. */
export type UpdateHubPagePayload = {
  readonly __typename?: 'UpdateHubPagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Update Mutation. Page for Hubs */
  readonly hubPage?: Maybe<HubPage>;
};

/** The payload for the updateHub mutation. */
export type UpdateHubPayload = {
  readonly __typename?: 'UpdateHubPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Update Mutation. Hub */
  readonly hub?: Maybe<Hub>;
};

/** Input for the updateMediaItem mutation. */
export type UpdateMediaItemInput = {
  /** Alternative text to display when mediaItem is not displayed */
  readonly altText?: InputMaybe<Scalars['String']['input']>;
  /** The userId to assign as the author of the mediaItem */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The caption for the mediaItem */
  readonly caption?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment status for the mediaItem */
  readonly commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The date of the mediaItem */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** The date (in GMT zone) of the mediaItem */
  readonly dateGmt?: InputMaybe<Scalars['String']['input']>;
  /** Description of the mediaItem */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The file name of the mediaItem */
  readonly filePath?: InputMaybe<Scalars['String']['input']>;
  /** The file type of the mediaItem */
  readonly fileType?: InputMaybe<MimeTypeEnum>;
  /** The ID of the mediaItem object */
  readonly id: Scalars['ID']['input'];
  /** The ID of the parent object */
  readonly parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The ping status for the mediaItem */
  readonly pingStatus?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the mediaItem */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the mediaItem */
  readonly status?: InputMaybe<MediaItemStatusEnum>;
  /** The title of the mediaItem */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateMediaItem mutation. */
export type UpdateMediaItemPayload = {
  readonly __typename?: 'UpdateMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The MediaItem object mutation type. */
  readonly mediaItem?: Maybe<MediaItem>;
};

/** Input for the updatePage mutation. */
export type UpdatePageInput = {
  /** The userId to assign as the author of the object */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment status for the object */
  readonly commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The content of the object */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the page object */
  readonly id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  readonly ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  readonly menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the parent object */
  readonly parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The password used to protect the content of the object */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the object */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updatePage mutation. */
export type UpdatePagePayload = {
  readonly __typename?: 'UpdatePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  readonly page?: Maybe<Page>;
};

/** Update Input Type: PostAccessRecipient */
export type UpdatePostAccessRecipientInput = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The date the post was created, in the site's timezone */
  readonly created?: InputMaybe<Scalars['String']['input']>;
  /** Email Domain */
  readonly domain?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** The date the post expires, in the site's timezone */
  readonly expiresAt?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the PostAccessRecipient object */
  readonly id: Scalars['ID']['input'];
  /** The date the post was last modified, in the site's timezone */
  readonly modified?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the post this recipient has access to */
  readonly postId?: InputMaybe<Scalars['ID']['input']>;
  /** Status of the post access recipient */
  readonly status?: InputMaybe<PostAccessRecipientStatusEnum>;
  /** The type of the post */
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updatePostAccessRecipient mutation. */
export type UpdatePostAccessRecipientPayload = {
  readonly __typename?: 'UpdatePostAccessRecipientPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Update Mutation. Table for storing post access recipients */
  readonly postAccessRecipient?: Maybe<PostAccessRecipient>;
};

/** Input for the updatePostFormat mutation. */
export type UpdatePostFormatInput = {
  /** The slug that the post_format will be an alias of */
  readonly aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the post_format object */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the postFormat object to update */
  readonly id: Scalars['ID']['input'];
  /** The name of the post_format object to mutate */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updatePostFormat mutation. */
export type UpdatePostFormatPayload = {
  readonly __typename?: 'UpdatePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created post_format */
  readonly postFormat?: Maybe<PostFormat>;
};

/** Input for the updatePost mutation. */
export type UpdatePostInput = {
  /** The userId to assign as the author of the object */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** Set connections between the post and categories */
  readonly categories?: InputMaybe<PostCategoriesInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment status for the object */
  readonly commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The content of the object */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** The excerpt of the object */
  readonly excerpt?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the post object */
  readonly id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  readonly ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  readonly menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The password used to protect the content of the object */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** The ping status for the object */
  readonly pingStatus?: InputMaybe<Scalars['String']['input']>;
  /** URLs that have been pinged. */
  readonly pinged?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Set connections between the post and postFormats */
  readonly postFormats?: InputMaybe<PostPostFormatsInput>;
  /** The slug of the object */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** Set connections between the post and tags */
  readonly tags?: InputMaybe<PostTagsInput>;
  /** The title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** URLs queued to be pinged. */
  readonly toPing?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

/** The payload for the updatePost mutation. */
export type UpdatePostPayload = {
  readonly __typename?: 'UpdatePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  readonly post?: Maybe<Post>;
};

/** Input for the updateSettings mutation. */
export type UpdateSettingsInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Allow people to submit comments on new posts. */
  readonly discussionSettingsDefaultCommentStatus?: InputMaybe<Scalars['String']['input']>;
  /** Allow link notifications from other blogs (pingbacks and trackbacks) on new articles. */
  readonly discussionSettingsDefaultPingStatus?: InputMaybe<Scalars['String']['input']>;
  /** A date format for all date strings. */
  readonly generalSettingsDateFormat?: InputMaybe<Scalars['String']['input']>;
  /** Site tagline. */
  readonly generalSettingsDescription?: InputMaybe<Scalars['String']['input']>;
  /** This address is used for admin purposes, like new user notification. */
  readonly generalSettingsEmail?: InputMaybe<Scalars['String']['input']>;
  /** WordPress locale code. */
  readonly generalSettingsLanguage?: InputMaybe<Scalars['String']['input']>;
  /** A day number of the week that the week should start on. */
  readonly generalSettingsStartOfWeek?: InputMaybe<Scalars['Int']['input']>;
  /** A time format for all time strings. */
  readonly generalSettingsTimeFormat?: InputMaybe<Scalars['String']['input']>;
  /** A city in the same timezone as you. */
  readonly generalSettingsTimezone?: InputMaybe<Scalars['String']['input']>;
  /** Site title. */
  readonly generalSettingsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Site URL. */
  readonly generalSettingsUrl?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the page that should display the latest posts */
  readonly readingSettingsPageForPosts?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the page that should be displayed on the front page */
  readonly readingSettingsPageOnFront?: InputMaybe<Scalars['Int']['input']>;
  /** Blog pages show at most. */
  readonly readingSettingsPostsPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** What to show on the front page */
  readonly readingSettingsShowOnFront?: InputMaybe<Scalars['String']['input']>;
  /** Default post category. */
  readonly writingSettingsDefaultCategory?: InputMaybe<Scalars['Int']['input']>;
  /** Default post format. */
  readonly writingSettingsDefaultPostFormat?: InputMaybe<Scalars['String']['input']>;
  /** Convert emoticons like :-) and :-P to graphics on display. */
  readonly writingSettingsUseSmilies?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the updateSettings mutation. */
export type UpdateSettingsPayload = {
  readonly __typename?: 'UpdateSettingsPayload';
  /** Update all settings. */
  readonly allSettings?: Maybe<Settings>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Update the DiscussionSettings setting. */
  readonly discussionSettings?: Maybe<DiscussionSettings>;
  /** Update the GeneralSettings setting. */
  readonly generalSettings?: Maybe<GeneralSettings>;
  /** Update the ReadingSettings setting. */
  readonly readingSettings?: Maybe<ReadingSettings>;
  /** Update the WritingSettings setting. */
  readonly writingSettings?: Maybe<WritingSettings>;
};

/** Input for the updateSiteSettings mutation. */
export type UpdateSiteSettingsInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** TheUImetafieldforthelogo */
  readonly hdLogo?: InputMaybe<SiteSettingsUiMetaFieldInput>;
  /** TheUImetafieldforthelogotext */
  readonly hdLogoText?: InputMaybe<SiteSettingsUiMetaFieldInput>;
  /** Mailersettings */
  readonly mailer?: InputMaybe<SiteSettingsMailerInput>;
  /** Thetypeoftagfunctionality */
  readonly tagFunctionalityType?: InputMaybe<SiteSettingsTagFunctionalityTypeEnum>;
  /** Thelistofstatictags */
  readonly tagStaticList?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

/** The payload for the updateSiteSettings mutation. */
export type UpdateSiteSettingsPayload = {
  readonly __typename?: 'UpdateSiteSettingsPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated site settings */
  readonly siteSettings?: Maybe<SiteSettings>;
};

/** Input for the updateTag mutation. */
export type UpdateTagInput = {
  /** The slug that the post_tag will be an alias of */
  readonly aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the post_tag object */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the tag object to update */
  readonly id: Scalars['ID']['input'];
  /** The name of the post_tag object to mutate */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateTag mutation. */
export type UpdateTagPayload = {
  readonly __typename?: 'UpdateTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created post_tag */
  readonly tag?: Maybe<Tag>;
};

/** Input for the updateUser mutation. */
export type UpdateUserInput = {
  /** User's AOL IM account. */
  readonly aim?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A string containing content about the user. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  readonly displayName?: InputMaybe<Scalars['String']['input']>;
  /** A string containing the user's email address. */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** The user's first name. */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user */
  readonly id: Scalars['ID']['input'];
  /** User's Jabber account. */
  readonly jabber?: InputMaybe<Scalars['String']['input']>;
  /** The title of the user's job role | ACF Type: text | Graphql Type: String */
  readonly jobRole?: InputMaybe<Scalars['String']['input']>;
  /** The user's last name. */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** User's locale. */
  readonly locale?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  readonly nicename?: InputMaybe<Scalars['String']['input']>;
  /** The user's nickname, defaults to the user's username. */
  readonly nickname?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains the plain text password for the user. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: repeater | Graphql Type: {"list_of":"User_Meta_ProfileArticleLinks_RepeaterInput"} */
  readonly profileArticleLinks?: InputMaybe<ReadonlyArray<InputMaybe<User_Meta_ProfileArticleLinks_RepeaterInput>>>;
  /** The profile image of the user | ACF Type: image | Graphql Type: ID */
  readonly profileImage?: InputMaybe<Scalars['ID']['input']>;
  /** ACF Type: repeater | Graphql Type: {"list_of":"User_Meta_ProfileSocialLinks_RepeaterInput"} */
  readonly profileSocialLinks?: InputMaybe<ReadonlyArray<InputMaybe<User_Meta_ProfileSocialLinks_RepeaterInput>>>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  readonly registered?: InputMaybe<Scalars['String']['input']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  readonly richEditing?: InputMaybe<Scalars['String']['input']>;
  /** An array of roles to be assigned to the user. */
  readonly roles?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** A string containing the user's URL for the user's web site. */
  readonly websiteUrl?: InputMaybe<Scalars['String']['input']>;
  /** User's Yahoo IM account. */
  readonly yim?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateUser mutation. */
export type UpdateUserPayload = {
  readonly __typename?: 'UpdateUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The User object mutation type. */
  readonly user?: Maybe<User>;
};

/** Input for the updateZnglist mutation. */
export type UpdateZnglistInput = {
  /** The userId to assign as the author of the object */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** Restrict the content. A Form must be completed before the content can be accessed. | ACF Type: number | Graphql Type: ID */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the znglist object */
  readonly id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  readonly ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  readonly menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** ACF Type: number | Graphql Type: Int */
  readonly order?: InputMaybe<Scalars['Int']['input']>;
  /** The password used to protect the content of the object */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the object */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly statusSettings?: InputMaybe<StatusSettingsInput>;
  /** ACF Type: select | Graphql Type: ZnglistTemplateTypeEnum */
  readonly templateType?: InputMaybe<ZnglistTemplateTypeEnum>;
  /** The title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: select | Graphql Type: ZnglistUserTypeEnum */
  readonly userType?: InputMaybe<ZnglistUserTypeEnum>;
  /** ACF Type: post_object | Graphql Type: {"list_of":"ID"} */
  readonly znglyContents?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
};

/** The payload for the updateZnglist mutation. */
export type UpdateZnglistPayload = {
  readonly __typename?: 'UpdateZnglistPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  readonly znglist?: Maybe<Znglist>;
};

/** Input for the updateZnglyInfo mutation. */
export type UpdateZnglyInfoInput = {
  /** ACF Type: text | Graphql Type: String */
  readonly address1?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly address2?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly address3?: InputMaybe<Scalars['String']['input']>;
  /** Backend Primary Color | ACF Type: color_picker | Graphql Type: String */
  readonly backendPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Backend Secondary Color | ACF Type: color_picker | Graphql Type: String */
  readonly backendSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Background Color Of The Media Description Box | ACF Type: color_picker | Graphql Type: String */
  readonly bodyDescBoxClr?: InputMaybe<Scalars['String']['input']>;
  /** Text Color Of The Media Description Box | ACF Type: color_picker | Graphql Type: String */
  readonly bodyDescBoxTxtClr?: InputMaybe<Scalars['String']['input']>;
  /** The title shown in the browser tab | ACF Type: text | Graphql Type: String */
  readonly browserTabTitle?: InputMaybe<Scalars['String']['input']>;
  /** Color for Category and Znglisty dropdown menus | ACF Type: color_picker | Graphql Type: String */
  readonly catZnglistClr?: InputMaybe<Scalars['String']['input']>;
  /** Enter your Dialogflow CX Agent ID to enable the Zngly chatbot on your site | ACF Type: text | Graphql Type: String */
  readonly chatbotAgentId?: InputMaybe<Scalars['String']['input']>;
  /** Enable to automatically open the chatbot when the page loads | ACF Type: select | Graphql Type: String */
  readonly chatbotAutoOpen?: InputMaybe<Scalars['String']['input']>;
  /** Border radius for the chat window (e.g., 15px) | ACF Type: text | Graphql Type: String */
  readonly chatbotBorderRadius?: InputMaybe<Scalars['String']['input']>;
  /** Background color of the chat bubble button | ACF Type: color_picker | Graphql Type: String */
  readonly chatbotBubbleBackground?: InputMaybe<Scalars['String']['input']>;
  /** Background color of the chat window | ACF Type: color_picker | Graphql Type: String */
  readonly chatbotChatBackground?: InputMaybe<Scalars['String']['input']>;
  /** Enter your Datastore ID to be used with the chatbot for search filtering | ACF Type: text | Graphql Type: String */
  readonly chatbotDatastoreId?: InputMaybe<Scalars['String']['input']>;
  /** Choose how the chatbot should be displayed. Sidebar mode shows a fixed panel, while popup mode shows a floating button. | ACF Type: select | Graphql Type: String */
  readonly chatbotDisplayMode?: InputMaybe<Scalars['String']['input']>;
  /** Text color inside the chatbot | ACF Type: color_picker | Graphql Type: String */
  readonly chatbotFontColor?: InputMaybe<Scalars['String']['input']>;
  /** Font family override for the chatbot (leave empty to use site default) | ACF Type: text | Graphql Type: String */
  readonly chatbotFontFamily?: InputMaybe<Scalars['String']['input']>;
  /** Main accent color for the chatbot | ACF Type: color_picker | Graphql Type: String */
  readonly chatbotPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Color of the send button icon | ACF Type: color_picker | Graphql Type: String */
  readonly chatbotSendIconColor?: InputMaybe<Scalars['String']['input']>;
  /** Enter the title that will be displayed in the chatbot header | ACF Type: text | Graphql Type: String */
  readonly chatbotTitle?: InputMaybe<Scalars['String']['input']>;
  /** Background color of the chatbot header | ACF Type: color_picker | Graphql Type: String */
  readonly chatbotTitlebarBackground?: InputMaybe<Scalars['String']['input']>;
  /** Text color in the chatbot header | ACF Type: color_picker | Graphql Type: String */
  readonly chatbotTitlebarFontColor?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The content of the object */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** Primary color for the cta button | ACF Type: color_picker | Graphql Type: String */
  readonly ctaPrimaryClr?: InputMaybe<Scalars['String']['input']>;
  /** Primary text color for the cta button | ACF Type: color_picker | Graphql Type: String */
  readonly ctaPrimaryTxtClr?: InputMaybe<Scalars['String']['input']>;
  /** Secondary color for the cta button | ACF Type: color_picker | Graphql Type: String */
  readonly ctaSecondaryClr?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: repeater | Graphql Type: {"list_of":"ZnglyInfo_Znglyinfo_CustomSocialLinks_RepeaterInput"} */
  readonly customSocialLinks?: InputMaybe<ReadonlyArray<InputMaybe<ZnglyInfo_Znglyinfo_CustomSocialLinks_RepeaterInput>>>;
  /** Google Dashboard Link for Analytics | ACF Type: text | Graphql Type: String */
  readonly dashboardLink?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** Background color for category and znglist dropdown menu | ACF Type: color_picker | Graphql Type: String */
  readonly ddBgClr?: InputMaybe<Scalars['String']['input']>;
  /** Primary text color for category and znglist dropdown menu | ACF Type: color_picker | Graphql Type: String */
  readonly ddPrimaryTxtClr?: InputMaybe<Scalars['String']['input']>;
  /** Secondary text color for category and znglist dropdown menu (hover) | ACF Type: color_picker | Graphql Type: String */
  readonly ddSecondaryTxtClr?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: image | Graphql Type: ID */
  readonly favicon?: InputMaybe<Scalars['ID']['input']>;
  /** Site font style | ACF Type: text | Graphql Type: String */
  readonly fontStyle?: InputMaybe<Scalars['String']['input']>;
  /** Link Hover Color | ACF Type: color_picker | Graphql Type: String */
  readonly footerAccentClr?: InputMaybe<Scalars['String']['input']>;
  /** Background Color | ACF Type: color_picker | Graphql Type: String */
  readonly footerBgClr?: InputMaybe<Scalars['String']['input']>;
  /** Heading Color | ACF Type: color_picker | Graphql Type: String */
  readonly footerPrimaryTxtClr?: InputMaybe<Scalars['String']['input']>;
  /** Text/Link Color | ACF Type: color_picker | Graphql Type: String */
  readonly footerSecondaryTxtClr?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly googleAnalyticsId?: InputMaybe<Scalars['String']['input']>;
  /** Header Background Color | ACF Type: color_picker | Graphql Type: String */
  readonly headerBgClr?: InputMaybe<Scalars['String']['input']>;
  /** Buttons | ACF Type: repeater | Graphql Type: {"list_of":"ZnglyInfo_Znglyinfo_HeaderButtons_RepeaterInput"} */
  readonly headerButtons?: InputMaybe<ReadonlyArray<InputMaybe<ZnglyInfo_Znglyinfo_HeaderButtons_RepeaterInput>>>;
  /** Image shown in the header which represents the company logo | ACF Type: image | Graphql Type: ID */
  readonly headerLogo?: InputMaybe<Scalars['ID']['input']>;
  /** The link that is navigated to when the company logo is pressed | ACF Type: text | Graphql Type: String */
  readonly headerLogoLink?: InputMaybe<Scalars['String']['input']>;
  /** Text Color/Background Color For The Home & Contact Buttons | ACF Type: color_picker | Graphql Type: String */
  readonly headerPrimaryAccentClr?: InputMaybe<Scalars['String']['input']>;
  /** Company name, Powered By Zngly, Username Color | ACF Type: color_picker | Graphql Type: String */
  readonly headerPrimaryTxtClr?: InputMaybe<Scalars['String']['input']>;
  /** Inverse Text Color/Background Color For The Home & Contact Buttons | ACF Type: color_picker | Graphql Type: String */
  readonly headerSecondaryAccentClr?: InputMaybe<Scalars['String']['input']>;
  /** Link Hover Color | ACF Type: color_picker | Graphql Type: String */
  readonly headerSecondaryTxtClr?: InputMaybe<Scalars['String']['input']>;
  /** The text shown beside the logo which directs users back home | ACF Type: text | Graphql Type: String */
  readonly headerText?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly headerTextConditions?: InputMaybe<Scalars['String']['input']>;
  /** This is description that appears in the html metadata or when home page is shared. The same propagation issues from the above apply | ACF Type: text | Graphql Type: String */
  readonly homePreviewDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * Image shown when home page is shared on other platform,
   *                         also used if the post/page being shared does not contain any images.
   *                         Propagation might take a while due to aggressive caching by other platforms,
   *                         use their respective share scraper to vertify changes and use the home url with some random url params e.g. .../?test=testing | ACF Type: image | Graphql Type: ID
   */
  readonly homePreviewImage?: InputMaybe<Scalars['ID']['input']>;
  /** Paste the hubId from the Hubspot Embed Code. src="//js.hs-scripts.com/{hubId}.js" | ACF Type: text | Graphql Type: String */
  readonly hubspotTracker?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the znglyInfo object */
  readonly id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  readonly ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
  /** Paste the Leadfeeder code from the Leadfeeder tracker. It is the ID located towards the end of the script | ACF Type: text | Graphql Type: String */
  readonly leadfeederTracker?: InputMaybe<Scalars['String']['input']>;
  /** Bottom Left Links Section | ACF Type: repeater | Graphql Type: {"list_of":"ZnglyInfo_Znglyinfo_Links_RepeaterInput"} */
  readonly links?: InputMaybe<ReadonlyArray<InputMaybe<ZnglyInfo_Znglyinfo_Links_RepeaterInput>>>;
  /** Title to the Links Section | ACF Type: text | Graphql Type: String */
  readonly linksTitle?: InputMaybe<Scalars['String']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  readonly menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Link Color, Category & Playlist Border/Background Color | ACF Type: color_picker | Graphql Type: String */
  readonly pagePrimaryAccClr?: InputMaybe<Scalars['String']['input']>;
  /** Body Text Color | ACF Type: color_picker | Graphql Type: String */
  readonly pagePrimaryTxtClr?: InputMaybe<Scalars['String']['input']>;
  /** Link Hover Color, Category & Playlist Dropdown Menu Background Color | ACF Type: color_picker | Graphql Type: String */
  readonly pageSecondaryAccClr?: InputMaybe<Scalars['String']['input']>;
  /** Category & Playlist Menu Text Color | ACF Type: color_picker | Graphql Type: String */
  readonly pageSecondaryTxtClr?: InputMaybe<Scalars['String']['input']>;
  /** The password used to protect the content of the object */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly phone1?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly phone2?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: group | Graphql Type: ZnglyInfo_Znglyinfo_Pinning_GroupInput */
  readonly pinning?: InputMaybe<ZnglyInfo_Znglyinfo_Pinning_GroupInput>;
  /** ACF Type: text | Graphql Type: String */
  readonly privacyPolicy?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly privacyPolicyDate?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly privacyPolicyEditing?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly privacyPolicyTitle?: InputMaybe<Scalars['String']['input']>;
  /** Privacy Cookie Consent Enforcement Level For Users: GDPR, OPT_OUT, DISABLED | ACF Type: text | Graphql Type: ZnglyPrivacyUserConsentLevelEnum */
  readonly privacyUserConsentLevel?: InputMaybe<ZnglyPrivacyUserConsentLevelEnum>;
  /** ACF Type: repeater | Graphql Type: {"list_of":"ZnglyInfo_Znglyinfo_PvImages_RepeaterInput"} */
  readonly pvImages?: InputMaybe<ReadonlyArray<InputMaybe<ZnglyInfo_Znglyinfo_PvImages_RepeaterInput>>>;
  /** The image shown in the centre of the QR code | ACF Type: image | Graphql Type: ID */
  readonly qrImage?: InputMaybe<Scalars['ID']['input']>;
  /** The primary color of the QR codes | ACF Type: text | Graphql Type: String */
  readonly qrPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  /** The secondary color of the QR codes | ACF Type: text | Graphql Type: String */
  readonly qrSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Primary color for the read more button | ACF Type: color_picker | Graphql Type: String */
  readonly readMorePrimaryClr?: InputMaybe<Scalars['String']['input']>;
  /** Primary text color for the read more button | ACF Type: color_picker | Graphql Type: String */
  readonly readMorePrimaryTxtClr?: InputMaybe<Scalars['String']['input']>;
  /** Secondary color for the read more button | ACF Type: color_picker | Graphql Type: String */
  readonly readMoreSecondaryClr?: InputMaybe<Scalars['String']['input']>;
  /** Paste the salesforce MID here to enable salesforce tracking | ACF Type: text | Graphql Type: String */
  readonly salesforceMid?: InputMaybe<Scalars['String']['input']>;
  /** Image for the Search | ACF Type: image | Graphql Type: ID */
  readonly searchImage?: InputMaybe<Scalars['ID']['input']>;
  /** Image for the Ai Search | ACF Type: image | Graphql Type: ID */
  readonly searchImageAi?: InputMaybe<Scalars['ID']['input']>;
  /** Placeholder text for the search bar | ACF Type: text | Graphql Type: String */
  readonly searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** Placeholder text for the search bar | ACF Type: text | Graphql Type: String */
  readonly searchPlaceholderAi?: InputMaybe<Scalars['String']['input']>;
  /** Primary share button color | ACF Type: color_picker | Graphql Type: String */
  readonly shareBtnPrimaryClr?: InputMaybe<Scalars['String']['input']>;
  /** Secondary share button color (hover) | ACF Type: color_picker | Graphql Type: String */
  readonly shareBtnSecondaryClr?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the object */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** Include the tawk.to Id. Only the id after http://embed.tawk.to/copy_from_here/to_here | ACF Type: text | Graphql Type: String */
  readonly tawkId?: InputMaybe<Scalars['String']['input']>;
  /** The title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly umamiAnalyticsId?: InputMaybe<Scalars['String']['input']>;
  /** Background color for user dropdown menu | ACF Type: color_picker | Graphql Type: String */
  readonly userMenuBackgroundClr?: InputMaybe<Scalars['String']['input']>;
  /** Link color for user dropdown menu | ACF Type: color_picker | Graphql Type: String */
  readonly userMenuLinkClr?: InputMaybe<Scalars['String']['input']>;
  /** Link hover color for user dropdown menu | ACF Type: color_picker | Graphql Type: String */
  readonly userMenuLinkHoverClr?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly zoomInfoTracker?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateZnglyInfo mutation. */
export type UpdateZnglyInfoPayload = {
  readonly __typename?: 'UpdateZnglyInfoPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  readonly znglyInfo?: Maybe<ZnglyInfo>;
};

/** Input for the updateZnglyVideo mutation. */
export type UpdateZnglyVideoInput = {
  /** The AI Summary of the content. | ACF Type: text | Graphql Type: String */
  readonly aiSummary?: InputMaybe<Scalars['String']['input']>;
  /** The userId to assign as the author of the object */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** Set connections between the znglyVideo and categories */
  readonly categories?: InputMaybe<ZnglyVideoCategoriesInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The content of the object */
  readonly content?: InputMaybe<Scalars['String']['input']>;
  /** The HTML code for the embed. | ACF Type: text | Graphql Type: String */
  readonly contentEmbedHtml?: InputMaybe<Scalars['String']['input']>;
  /** File Must be one of [pdf, jpg, png, jpeg, gif, mp4] Types | ACF Type: file | Graphql Type: ID */
  readonly contentFile?: InputMaybe<Scalars['ID']['input']>;
  /** Link to the content. | ACF Type: text | Graphql Type: String */
  readonly contentLink?: InputMaybe<Scalars['String']['input']>;
  /** mp4/vimeo/png etc... | ACF Type: text | Graphql Type: ZnglyVideoMediaNameEnum */
  readonly contentMediaName?: InputMaybe<ZnglyVideoMediaNameEnum>;
  /** embed/file/external | ACF Type: text | Graphql Type: ZnglyVideoPostTypeEnum */
  readonly contentMediaType?: InputMaybe<ZnglyVideoPostTypeEnum>;
  /** ACF Type: text | Graphql Type: String */
  readonly ctaLink?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: String */
  readonly ctaName?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** The excerpt of the object */
  readonly excerpt?: InputMaybe<Scalars['String']['input']>;
  /** File Must be one of [pdf, jpg, png, jpeg, gif, mp4] Types | ACF Type: file | Graphql Type: ID */
  readonly featuredImageFile?: InputMaybe<Scalars['ID']['input']>;
  /** Link to the Featured Image. | ACF Type: text | Graphql Type: String */
  readonly featuredImageLink?: InputMaybe<Scalars['String']['input']>;
  /** Restrict the content. A Form must be completed before the content can be accessed. | ACF Type: number | Graphql Type: ID */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** ACF Type: wysiwyg | Graphql Type: String */
  readonly htmlDesc?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the znglyVideo object */
  readonly id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  readonly ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  readonly menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The password used to protect the content of the object */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: textarea | Graphql Type: String */
  readonly shortText?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the object */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly statusSettings?: InputMaybe<StatusSettingsInput>;
  /** Set connections between the znglyVideo and tags */
  readonly tags?: InputMaybe<ZnglyVideoTagsInput>;
  /** The title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** The Duration of a Video. | ACF Type: text | Graphql Type: String */
  readonly videoDuration?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateZnglyVideo mutation. */
export type UpdateZnglyVideoPayload = {
  readonly __typename?: 'UpdateZnglyVideoPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  readonly znglyVideo?: Maybe<ZnglyVideo>;
};

/** Input for the uploadVideoPost mutation. */
export type UploadVideoPostInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly files?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Upload']['input']>>>;
  readonly shortText: Scalars['String']['input'];
  readonly title: Scalars['String']['input'];
};

/** The payload for the uploadVideoPost mutation. */
export type UploadVideoPostPayload = {
  readonly __typename?: 'UploadVideoPostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly databaseId?: Maybe<Scalars['ID']['output']>;
  readonly znglyVideo?: Maybe<ZnglyVideo>;
};

/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type User = Commenter & DatabaseIdentifier & Node & UniformResourceIdentifiable & {
  readonly __typename?: 'User';
  /** Headless Login authentication data. */
  readonly auth?: Maybe<AuthenticationData>;
  /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
  readonly avatar?: Maybe<Avatar>;
  /** User metadata option name. Usually it will be &quot;wp_capabilities&quot;. */
  readonly capKey?: Maybe<Scalars['String']['output']>;
  /** A list of capabilities (permissions) granted to the user */
  readonly capabilities?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** Connection between the User type and the Comment type */
  readonly comments?: Maybe<UserToCommentConnection>;
  /** Identifies the primary key from the database. */
  readonly databaseId: Scalars['Int']['output'];
  /** Description of the user. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Email address of the user. This is equivalent to the WP_User-&gt;user_email property. */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** Connection between the User type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<UserToEnqueuedScriptConnection>;
  /** Connection between the User type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<UserToEnqueuedStylesheetConnection>;
  /** A complete list of capabilities including capabilities inherited from a role. This is equivalent to the array keys of WP_User-&gt;allcaps. */
  readonly extraCapabilities?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** First name of the user. This is equivalent to the WP_User-&gt;user_first_name property. */
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** Connection between the User type and the Form type */
  readonly forms?: Maybe<UserToFormConnection>;
  /** The globally unique identifier for the user object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** Last name of the user. This is equivalent to the WP_User-&gt;user_last_name property. */
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** The preferred language locale set for the user. Value derived from get_user_locale(). */
  readonly locale?: Maybe<Scalars['String']['output']>;
  /** Connection between the User type and the mediaItem type */
  readonly mediaItems?: Maybe<UserToMediaItemConnection>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;User Meta&quot; was set to Show in GraphQL. */
  readonly meta?: Maybe<User_Meta>;
  /** Display name of the user. This is equivalent to the WP_User-&gt;display_name property. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** The nicename for the user. This field is equivalent to WP_User-&gt;user_nicename */
  readonly nicename?: Maybe<Scalars['String']['output']>;
  /** Nickname of the user. */
  readonly nickname?: Maybe<Scalars['String']['output']>;
  /** Connection between the User type and the page type */
  readonly pages?: Maybe<UserToPageConnection>;
  /** Connection between the User type and the post type */
  readonly posts?: Maybe<UserToPostConnection>;
  /** The date the user registered or was created. The field follows a full ISO8601 date string format. */
  readonly registeredDate?: Maybe<Scalars['String']['output']>;
  /** Connection between the User and Revisions authored by the user */
  readonly revisions?: Maybe<UserToRevisionsConnection>;
  /** The user&#039;s role */
  readonly role?: Maybe<Scalars['String']['output']>;
  /** Connection between the User type and the UserRole type */
  readonly roles?: Maybe<UserToUserRoleConnection>;
  /** Whether the Toolbar should be displayed when the user is viewing the site. */
  readonly shouldShowAdminToolbar?: Maybe<Scalars['Boolean']['output']>;
  /** The slug for the user. This field is equivalent to WP_User-&gt;user_nicename */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
  /** A website url that is associated with the user. */
  readonly url?: Maybe<Scalars['String']['output']>;
  /**
   * The Id of the user. Equivalent to WP_User-&gt;ID
   * @deprecated Deprecated in favor of the databaseId field
   */
  readonly userId?: Maybe<Scalars['Int']['output']>;
  /** Username for the user. This field is equivalent to WP_User-&gt;user_login. */
  readonly username?: Maybe<Scalars['String']['output']>;
  /** Connection between the User type and the znglist type */
  readonly znglists?: Maybe<UserToZnglistConnection>;
  /** Connection between the User type and the znglyVideo type */
  readonly znglyVideos?: Maybe<UserToZnglyVideoConnection>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserAvatarArgs = {
  forceDefault?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<AvatarRatingEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserToCommentConnectionWhereArgs>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserMediaItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserToMediaItemConnectionWhereArgs>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserToPageConnectionWhereArgs>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserToPostConnectionWhereArgs>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserRevisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserToRevisionsConnectionWhereArgs>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserZnglistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserToZnglistConnectionWhereArgs>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserZnglyVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserToZnglyVideoConnectionWhereArgs>;
};

/** A paginated collection of User Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of User Nodes */
export type UserConnection = {
  /** A list of edges (relational context) between RootQuery and connected User Nodes */
  readonly edges: ReadonlyArray<UserConnectionEdge>;
  /** A list of connected User Nodes */
  readonly nodes: ReadonlyArray<User>;
  /** Information about pagination in a connection. */
  readonly pageInfo: UserConnectionPageInfo;
};

/** Represents a connection to a User. Contains both the User Node and metadata about the relationship. */
export type UserConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected User Node */
  readonly node: User;
};

/** Pagination metadata specific to &quot;UserConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;UserConnectionEdge&quot; Nodes. */
export type UserConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifier types for retrieving a specific user. Determines whether to look up users by ID, email, username, or other unique properties. */
export enum UserNodeIdTypeEnum {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The Email of the User */
  Email = 'EMAIL',
  /** The hashed Global ID */
  Id = 'ID',
  /** The slug of the User */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
  /** The username the User uses to login with */
  Username = 'USERNAME'
}

/** A user role object */
export type UserRole = Node & {
  readonly __typename?: 'UserRole';
  /** The capabilities that belong to this role */
  readonly capabilities?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** The display name of the role */
  readonly displayName?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier for the user role object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** The registered name of the role */
  readonly name?: Maybe<Scalars['String']['output']>;
};

/** A paginated collection of UserRole Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of UserRole Nodes */
export type UserRoleConnection = {
  /** A list of edges (relational context) between RootQuery and connected UserRole Nodes */
  readonly edges: ReadonlyArray<UserRoleConnectionEdge>;
  /** A list of connected UserRole Nodes */
  readonly nodes: ReadonlyArray<UserRole>;
  /** Information about pagination in a connection. */
  readonly pageInfo: UserRoleConnectionPageInfo;
};

/** Represents a connection to a UserRole. Contains both the UserRole Node and metadata about the relationship. */
export type UserRoleConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected UserRole Node */
  readonly node: UserRole;
};

/** Pagination metadata specific to &quot;UserRoleConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;UserRoleConnectionEdge&quot; Nodes. */
export type UserRoleConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Permission levels for user accounts. Defines the standard access levels that control what actions users can perform within the system. */
export enum UserRoleEnum {
  /** User role with specific capabilities */
  Admin = 'ADMIN',
  /** User role with specific capabilities */
  Administrator = 'ADMINISTRATOR',
  /** User role with specific capabilities */
  Guest = 'GUEST',
  /** User role with specific capabilities */
  SalesUser = 'SALES_USER',
  /** User role with specific capabilities */
  SalesUserRestricted = 'SALES_USER__RESTRICTED_',
  /** User role with specific capabilities */
  User = 'USER'
}

/** Connection between the User type and the Comment type */
export type UserToCommentConnection = CommentConnection & Connection & {
  readonly __typename?: 'UserToCommentConnection';
  /** Edges for the UserToCommentConnection connection */
  readonly edges: ReadonlyArray<UserToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Comment>;
  /** Information about pagination in a connection. */
  readonly pageInfo: UserToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type UserToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  readonly __typename?: 'UserToCommentConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Comment;
};

/** Pagination metadata specific to &quot;UserToCommentConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToCommentConnection Nodes. */
export type UserToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'UserToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the UserToCommentConnection connection */
export type UserToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  readonly authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  readonly authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  readonly commentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  readonly commentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  readonly commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  readonly commentTypeIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  readonly commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  readonly contentAuthor?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  readonly contentAuthorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  readonly contentAuthorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  readonly contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  readonly contentIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  readonly contentIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  readonly contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  readonly contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentStatus?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  readonly contentType?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  readonly includeUnapproved?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  readonly karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  readonly orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the User type and the EnqueuedScript type */
export type UserToEnqueuedScriptConnection = Connection & EnqueuedScriptConnection & {
  readonly __typename?: 'UserToEnqueuedScriptConnection';
  /** Edges for the UserToEnqueuedScriptConnection connection */
  readonly edges: ReadonlyArray<UserToEnqueuedScriptConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<EnqueuedScript>;
  /** Information about pagination in a connection. */
  readonly pageInfo: UserToEnqueuedScriptConnectionPageInfo;
};

/** An edge in a connection */
export type UserToEnqueuedScriptConnectionEdge = Edge & EnqueuedScriptConnectionEdge & {
  readonly __typename?: 'UserToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: EnqueuedScript;
};

/** Pagination metadata specific to &quot;UserToEnqueuedScriptConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToEnqueuedScriptConnection Nodes. */
export type UserToEnqueuedScriptConnectionPageInfo = EnqueuedScriptConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'UserToEnqueuedScriptConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the User type and the EnqueuedStylesheet type */
export type UserToEnqueuedStylesheetConnection = Connection & EnqueuedStylesheetConnection & {
  readonly __typename?: 'UserToEnqueuedStylesheetConnection';
  /** Edges for the UserToEnqueuedStylesheetConnection connection */
  readonly edges: ReadonlyArray<UserToEnqueuedStylesheetConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  readonly pageInfo: UserToEnqueuedStylesheetConnectionPageInfo;
};

/** An edge in a connection */
export type UserToEnqueuedStylesheetConnectionEdge = Edge & EnqueuedStylesheetConnectionEdge & {
  readonly __typename?: 'UserToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: EnqueuedStylesheet;
};

/** Pagination metadata specific to &quot;UserToEnqueuedStylesheetConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToEnqueuedStylesheetConnection Nodes. */
export type UserToEnqueuedStylesheetConnectionPageInfo = EnqueuedStylesheetConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'UserToEnqueuedStylesheetConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the User type and the Form type */
export type UserToFormConnection = Connection & FormConnection & {
  readonly __typename?: 'UserToFormConnection';
  /** Edges for the UserToFormConnection connection */
  readonly edges: ReadonlyArray<UserToFormConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Form>;
  /** Information about pagination in a connection. */
  readonly pageInfo: UserToFormConnectionPageInfo;
};

/** An edge in a connection */
export type UserToFormConnectionEdge = Edge & FormConnectionEdge & {
  readonly __typename?: 'UserToFormConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Form;
};

/** Pagination metadata specific to &quot;UserToFormConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToFormConnection Nodes. */
export type UserToFormConnectionPageInfo = FormConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'UserToFormConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the User type and the mediaItem type */
export type UserToMediaItemConnection = Connection & MediaItemConnection & {
  readonly __typename?: 'UserToMediaItemConnection';
  /** Edges for the UserToMediaItemConnection connection */
  readonly edges: ReadonlyArray<UserToMediaItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<MediaItem>;
  /** Information about pagination in a connection. */
  readonly pageInfo: UserToMediaItemConnectionPageInfo;
};

/** An edge in a connection */
export type UserToMediaItemConnectionEdge = Edge & MediaItemConnectionEdge & {
  readonly __typename?: 'UserToMediaItemConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: MediaItem;
};

/** Pagination metadata specific to &quot;UserToMediaItemConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToMediaItemConnection Nodes. */
export type UserToMediaItemConnectionPageInfo = MediaItemConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'UserToMediaItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the UserToMediaItemConnection connection */
export type UserToMediaItemConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the User type and the page type */
export type UserToPageConnection = Connection & PageConnection & {
  readonly __typename?: 'UserToPageConnection';
  /** Edges for the UserToPageConnection connection */
  readonly edges: ReadonlyArray<UserToPageConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Page>;
  /** Information about pagination in a connection. */
  readonly pageInfo: UserToPageConnectionPageInfo;
};

/** An edge in a connection */
export type UserToPageConnectionEdge = Edge & PageConnectionEdge & {
  readonly __typename?: 'UserToPageConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Page;
};

/** Pagination metadata specific to &quot;UserToPageConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToPageConnection Nodes. */
export type UserToPageConnectionPageInfo = PageConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'UserToPageConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the UserToPageConnection connection */
export type UserToPageConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the User type and the post type */
export type UserToPostConnection = Connection & PostConnection & {
  readonly __typename?: 'UserToPostConnection';
  /** Edges for the UserToPostConnection connection */
  readonly edges: ReadonlyArray<UserToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Post>;
  /** Information about pagination in a connection. */
  readonly pageInfo: UserToPostConnectionPageInfo;
};

/** An edge in a connection */
export type UserToPostConnectionEdge = Edge & PostConnectionEdge & {
  readonly __typename?: 'UserToPostConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Post;
};

/** Pagination metadata specific to &quot;UserToPostConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToPostConnection Nodes. */
export type UserToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'UserToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the UserToPostConnection connection */
export type UserToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  readonly categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  readonly categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  readonly tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  readonly tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  readonly tagSlugAnd?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  readonly tagSlugIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the User type and the ContentNode type */
export type UserToRevisionsConnection = Connection & ContentNodeConnection & {
  readonly __typename?: 'UserToRevisionsConnection';
  /** Edges for the UserToRevisionsConnection connection */
  readonly edges: ReadonlyArray<UserToRevisionsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ContentNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: UserToRevisionsConnectionPageInfo;
};

/** An edge in a connection */
export type UserToRevisionsConnectionEdge = ContentNodeConnectionEdge & Edge & {
  readonly __typename?: 'UserToRevisionsConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ContentNode;
};

/** Pagination metadata specific to &quot;UserToRevisionsConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToRevisionsConnection Nodes. */
export type UserToRevisionsConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'UserToRevisionsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the UserToRevisionsConnection connection */
export type UserToRevisionsConnectionWhereArgs = {
  /** The Types of content to filter */
  readonly contentTypes?: InputMaybe<ReadonlyArray<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the User type and the UserRole type */
export type UserToUserRoleConnection = Connection & UserRoleConnection & {
  readonly __typename?: 'UserToUserRoleConnection';
  /** Edges for the UserToUserRoleConnection connection */
  readonly edges: ReadonlyArray<UserToUserRoleConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<UserRole>;
  /** Information about pagination in a connection. */
  readonly pageInfo: UserToUserRoleConnectionPageInfo;
};

/** An edge in a connection */
export type UserToUserRoleConnectionEdge = Edge & UserRoleConnectionEdge & {
  readonly __typename?: 'UserToUserRoleConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: UserRole;
};

/** Pagination metadata specific to &quot;UserToUserRoleConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToUserRoleConnection Nodes. */
export type UserToUserRoleConnectionPageInfo = PageInfo & UserRoleConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'UserToUserRoleConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the User type and the znglist type */
export type UserToZnglistConnection = Connection & ZnglistConnection & {
  readonly __typename?: 'UserToZnglistConnection';
  /** Edges for the UserToZnglistConnection connection */
  readonly edges: ReadonlyArray<UserToZnglistConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Znglist>;
  /** Information about pagination in a connection. */
  readonly pageInfo: UserToZnglistConnectionPageInfo;
};

/** An edge in a connection */
export type UserToZnglistConnectionEdge = Edge & ZnglistConnectionEdge & {
  readonly __typename?: 'UserToZnglistConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Znglist;
};

/** Pagination metadata specific to &quot;UserToZnglistConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToZnglistConnection Nodes. */
export type UserToZnglistConnectionPageInfo = PageInfo & WpPageInfo & ZnglistConnectionPageInfo & {
  readonly __typename?: 'UserToZnglistConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the UserToZnglistConnection connection */
export type UserToZnglistConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the User type and the znglyVideo type */
export type UserToZnglyVideoConnection = Connection & ZnglyVideoConnection & {
  readonly __typename?: 'UserToZnglyVideoConnection';
  /** Edges for the UserToZnglyVideoConnection connection */
  readonly edges: ReadonlyArray<UserToZnglyVideoConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ZnglyVideo>;
  /** Information about pagination in a connection. */
  readonly pageInfo: UserToZnglyVideoConnectionPageInfo;
};

/** An edge in a connection */
export type UserToZnglyVideoConnectionEdge = Edge & ZnglyVideoConnectionEdge & {
  readonly __typename?: 'UserToZnglyVideoConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ZnglyVideo;
};

/** Pagination metadata specific to &quot;UserToZnglyVideoConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToZnglyVideoConnection Nodes. */
export type UserToZnglyVideoConnectionPageInfo = PageInfo & WpPageInfo & ZnglyVideoConnectionPageInfo & {
  readonly __typename?: 'UserToZnglyVideoConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the UserToZnglyVideoConnection connection */
export type UserToZnglyVideoConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  readonly author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  readonly authorIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  readonly authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  readonly authorNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  readonly categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  readonly categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  readonly categoryNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  readonly dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  readonly hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly metaQuery?: InputMaybe<MetaQuery>;
  /** Get objects with a specific mimeType property */
  readonly mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  readonly nameIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  readonly notIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  readonly orderby?: InputMaybe<ReadonlyArray<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  readonly parentIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  readonly parentNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  readonly stati?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  readonly status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  readonly tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  readonly tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  readonly tagNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  readonly tagSlugAnd?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  readonly tagSlugIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly taxQuery?: InputMaybe<TaxQuery>;
  /** Title of the object */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Field Group */
export type User_Meta = AcfFieldGroup & {
  readonly __typename?: 'User_Meta';
  /** The name of the ACF Field Group */
  readonly fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** The title of the user&#039;s job role */
  readonly jobRole?: Maybe<Scalars['String']['output']>;
  readonly profileArticleLinks?: Maybe<ReadonlyArray<Maybe<User_Meta_ProfileArticleLinks>>>;
  /** The profile image of the user */
  readonly profileImage?: Maybe<MediaItem>;
  readonly profileSocialLinks?: Maybe<ReadonlyArray<Maybe<User_Meta_ProfileSocialLinks>>>;
};

/** Field Group */
export type User_Meta_ProfileArticleLinks = AcfFieldGroup & {
  readonly __typename?: 'User_Meta_profileArticleLinks';
  /** The name of the ACF Field Group */
  readonly fieldGroupName?: Maybe<Scalars['String']['output']>;
  readonly iconName?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

/** Field Group */
export type User_Meta_ProfileSocialLinks = AcfFieldGroup & {
  readonly __typename?: 'User_Meta_profileSocialLinks';
  /** The name of the ACF Field Group */
  readonly fieldGroupName?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

/** ACF Type: repeater | Graphql Type:  */
export type User_Meta_ProfileArticleLinks_RepeaterInput = {
  /** ACF Type: text | Graphql Type: "String" */
  readonly iconName?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: "String" */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: "String" */
  readonly url?: InputMaybe<Scalars['String']['input']>;
};

/** ACF Type: repeater | Graphql Type:  */
export type User_Meta_ProfileSocialLinks_RepeaterInput = {
  /** ACF Type: text | Graphql Type: "String" */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: "String" */
  readonly url?: InputMaybe<Scalars['String']['input']>;
};

/** User attribute sorting options. Determines which property of user accounts is used for ordering user listings. */
export enum UsersConnectionOrderbyEnum {
  /** Order by display name */
  DisplayName = 'DISPLAY_NAME',
  /** Order by email address */
  Email = 'EMAIL',
  /** Order by login */
  Login = 'LOGIN',
  /** Preserve the login order given in the LOGIN_IN array */
  LoginIn = 'LOGIN_IN',
  /** Order by nice name */
  NiceName = 'NICE_NAME',
  /** Preserve the nice name order given in the NICE_NAME_IN array */
  NiceNameIn = 'NICE_NAME_IN',
  /** Order by registration date */
  Registered = 'REGISTERED',
  /** Order by URL */
  Url = 'URL'
}

/** Options for ordering the connection */
export type UsersConnectionOrderbyInput = {
  /** The field name used to sort the results. */
  readonly field: UsersConnectionOrderbyEnum;
  /** The cardinality of the order of the connection */
  readonly order?: InputMaybe<OrderEnum>;
};

/** User properties that can be targeted in search operations. Defines which user attributes can be searched when looking for specific users. */
export enum UsersConnectionSearchColumnEnum {
  /** The user's email address. */
  Email = 'EMAIL',
  /** The globally unique ID. */
  Id = 'ID',
  /** The username the User uses to login with. */
  Login = 'LOGIN',
  /** A URL-friendly name for the user. The default is the user's username. */
  Nicename = 'NICENAME',
  /** The URL of the user's website. */
  Url = 'URL'
}

export type ValidateContacts = {
  readonly __typename?: 'ValidateContacts';
  /** Zngly Contacts */
  readonly contact?: Maybe<Contact>;
  /** Whether the record exists in the database */
  readonly exists?: Maybe<Scalars['Boolean']['output']>;
  /** contact id */
  readonly id?: Maybe<Scalars['ID']['output']>;
  /** The input number used to validate the record */
  readonly inputNumber?: Maybe<Scalars['Int']['output']>;
  /** The input string used to validate the record */
  readonly inputString?: Maybe<Scalars['String']['output']>;
};

/** The fields to validate against the record */
export enum ValidateContactsFieldEnum {
  /** Contact email */
  Email = 'email',
  /** contact id */
  Id = 'id'
}

/** Verify Password Input Type: Form */
export type VerifyFormPasswordInput = {
  /** The field name of the Form to verify password for */
  readonly field?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Form to verify password for */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** The password of the Form to verify */
  readonly password?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the verifyFormPassword mutation. */
export type VerifyFormPasswordPayload = {
  readonly __typename?: 'VerifyFormPasswordPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the password was verified or not */
  readonly verified?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for the verifyPostAccess mutation. */
export type VerifyPostAccessInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the post to verify access for */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** ID type of the post to verify access for */
  readonly idType?: InputMaybe<PostIdType>;
  /** Type of the post to verify access for */
  readonly postType?: InputMaybe<ZnglyPostTypeEnum>;
};

/** The payload for the verifyPostAccess mutation. */
export type VerifyPostAccessPayload = {
  readonly __typename?: 'VerifyPostAccessPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the user has access to the post */
  readonly hasAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the session is active */
  readonly sessionActive?: Maybe<Scalars['Boolean']['output']>;
  /** UI permission settings for the post */
  readonly uiPermission?: Maybe<StatusUiPermissionEnum>;
};

/** Type of prompt to use for the summary. */
export enum VertexGenAiPromptType {
  /** analyse type */
  Analyse = 'analyse',
  /** highlights type */
  Highlights = 'highlights',
  /** summarise type */
  Summarise = 'summarise'
}

export type VertexGenAi = {
  readonly __typename?: 'VertexGenAi';
  /** Summary Result */
  readonly summary?: Maybe<Scalars['String']['output']>;
};

/** Connection between the RootQuery type and the znglyVideo type */
export type VertexSearchAgentConnection = Connection & ZnglyVideoConnection & {
  readonly __typename?: 'VertexSearchAgentConnection';
  /** Corrected Query */
  readonly correctedQuery?: Maybe<Scalars['String']['output']>;
  /** Edges for the VertexSearchAgentConnection connection */
  readonly edges: ReadonlyArray<VertexSearchAgentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ZnglyVideo>;
  /** Information about pagination in a connection. */
  readonly pageInfo: VertexSearchAgentConnectionPageInfo;
  /** Summary */
  readonly summary?: Maybe<Summary>;
};

/** An edge in a connection */
export type VertexSearchAgentConnectionEdge = Edge & ZnglyVideoConnectionEdge & {
  readonly __typename?: 'VertexSearchAgentConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: ZnglyVideo;
};

/** Pagination metadata specific to &quot;VertexSearchAgentConnection&quot; collections. Provides cursors and flags for navigating through sets of VertexSearchAgentConnection Nodes. */
export type VertexSearchAgentConnectionPageInfo = PageInfo & WpPageInfo & ZnglyVideoConnectionPageInfo & {
  readonly __typename?: 'VertexSearchAgentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the VertexSearchAgentConnection connection */
export type VertexSearchAgentConnectionWhereArgs = {
  readonly vertex?: InputMaybe<VertexSearchAgentInputType>;
};

/** Vertex Search Agent Input */
export type VertexSearchAgentInputType = {
  readonly categoryIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly hubId?: InputMaybe<Scalars['ID']['input']>;
  readonly hubPageId?: InputMaybe<Scalars['ID']['input']>;
  readonly pageType?: InputMaybe<Scalars['String']['input']>;
  /** Search Query */
  readonly query?: InputMaybe<Scalars['String']['input']>;
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostStatusEnum>>>;
  readonly znglistId?: InputMaybe<Scalars['ID']['input']>;
};

/** Metadata for cursor-based pagination. Provides cursors for continuing pagination and boolean flags indicating if more items exist in either direction. */
export type WpPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** The writing setting type */
export type WritingSettings = {
  readonly __typename?: 'WritingSettings';
  /** Default post category. */
  readonly defaultCategory?: Maybe<Scalars['Int']['output']>;
  /** Default post format. */
  readonly defaultPostFormat?: Maybe<Scalars['String']['output']>;
  /** Convert emoticons like :-) and :-P to graphics on display. */
  readonly useSmilies?: Maybe<Scalars['Boolean']['output']>;
};

/** An object with an ID */
export type ZnNode = {
  /** The unique identifier stored in the database */
  readonly databaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique ID for the object */
  readonly id: Scalars['ID']['output'];
};

/** Input for the znSendPasswordResetEmail mutation. */
export type ZnSendPasswordResetEmailInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains the user's username or email address. */
  readonly username: Scalars['String']['input'];
};

/** The payload for the znSendPasswordResetEmail mutation. */
export type ZnSendPasswordResetEmailPayload = {
  readonly __typename?: 'ZnSendPasswordResetEmailPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the mutation completed successfully. This does NOT necessarily mean that an email was sent. */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The user that the password reset email was sent to
   * @deprecated This field will be removed in a future version of WPGraphQL
   */
  readonly user?: Maybe<User>;
};

/** Custom Post type for adding Zngly Playlists */
export type Znglist = ContentNode & DatabaseIdentifier & MenuItemLinkable & Node & NodeWithAuthor & NodeWithTemplate & NodeWithTitle & Previewable & UniformResourceIdentifiable & {
  readonly __typename?: 'Znglist';
  /**
   * The ancestors of the content node.
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly ancestors?: Maybe<ZnglistToZnglistConnection>;
  /** Connection between the NodeWithAuthor type and the User type */
  readonly author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the author of the node */
  readonly authorId?: Maybe<Scalars['ID']['output']>;
  /** Connection between the ContentNode type and the ContentType type */
  readonly contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  readonly contentTypeName: Scalars['String']['output'];
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  readonly date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  readonly dateGmt?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  readonly desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  readonly editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  readonly enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  readonly guid?: Maybe<Scalars['String']['output']>;
  /** Whether the znglist object is password protected. */
  readonly hasPassword?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the znglist object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  readonly isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  readonly lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  readonly modifiedGmt?: Maybe<Scalars['String']['output']>;
  /**
   * The parent of the content node.
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  readonly parent?: Maybe<ZnglistToParentConnectionEdge>;
  /** The password for the znglist object. */
  readonly password?: Maybe<Scalars['String']['output']>;
  /** Connection between the Znglist type and the PostAccessRecipient type */
  readonly postAccessRecipients?: Maybe<ZnglistToPostAccessRecipientConnection>;
  /** Connection between the Znglist type and the znglist type */
  readonly preview?: Maybe<ZnglistToPreviewConnectionEdge>;
  /** The database id of the preview node */
  readonly previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  readonly previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly statusSettings?: Maybe<StatusSettings>;
  /** The template assigned to the node */
  readonly template?: Maybe<ContentTemplate>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  readonly title?: Maybe<Scalars['String']['output']>;
  /** Trash Date of the Post */
  readonly trashDate?: Maybe<Scalars['String']['output']>;
  /** Time until the post is deleted */
  readonly trashTimeUntil?: Maybe<Scalars['String']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Znglist&quot; was set to Show in GraphQL. */
  readonly znglist?: Maybe<Znglist_Znglist>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of the databaseId field
   */
  readonly znglistId: Scalars['Int']['output'];
};


/** Custom Post type for adding Zngly Playlists */
export type ZnglistAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom Post type for adding Zngly Playlists */
export type ZnglistEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom Post type for adding Zngly Playlists */
export type ZnglistEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom Post type for adding Zngly Playlists */
export type ZnglistPostAccessRecipientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ZnglistToPostAccessRecipientConnectionWhereArgs>;
};


/** Custom Post type for adding Zngly Playlists */
export type ZnglistTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A paginated collection of znglist Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of znglist Nodes */
export type ZnglistConnection = {
  /** A list of edges (relational context) between RootQuery and connected znglist Nodes */
  readonly edges: ReadonlyArray<ZnglistConnectionEdge>;
  /** A list of connected znglist Nodes */
  readonly nodes: ReadonlyArray<Znglist>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ZnglistConnectionPageInfo;
};

/** Represents a connection to a znglist. Contains both the znglist Node and metadata about the relationship. */
export type ZnglistConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected znglist Node */
  readonly node: Znglist;
};

/** Pagination metadata specific to &quot;ZnglistConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;ZnglistConnectionEdge&quot; Nodes. */
export type ZnglistConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifier types for retrieving a specific Znglist. Specifies which unique attribute is used to find an exact Znglist. */
export enum ZnglistIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Znglist Template Type Enum */
export enum ZnglistTemplateTypeEnum {
  Classic = 'CLASSIC',
  Pending = 'PENDING',
  Personal = 'PERSONAL'
}

/** Connection between the Znglist type and the znglist type */
export type ZnglistToParentConnectionEdge = Edge & OneToOneConnection & ZnglistConnectionEdge & {
  readonly __typename?: 'ZnglistToParentConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /**
   * The node of the connection, without the edges
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  readonly node: Znglist;
};

/** Connection between the Znglist type and the PostAccessRecipient type */
export type ZnglistToPostAccessRecipientConnection = Connection & PostAccessRecipientConnection & {
  readonly __typename?: 'ZnglistToPostAccessRecipientConnection';
  /** Edges for the ZnglistToPostAccessRecipientConnection connection */
  readonly edges: ReadonlyArray<ZnglistToPostAccessRecipientConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<PostAccessRecipient>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ZnglistToPostAccessRecipientConnectionPageInfo;
};

/** An edge in a connection */
export type ZnglistToPostAccessRecipientConnectionEdge = Edge & PostAccessRecipientConnectionEdge & {
  readonly __typename?: 'ZnglistToPostAccessRecipientConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: PostAccessRecipient;
};

/** Pagination metadata specific to &quot;ZnglistToPostAccessRecipientConnection&quot; collections. Provides cursors and flags for navigating through sets of ZnglistToPostAccessRecipientConnection Nodes. */
export type ZnglistToPostAccessRecipientConnectionPageInfo = PageInfo & PostAccessRecipientConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'ZnglistToPostAccessRecipientConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the ZnglistToPostAccessRecipientConnection connection */
export type ZnglistToPostAccessRecipientConnectionWhereArgs = {
  /** The ID of the author of the post */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the author of the post */
  readonly authorIdIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The ID of the author of the post */
  readonly authorIdNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The date the post was created, in the site's timezone */
  readonly createdDateQuery?: InputMaybe<DateQueryInput>;
  /** Email Domain */
  readonly domain?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** The date the post expires, in the site's timezone */
  readonly expiresAtDateQuery?: InputMaybe<DateQueryInput>;
  /** access recipient id */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** access recipient id */
  readonly idIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** access recipient id */
  readonly idNotIn?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** The date the post was last modified, in the site's timezone */
  readonly modifiedDateQuery?: InputMaybe<DateQueryInput>;
  /** Order by field */
  readonly order?: InputMaybe<OrderEnum>;
  /** Order by field */
  readonly orderBy?: InputMaybe<ReadonlyArray<InputMaybe<PostAccessRecipientSearchFieldsEnum>>>;
  /** Search for PostAccessRecipients by any field */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Search for PostAccessRecipients by specific fields - empty array will search all fields */
  readonly searchFields?: InputMaybe<ReadonlyArray<InputMaybe<PostAccessRecipientSearchFieldsEnum>>>;
  /** Status of the post access recipient */
  readonly status?: InputMaybe<PostAccessRecipientStatusEnum>;
  /** Status of the post access recipient */
  readonly statusIn?: InputMaybe<ReadonlyArray<InputMaybe<PostAccessRecipientStatusEnum>>>;
  /** Status of the post access recipient */
  readonly statusNotIn?: InputMaybe<ReadonlyArray<InputMaybe<PostAccessRecipientStatusEnum>>>;
};

/** Connection between the Znglist type and the znglist type */
export type ZnglistToPreviewConnectionEdge = Edge & OneToOneConnection & ZnglistConnectionEdge & {
  readonly __typename?: 'ZnglistToPreviewConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Znglist;
};

/** Connection between the Znglist type and the znglist type */
export type ZnglistToZnglistConnection = Connection & ZnglistConnection & {
  readonly __typename?: 'ZnglistToZnglistConnection';
  /** Edges for the ZnglistToZnglistConnection connection */
  readonly edges: ReadonlyArray<ZnglistToZnglistConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Znglist>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ZnglistToZnglistConnectionPageInfo;
};

/** An edge in a connection */
export type ZnglistToZnglistConnectionEdge = Edge & ZnglistConnectionEdge & {
  readonly __typename?: 'ZnglistToZnglistConnectionEdge';
  /**
   * A cursor for use in pagination
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /**
   * The item at the end of the edge
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly node: Znglist;
};

/** Pagination metadata specific to &quot;ZnglistToZnglistConnection&quot; collections. Provides cursors and flags for navigating through sets of ZnglistToZnglistConnection Nodes. */
export type ZnglistToZnglistConnectionPageInfo = PageInfo & WpPageInfo & ZnglistConnectionPageInfo & {
  readonly __typename?: 'ZnglistToZnglistConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Znglist UserType Enum */
export enum ZnglistUserTypeEnum {
  Admin = 'ADMIN',
  User = 'USER'
}

/** Field Group */
export type Znglist_Znglist = AcfFieldGroup & {
  readonly __typename?: 'Znglist_Znglist';
  /** The name of the ACF Field Group */
  readonly fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Connection between the Znglist_Znglist type and the Form type */
  readonly form?: Maybe<Znglist_ZnglistToFormConnectionEdge>;
  /** Restrict the content. A Form must be completed before the content can be accessed. */
  readonly formId?: Maybe<Scalars['Float']['output']>;
  readonly order?: Maybe<Scalars['Float']['output']>;
  readonly templateType?: Maybe<Scalars['String']['output']>;
  readonly userType?: Maybe<Scalars['String']['output']>;
  readonly znglyContents?: Maybe<ReadonlyArray<Maybe<Znglist_Znglist_ZnglyContents>>>;
};

/** Connection between the Znglist_Znglist type and the Form type */
export type Znglist_ZnglistToFormConnectionEdge = Edge & FormConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'Znglist_ZnglistToFormConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Form;
};

export type Znglist_Znglist_ZnglyContents = ZnglyVideo;

/** Custom Post type for adding Zngly Site Information */
export type ZnglyInfo = ContentNode & DatabaseIdentifier & MenuItemLinkable & Node & NodeWithContentEditor & NodeWithTemplate & NodeWithTitle & Previewable & UniformResourceIdentifiable & {
  readonly __typename?: 'ZnglyInfo';
  /**
   * The ancestors of the content node.
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly ancestors?: Maybe<ZnglyInfoToZnglyInfoConnection>;
  /** The content of the post. */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the ContentType type */
  readonly contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  readonly contentTypeName: Scalars['String']['output'];
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  readonly date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  readonly dateGmt?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  readonly desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  readonly editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  readonly enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  readonly guid?: Maybe<Scalars['String']['output']>;
  /** Whether the zngly_info object is password protected. */
  readonly hasPassword?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the zngly_info object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  readonly isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  readonly lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  readonly modifiedGmt?: Maybe<Scalars['String']['output']>;
  /**
   * The parent of the content node.
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  readonly parent?: Maybe<ZnglyInfoToParentConnectionEdge>;
  /** The password for the zngly_info object. */
  readonly password?: Maybe<Scalars['String']['output']>;
  /** Connection between the ZnglyInfo type and the znglyInfo type */
  readonly preview?: Maybe<ZnglyInfoToPreviewConnectionEdge>;
  /** The database id of the preview node */
  readonly previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  readonly previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  readonly status?: Maybe<Scalars['String']['output']>;
  /** The template assigned to the node */
  readonly template?: Maybe<ContentTemplate>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly unencodedContent?: Maybe<Scalars['String']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;ZnglyInfo&quot; was set to Show in GraphQL. */
  readonly znglyInfo?: Maybe<ZnglyInfo_Znglyinfo>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of the databaseId field
   */
  readonly znglyInfoId: Scalars['Int']['output'];
};


/** Custom Post type for adding Zngly Site Information */
export type ZnglyInfoAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom Post type for adding Zngly Site Information */
export type ZnglyInfoContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** Custom Post type for adding Zngly Site Information */
export type ZnglyInfoEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom Post type for adding Zngly Site Information */
export type ZnglyInfoEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom Post type for adding Zngly Site Information */
export type ZnglyInfoTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A paginated collection of znglyInfo Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of znglyInfo Nodes */
export type ZnglyInfoConnection = {
  /** A list of edges (relational context) between RootQuery and connected znglyInfo Nodes */
  readonly edges: ReadonlyArray<ZnglyInfoConnectionEdge>;
  /** A list of connected znglyInfo Nodes */
  readonly nodes: ReadonlyArray<ZnglyInfo>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ZnglyInfoConnectionPageInfo;
};

/** Represents a connection to a znglyInfo. Contains both the znglyInfo Node and metadata about the relationship. */
export type ZnglyInfoConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected znglyInfo Node */
  readonly node: ZnglyInfo;
};

/** Pagination metadata specific to &quot;ZnglyInfoConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;ZnglyInfoConnectionEdge&quot; Nodes. */
export type ZnglyInfoConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifier types for retrieving a specific ZnglyInfo. Specifies which unique attribute is used to find an exact ZnglyInfo. */
export enum ZnglyInfoIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** ZnglyInfo Enum of Available pinned content types */
export enum ZnglyInfoPinnedContentType {
  List = 'LIST',
  None = 'NONE',
  Single = 'SINGLE'
}

/** Connection between the ZnglyInfo type and the znglyInfo type */
export type ZnglyInfoToParentConnectionEdge = Edge & OneToOneConnection & ZnglyInfoConnectionEdge & {
  readonly __typename?: 'ZnglyInfoToParentConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /**
   * The node of the connection, without the edges
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  readonly node: ZnglyInfo;
};

/** Connection between the ZnglyInfo type and the znglyInfo type */
export type ZnglyInfoToPreviewConnectionEdge = Edge & OneToOneConnection & ZnglyInfoConnectionEdge & {
  readonly __typename?: 'ZnglyInfoToPreviewConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: ZnglyInfo;
};

/** Connection between the ZnglyInfo type and the znglyInfo type */
export type ZnglyInfoToZnglyInfoConnection = Connection & ZnglyInfoConnection & {
  readonly __typename?: 'ZnglyInfoToZnglyInfoConnection';
  /** Edges for the ZnglyInfoToZnglyInfoConnection connection */
  readonly edges: ReadonlyArray<ZnglyInfoToZnglyInfoConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ZnglyInfo>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ZnglyInfoToZnglyInfoConnectionPageInfo;
};

/** An edge in a connection */
export type ZnglyInfoToZnglyInfoConnectionEdge = Edge & ZnglyInfoConnectionEdge & {
  readonly __typename?: 'ZnglyInfoToZnglyInfoConnectionEdge';
  /**
   * A cursor for use in pagination
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /**
   * The item at the end of the edge
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly node: ZnglyInfo;
};

/** Pagination metadata specific to &quot;ZnglyInfoToZnglyInfoConnection&quot; collections. Provides cursors and flags for navigating through sets of ZnglyInfoToZnglyInfoConnection Nodes. */
export type ZnglyInfoToZnglyInfoConnectionPageInfo = PageInfo & WpPageInfo & ZnglyInfoConnectionPageInfo & {
  readonly __typename?: 'ZnglyInfoToZnglyInfoConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Field Group */
export type ZnglyInfo_Znglyinfo = AcfFieldGroup & {
  readonly __typename?: 'ZnglyInfo_Znglyinfo';
  readonly address1?: Maybe<Scalars['String']['output']>;
  readonly address2?: Maybe<Scalars['String']['output']>;
  readonly address3?: Maybe<Scalars['String']['output']>;
  /** Backend Primary Color */
  readonly backendPrimaryColor?: Maybe<Scalars['String']['output']>;
  /** Backend Secondary Color */
  readonly backendSecondaryColor?: Maybe<Scalars['String']['output']>;
  /** Background Color Of The Media Description Box */
  readonly bodyDescBoxClr?: Maybe<Scalars['String']['output']>;
  /** Text Color Of The Media Description Box */
  readonly bodyDescBoxTxtClr?: Maybe<Scalars['String']['output']>;
  /** The title shown in the browser tab */
  readonly browserTabTitle?: Maybe<Scalars['String']['output']>;
  /** Color for Category and Znglisty dropdown menus */
  readonly catZnglistClr?: Maybe<Scalars['String']['output']>;
  /** Enter your Dialogflow CX Agent ID to enable the Zngly chatbot on your site */
  readonly chatbotAgentId?: Maybe<Scalars['String']['output']>;
  /** Enable to automatically open the chatbot when the page loads */
  readonly chatbotAutoOpen?: Maybe<Scalars['String']['output']>;
  /** Border radius for the chat window (e.g., 15px) */
  readonly chatbotBorderRadius?: Maybe<Scalars['String']['output']>;
  /** Background color of the chat bubble button */
  readonly chatbotBubbleBackground?: Maybe<Scalars['String']['output']>;
  /** Background color of the chat window */
  readonly chatbotChatBackground?: Maybe<Scalars['String']['output']>;
  /** Enter your Datastore ID to be used with the chatbot for search filtering */
  readonly chatbotDatastoreId?: Maybe<Scalars['String']['output']>;
  /** Choose how the chatbot should be displayed. Sidebar mode shows a fixed panel, while popup mode shows a floating button. */
  readonly chatbotDisplayMode?: Maybe<Scalars['String']['output']>;
  /** Text color inside the chatbot */
  readonly chatbotFontColor?: Maybe<Scalars['String']['output']>;
  /** Font family override for the chatbot (leave empty to use site default) */
  readonly chatbotFontFamily?: Maybe<Scalars['String']['output']>;
  /** Main accent color for the chatbot */
  readonly chatbotPrimaryColor?: Maybe<Scalars['String']['output']>;
  /** Color of the send button icon */
  readonly chatbotSendIconColor?: Maybe<Scalars['String']['output']>;
  /** Enter the title that will be displayed in the chatbot header */
  readonly chatbotTitle?: Maybe<Scalars['String']['output']>;
  /** Background color of the chatbot header */
  readonly chatbotTitlebarBackground?: Maybe<Scalars['String']['output']>;
  /** Text color in the chatbot header */
  readonly chatbotTitlebarFontColor?: Maybe<Scalars['String']['output']>;
  /** Primary color for the cta button */
  readonly ctaPrimaryClr?: Maybe<Scalars['String']['output']>;
  /** Primary text color for the cta button */
  readonly ctaPrimaryTxtClr?: Maybe<Scalars['String']['output']>;
  /** Secondary color for the cta button */
  readonly ctaSecondaryClr?: Maybe<Scalars['String']['output']>;
  readonly customSocialLinks?: Maybe<ReadonlyArray<Maybe<ZnglyInfo_Znglyinfo_CustomSocialLinks>>>;
  /** Google Dashboard Link for Analytics */
  readonly dashboardLink?: Maybe<Scalars['String']['output']>;
  /** Background color for category and znglist dropdown menu */
  readonly ddBgClr?: Maybe<Scalars['String']['output']>;
  /** Primary text color for category and znglist dropdown menu */
  readonly ddPrimaryTxtClr?: Maybe<Scalars['String']['output']>;
  /** Secondary text color for category and znglist dropdown menu (hover) */
  readonly ddSecondaryTxtClr?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly favicon?: Maybe<MediaItem>;
  /** The name of the ACF Field Group */
  readonly fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Site font style */
  readonly fontStyle?: Maybe<Scalars['String']['output']>;
  /** Link Hover Color */
  readonly footerAccentClr?: Maybe<Scalars['String']['output']>;
  /** Background Color */
  readonly footerBgClr?: Maybe<Scalars['String']['output']>;
  /** Heading Color */
  readonly footerPrimaryTxtClr?: Maybe<Scalars['String']['output']>;
  /** Text/Link Color */
  readonly footerSecondaryTxtClr?: Maybe<Scalars['String']['output']>;
  readonly googleAnalyticsId?: Maybe<Scalars['String']['output']>;
  /** Header Background Color */
  readonly headerBgClr?: Maybe<Scalars['String']['output']>;
  /** Buttons */
  readonly headerButtons?: Maybe<ReadonlyArray<Maybe<ZnglyInfo_Znglyinfo_HeaderButtons>>>;
  /** Image shown in the header which represents the company logo */
  readonly headerLogo?: Maybe<MediaItem>;
  /** The link that is navigated to when the company logo is pressed */
  readonly headerLogoLink?: Maybe<Scalars['String']['output']>;
  /** Text Color/Background Color For The Home &amp; Contact Buttons */
  readonly headerPrimaryAccentClr?: Maybe<Scalars['String']['output']>;
  /** Company name, Powered By Zngly, Username Color */
  readonly headerPrimaryTxtClr?: Maybe<Scalars['String']['output']>;
  /** Inverse Text Color/Background Color For The Home &amp; Contact Buttons */
  readonly headerSecondaryAccentClr?: Maybe<Scalars['String']['output']>;
  /** Link Hover Color */
  readonly headerSecondaryTxtClr?: Maybe<Scalars['String']['output']>;
  /** The text shown beside the logo which directs users back home */
  readonly headerText?: Maybe<Scalars['String']['output']>;
  readonly headerTextConditions?: Maybe<Scalars['String']['output']>;
  /** This is description that appears in the html metadata or when home page is shared. The same propagation issues from the above apply */
  readonly homePreviewDescription?: Maybe<Scalars['String']['output']>;
  /**
   * Image shown when home page is shared on other platform,
   *                         also used if the post/page being shared does not contain any images.
   *                         Propagation might take a while due to aggressive caching by other platforms,
   *                         use their respective share scraper to vertify changes and use the home url with some random url params e.g. .../?test=testing
   */
  readonly homePreviewImage?: Maybe<MediaItem>;
  /** Paste the hubId from the Hubspot Embed Code. src=&quot;//js.hs-scripts.com/{hubId}.js&quot; */
  readonly hubspotTracker?: Maybe<Scalars['String']['output']>;
  /** Paste the Leadfeeder code from the Leadfeeder tracker. It is the ID located towards the end of the script */
  readonly leadfeederTracker?: Maybe<Scalars['String']['output']>;
  /** Bottom Left Links Section */
  readonly links?: Maybe<ReadonlyArray<Maybe<ZnglyInfo_Znglyinfo_Links>>>;
  /** Title to the Links Section */
  readonly linksTitle?: Maybe<Scalars['String']['output']>;
  /** Link Color, Category &amp; Playlist Border/Background Color */
  readonly pagePrimaryAccClr?: Maybe<Scalars['String']['output']>;
  /** Body Text Color */
  readonly pagePrimaryTxtClr?: Maybe<Scalars['String']['output']>;
  /** Link Hover Color, Category &amp; Playlist Dropdown Menu Background Color */
  readonly pageSecondaryAccClr?: Maybe<Scalars['String']['output']>;
  /** Category &amp; Playlist Menu Text Color */
  readonly pageSecondaryTxtClr?: Maybe<Scalars['String']['output']>;
  readonly phone1?: Maybe<Scalars['String']['output']>;
  readonly phone2?: Maybe<Scalars['String']['output']>;
  readonly pinning?: Maybe<ZnglyInfo_Znglyinfo_Pinning>;
  readonly privacyPolicy?: Maybe<Scalars['String']['output']>;
  readonly privacyPolicyDate?: Maybe<Scalars['String']['output']>;
  readonly privacyPolicyEditing?: Maybe<Scalars['String']['output']>;
  readonly privacyPolicyTitle?: Maybe<Scalars['String']['output']>;
  /** Privacy Cookie Consent Enforcement Level For Users: GDPR, OPT_OUT, DISABLED */
  readonly privacyUserConsentLevel?: Maybe<Scalars['String']['output']>;
  readonly pvImages?: Maybe<ReadonlyArray<Maybe<ZnglyInfo_Znglyinfo_PvImages>>>;
  /** The image shown in the centre of the QR code */
  readonly qrImage?: Maybe<MediaItem>;
  /** The primary color of the QR codes */
  readonly qrPrimaryColor?: Maybe<Scalars['String']['output']>;
  /** The secondary color of the QR codes */
  readonly qrSecondaryColor?: Maybe<Scalars['String']['output']>;
  /** Primary color for the read more button */
  readonly readMorePrimaryClr?: Maybe<Scalars['String']['output']>;
  /** Primary text color for the read more button */
  readonly readMorePrimaryTxtClr?: Maybe<Scalars['String']['output']>;
  /** Secondary color for the read more button */
  readonly readMoreSecondaryClr?: Maybe<Scalars['String']['output']>;
  /** Paste the salesforce MID here to enable salesforce tracking */
  readonly salesforceMid?: Maybe<Scalars['String']['output']>;
  /** Image for the Search */
  readonly searchImage?: Maybe<MediaItem>;
  /** Image for the Ai Search */
  readonly searchImageAi?: Maybe<MediaItem>;
  /** Placeholder text for the search bar */
  readonly searchPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Placeholder text for the search bar */
  readonly searchPlaceholderAi?: Maybe<Scalars['String']['output']>;
  /** Primary share button color */
  readonly shareBtnPrimaryClr?: Maybe<Scalars['String']['output']>;
  /** Secondary share button color (hover) */
  readonly shareBtnSecondaryClr?: Maybe<Scalars['String']['output']>;
  /** Include the tawk.to Id. Only the id after http://embed.tawk.to/copy_from_here/to_here */
  readonly tawkId?: Maybe<Scalars['String']['output']>;
  readonly umamiAnalyticsId?: Maybe<Scalars['String']['output']>;
  /** Background color for user dropdown menu */
  readonly userMenuBackgroundClr?: Maybe<Scalars['String']['output']>;
  /** Link color for user dropdown menu */
  readonly userMenuLinkClr?: Maybe<Scalars['String']['output']>;
  /** Link hover color for user dropdown menu */
  readonly userMenuLinkHoverClr?: Maybe<Scalars['String']['output']>;
  readonly zoomInfoTracker?: Maybe<Scalars['String']['output']>;
};

/** Field Group */
export type ZnglyInfo_Znglyinfo_Pinning = AcfFieldGroup & {
  readonly __typename?: 'ZnglyInfo_Znglyinfo_Pinning';
  /** The name of the ACF Field Group */
  readonly fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Show a single post by default or control the entire page by choosing a list */
  readonly pinContentType?: Maybe<Scalars['String']['output']>;
  /**
   * You must choose from a private znglist. If there is none then you can create one in the
   *                             edit znglist dropdown panel
   */
  readonly pinnedList?: Maybe<ZnglyInfo_Znglyinfo_Pinning_PinnedList>;
  /**
   * This content will be shown on the home page, if this content does not have any categories
   *                             it will show all items in suggested content. If content has category assigned, suggeted content will have
   *                             items from that category. If you do not want to see this Pinned Content anywhere else on the site, set
   *                             the visibility to hidden
   */
  readonly pinnedVideo?: Maybe<ZnglyInfo_Znglyinfo_Pinning_PinnedVideo>;
};

export type ZnglyInfo_Znglyinfo_Pinning_PinnedList = Znglist;

export type ZnglyInfo_Znglyinfo_Pinning_PinnedVideo = ZnglyVideo;

/** Field Group */
export type ZnglyInfo_Znglyinfo_CustomSocialLinks = AcfFieldGroup & {
  readonly __typename?: 'ZnglyInfo_Znglyinfo_customSocialLinks';
  /** The name of the ACF Field Group */
  readonly fieldGroupName?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

/** Field Group */
export type ZnglyInfo_Znglyinfo_HeaderButtons = AcfFieldGroup & {
  readonly __typename?: 'ZnglyInfo_Znglyinfo_headerButtons';
  readonly bgColor?: Maybe<Scalars['String']['output']>;
  readonly bgHvColor?: Maybe<Scalars['String']['output']>;
  /** The name of the ACF Field Group */
  readonly fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Connection between the ZnglyInfo_Znglyinfo_headerButtons type and the Form type */
  readonly form?: Maybe<ZnglyInfo_Znglyinfo_HeaderButtonsToFormConnectionEdge>;
  readonly formId?: Maybe<Scalars['Float']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly textColor?: Maybe<Scalars['String']['output']>;
  readonly textHvColor?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

/** Connection between the ZnglyInfo_Znglyinfo_headerButtons type and the Form type */
export type ZnglyInfo_Znglyinfo_HeaderButtonsToFormConnectionEdge = Edge & FormConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'ZnglyInfo_Znglyinfo_headerButtonsToFormConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Form;
};

/** Field Group */
export type ZnglyInfo_Znglyinfo_Links = AcfFieldGroup & {
  readonly __typename?: 'ZnglyInfo_Znglyinfo_links';
  /** The name of the ACF Field Group */
  readonly fieldGroupName?: Maybe<Scalars['String']['output']>;
  readonly linkName?: Maybe<Scalars['String']['output']>;
  readonly linkUrl?: Maybe<Scalars['String']['output']>;
};

/** Field Group */
export type ZnglyInfo_Znglyinfo_PvImages = AcfFieldGroup & {
  readonly __typename?: 'ZnglyInfo_Znglyinfo_pvImages';
  /** The name of the ACF Field Group */
  readonly fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** The image shown in the personalised video */
  readonly image?: Maybe<MediaItem>;
};

/** ACF Type: repeater | Graphql Type:  */
export type ZnglyInfo_Znglyinfo_CustomSocialLinks_RepeaterInput = {
  /** ACF Type: text | Graphql Type: "String" */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: url | Graphql Type: "String" */
  readonly url?: InputMaybe<Scalars['String']['input']>;
};

/** Buttons | ACF Type: repeater | Graphql Type:  */
export type ZnglyInfo_Znglyinfo_HeaderButtons_RepeaterInput = {
  /** ACF Type: text | Graphql Type: "String" */
  readonly bgColor?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: "String" */
  readonly bgHvColor?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: number | Graphql Type: "ID" */
  readonly formId?: InputMaybe<Scalars['ID']['input']>;
  /** ACF Type: text | Graphql Type: "String" */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: "String" */
  readonly textColor?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: "String" */
  readonly textHvColor?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: "String" */
  readonly url?: InputMaybe<Scalars['String']['input']>;
};

/** Bottom Left Links Section | ACF Type: repeater | Graphql Type:  */
export type ZnglyInfo_Znglyinfo_Links_RepeaterInput = {
  /** ACF Type: text | Graphql Type: "String" */
  readonly linkName?: InputMaybe<Scalars['String']['input']>;
  /** ACF Type: text | Graphql Type: "String" */
  readonly linkUrl?: InputMaybe<Scalars['String']['input']>;
};

/** ACF Type: group | Graphql Type:  */
export type ZnglyInfo_Znglyinfo_Pinning_GroupInput = {
  /** Show a single post by default or control the entire page by choosing a list | ACF Type: text | Graphql Type: "ZnglyInfoPinnedContentType" */
  readonly pinContentType?: InputMaybe<ZnglyInfoPinnedContentType>;
  /**
   * You must choose from a private znglist. If there is none then you can create one in the
   *                             edit znglist dropdown panel | ACF Type: post_object | Graphql Type: "ID"
   */
  readonly pinnedList?: InputMaybe<Scalars['ID']['input']>;
  /**
   * This content will be shown on the home page, if this content does not have any categories
   *                             it will show all items in suggested content. If content has category assigned, suggeted content will have
   *                             items from that category. If you do not want to see this Pinned Content anywhere else on the site, set
   *                             the visibility to hidden | ACF Type: post_object | Graphql Type: "ID"
   */
  readonly pinnedVideo?: InputMaybe<Scalars['ID']['input']>;
};

/** ACF Type: repeater | Graphql Type:  */
export type ZnglyInfo_Znglyinfo_PvImages_RepeaterInput = {
  /** The image shown in the personalised video | ACF Type: image | Graphql Type: "ID" */
  readonly image?: InputMaybe<Scalars['ID']['input']>;
};

/** Type of the post */
export enum ZnglyPostTypeEnum {
  /** Catalog type */
  Catalog = 'Catalog',
  /** Category type */
  Category = 'Category',
  /** CrmList type */
  CrmList = 'CrmList',
  /** Form type */
  Form = 'Form',
  /** FormEntry type */
  FormEntry = 'FormEntry',
  /** Hub type */
  Hub = 'Hub',
  /** HubPage type */
  HubPage = 'HubPage',
  /** MediaItem type */
  MediaItem = 'MediaItem',
  /** SiteSettings type */
  SiteSettings = 'SiteSettings',
  /** User type */
  User = 'User',
  /** Znglist type */
  Znglist = 'Znglist'
}

/** ZnglyPrivacyUserConsentLevelEnum */
export enum ZnglyPrivacyUserConsentLevelEnum {
  /** DISABLED type */
  Disabled = 'DISABLED',
  /** GDPR type */
  Gdpr = 'GDPR',
  /** OPT_OUT type */
  OptOut = 'OPT_OUT'
}

/** Custom Post type for adding Zngly content */
export type ZnglyVideo = ContentNode & DatabaseIdentifier & MenuItemLinkable & Node & NodeWithAuthor & NodeWithContentEditor & NodeWithExcerpt & NodeWithFeaturedImage & NodeWithTemplate & NodeWithTitle & Previewable & UniformResourceIdentifiable & {
  readonly __typename?: 'ZnglyVideo';
  /**
   * The ancestors of the content node.
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly ancestors?: Maybe<ZnglyVideoToZnglyVideoConnection>;
  /** Connection between the NodeWithAuthor type and the User type */
  readonly author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  readonly authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the author of the node */
  readonly authorId?: Maybe<Scalars['ID']['output']>;
  /** Connection between the ZnglyVideo type and the category type */
  readonly categories?: Maybe<ZnglyVideoToCategoryConnection>;
  /** The content of the post. */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the ContentType type */
  readonly contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  readonly contentTypeName: Scalars['String']['output'];
  /** The unique identifier stored in the database */
  readonly databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  readonly date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  readonly dateGmt?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  readonly desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  readonly editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  readonly enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  readonly enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  readonly enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The excerpt of the post. */
  readonly excerpt?: Maybe<Scalars['String']['output']>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  readonly featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  readonly featuredImageDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Globally unique ID of the featured image assigned to the node */
  readonly featuredImageId?: Maybe<Scalars['ID']['output']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  readonly guid?: Maybe<Scalars['String']['output']>;
  /** Whether the ditto_videos object is password protected. */
  readonly hasPassword?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the ditto_videos object. */
  readonly id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  readonly isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  readonly isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  readonly isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  readonly isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  readonly isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the object is restricted from the current viewer */
  readonly isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  readonly isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  readonly lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  readonly link?: Maybe<Scalars['String']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  readonly modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  readonly modifiedGmt?: Maybe<Scalars['String']['output']>;
  /**
   * The parent of the content node.
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  readonly parent?: Maybe<ZnglyVideoToParentConnectionEdge>;
  /** The password for the ditto_videos object. */
  readonly password?: Maybe<Scalars['String']['output']>;
  /** Connection between the ZnglyVideo type and the znglyVideo type */
  readonly preview?: Maybe<ZnglyVideoToPreviewConnectionEdge>;
  /** The database id of the preview node */
  readonly previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  readonly previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** Search Results */
  readonly searchResults?: Maybe<AiSearchResults>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  readonly slug?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly statusSettings?: Maybe<StatusSettings>;
  /** Connection between the ZnglyVideo type and the tag type */
  readonly tags?: Maybe<ZnglyVideoToTagConnection>;
  /** The template assigned to the node */
  readonly template?: Maybe<ContentTemplate>;
  /** Connection between the ZnglyVideo type and the TermNode type */
  readonly terms?: Maybe<ZnglyVideoToTermNodeConnection>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  readonly title?: Maybe<Scalars['String']['output']>;
  /** Trash Date of the Post */
  readonly trashDate?: Maybe<Scalars['String']['output']>;
  /** Time until the post is deleted */
  readonly trashTimeUntil?: Maybe<Scalars['String']['output']>;
  readonly unencodedContent?: Maybe<Scalars['String']['output']>;
  /** The unique resource identifier path */
  readonly uri?: Maybe<Scalars['String']['output']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Ditto Video&quot; was set to Show in GraphQL. */
  readonly znglyContent?: Maybe<ZnglyVideo_Znglycontent>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of the databaseId field
   */
  readonly znglyVideoId: Scalars['Int']['output'];
};


/** Custom Post type for adding Zngly content */
export type ZnglyVideoAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom Post type for adding Zngly content */
export type ZnglyVideoCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ZnglyVideoToCategoryConnectionWhereArgs>;
};


/** Custom Post type for adding Zngly content */
export type ZnglyVideoContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** Custom Post type for adding Zngly content */
export type ZnglyVideoEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom Post type for adding Zngly content */
export type ZnglyVideoEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom Post type for adding Zngly content */
export type ZnglyVideoExcerptArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** Custom Post type for adding Zngly content */
export type ZnglyVideoTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ZnglyVideoToTagConnectionWhereArgs>;
};


/** Custom Post type for adding Zngly content */
export type ZnglyVideoTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ZnglyVideoToTermNodeConnectionWhereArgs>;
};


/** Custom Post type for adding Zngly content */
export type ZnglyVideoTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Set relationships between the znglyVideo to categories */
export type ZnglyVideoCategoriesInput = {
  /** If true, this will append the category to existing related categories. If false, this will replace existing relationships. Default true. */
  readonly append?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input list of items to set. */
  readonly nodes?: InputMaybe<ReadonlyArray<InputMaybe<ZnglyVideoCategoriesNodeInput>>>;
};

/** List of categories to connect the znglyVideo to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type ZnglyVideoCategoriesNodeInput = {
  /** The description of the category. This field is used to set a description of the category if a new one is created during the mutation. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the category. If present, this will be used to connect to the znglyVideo. If no existing category exists with this ID, no connection will be made. */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the category. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the category. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
};

/** A paginated collection of znglyVideo Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of znglyVideo Nodes */
export type ZnglyVideoConnection = {
  /** A list of edges (relational context) between RootQuery and connected znglyVideo Nodes */
  readonly edges: ReadonlyArray<ZnglyVideoConnectionEdge>;
  /** A list of connected znglyVideo Nodes */
  readonly nodes: ReadonlyArray<ZnglyVideo>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ZnglyVideoConnectionPageInfo;
};

/** Represents a connection to a ZnglyVideo. Contains both the ZnglyVideo Node and metadata about the relationship. */
export type ZnglyVideoConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The connected ZnglyVideo Node */
  readonly node: ZnglyVideo;
};

/** Pagination metadata specific to &quot;ZnglyVideoConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;ZnglyVideoConnectionEdge&quot; Nodes. */
export type ZnglyVideoConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifier types for retrieving a specific ZnglyVideo. Specifies which unique attribute is used to find an exact ZnglyVideo. */
export enum ZnglyVideoIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** ZnglyVideo Enum of Available Content Media Names */
export enum ZnglyVideoMediaNameEnum {
  Audio = 'AUDIO',
  Csv = 'CSV',
  Embed = 'EMBED',
  Image = 'IMAGE',
  Link = 'LINK',
  Mixcloud = 'MIXCLOUD',
  Mp4 = 'MP4',
  Other = 'OTHER',
  Pdf = 'PDF',
  Sharepoint = 'SHAREPOINT',
  Soundcloud = 'SOUNDCLOUD',
  Spotify = 'SPOTIFY',
  Synthesia = 'SYNTHESIA',
  Ted = 'TED',
  Undefined = 'UNDEFINED',
  Vimeo = 'VIMEO',
  Youtube = 'YOUTUBE'
}

/** ZnglyVideo Enum of Available post types */
export enum ZnglyVideoPostTypeEnum {
  Embed = 'EMBED',
  External = 'EXTERNAL',
  File = 'FILE'
}

/** ZnglyVideo Enum of Available query types */
export enum ZnglyVideoQueryTypeEnum {
  /** HOMEPAGE type */
  Homepage = 'HOMEPAGE',
  /** SINGLE type */
  Single = 'SINGLE'
}

/** Set relationships between the znglyVideo to tags */
export type ZnglyVideoTagsInput = {
  /** If true, this will append the tag to existing related tags. If false, this will replace existing relationships. Default true. */
  readonly append?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input list of items to set. */
  readonly nodes?: InputMaybe<ReadonlyArray<InputMaybe<ZnglyVideoTagsNodeInput>>>;
};

/** List of tags to connect the znglyVideo to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type ZnglyVideoTagsNodeInput = {
  /** The description of the tag. This field is used to set a description of the tag if a new one is created during the mutation. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the tag. If present, this will be used to connect to the znglyVideo. If no existing tag exists with this ID, no connection will be made. */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the tag. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the tag. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  readonly slug?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the ZnglyVideo type and the category type */
export type ZnglyVideoToCategoryConnection = CategoryConnection & Connection & {
  readonly __typename?: 'ZnglyVideoToCategoryConnection';
  /** Edges for the ZnglyVideoToCategoryConnection connection */
  readonly edges: ReadonlyArray<ZnglyVideoToCategoryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Category>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ZnglyVideoToCategoryConnectionPageInfo;
};

/** An edge in a connection */
export type ZnglyVideoToCategoryConnectionEdge = CategoryConnectionEdge & Edge & {
  readonly __typename?: 'ZnglyVideoToCategoryConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Category;
};

/** Pagination metadata specific to &quot;ZnglyVideoToCategoryConnection&quot; collections. Provides cursors and flags for navigating through sets of ZnglyVideoToCategoryConnection Nodes. */
export type ZnglyVideoToCategoryConnectionPageInfo = CategoryConnectionPageInfo & PageInfo & WpPageInfo & {
  readonly __typename?: 'ZnglyVideoToCategoryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the ZnglyVideoToCategoryConnection connection */
export type ZnglyVideoToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the ZnglyVideo type and the znglyVideo type */
export type ZnglyVideoToParentConnectionEdge = Edge & OneToOneConnection & ZnglyVideoConnectionEdge & {
  readonly __typename?: 'ZnglyVideoToParentConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /**
   * The node of the connection, without the edges
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  readonly node: ZnglyVideo;
};

/** Connection between the ZnglyVideo type and the znglyVideo type */
export type ZnglyVideoToPreviewConnectionEdge = Edge & OneToOneConnection & ZnglyVideoConnectionEdge & {
  readonly __typename?: 'ZnglyVideoToPreviewConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: ZnglyVideo;
};

/** Connection between the ZnglyVideo type and the tag type */
export type ZnglyVideoToTagConnection = Connection & TagConnection & {
  readonly __typename?: 'ZnglyVideoToTagConnection';
  /** Edges for the ZnglyVideoToTagConnection connection */
  readonly edges: ReadonlyArray<ZnglyVideoToTagConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<Tag>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ZnglyVideoToTagConnectionPageInfo;
};

/** An edge in a connection */
export type ZnglyVideoToTagConnectionEdge = Edge & TagConnectionEdge & {
  readonly __typename?: 'ZnglyVideoToTagConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: Tag;
};

/** Pagination metadata specific to &quot;ZnglyVideoToTagConnection&quot; collections. Provides cursors and flags for navigating through sets of ZnglyVideoToTagConnection Nodes. */
export type ZnglyVideoToTagConnectionPageInfo = PageInfo & TagConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'ZnglyVideoToTagConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the ZnglyVideoToTagConnection connection */
export type ZnglyVideoToTagConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the ZnglyVideo type and the TermNode type */
export type ZnglyVideoToTermNodeConnection = Connection & TermNodeConnection & {
  readonly __typename?: 'ZnglyVideoToTermNodeConnection';
  /** Edges for the ZnglyVideoToTermNodeConnection connection */
  readonly edges: ReadonlyArray<ZnglyVideoToTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<TermNode>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ZnglyVideoToTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type ZnglyVideoToTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  readonly __typename?: 'ZnglyVideoToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  readonly node: TermNode;
};

/** Pagination metadata specific to &quot;ZnglyVideoToTermNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of ZnglyVideoToTermNodeConnection Nodes. */
export type ZnglyVideoToTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  readonly __typename?: 'ZnglyVideoToTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Arguments for filtering the ZnglyVideoToTermNodeConnection connection */
export type ZnglyVideoToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  readonly cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  readonly childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  readonly childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  readonly descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  readonly exclude?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  readonly excludeTree?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  readonly hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  readonly hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  readonly include?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  readonly nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  readonly order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  readonly orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  readonly padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  readonly slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  /** The Taxonomy to filter terms by */
  readonly taxonomies?: InputMaybe<ReadonlyArray<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  readonly termTaxonomyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  readonly updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the ZnglyVideo type and the znglyVideo type */
export type ZnglyVideoToZnglyVideoConnection = Connection & ZnglyVideoConnection & {
  readonly __typename?: 'ZnglyVideoToZnglyVideoConnection';
  /** Edges for the ZnglyVideoToZnglyVideoConnection connection */
  readonly edges: ReadonlyArray<ZnglyVideoToZnglyVideoConnectionEdge>;
  /** The nodes of the connection, without the edges */
  readonly nodes: ReadonlyArray<ZnglyVideo>;
  /** Information about pagination in a connection. */
  readonly pageInfo: ZnglyVideoToZnglyVideoConnectionPageInfo;
};

/** An edge in a connection */
export type ZnglyVideoToZnglyVideoConnectionEdge = Edge & ZnglyVideoConnectionEdge & {
  readonly __typename?: 'ZnglyVideoToZnglyVideoConnectionEdge';
  /**
   * A cursor for use in pagination
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /**
   * The item at the end of the edge
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  readonly node: ZnglyVideo;
};

/** Pagination metadata specific to &quot;ZnglyVideoToZnglyVideoConnection&quot; collections. Provides cursors and flags for navigating through sets of ZnglyVideoToZnglyVideoConnection Nodes. */
export type ZnglyVideoToZnglyVideoConnectionPageInfo = PageInfo & WpPageInfo & ZnglyVideoConnectionPageInfo & {
  readonly __typename?: 'ZnglyVideoToZnglyVideoConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** Field Group */
export type ZnglyVideo_Znglycontent = AcfFieldGroup & {
  readonly __typename?: 'ZnglyVideo_Znglycontent';
  /** The AI Summary of the content. */
  readonly aiSummary?: Maybe<Scalars['String']['output']>;
  /** The HTML code for the embed. */
  readonly contentEmbedHtml?: Maybe<Scalars['String']['output']>;
  /** File Must be one of [pdf, jpg, png, jpeg, gif, mp4] Types */
  readonly contentFile?: Maybe<MediaItem>;
  /** Link to the content. */
  readonly contentLink?: Maybe<Scalars['String']['output']>;
  /** mp4/vimeo/png etc... */
  readonly contentMediaName?: Maybe<Scalars['String']['output']>;
  /** embed/file/external */
  readonly contentMediaType?: Maybe<Scalars['String']['output']>;
  readonly ctaLink?: Maybe<Scalars['String']['output']>;
  readonly ctaName?: Maybe<Scalars['String']['output']>;
  /** File Must be one of [pdf, jpg, png, jpeg, gif, mp4] Types */
  readonly featuredImageFile?: Maybe<MediaItem>;
  /** Link to the Featured Image. */
  readonly featuredImageLink?: Maybe<Scalars['String']['output']>;
  /** The name of the ACF Field Group */
  readonly fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Connection between the ZnglyVideo_Znglycontent type and the Form type */
  readonly form?: Maybe<ZnglyVideo_ZnglycontentToFormConnectionEdge>;
  /** Restrict the content. A Form must be completed before the content can be accessed. */
  readonly formId?: Maybe<Scalars['Float']['output']>;
  readonly htmlDesc?: Maybe<Scalars['String']['output']>;
  readonly shortText?: Maybe<Scalars['String']['output']>;
  /** The Duration of a Video. */
  readonly videoDuration?: Maybe<Scalars['String']['output']>;
};

/** Connection between the ZnglyVideo_Znglycontent type and the Form type */
export type ZnglyVideo_ZnglycontentToFormConnectionEdge = Edge & FormConnectionEdge & OneToOneConnection & {
  readonly __typename?: 'ZnglyVideo_ZnglycontentToFormConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  readonly cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  readonly node: Form;
};

export type ZntrkDecode = {
  readonly __typename?: 'ZntrkDecode';
  /** result */
  readonly leads?: Maybe<ReadonlyArray<Maybe<Contact>>>;
};

/** Input for the zohoDeleteAuth mutation. */
export type ZohoDeleteAuthInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Remove the tenant */
  readonly remove?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the zohoDeleteAuth mutation. */
export type ZohoDeleteAuthPayload = {
  readonly __typename?: 'ZohoDeleteAuthPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** whether the mutation was successful */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type ZohoInfo = {
  readonly __typename?: 'ZohoInfo';
  /** response */
  readonly hasAuth?: Maybe<Scalars['Boolean']['output']>;
  /** response */
  readonly salesIqAppCode?: Maybe<Scalars['String']['output']>;
  /** response */
  readonly salesIqAppId?: Maybe<Scalars['String']['output']>;
  /** Zoho Sales IQ App */
  readonly salesIqApps?: Maybe<ReadonlyArray<Maybe<ZohoSalesIqApp>>>;
  /** response */
  readonly salesIqPortalId?: Maybe<Scalars['String']['output']>;
  /** response */
  readonly salesIqPortals?: Maybe<ReadonlyArray<Maybe<ZohoSalesIqPortal>>>;
};


export type ZohoInfoSalesIqAppsArgs = {
  portalId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for the zohoRegisterAuth mutation. */
export type ZohoRegisterAuthInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** zoho code token for registering new Oauth credentials */
  readonly code: Scalars['String']['input'];
};

/** The payload for the zohoRegisterAuth mutation. */
export type ZohoRegisterAuthPayload = {
  readonly __typename?: 'ZohoRegisterAuthPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** whether the mutation was successful */
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

/** Zoho Sales IQ App */
export type ZohoSalesIqApp = {
  readonly __typename?: 'ZohoSalesIqApp';
  /** Sales Iq Code; Used in the tracker script */
  readonly code?: Maybe<Scalars['String']['output']>;
  /** App ID */
  readonly id?: Maybe<Scalars['String']['output']>;
  /** App Name */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** App Unique Name */
  readonly uniqueName?: Maybe<Scalars['String']['output']>;
};

/** Zoho Sales IQ Portal */
export type ZohoSalesIqPortal = {
  readonly __typename?: 'ZohoSalesIqPortal';
  /** Portal Created Time */
  readonly createdTime?: Maybe<Scalars['String']['output']>;
  /** Portal ID */
  readonly id?: Maybe<Scalars['String']['output']>;
  /** Portal Is Default */
  readonly isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Portal Logo */
  readonly logo?: Maybe<Scalars['String']['output']>;
  /** Portal Name */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Portal ID */
  readonly operatorId?: Maybe<Scalars['String']['output']>;
  /** Portal Owner ZUID */
  readonly ownerZuid?: Maybe<Scalars['String']['output']>;
  /** Portal Screen Name */
  readonly screenName?: Maybe<Scalars['String']['output']>;
};

/** Input for the zohoUpdateSettings mutation. */
export type ZohoUpdateSettingsInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Zoho App Code */
  readonly salesIqAppCode?: InputMaybe<Scalars['String']['input']>;
  /** Zoho App ID */
  readonly salesIqAppId?: InputMaybe<Scalars['String']['input']>;
  /** Zoho Portal ID */
  readonly salesIqPortalId?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the zohoUpdateSettings mutation. */
export type ZohoUpdateSettingsPayload = {
  readonly __typename?: 'ZohoUpdateSettingsPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Zoho App Code */
  readonly salesIqAppCode?: Maybe<Scalars['String']['output']>;
  /** Zoho App ID */
  readonly salesIqAppId?: Maybe<Scalars['String']['output']>;
  /** Zoho Portal ID */
  readonly salesIqPortalId?: Maybe<Scalars['String']['output']>;
};
